(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return webpackJsonp([1],{

/***/ "++bj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROJECT_PREFERENCE_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_PREFERENCE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ProjectPreferenceController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ProjectPreference; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project_preference_scss__ = __webpack_require__("6TBy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project_preference_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__project_preference_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__("lsdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_i18n__ = __webpack_require__("BOQq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_util__ = __webpack_require__("jQAO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__oligo_config_preference_oligo_config_preference__ = __webpack_require__("LqB4");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var PROJECT_PREFERENCE_SHOW = 'project-preference-show';
var PROJECT_PREFERENCE_NAME = 'projectPreference';
function preferenceTitle(headerTpl, project) {
    return __WEBPACK_IMPORTED_MODULE_2__models_i18n__["c" /* replacePlaceHolders */](headerTpl, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__models_i18n__["b" /* PlaceHolderKeys */].PROJECT_NUMBER, project ? '' + (project.index + 1) : ''));
}
var ProjectPreferenceController = function () {
    function ProjectPreferenceController($scope, $ngRedux, projectActions) {
        var _this = this;

        _classCallCheck(this, ProjectPreferenceController);

        this.MODAL_ID = 'project-preference';
        this.options = {
            scale: {
                items: __WEBPACK_IMPORTED_MODULE_3__models_util__["d" /* defaultDropDownContent */]()
            },
            purification: {
                items: __WEBPACK_IMPORTED_MODULE_3__models_util__["d" /* defaultDropDownContent */]()
            },
            format: {
                items: __WEBPACK_IMPORTED_MODULE_3__models_util__["d" /* defaultDropDownContent */]()
            }
        };
        this.openedAtLeastOnce = false;
        this.loading = false;
        this.updateProject = null;
        this.HEADER_TITLE_TPL = 'Project {{PROJECT_NUMBER}} Preferences';
        this.APPLY_PREFERENCE_LABEL = 'Apply to project';
        var bindDispatchers = function bindDispatchers(dispatch) {
            _this.updateProject = function (request) {
                return dispatch(projectActions.updateProject(request));
            };
        };
        var unsubscribeRedux = $ngRedux.connect(this.mapStateToThis.bind(this), bindDispatchers)(this);
        var latestOptions = void 0;
        var projectChangeListener = function projectChangeListener(event, newProject) {
            if (!newProject) {
                return;
            }
            var preference = newProject.preference;

            _this.loading = true;
            _this.openedAtLeastOnce = true;
            _this.preference = Object.assign({}, preference);
            _this.preferenceTitle = preferenceTitle(_this.HEADER_TITLE_TPL, newProject);
        };
        var preferenceChangeHandler = {
            onOptionChangeStart: function onOptionChangeStart() {
                _this.loading = true;
            },
            onOptionChangeSuccess: function onOptionChangeSuccess(newOptions) {
                var options = Object.assign({}, newOptions);
                _this.options = options;
                latestOptions = Object(__WEBPACK_IMPORTED_MODULE_4__oligo_config_preference_oligo_config_preference__["d" /* cloneOptions */])(options);
                _this.loading = false;
            },
            onOptionChangeFailed: function onOptionChangeFailed(errorCause) {
                _this.loading = false;
                if (latestOptions) {
                    _this.options = Object(__WEBPACK_IMPORTED_MODULE_4__oligo_config_preference_oligo_config_preference__["d" /* cloneOptions */])(latestOptions);
                }
                $scope.$emit(__WEBPACK_IMPORTED_MODULE_1__models__["k" /* ScopeEvents */].ERROR, errorCause);
            }
        };
        var applyPreference = function applyPreference() {
            if (!_this.options || !_this.updateProject) {
                return;
            }
            var preference = Object(__WEBPACK_IMPORTED_MODULE_4__oligo_config_preference_oligo_config_preference__["e" /* preferenceOptionsToPreference */])(_this.options);
            if (_this.project) {
                var request = Object.assign({}, _this.project, { preference: preference });
                _this.loading = true;
                _this.updateProject(request).then(function () {
                    _this.getJQ().modal('hide');
                }, function (errorCause) {
                    $scope.$emit(__WEBPACK_IMPORTED_MODULE_1__models__["k" /* ScopeEvents */].ERROR, errorCause);
                }).finally(function () {
                    return _this.loading = false;
                });
            }
        };
        this.preferenceChangeHandler = preferenceChangeHandler;
        this.applyPreference = applyPreference;
        var unwatchProjectChange = $scope.$on(PROJECT_PREFERENCE_SHOW, projectChangeListener);
        $scope.$on('$destroy', function () {
            unsubscribeRedux();
            unwatchProjectChange();
        });
    }

    _createClass(ProjectPreferenceController, [{
        key: '$onDestroy',
        value: function $onDestroy() {
            this.options = null;
            this.updateProject = null;
        }
    }, {
        key: 'getJQ',
        value: function getJQ() {
            if (!this.jq) {
                this.jq = $('#' + this.MODAL_ID);
            }
            return this.jq;
        }
    }, {
        key: 'mapStateToThis',
        value: function mapStateToThis(state) {
            var world = state.world;
            var vocabulary = world.vocabulary;

            return {
                HEADER_TITLE_TPL: vocabulary[__WEBPACK_IMPORTED_MODULE_2__models_i18n__["a" /* DictionaryKeys */].PROJECT_PREFERENCE_POPOVER_TITLE] || this.HEADER_TITLE_TPL,
                APPLY_PREFERENCE_LABEL: vocabulary[__WEBPACK_IMPORTED_MODULE_2__models_i18n__["a" /* DictionaryKeys */].PROJECT_PREFERENCE_POPOVER_APPLY_BUTTON] || this.APPLY_PREFERENCE_LABEL
            };
        }
    }]);

    return ProjectPreferenceController;
}();
var ProjectPreference = {
    template: function () {
        var bsJQ = $.fn;
        if (!bsJQ.modal || !bsJQ.modal.Constructor) {
            return '';
        }
        var version = bsJQ.modal.Constructor.VERSION;
        if (version) {
            if (version.indexOf('4') === 0) {
                return __webpack_require__("0bvj");
            }
        } else {
            var isBS2 = bsJQ.modal.toString().indexOf('bs.modal') === -1;
            if (isBS2) {
                return __webpack_require__("XLHB");
            }
        }
        return '';
    }(),
    controller: ProjectPreferenceController,
    controllerAs: 'projectPreference',
    bindings: {
        preferenceTitle: '@',
        openedAtLeastOnce: '<',
        preference: '=',
        project: '='
    }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("0iPh")))

/***/ }),

/***/ "+XqU":
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.7.5
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $sanitizeMinErr = angular.$$minErr('$sanitize');
var bind;
var extend;
var forEach;
var isArray;
var isDefined;
var lowercase;
var noop;
var nodeContains;
var htmlParser;
var htmlSanitizeWriter;

/**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */

/**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   Sanitizes an html string by stripping all potentially dangerous tokens.
 *
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
 *   then serialized back to a properly escaped HTML string. This means that no unsafe input can make
 *   it into the returned string.
 *
 *   The whitelist for URL sanitization of attribute values is configured using the functions
 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link $compileProvider}.
 *
 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */


/**
 * @ngdoc provider
 * @name $sanitizeProvider
 * @this
 *
 * @description
 * Creates and configures {@link $sanitize} instance.
 */
function $SanitizeProvider() {
  var hasBeenInstantiated = false;
  var svgEnabled = false;

  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
    hasBeenInstantiated = true;
    if (svgEnabled) {
      extend(validElements, svgElements);
    }
    return function(html) {
      var buf = [];
      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
      }));
      return buf.join('');
    };
  }];


  /**
   * @ngdoc method
   * @name $sanitizeProvider#enableSvg
   * @kind function
   *
   * @description
   * Enables a subset of svg to be supported by the sanitizer.
   *
   * <div class="alert alert-warning">
   *   <p>By enabling this setting without taking other precautions, you might expose your
   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
   *   link). Such behavior can then result in phishing incidents.</p>
   *
   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
   *   tags within the sanitized content:</p>
   *
   *   <br>
   *
   *   <pre><code>
   *   .rootOfTheIncludedContent svg {
   *     overflow: hidden !important;
   *   }
   *   </code></pre>
   * </div>
   *
   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
   *    without an argument or self for chaining otherwise.
   */
  this.enableSvg = function(enableSvg) {
    if (isDefined(enableSvg)) {
      svgEnabled = enableSvg;
      return this;
    } else {
      return svgEnabled;
    }
  };


  /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidElements
   * @kind function
   *
   * @description
   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
   * and are not stripped off during sanitization. You can extend the following lists of elements:
   *
   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
   *   elements. HTML elements considered safe will not be removed during sanitization. All other
   *   elements will be stripped off.
   *
   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
   *   "void elements" (similar to HTML
   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
   *   elements have no end tag and cannot have content.
   *
   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
   *   `$sanitize`.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the elements you add.
   * </div>
   *
   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
   *   more of the following properties:
   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     HTML elements.
   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     void HTML elements; i.e. elements that do not have an end tag.
   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
   *     elements. The list of SVG elements is only taken into account if SVG is
   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
   *
   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
   *
   * @return {$sanitizeProvider} Returns self for chaining.
   */
  this.addValidElements = function(elements) {
    if (!hasBeenInstantiated) {
      if (isArray(elements)) {
        elements = {htmlElements: elements};
      }

      addElementsTo(svgElements, elements.svgElements);
      addElementsTo(voidElements, elements.htmlVoidElements);
      addElementsTo(validElements, elements.htmlVoidElements);
      addElementsTo(validElements, elements.htmlElements);
    }

    return this;
  };


  /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidAttrs
   * @kind function
   *
   * @description
   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
   * not stripped off during sanitization.
   *
   * **Note**:
   * The new attributes will not be treated as URI attributes, which means their values will not be
   * sanitized as URIs using `$compileProvider`'s
   * {@link ng.$compileProvider#aHrefSanitizationWhitelist aHrefSanitizationWhitelist} and
   * {@link ng.$compileProvider#imgSrcSanitizationWhitelist imgSrcSanitizationWhitelist}.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the attributes you add.
   * </div>
   *
   * @param {Array<String>} attrs - A list of valid attributes.
   *
   * @returns {$sanitizeProvider} Returns self for chaining.
   */
  this.addValidAttrs = function(attrs) {
    if (!hasBeenInstantiated) {
      extend(validAttrs, arrayToMap(attrs, true));
    }
    return this;
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////
  // Private stuff
  //////////////////////////////////////////////////////////////////////////////////////////////////

  bind = angular.bind;
  extend = angular.extend;
  forEach = angular.forEach;
  isArray = angular.isArray;
  isDefined = angular.isDefined;
  lowercase = angular.$$lowercase;
  noop = angular.noop;

  htmlParser = htmlParserImpl;
  htmlSanitizeWriter = htmlSanitizeWriterImpl;

  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
    // eslint-disable-next-line no-bitwise
    return !!(this.compareDocumentPosition(arg) & 16);
  };

  // Regular Expressions for parsing tags and attributes
  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
    // Match everything outside of normal chars and " (quote character)
    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;


  // Good source of info about elements and attributes
  // http://dev.w3.org/html5/spec/Overview.html#semantics
  // http://simon.html5.org/html-elements

  // Safe Void Elements - HTML5
  // http://dev.w3.org/html5/spec/Overview.html#void-elements
  var voidElements = stringToMap('area,br,col,hr,img,wbr');

  // Elements that you can, intentionally, leave open (and which close themselves)
  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
  var optionalEndTagBlockElements = stringToMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
      optionalEndTagInlineElements = stringToMap('rp,rt'),
      optionalEndTagElements = extend({},
                                              optionalEndTagInlineElements,
                                              optionalEndTagBlockElements);

  // Safe Block Elements - HTML5
  var blockElements = extend({}, optionalEndTagBlockElements, stringToMap('address,article,' +
          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));

  // Inline Elements - HTML5
  var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap('a,abbr,acronym,b,' +
          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));

  // SVG Elements
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
  // They can potentially allow for arbitrary javascript to be executed. See #11290
  var svgElements = stringToMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
          'radialGradient,rect,stop,svg,switch,text,title,tspan');

  // Blocked Elements (will be stripped)
  var blockedElements = stringToMap('script,style');

  var validElements = extend({},
                                     voidElements,
                                     blockElements,
                                     inlineElements,
                                     optionalEndTagElements);

  //Attributes that have href and hence need to be sanitized
  var uriAttrs = stringToMap('background,cite,href,longdesc,src,xlink:href,xml:base');

  var htmlAttrs = stringToMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
      'valign,value,vspace,width');

  // SVG attributes (without "id" and "name" attributes)
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
  var svgAttrs = stringToMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);

  var validAttrs = extend({},
                                  uriAttrs,
                                  svgAttrs,
                                  htmlAttrs);

  function stringToMap(str, lowercaseKeys) {
    return arrayToMap(str.split(','), lowercaseKeys);
  }

  function arrayToMap(items, lowercaseKeys) {
    var obj = {}, i;
    for (i = 0; i < items.length; i++) {
      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
    }
    return obj;
  }

  function addElementsTo(elementsMap, newElements) {
    if (newElements && newElements.length) {
      extend(elementsMap, arrayToMap(newElements));
    }
  }

  /**
   * Create an inert document that contains the dirty HTML that needs sanitizing
   * Depending upon browser support we use one of three strategies for doing this.
   * Support: Safari 10.x -> XHR strategy
   * Support: Firefox -> DomParser strategy
   */
  var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function(window, document) {
    var inertDocument;
    if (document && document.implementation) {
      inertDocument = document.implementation.createHTMLDocument('inert');
    } else {
      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
    }
    var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector('body');

    // Check for the Safari 10.1 bug - which allows JS to run inside the SVG G element
    inertBodyElement.innerHTML = '<svg><g onload="this.parentNode.remove()"></g></svg>';
    if (!inertBodyElement.querySelector('svg')) {
      return getInertBodyElement_XHR;
    } else {
      // Check for the Firefox bug - which prevents the inner img JS from being sanitized
      inertBodyElement.innerHTML = '<svg><p><style><img src="</style><img src=x onerror=alert(1)//">';
      if (inertBodyElement.querySelector('svg img')) {
        return getInertBodyElement_DOMParser;
      } else {
        return getInertBodyElement_InertDocument;
      }
    }

    function getInertBodyElement_XHR(html) {
      // We add this dummy element to ensure that the rest of the content is parsed as expected
      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
      html = '<remove></remove>' + html;
      try {
        html = encodeURI(html);
      } catch (e) {
        return undefined;
      }
      var xhr = new window.XMLHttpRequest();
      xhr.responseType = 'document';
      xhr.open('GET', 'data:text/html;charset=utf-8,' + html, false);
      xhr.send(null);
      var body = xhr.response.body;
      body.firstChild.remove();
      return body;
    }

    function getInertBodyElement_DOMParser(html) {
      // We add this dummy element to ensure that the rest of the content is parsed as expected
      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
      html = '<remove></remove>' + html;
      try {
        var body = new window.DOMParser().parseFromString(html, 'text/html').body;
        body.firstChild.remove();
        return body;
      } catch (e) {
        return undefined;
      }
    }

    function getInertBodyElement_InertDocument(html) {
      inertBodyElement.innerHTML = html;

      // Support: IE 9-11 only
      // strip custom-namespaced attributes on IE<=11
      if (document.documentMode) {
        stripCustomNsAttrs(inertBodyElement);
      }

      return inertBodyElement;
    }
  })(window, window.document);

  /**
   * @example
   * htmlParser(htmlString, {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * });
   *
   * @param {string} html string
   * @param {object} handler
   */
  function htmlParserImpl(html, handler) {
    if (html === null || html === undefined) {
      html = '';
    } else if (typeof html !== 'string') {
      html = '' + html;
    }

    var inertBodyElement = getInertBodyElement(html);
    if (!inertBodyElement) return '';

    //mXSS protection
    var mXSSAttempts = 5;
    do {
      if (mXSSAttempts === 0) {
        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
      }
      mXSSAttempts--;

      // trigger mXSS if it is going to happen by reading and writing the innerHTML
      html = inertBodyElement.innerHTML;
      inertBodyElement = getInertBodyElement(html);
    } while (html !== inertBodyElement.innerHTML);

    var node = inertBodyElement.firstChild;
    while (node) {
      switch (node.nodeType) {
        case 1: // ELEMENT_NODE
          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
          break;
        case 3: // TEXT NODE
          handler.chars(node.textContent);
          break;
      }

      var nextNode;
      if (!(nextNode = node.firstChild)) {
        if (node.nodeType === 1) {
          handler.end(node.nodeName.toLowerCase());
        }
        nextNode = getNonDescendant('nextSibling', node);
        if (!nextNode) {
          while (nextNode == null) {
            node = getNonDescendant('parentNode', node);
            if (node === inertBodyElement) break;
            nextNode = getNonDescendant('nextSibling', node);
            if (node.nodeType === 1) {
              handler.end(node.nodeName.toLowerCase());
            }
          }
        }
      }
      node = nextNode;
    }

    while ((node = inertBodyElement.firstChild)) {
      inertBodyElement.removeChild(node);
    }
  }

  function attrToMap(attrs) {
    var map = {};
    for (var i = 0, ii = attrs.length; i < ii; i++) {
      var attr = attrs[i];
      map[attr.name] = attr.value;
    }
    return map;
  }


  /**
   * Escapes all potentially dangerous characters, so that the
   * resulting string can be safely inserted into attribute or
   * element text.
   * @param value
   * @returns {string} escaped text
   */
  function encodeEntities(value) {
    return value.
      replace(/&/g, '&amp;').
      replace(SURROGATE_PAIR_REGEXP, function(value) {
        var hi = value.charCodeAt(0);
        var low = value.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
      }).
      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
        return '&#' + value.charCodeAt(0) + ';';
      }).
      replace(/</g, '&lt;').
      replace(/>/g, '&gt;');
  }

  /**
   * create an HTML/XML writer which writes to buffer
   * @param {Array} buf use buf.join('') to get out sanitized html string
   * @returns {object} in the form of {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * }
   */
  function htmlSanitizeWriterImpl(buf, uriValidator) {
    var ignoreCurrentElement = false;
    var out = bind(buf, buf.push);
    return {
      start: function(tag, attrs) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && blockedElements[tag]) {
          ignoreCurrentElement = tag;
        }
        if (!ignoreCurrentElement && validElements[tag] === true) {
          out('<');
          out(tag);
          forEach(attrs, function(value, key) {
            var lkey = lowercase(key);
            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
            if (validAttrs[lkey] === true &&
              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
              out(' ');
              out(key);
              out('="');
              out(encodeEntities(value));
              out('"');
            }
          });
          out('>');
        }
      },
      end: function(tag) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
          out('</');
          out(tag);
          out('>');
        }
        // eslint-disable-next-line eqeqeq
        if (tag == ignoreCurrentElement) {
          ignoreCurrentElement = false;
        }
      },
      chars: function(chars) {
        if (!ignoreCurrentElement) {
          out(encodeEntities(chars));
        }
      }
    };
  }


  /**
   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
   * to allow any of these custom attributes. This method strips them all.
   *
   * @param node Root element to process
   */
  function stripCustomNsAttrs(node) {
    while (node) {
      if (node.nodeType === window.Node.ELEMENT_NODE) {
        var attrs = node.attributes;
        for (var i = 0, l = attrs.length; i < l; i++) {
          var attrNode = attrs[i];
          var attrName = attrNode.name.toLowerCase();
          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
            node.removeAttributeNode(attrNode);
            i--;
            l--;
          }
        }
      }

      var nextNode = node.firstChild;
      if (nextNode) {
        stripCustomNsAttrs(nextNode);
      }

      node = getNonDescendant('nextSibling', node);
    }
  }

  function getNonDescendant(propName, node) {
    // An element is clobbered if its `propName` property points to one of its descendants
    var nextNode = node[propName];
    if (nextNode && nodeContains.call(node, nextNode)) {
      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
    }
    return nextNode;
  }
}

function sanitizeText(chars) {
  var buf = [];
  var writer = htmlSanitizeWriter(buf, noop);
  writer.chars(chars);
  return buf.join('');
}


// define ngSanitize module and register $sanitize service
angular.module('ngSanitize', [])
  .provider('$sanitize', $SanitizeProvider)
  .info({ angularVersion: '1.7.5' });

/**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
 *
 *    Can be one of:
 *
 *    - `object`: A map of attributes
 *    - `function`: Takes the url as a parameter and returns a map of attributes
 *
 *    If the map of attributes contains a value for `target`, it overrides the value of
 *    the target parameter.
 *
 *
 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
     <file name="index.html">
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <th>Filter</th>
           <th>Source</th>
           <th>Rendered</th>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="linky-custom-attributes">
          <td>linky custom attributes</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="script.js">
       angular.module('linkyExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.snippet =
             'Pretty text with some links:\n' +
             'http://angularjs.org/,\n' +
             'mailto:us@somewhere.org,\n' +
             'another@somewhere.org,\n' +
             'and one more: ftp://127.0.0.1/.';
           $scope.snippetWithSingleURL = 'http://angularjs.org/';
         }]);
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });

       it('should optionally add custom attributes', function() {
        expect(element(by.id('linky-custom-attributes')).
            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
       });
     </file>
   </example>
 */
angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
  var LINKY_URL_REGEXP =
        /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
      MAILTO_REGEXP = /^mailto:/i;

  var linkyMinErr = angular.$$minErr('linky');
  var isDefined = angular.isDefined;
  var isFunction = angular.isFunction;
  var isObject = angular.isObject;
  var isString = angular.isString;

  return function(text, target, attributes) {
    if (text == null || text === '') return text;
    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);

    var attributesFn =
      isFunction(attributes) ? attributes :
      isObject(attributes) ? function getAttributesObject() {return attributes;} :
      function getEmptyAttributesObject() {return {};};

    var match;
    var raw = text;
    var html = [];
    var url;
    var i;
    while ((match = raw.match(LINKY_URL_REGEXP))) {
      // We can not end in these as they are sometimes found at the end of the sentence
      url = match[0];
      // if we did not match ftp/http/www/mailto then assume mailto
      if (!match[2] && !match[4]) {
        url = (match[3] ? 'http://' : 'mailto:') + url;
      }
      i = match.index;
      addText(raw.substr(0, i));
      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
      raw = raw.substring(i + match[0].length);
    }
    addText(raw);
    return $sanitize(html.join(''));

    function addText(text) {
      if (!text) {
        return;
      }
      html.push(sanitizeText(text));
    }

    function addLink(url, text) {
      var key, linkAttributes = attributesFn(url);
      html.push('<a ');

      for (key in linkAttributes) {
        html.push(key + '="' + linkAttributes[key] + '" ');
      }

      if (isDefined(target) && !('target' in linkAttributes)) {
        html.push('target="',
                  target,
                  '" ');
      }
      html.push('href="',
                url.replace(/"/g, '&quot;'),
                '">');
      addText(text);
      html.push('</a>');
    }
  };
}]);


})(window, window.angular);


/***/ }),

/***/ "+sGE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProjectDetailController */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_DETAIL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProjectDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project_detail_scss__ = __webpack_require__("93wI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project_detail_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__project_detail_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var ProjectDetailController = function () {
    function ProjectDetailController() {
        _classCallCheck(this, ProjectDetailController);

        this.project = null;
        this.config = null;
        this.oligoDetailDimensions = [];
    }

    _createClass(ProjectDetailController, [{
        key: '$onDestroy',
        value: function $onDestroy() {
            this.project = null;
        }
    }, {
        key: 'onOligoComponentLayout',
        value: function onOligoComponentLayout(oligo) {}
    }]);

    return ProjectDetailController;
}();
var PROJECT_DETAIL_NAME = 'projectDetail';
var ProjectDetail = function ProjectDetail($timeout, $document, $window) {
    return {
        template: __webpack_require__("Heu4"),
        controller: ProjectDetailController,
        controllerAs: 'projectDetail',
        restrict: 'E',
        bindToController: true,
        transclude: true,
        scope: {
            project: '<',
            config: '<'
        },
        link: function link($scope, element, attrs, ctrl) {
            var controller = ctrl;
            var oligoDetailDimensions = controller.oligoDetailDimensions;

            var scrollInAction = false;
            var isHiddenFromViewport = function isHiddenFromViewport(rect) {
                return rect.bottom < 0 || rect.top > ($window.innerHeight || $document[0].documentElement.clientHeight);
            };
            var needsTombstones = function needsTombstones(project, config) {
                return project && config && config.tombstoneStart ? project.oligos.length > config.tombstoneStart : false;
            };
            var framesPerSecond = 60 / 1000;
            var tombstoneListener = function tombstoneListener() {
                if (scrollInAction || !needsTombstones(controller.project, controller.config)) {
                    return;
                }
                $timeout(function () {
                    if (controller.project) {
                        controller.project.oligos.forEach(function (oligo, index) {
                            var oligoDetailRect = element.find('#project-detail__oligo_' + oligo.id)[0].getBoundingClientRect();
                            var dimension = oligoDetailDimensions[index];
                            var tombstone = isHiddenFromViewport(oligoDetailRect);
                            if (!dimension) {
                                dimension = {
                                    tombstone: tombstone
                                };
                            } else {
                                dimension.tombstone = tombstone;
                            }
                            oligoDetailDimensions[index] = dimension;
                        });
                    }
                    scrollInAction = false;
                }, framesPerSecond);
                scrollInAction = true;
            };
            var updateMatchingOligosWithNoDimension = function updateMatchingOligosWithNoDimension(reference, referenceDim) {
                var hasSameDisplaySetting = function hasSameDisplaySetting(oligo2) {
                    return reference.id !== oligo2.id && reference.configDisplayType === oligo2.configDisplayType && reference.displayType === oligo2.displayType;
                };
                var project = controller.project;

                if (!project) {
                    return;
                }
                project.oligos.filter(hasSameDisplaySetting).map(function (oligo) {
                    return oligoDetailDimensions[oligo.index];
                }).filter(function (dimension) {
                    return dimension && !dimension.height && !dimension.width;
                }).forEach(function (dimension) {
                    dimension.height = referenceDim.height;
                    dimension.width = referenceDim.width;
                });
            };
            var onOligoComponentLayout = function onOligoComponentLayout(oligo) {
                var oligoId = oligo.id,
                    index = oligo.index;

                var oligoDetailJQ = element.find('#project-detail__oligo_' + oligoId);
                if (oligoDetailJQ.length > 0) {
                    var rect = oligoDetailJQ[0].getBoundingClientRect();
                    var dimension = oligoDetailDimensions[index];
                    dimension = {
                        width: rect.width,
                        height: rect.height,
                        tombstone: dimension ? dimension.tombstone : false
                    };
                    oligoDetailDimensions[index] = dimension;
                    updateMatchingOligosWithNoDimension(oligo, dimension);
                }
            };
            controller.onOligoComponentLayout = function (oligo) {
                $timeout(function () {
                    onOligoComponentLayout(oligo.data);
                    tombstoneListener();
                });
            };
            ['scroll', 'resize'].forEach(function (eventName) {
                $window.addEventListener(eventName, tombstoneListener);
            });
            element.on('$destroy', function () {
                ['scroll, resize'].forEach(function (eventName) {
                    $window.removeEventListener(eventName, tombstoneListener);
                });
            });
            var bootstrap = function bootstrap() {
                var project = controller.project,
                    config = controller.config;
                var tombstoneStart = config.tombstoneStart;
                var oligos = project.oligos;

                oligos.forEach(function (oligo) {
                    oligoDetailDimensions[oligo.index] = {
                        tombstone: oligo.index >= tombstoneStart
                    };
                });
                $timeout(function () {
                    oligos.filter(function (oligo) {
                        return oligo.index < tombstoneStart;
                    }).forEach(onOligoComponentLayout);
                });
            };
            bootstrap();
        }
    };
};

/***/ }),

/***/ "/a58":
/***/ (function(module, exports) {

module.exports = "<!-- Cards Section Start -->\n<div class=\"cards-container\">\n  <div class=\"card-container\">\n    <div class=\"card-text-container\">\n      <span class=\"cart-text\" detect-ellipsis-on-text-overflow=\"{{cardDetail.plateOligoCardText}}\">\n        {{cardDetail.plateOligoCardText}}\n      </span>\n    </div>\n    <a class=\"card-link\" href=\"{{cardDetail.plateOligoUrl}}\">\n      <span> {{cardDetail.plateOligoLinkText}} </span>\n      <span class=\"icon-16-externallink-mono\"> </span>\n    </a>\n  </div>\n  <div class=\"card-container\">\n    <div class=\"card-text-container\">\n      <span class=\"cart-text\" detect-ellipsis-on-text-overflow=\"{{cardDetail.supportCardText}}\">\n        {{cardDetail.supportCardText}}\n      </span>\n    </div>\n    <a href=\"{{cardDetail.supportUrl}}\" class=\"card-link\">\n      <span> {{cardDetail.supportLinkText}} </span>\n      <span class=\"icon-16-externallink-mono\"> </span>\n    </a>\n  </div>\n</div>\n<!-- Cards Section End-->";

/***/ }),

/***/ "/whu":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "/zz5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("etoP");


/***/ }),

/***/ "0K64":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("WpTh");
module.exports = __webpack_require__("7gX0").Array.find;


/***/ }),

/***/ "0VzT":
/***/ (function(module, exports) {

module.exports = "<header class=\"project-header\">\n  <div class=\"project-header-menu\">\n    <div class=\"project-header-label-and-preference\">\n      <span class=\"project-header__label\">{{projectHeader.HEADER_TITLE}}</span>\n      <span class=\"project-header__preference\">\n        <a href=\"\" ng-click=\"projectHeader.showPreference()\">\n          <span class=\"project-preference-label\">{{projectHeader.PROJECT_PREFERENCE_LABEL}}</span>\n          <span class=\"project-preference-icon\"><em ng-class=\"{ 'icon-16-chevron-down-bold': !projectHeader.showProjectPreference, 'icon-16-chevron-up-bold': projectHeader.showProjectPreference}\"></em></span>\n        </a>\n      </span>\n    </div>\n    <div class=\"vertical-split-and-delete\">\n      <span class=\"vertical-split\"></span>\n      <span class=\"btn-config-delete\" ng-click=\"projectHeader.publishProjectDelete()\"><em class=\"icon-16-bin-mono\"></em></span>\n    </div>\n    <div class=\"loader-container\" ng-if=\"projectHeader.loading\">\n      <div class=\"loader\"></div>\n    </div>\n  </div>\n  <hr class=\"c-divider\" ng-if=\"projectHeader.showProjectPreference\"> \n  <div class=\"project-preference-option\" ng-if=\"projectHeader.showProjectPreference\">\n    <project-preference preference-title=\"{{projectHeader.project.name}}\"\n                        opened-at-least-once=true\n                        preference=\"projectHeader.project.preference\"\n                        header-call=true\n                        project=\"projectHeader.project\">\n    </project-preference>\n  </div>\n</header>";

/***/ }),

/***/ "0bvj":
/***/ (function(module, exports) {

module.exports = "<div id=\"{{projectPreference.MODAL_ID}}\" class=\"project-preference\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"project-preference__title\" aria-hidden=\"true\">\n  <div class=\"modal-dialog modal-dialog-centered modal-lg\" role=\"document\">\n    <div class=\"modal-content\">\n        <div class=\"container-fluid\">\n          <oligo-config-preference ng-if=\"projectPreference.openedAtLeastOnce\"\n                                   preference=\"projectPreference.preference\"\n                                   change-handler=\"projectPreference.preferenceChangeHandler\">\n          </oligo-config-preference>\n        </div>\n          <button type=\"button\"\n                  class=\"btn btn-danger\"\n                  ng-if=\"projectPreference.openedAtLeastOnce\"\n                  ng-click=\"projectPreference.applyPreference()\">\n            {{projectPreference.APPLY_PREFERENCE_LABEL}}\n          </button>\n    </div>\n  </div>\n  <div class=\"loader-container\" ng-if=\"projectPreference.loading\">\n    <div class=\"loader\"></div>\n  </div>\n</div>";

/***/ }),

/***/ "11R0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OligoSummaryBarController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OLIGO_SUMMARY_BAR_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OligoSummaryBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__oligo_summary_bar_scss__ = __webpack_require__("pIx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__oligo_summary_bar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__oligo_summary_bar_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__("lsdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_i18n__ = __webpack_require__("BOQq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_util__ = __webpack_require__("jQAO");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var OligoSummaryBarController = function () {
    function OligoSummaryBarController($scope, $window, $ngRedux, cartService) {
        var _this = this;

        _classCallCheck(this, OligoSummaryBarController);

        this.$scope = $scope;
        this.$window = $window;
        this.cartService = cartService;
        this.data = {
            totalOligos: 0,
            valid: true,
            maxNoOfOligos: 200,
            appState: __WEBPACK_IMPORTED_MODULE_1__models__["b" /* AppStates */].DRAFT
        };
        this.projects = [];
        this.priceProcessing = false;
        this.formatAmount = __WEBPACK_IMPORTED_MODULE_3__models_util__["e" /* formatAmount */];
        this.language = 'en';
        this.country = 'us';
        this.ADD_TO_CART_LABEL = 'Add to Cart';
        this.OLIGO_COUNT_LABEL_TPL = '{{OLIGO_COUNT}} Oligo';
        this.OLIGO_COUNT_LABEL = '';
        this.TOTAL_AMOUNT_LABEL = 'Total';
        this.MAX_OLIGO_EXCEEDED_HINT = 'You have exceeded the maximum limit of {{' + __WEBPACK_IMPORTED_MODULE_2__models_i18n__["b" /* PlaceHolderKeys */].MAX_OLIGO_COUNT + '}} oligos. Please review your oligo entries.';
        this.INVALID_OLIGO_HINT = 'There are one or more invalid oligo configurations. Please review your oligo entries.';
        this.mapStateToThis = function (state) {
            var projects = state.projects,
                world = state.world;
            var language = world.language,
                maxNoOfOligos = world.maxNoOfOligos,
                appState = world.appState,
                clientConfig = world.clientConfig,
                country = world.countryCode;
            var cartRedirectDelaySecs = clientConfig.cartRedirectDelaySecs,
                productFamilySku = clientConfig.productFamilySku;

            var data = state.projects.reduce(function (acc1, project) {
                return project.oligos.reduce(function (acc2, oligo) {
                    var pricing = oligo.pricing,
                        definition = oligo.definition;
                    var totalPrice = acc2.price;

                    if (pricing) {
                        if (totalPrice) {
                            totalPrice.available = totalPrice.available && pricing.available;
                            totalPrice.amount = totalPrice.amount + pricing.amount;
                            totalPrice.loading = totalPrice.loading || pricing.loading;
                        } else {
                            acc2.price = Object.assign({}, pricing);
                        }
                    }
                    acc2.valid = acc2.valid && definition.status.state === __WEBPACK_IMPORTED_MODULE_1__models__["g" /* OligoStates */].VALID;
                    acc2.totalOligos++;
                    acc2.totalOligos = acc2.totalOligos + definition.advanced.alternate.selected.length;
                    return acc2;
                }, acc1);
            }, { appState: appState, maxNoOfOligos: maxNoOfOligos, totalOligos: 0, valid: appState === __WEBPACK_IMPORTED_MODULE_1__models__["b" /* AppStates */].DRAFT });
            var vocabulary = world.vocabulary;

            var OLIGO_COUNT_LABEL_TPL = vocabulary[__WEBPACK_IMPORTED_MODULE_2__models_i18n__["a" /* DictionaryKeys */].APP_FOOTER_OLIGO_COUNT_TITLE] || _this.OLIGO_COUNT_LABEL_TPL;
            var maxOligoExceededHint = vocabulary[__WEBPACK_IMPORTED_MODULE_2__models_i18n__["a" /* DictionaryKeys */].APP_FOOTER_ADD_TO_CART_EXCEED_MAX_OLIGO_HINT] || _this.MAX_OLIGO_EXCEEDED_HINT;
            maxOligoExceededHint = __WEBPACK_IMPORTED_MODULE_2__models_i18n__["c" /* replacePlaceHolders */](maxOligoExceededHint, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__models_i18n__["b" /* PlaceHolderKeys */].MAX_OLIGO_COUNT, '' + maxNoOfOligos));
            return {
                data: data,
                language: language,
                country: country,
                projects: projects,
                priceProcessing: data.price ? data.price.loading : false,
                cartRedirectDelaySecs: cartRedirectDelaySecs,
                productFamilySku: productFamilySku,
                OLIGO_COUNT_LABEL_TPL: OLIGO_COUNT_LABEL_TPL,
                ADD_TO_CART_LABEL: vocabulary[__WEBPACK_IMPORTED_MODULE_2__models_i18n__["a" /* DictionaryKeys */].APP_FOOTER_ADD_TO_CART_BUTTON] || _this.ADD_TO_CART_LABEL,
                OLIGO_COUNT_LABEL: __WEBPACK_IMPORTED_MODULE_2__models_i18n__["c" /* replacePlaceHolders */](OLIGO_COUNT_LABEL_TPL, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__models_i18n__["b" /* PlaceHolderKeys */].OLIGO_COUNT, '' + data.totalOligos)),
                TOTAL_AMOUNT_LABEL: vocabulary[__WEBPACK_IMPORTED_MODULE_2__models_i18n__["a" /* DictionaryKeys */].APP_FOOTER_TOTAL_PRICE_TITLE] || _this.TOTAL_AMOUNT_LABEL,
                INVALID_OLIGO_HINT: vocabulary[__WEBPACK_IMPORTED_MODULE_2__models_i18n__["a" /* DictionaryKeys */].APP_FOOTER_ADD_TO_CART_INVALID_OLIGO_HINT] || _this.INVALID_OLIGO_HINT,
                MAX_OLIGO_EXCEEDED_HINT: maxOligoExceededHint
            };
        };
        var unsubscribe = $ngRedux.connect(this.mapStateToThis.bind(this))(this);
        $scope.$on('$destroy', function () {
            unsubscribe();
            _this.cartService = null;
        });
    }

    _createClass(OligoSummaryBarController, [{
        key: 'addToCart',
        value: function addToCart() {
            var _this2 = this;

            if (!this.data || !this.projects || !this.cartService) {
                return;
            }
            if (this.cannotAddToCart()) {
                return;
            }
            var projects = this.projects;

            var cartRedirectDelaySecs = this.cartRedirectDelaySecs || __WEBPACK_IMPORTED_MODULE_1__models__["l" /* WORLD_INITIAL */].clientConfig.cartRedirectDelaySecs;
            var productFamilySku = this.productFamilySku || __WEBPACK_IMPORTED_MODULE_1__models__["l" /* WORLD_INITIAL */].clientConfig.productFamilySku;
            this.cartProcessing = true;
            this.updateCartState(__WEBPACK_IMPORTED_MODULE_1__models__["c" /* CartStates */].PROCESSING);
            this.cartService.addToCart({ projects: projects }).then(function (response) {
                var errors = response.errors,
                    cartURL = response.cartURL;

                var hasErrors = errors && errors.length > 0;
                if (hasErrors) {
                    _this2.cartProcessing = false;
                    _this2.updateCartState(__WEBPACK_IMPORTED_MODULE_1__models__["c" /* CartStates */].FAILED);
                    return;
                }
                _this2.$scope.$emit(__WEBPACK_IMPORTED_MODULE_1__models__["k" /* ScopeEvents */].CART_ADD, projects, productFamilySku);
                setTimeout(function () {
                    _this2.$window.location.href = cartURL;
                }, (cartRedirectDelaySecs || 0) * 1000);
            }, function (error) {
                _this2.cartProcessing = false;
                _this2.updateCartState(__WEBPACK_IMPORTED_MODULE_1__models__["c" /* CartStates */].FAILED);
                _this2.$scope.$emit(__WEBPACK_IMPORTED_MODULE_1__models__["k" /* ScopeEvents */].ERROR, error);
            });
        }
    }, {
        key: 'cannotAddToCart',
        value: function cannotAddToCart() {
            var data = this.data;

            if (!data) {
                return true;
            }
            return !data.valid || data.totalOligos <= 0 || data.totalOligos > data.maxNoOfOligos;
        }
    }, {
        key: 'updateCartState',
        value: function updateCartState(state) {
            if (!this.onCartStateChange) {
                return;
            }
            this.onCartStateChange({ state: state });
        }
    }]);

    return OligoSummaryBarController;
}();
var OLIGO_SUMMARY_BAR_NAME = 'oligoSummaryBar';
var OligoSummaryBar = function OligoSummaryBar() {
    return {
        template: __webpack_require__("kYf+"),
        controller: OligoSummaryBarController,
        controllerAs: 'oligoSummary',
        bindToController: true,
        restrict: 'E',
        transclude: true,
        scope: {
            onCartStateChange: '&',
            cartProcessing: '<'
        },
        link: function link($scope, $elem, attrs, ctrl) {
            var controller = ctrl;
            var addToCartBtnHintJQ = void 0;
            var unwatchOligoSummary = $scope.$watch(function () {
                return controller.data;
            }, function (summaryData) {
                if (!addToCartBtnHintJQ) {
                    var addOligoHintPopover = $elem.find('.btn.btn-outline-primary');
                    if (typeof addOligoHintPopover.popover === 'function') {
                        addToCartBtnHintJQ = addOligoHintPopover;
                    }
                }
                if (addToCartBtnHintJQ) {
                    var exceededThreshold = summaryData.totalOligos > summaryData.maxNoOfOligos;
                    var hasInvalidOligos = !summaryData.valid && summaryData.appState === __WEBPACK_IMPORTED_MODULE_1__models__["b" /* AppStates */].DRAFT;
                    addToCartBtnHintJQ.popover('destroy');
                    if (exceededThreshold || hasInvalidOligos) {
                        var MAX_OLIGO_EXCEEDED_HINT = controller.MAX_OLIGO_EXCEEDED_HINT,
                            INVALID_OLIGO_HINT = controller.INVALID_OLIGO_HINT;

                        var content = exceededThreshold ? MAX_OLIGO_EXCEEDED_HINT : INVALID_OLIGO_HINT;
                        var popover = {
                            content: content,
                            html: true,
                            placement: 'top',
                            trigger: 'hover'
                        };
                        addToCartBtnHintJQ.popover(popover);
                    }
                }
            });
            $scope.$on('$destroy', function () {
                unwatchOligoSummary();
                if (addToCartBtnHintJQ) {
                    addToCartBtnHintJQ.popover('destroy');
                    addToCartBtnHintJQ = null;
                }
            });
        }
    };
};

/***/ }),

/***/ "1A13":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("49qz")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("uc2A")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "1SVs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1kGX":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-45Light.ttf";

/***/ }),

/***/ "22C0":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;/*!
    localForage -- Offline Storage, Improved
    Version 1.7.3
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.localforage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(_dereq_,module,exports){
'use strict';
var immediate = _dereq_(1);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"1":1}],3:[function(_dereq_,module,exports){
(function (global){
'use strict';
if (typeof global.Promise !== 'function') {
  global.Promise = _dereq_(2);
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"2":2}],4:[function(_dereq_,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getIDB() {
    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
    try {
        if (typeof indexedDB !== 'undefined') {
            return indexedDB;
        }
        if (typeof webkitIndexedDB !== 'undefined') {
            return webkitIndexedDB;
        }
        if (typeof mozIndexedDB !== 'undefined') {
            return mozIndexedDB;
        }
        if (typeof OIndexedDB !== 'undefined') {
            return OIndexedDB;
        }
        if (typeof msIndexedDB !== 'undefined') {
            return msIndexedDB;
        }
    } catch (e) {
        return;
    }
}

var idb = getIDB();

function isIndexedDBValid() {
    try {
        // Initialize IndexedDB; fall back to vendor-prefixed versions
        // if needed.
        if (!idb) {
            return false;
        }
        // We mimic PouchDB here;
        //
        // We test for openDatabase because IE Mobile identifies itself
        // as Safari. Oh the lulz...
        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

        // Safari <10.1 does not meet our requirements for IDB support (#5572)
        // since Safari 10.1 shipped with fetch, we can use that to detect it
        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
        // some outdated implementations of IDB that appear on Samsung
        // and HTC Android devices <4.4 are missing IDBKeyRange
        // See: https://github.com/mozilla/localForage/issues/128
        // See: https://github.com/mozilla/localForage/issues/272
        typeof IDBKeyRange !== 'undefined';
    } catch (e) {
        return false;
    }
}

// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
function createBlob(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== 'TypeError') {
            throw e;
        }
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
}

// This is CommonJS because lie is an external dependency, so Rollup
// can just ignore it.
if (typeof Promise === 'undefined') {
    // In the "nopromises" build this will just throw if you don't have
    // a global promise object, but it would throw anyway later.
    _dereq_(3);
}
var Promise$1 = Promise;

function executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(null, result);
        }, function (error) {
            callback(error);
        });
    }
}

function executeTwoCallbacks(promise, callback, errorCallback) {
    if (typeof callback === 'function') {
        promise.then(callback);
    }

    if (typeof errorCallback === 'function') {
        promise["catch"](errorCallback);
    }
}

function normalizeKey(key) {
    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    return key;
}

function getCallback() {
    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
        return arguments[arguments.length - 1];
    }
}

// Some code originally from async_storage.js in
// [Gaia](https://github.com/mozilla-b2g/gaia).

var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
var supportsBlobs = void 0;
var dbContexts = {};
var toString = Object.prototype.toString;

// Transaction Modes
var READ_ONLY = 'readonly';
var READ_WRITE = 'readwrite';

// Transform a binary string to an array buffer, because otherwise
// weird stuff happens when you try to work with the binary string directly.
// It is known.
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function _binStringToArrayBuffer(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
    }
    return buf;
}

//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37 and Android <5. In those versions, storing a blob will throw.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
// Code borrowed from PouchDB. See:
// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
//
function _checkBlobSupportWithoutCaching(idb) {
    return new Promise$1(function (resolve) {
        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
        var blob = createBlob(['']);
        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

        txn.onabort = function (e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };

        txn.oncomplete = function () {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
    })["catch"](function () {
        return false; // error, so assume unsupported
    });
}

function _checkBlobSupport(idb) {
    if (typeof supportsBlobs === 'boolean') {
        return Promise$1.resolve(supportsBlobs);
    }
    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
        supportsBlobs = value;
        return supportsBlobs;
    });
}

function _deferReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Create a deferred object representing the current database operation.
    var deferredOperation = {};

    deferredOperation.promise = new Promise$1(function (resolve, reject) {
        deferredOperation.resolve = resolve;
        deferredOperation.reject = reject;
    });

    // Enqueue the deferred operation.
    dbContext.deferredOperations.push(deferredOperation);

    // Chain its promise to the database readiness.
    if (!dbContext.dbReady) {
        dbContext.dbReady = deferredOperation.promise;
    } else {
        dbContext.dbReady = dbContext.dbReady.then(function () {
            return deferredOperation.promise;
        });
    }
}

function _advanceReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Resolve its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.resolve();
        return deferredOperation.promise;
    }
}

function _rejectReadiness(dbInfo, err) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Reject its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.reject(err);
        return deferredOperation.promise;
    }
}

function _getConnection(dbInfo, upgradeNeeded) {
    return new Promise$1(function (resolve, reject) {
        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

        if (dbInfo.db) {
            if (upgradeNeeded) {
                _deferReadiness(dbInfo);
                dbInfo.db.close();
            } else {
                return resolve(dbInfo.db);
            }
        }

        var dbArgs = [dbInfo.name];

        if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
        }

        var openreq = idb.open.apply(idb, dbArgs);

        if (upgradeNeeded) {
            openreq.onupgradeneeded = function (e) {
                var db = openreq.result;
                try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                        // Added when support for blob shims was added
                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                } catch (ex) {
                    if (ex.name === 'ConstraintError') {
                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                        throw ex;
                    }
                }
            };
        }

        openreq.onerror = function (e) {
            e.preventDefault();
            reject(openreq.error);
        };

        openreq.onsuccess = function () {
            resolve(openreq.result);
            _advanceReadiness(dbInfo);
        };
    });
}

function _getOriginalConnection(dbInfo) {
    return _getConnection(dbInfo, false);
}

function _getUpgradedConnection(dbInfo) {
    return _getConnection(dbInfo, true);
}

function _isUpgradeNeeded(dbInfo, defaultVersion) {
    if (!dbInfo.db) {
        return true;
    }

    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
    var isDowngrade = dbInfo.version < dbInfo.db.version;
    var isUpgrade = dbInfo.version > dbInfo.db.version;

    if (isDowngrade) {
        // If the version is not the default one
        // then warn for impossible downgrade.
        if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
        }
        // Align the versions to prevent errors.
        dbInfo.version = dbInfo.db.version;
    }

    if (isUpgrade || isNewStore) {
        // If the store is new then increment the version (if needed).
        // This will trigger an "upgradeneeded" event which is required
        // for creating a store.
        if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
                dbInfo.version = incVersion;
            }
        }

        return true;
    }

    return false;
}

// encode a blob for indexeddb engines that don't support blobs
function _encodeBlob(blob) {
    return new Promise$1(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = function (e) {
            var base64 = btoa(e.target.result || '');
            resolve({
                __local_forage_encoded_blob: true,
                data: base64,
                type: blob.type
            });
        };
        reader.readAsBinaryString(blob);
    });
}

// decode an encoded blob
function _decodeBlob(encodedBlob) {
    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
    return createBlob([arrayBuff], { type: encodedBlob.type });
}

// is this one of our fancy encoded blobs?
function _isEncodedBlob(value) {
    return value && value.__local_forage_encoded_blob;
}

// Specialize the default `ready()` function by making it dependent
// on the current database operations. Thus, the driver will be actually
// ready when it's been initialized (default) *and* there are no pending
// operations on the database (initiated by some other instances).
function _fullyReady(callback) {
    var self = this;

    var promise = self._initReady().then(function () {
        var dbContext = dbContexts[self._dbInfo.name];

        if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
        }
    });

    executeTwoCallbacks(promise, callback, callback);
    return promise;
}

// Try to establish a new db connection to replace the
// current one which is broken (i.e. experiencing
// InvalidStateError while creating a transaction).
function _tryReconnect(dbInfo) {
    _deferReadiness(dbInfo);

    var dbContext = dbContexts[dbInfo.name];
    var forages = dbContext.forages;

    for (var i = 0; i < forages.length; i++) {
        var forage = forages[i];
        if (forage._dbInfo.db) {
            forage._dbInfo.db.close();
            forage._dbInfo.db = null;
        }
    }
    dbInfo.db = null;

    return _getOriginalConnection(dbInfo).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        // store the latest db reference
        // in case the db was upgraded
        dbInfo.db = dbContext.db = db;
        for (var i = 0; i < forages.length; i++) {
            forages[i]._dbInfo.db = db;
        }
    })["catch"](function (err) {
        _rejectReadiness(dbInfo, err);
        throw err;
    });
}

// FF doesn't like Promises (micro-tasks) and IDDB store operations,
// so we have to do it with callbacks
function createTransaction(dbInfo, mode, callback, retries) {
    if (retries === undefined) {
        retries = 1;
    }

    try {
        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
        callback(null, tx);
    } catch (err) {
        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
            return Promise$1.resolve().then(function () {
                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                    // increase the db version, to create the new ObjectStore
                    if (dbInfo.db) {
                        dbInfo.version = dbInfo.db.version + 1;
                    }
                    // Reopen the database for upgrading.
                    return _getUpgradedConnection(dbInfo);
                }
            }).then(function () {
                return _tryReconnect(dbInfo).then(function () {
                    createTransaction(dbInfo, mode, callback, retries - 1);
                });
            })["catch"](callback);
        }

        callback(err);
    }
}

function createDbContext() {
    return {
        // Running localForages sharing a database.
        forages: [],
        // Shared database.
        db: null,
        // Database readiness (promise).
        dbReady: null,
        // Deferred operations on the database.
        deferredOperations: []
    };
}

// Open the IndexedDB database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    // Get the current context of the database;
    var dbContext = dbContexts[dbInfo.name];

    // ...or create a new context.
    if (!dbContext) {
        dbContext = createDbContext();
        // Register the new context in the global container.
        dbContexts[dbInfo.name] = dbContext;
    }

    // Register itself as a running localForage in the current context.
    dbContext.forages.push(self);

    // Replace the default `ready()` function with the specialized one.
    if (!self._initReady) {
        self._initReady = self.ready;
        self.ready = _fullyReady;
    }

    // Create an array of initialization states of the related localForages.
    var initPromises = [];

    function ignoreErrors() {
        // Don't handle errors here,
        // just makes sure related localForages aren't pending.
        return Promise$1.resolve();
    }

    for (var j = 0; j < dbContext.forages.length; j++) {
        var forage = dbContext.forages[j];
        if (forage !== self) {
            // Don't wait for itself...
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
        }
    }

    // Take a snapshot of the related localForages.
    var forages = dbContext.forages.slice(0);

    // Initialize the connection process only when
    // all the related localForages aren't pending.
    return Promise$1.all(initPromises).then(function () {
        dbInfo.db = dbContext.db;
        // Get the connection or open a new one without upgrade.
        return _getOriginalConnection(dbInfo);
    }).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        dbInfo.db = dbContext.db = db;
        self._dbInfo = dbInfo;
        // Share the final connection amongst related localForages.
        for (var k = 0; k < forages.length; k++) {
            var forage = forages[k];
            if (forage !== self) {
                // Self is already up-to-date.
                forage._dbInfo.db = dbInfo.db;
                forage._dbInfo.version = dbInfo.version;
            }
        }
    });
}

function getItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.get(key);

                    req.onsuccess = function () {
                        var value = req.result;
                        if (value === undefined) {
                            value = null;
                        }
                        if (_isEncodedBlob(value)) {
                            value = _decodeBlob(value);
                        }
                        resolve(value);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items stored in database.
function iterate(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var iterationNumber = 1;

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (cursor) {
                            var value = cursor.value;
                            if (_isEncodedBlob(value)) {
                                value = _decodeBlob(value);
                            }
                            var result = iterator(value, cursor.key, iterationNumber++);

                            // when the iterator callback retuns any
                            // (non-`undefined`) value, then we stop
                            // the iteration immediately
                            if (result !== void 0) {
                                resolve(result);
                            } else {
                                cursor["continue"]();
                            }
                        } else {
                            resolve();
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);

    return promise;
}

function setItem(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        var dbInfo;
        self.ready().then(function () {
            dbInfo = self._dbInfo;
            if (toString.call(value) === '[object Blob]') {
                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
                    if (blobSupport) {
                        return value;
                    }
                    return _encodeBlob(value);
                });
            }
            return value;
        }).then(function (value) {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);

                    // The reason we don't _save_ null is because IE 10 does
                    // not support saving the `null` type in IndexedDB. How
                    // ironic, given the bug below!
                    // See: https://github.com/mozilla/localForage/issues/161
                    if (value === null) {
                        value = undefined;
                    }

                    var req = store.put(value, key);

                    transaction.oncomplete = function () {
                        // Cast to undefined so the value passed to
                        // callback/promise is the same as what one would get out
                        // of `getItem()` later. This leads to some weirdness
                        // (setItem('foo', undefined) will return `null`), but
                        // it's not my fault localStorage is our baseline and that
                        // it's weird.
                        if (value === undefined) {
                            value = null;
                        }

                        resolve(value);
                    };
                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function removeItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    // We use a Grunt task to make this safe for IE and some
                    // versions of Android (including those used by Cordova).
                    // Normally IE won't like `.delete()` and will insist on
                    // using `['delete']()`, but we have a build step that
                    // fixes this for us now.
                    var req = store["delete"](key);
                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onerror = function () {
                        reject(req.error);
                    };

                    // The request will be also be aborted if we've exceeded our storage
                    // space.
                    transaction.onabort = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function clear(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.clear();

                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function length(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.count();

                    req.onsuccess = function () {
                        resolve(req.result);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function key(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        if (n < 0) {
            resolve(null);

            return;
        }

        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var advanced = false;
                    var req = store.openCursor();

                    req.onsuccess = function () {
                        var cursor = req.result;
                        if (!cursor) {
                            // this means there weren't enough keys
                            resolve(null);

                            return;
                        }

                        if (n === 0) {
                            // We have the first key, return it if that's what they
                            // wanted.
                            resolve(cursor.key);
                        } else {
                            if (!advanced) {
                                // Otherwise, ask the cursor to skip ahead n
                                // records.
                                advanced = true;
                                cursor.advance(n);
                            } else {
                                // When we get here, we've got the nth key.
                                resolve(cursor.key);
                            }
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var keys = [];

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (!cursor) {
                            resolve(keys);
                            return;
                        }

                        keys.push(cursor.key);
                        cursor["continue"]();
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
            var dbContext = dbContexts[options.name];
            var forages = dbContext.forages;
            dbContext.db = db;
            for (var i = 0; i < forages.length; i++) {
                forages[i]._dbInfo.db = db;
            }
            return db;
        });

        if (!options.storeName) {
            promise = dbPromise.then(function (db) {
                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                }

                var dropDBPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.deleteDatabase(options.name);

                    req.onerror = req.onblocked = function (err) {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        reject(err);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        resolve(db);
                    };
                });

                return dropDBPromise.then(function (db) {
                    dbContext.db = db;
                    for (var i = 0; i < forages.length; i++) {
                        var _forage = forages[i];
                        _advanceReadiness(_forage._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        } else {
            promise = dbPromise.then(function (db) {
                if (!db.objectStoreNames.contains(options.storeName)) {
                    return;
                }

                var newVersion = db.version + 1;

                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                    forage._dbInfo.version = newVersion;
                }

                var dropObjectPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.open(options.name, newVersion);

                    req.onerror = function (err) {
                        var db = req.result;
                        db.close();
                        reject(err);
                    };

                    req.onupgradeneeded = function () {
                        var db = req.result;
                        db.deleteObjectStore(options.storeName);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        db.close();
                        resolve(db);
                    };
                });

                return dropObjectPromise.then(function (db) {
                    dbContext.db = db;
                    for (var j = 0; j < forages.length; j++) {
                        var _forage2 = forages[j];
                        _forage2._dbInfo.db = db;
                        _advanceReadiness(_forage2._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        }
    }

    executeCallback(promise, callback);
    return promise;
}

var asyncStorage = {
    _driver: 'asyncStorage',
    _initStorage: _initStorage,
    _support: isIndexedDBValid(),
    iterate: iterate,
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear,
    length: length,
    key: key,
    keys: keys,
    dropInstance: dropInstance
};

function isWebSQLValid() {
    return typeof openDatabase === 'function';
}

// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
// it to Base64, so this is how we store it to prevent very strange errors with less
// verbose ways of binary <-> string data storage.
var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

var BLOB_TYPE_PREFIX = '~~local_forage_type~';
var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

var SERIALIZED_MARKER = '__lfsc__:';
var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

// OMG the serializations!
var TYPE_ARRAYBUFFER = 'arbf';
var TYPE_BLOB = 'blob';
var TYPE_INT8ARRAY = 'si08';
var TYPE_UINT8ARRAY = 'ui08';
var TYPE_UINT8CLAMPEDARRAY = 'uic8';
var TYPE_INT16ARRAY = 'si16';
var TYPE_INT32ARRAY = 'si32';
var TYPE_UINT16ARRAY = 'ur16';
var TYPE_UINT32ARRAY = 'ui32';
var TYPE_FLOAT32ARRAY = 'fl32';
var TYPE_FLOAT64ARRAY = 'fl64';
var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

var toString$1 = Object.prototype.toString;

function stringToBuffer(serializedString) {
    // Fill the string into a ArrayBuffer.
    var bufferLength = serializedString.length * 0.75;
    var len = serializedString.length;
    var i;
    var p = 0;
    var encoded1, encoded2, encoded3, encoded4;

    if (serializedString[serializedString.length - 1] === '=') {
        bufferLength--;
        if (serializedString[serializedString.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = new ArrayBuffer(bufferLength);
    var bytes = new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

        /*jslint bitwise: true */
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
}

// Converts a buffer to a string to store, serialized, in the backend
// storage library.
function bufferToString(buffer) {
    // base64-arraybuffer
    var bytes = new Uint8Array(buffer);
    var base64String = '';
    var i;

    for (i = 0; i < bytes.length; i += 3) {
        /*jslint bitwise: true */
        base64String += BASE_CHARS[bytes[i] >> 2];
        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64String += BASE_CHARS[bytes[i + 2] & 63];
    }

    if (bytes.length % 3 === 2) {
        base64String = base64String.substring(0, base64String.length - 1) + '=';
    } else if (bytes.length % 3 === 1) {
        base64String = base64String.substring(0, base64String.length - 2) + '==';
    }

    return base64String;
}

// Serialize a value, afterwards executing a callback (which usually
// instructs the `setItem()` callback/promise to be executed). This is how
// we store binary data with localStorage.
function serialize(value, callback) {
    var valueType = '';
    if (value) {
        valueType = toString$1.call(value);
    }

    // Cannot use `value instanceof ArrayBuffer` or such here, as these
    // checks fail when running the tests using casper.js...
    //
    // TODO: See why those tests fail and use a better solution.
    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
        // Convert binary arrays to a string and prefix the string with
        // a special marker.
        var buffer;
        var marker = SERIALIZED_MARKER;

        if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
        } else {
            buffer = value.buffer;

            if (valueType === '[object Int8Array]') {
                marker += TYPE_INT8ARRAY;
            } else if (valueType === '[object Uint8Array]') {
                marker += TYPE_UINT8ARRAY;
            } else if (valueType === '[object Uint8ClampedArray]') {
                marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === '[object Int16Array]') {
                marker += TYPE_INT16ARRAY;
            } else if (valueType === '[object Uint16Array]') {
                marker += TYPE_UINT16ARRAY;
            } else if (valueType === '[object Int32Array]') {
                marker += TYPE_INT32ARRAY;
            } else if (valueType === '[object Uint32Array]') {
                marker += TYPE_UINT32ARRAY;
            } else if (valueType === '[object Float32Array]') {
                marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === '[object Float64Array]') {
                marker += TYPE_FLOAT64ARRAY;
            } else {
                callback(new Error('Failed to get type for BinaryArray'));
            }
        }

        callback(marker + bufferToString(buffer));
    } else if (valueType === '[object Blob]') {
        // Conver the blob to a binaryArray and then to a string.
        var fileReader = new FileReader();

        fileReader.onload = function () {
            // Backwards-compatible prefix for the blob type.
            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
        };

        fileReader.readAsArrayBuffer(value);
    } else {
        try {
            callback(JSON.stringify(value));
        } catch (e) {
            console.error("Couldn't convert value into a JSON string: ", value);

            callback(null, e);
        }
    }
}

// Deserialize data we've inserted into a value column/field. We place
// special markers into our strings to mark them as encoded; this isn't
// as nice as a meta field, but it's the only sane thing we can do whilst
// keeping localStorage support intact.
//
// Oftentimes this will just deserialize JSON content, but if we have a
// special marker (SERIALIZED_MARKER, defined above), we will extract
// some kind of arraybuffer/binary data/typed array out of the string.
function deserialize(value) {
    // If we haven't marked this string as being specially serialized (i.e.
    // something other than serialized JSON), we can just return it and be
    // done with it.
    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
        return JSON.parse(value);
    }

    // The following code deals with deserializing some kind of Blob or
    // TypedArray. First we separate out the type of data we're dealing
    // with from the data itself.
    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

    var blobType;
    // Backwards-compatible blob type serialization strategy.
    // DBs created with older versions of localForage will simply not have the blob type.
    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
        blobType = matcher[1];
        serializedString = serializedString.substring(matcher[0].length);
    }
    var buffer = stringToBuffer(serializedString);

    // Return the right type based on the code/type set during
    // serialization.
    switch (type) {
        case TYPE_ARRAYBUFFER:
            return buffer;
        case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
        case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
        case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
        case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
        case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
        case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
        case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
        case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
        case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
        case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
        default:
            throw new Error('Unkown type: ' + type);
    }
}

var localforageSerializer = {
    serialize: serialize,
    deserialize: deserialize,
    stringToBuffer: stringToBuffer,
    bufferToString: bufferToString
};

/*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */

function createDbTable(t, dbInfo, callback, errorCallback) {
    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
}

// Open the WebSQL database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage$1(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
        }
    }

    var dbInfoPromise = new Promise$1(function (resolve, reject) {
        // Open the database; the openDatabase API will automatically
        // create it for us if it doesn't exist.
        try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
        } catch (e) {
            return reject(e);
        }

        // Create our key/value table if it doesn't exist.
        dbInfo.db.transaction(function (t) {
            createDbTable(t, dbInfo, function () {
                self._dbInfo = dbInfo;
                resolve();
            }, function (t, error) {
                reject(error);
            });
        }, reject);
    });

    dbInfo.serializer = localforageSerializer;
    return dbInfoPromise;
}

function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
    t.executeSql(sqlStatement, args, callback, function (t, error) {
        if (error.code === error.SYNTAX_ERR) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
                if (!results.rows.length) {
                    // if the table is missing (was deleted)
                    // re-create it table and retry
                    createDbTable(t, dbInfo, function () {
                        t.executeSql(sqlStatement, args, callback, errorCallback);
                    }, errorCallback);
                } else {
                    errorCallback(t, error);
                }
            }, errorCallback);
        } else {
            errorCallback(t, error);
        }
    }, errorCallback);
}

function getItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;

                    // Check to see if this is serialized content we need to
                    // unpack.
                    if (result) {
                        result = dbInfo.serializer.deserialize(result);
                    }

                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function iterate$1(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;

            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
                    var rows = results.rows;
                    var length = rows.length;

                    for (var i = 0; i < length; i++) {
                        var item = rows.item(i);
                        var result = item.value;

                        // Check to see if this is serialized content
                        // we need to unpack.
                        if (result) {
                            result = dbInfo.serializer.deserialize(result);
                        }

                        result = iterator(result, item.key, i + 1);

                        // void(0) prevents problems with redefinition
                        // of `undefined`.
                        if (result !== void 0) {
                            resolve(result);
                            return;
                        }
                    }

                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function _setItem(key, value, callback, retriesLeft) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            // The localStorage API doesn't return undefined values in an
            // "expected" way, so undefined is always cast to null in all
            // drivers. See: https://github.com/mozilla/localForage/pull/42
            if (value === undefined) {
                value = null;
            }

            // Save the original value to pass to the callback.
            var originalValue = value;

            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    dbInfo.db.transaction(function (t) {
                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
                            resolve(originalValue);
                        }, function (t, error) {
                            reject(error);
                        });
                    }, function (sqlError) {
                        // The transaction failed; check
                        // to see if it's a quota error.
                        if (sqlError.code === sqlError.QUOTA_ERR) {
                            // We reject the callback outright for now, but
                            // it's worth trying to re-run the transaction.
                            // Even if the user accepts the prompt to use
                            // more storage on Safari, this error will
                            // be called.
                            //
                            // Try to re-run the transaction.
                            if (retriesLeft > 0) {
                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
                                return;
                            }
                            reject(sqlError);
                        }
                    });
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function setItem$1(key, value, callback) {
    return _setItem.apply(this, [key, value, callback, 1]);
}

function removeItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Deletes every item in the table.
// TODO: Find out if this resets the AUTO_INCREMENT number.
function clear$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Does a simple `COUNT(key)` to get the number of items stored in
// localForage.
function length$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                // Ahhh, SQL makes this one soooooo easy.
                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
                    var result = results.rows.item(0).c;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Return the key located at key index X; essentially gets the key from a
// `WHERE id = ?`. This is the most efficient way I can think to implement
// this rarely-used (in my experience) part of the API, but it can seem
// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
// the ID of each key will change every time it's updated. Perhaps a stored
// procedure for the `setItem()` SQL would solve this problem?
// TODO: Don't change ID on `setItem()`.
function key$1(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
                    var keys = [];

                    for (var i = 0; i < results.rows.length; i++) {
                        keys.push(results.rows.item(i).key);
                    }

                    resolve(keys);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// https://www.w3.org/TR/webdatabase/#databases
// > There is no way to enumerate or delete the databases available for an origin from this API.
function getAllStoreNames(db) {
    return new Promise$1(function (resolve, reject) {
        db.transaction(function (t) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
                var storeNames = [];

                for (var i = 0; i < results.rows.length; i++) {
                    storeNames.push(results.rows.item(i).name);
                }

                resolve({
                    db: db,
                    storeNames: storeNames
                });
            }, function (t, error) {
                reject(error);
            });
        }, function (sqlError) {
            reject(sqlError);
        });
    });
}

function dropInstance$1(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            var db;
            if (options.name === currentConfig.name) {
                // use the db reference of the current instance
                db = self._dbInfo.db;
            } else {
                db = openDatabase(options.name, '', '', 0);
            }

            if (!options.storeName) {
                // drop all database tables
                resolve(getAllStoreNames(db));
            } else {
                resolve({
                    db: db,
                    storeNames: [options.storeName]
                });
            }
        }).then(function (operationInfo) {
            return new Promise$1(function (resolve, reject) {
                operationInfo.db.transaction(function (t) {
                    function dropTable(storeName) {
                        return new Promise$1(function (resolve, reject) {
                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
                                resolve();
                            }, function (t, error) {
                                reject(error);
                            });
                        });
                    }

                    var operations = [];
                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                        operations.push(dropTable(operationInfo.storeNames[i]));
                    }

                    Promise$1.all(operations).then(function () {
                        resolve();
                    })["catch"](function (e) {
                        reject(e);
                    });
                }, function (sqlError) {
                    reject(sqlError);
                });
            });
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var webSQLStorage = {
    _driver: 'webSQLStorage',
    _initStorage: _initStorage$1,
    _support: isWebSQLValid(),
    iterate: iterate$1,
    getItem: getItem$1,
    setItem: setItem$1,
    removeItem: removeItem$1,
    clear: clear$1,
    length: length$1,
    key: key$1,
    keys: keys$1,
    dropInstance: dropInstance$1
};

function isLocalStorageValid() {
    try {
        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
        // in IE8 typeof localStorage.setItem === 'object'
        !!localStorage.setItem;
    } catch (e) {
        return false;
    }
}

function _getKeyPrefix(options, defaultConfig) {
    var keyPrefix = options.name + '/';

    if (options.storeName !== defaultConfig.storeName) {
        keyPrefix += options.storeName + '/';
    }
    return keyPrefix;
}

// Check if localStorage throws when saving an item
function checkIfLocalStorageThrows() {
    var localStorageTestKey = '_localforage_support_test';

    try {
        localStorage.setItem(localStorageTestKey, true);
        localStorage.removeItem(localStorageTestKey);

        return false;
    } catch (e) {
        return true;
    }
}

// Check if localStorage is usable and allows to save an item
// This method checks if localStorage is usable in Safari Private Browsing
// mode, or in any other case where the available quota for localStorage
// is 0 and there wasn't any saved items yet.
function _isLocalStorageUsable() {
    return !checkIfLocalStorageThrows() || localStorage.length > 0;
}

// Config the localStorage backend, using options set in the config.
function _initStorage$2(options) {
    var self = this;
    var dbInfo = {};
    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

    if (!_isLocalStorageUsable()) {
        return Promise$1.reject();
    }

    self._dbInfo = dbInfo;
    dbInfo.serializer = localforageSerializer;

    return Promise$1.resolve();
}

// Remove all keys from the datastore, effectively destroying all data in
// the app's key/value store!
function clear$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var keyPrefix = self._dbInfo.keyPrefix;

        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);

            if (key.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key);
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Retrieve an item from the store. Unlike the original async_storage
// library in Gaia, we don't modify return values at all. If a key's value
// is `undefined`, we pass that value to the callback function.
function getItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result = localStorage.getItem(dbInfo.keyPrefix + key);

        // If a result was found, parse it from the serialized
        // string into a JS object. If result isn't truthy, the key
        // is likely undefined and we'll pass it straight to the
        // callback.
        if (result) {
            result = dbInfo.serializer.deserialize(result);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items in the store.
function iterate$2(iterator, callback) {
    var self = this;

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var keyPrefix = dbInfo.keyPrefix;
        var keyPrefixLength = keyPrefix.length;
        var length = localStorage.length;

        // We use a dedicated iterator instead of the `i` variable below
        // so other keys we fetch in localStorage aren't counted in
        // the `iterationNumber` argument passed to the `iterate()`
        // callback.
        //
        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
        var iterationNumber = 1;

        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key.indexOf(keyPrefix) !== 0) {
                continue;
            }
            var value = localStorage.getItem(key);

            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            if (value) {
                value = dbInfo.serializer.deserialize(value);
            }

            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

            if (value !== void 0) {
                return value;
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Same as localStorage's key() method, except takes a callback.
function key$2(n, callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result;
        try {
            result = localStorage.key(n);
        } catch (error) {
            result = null;
        }

        // Remove the prefix from the key, if a key is found.
        if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var length = localStorage.length;
        var keys = [];

        for (var i = 0; i < length; i++) {
            var itemKey = localStorage.key(i);
            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
            }
        }

        return keys;
    });

    executeCallback(promise, callback);
    return promise;
}

// Supply the number of keys in the datastore to the callback function.
function length$2(callback) {
    var self = this;
    var promise = self.keys().then(function (keys) {
        return keys.length;
    });

    executeCallback(promise, callback);
    return promise;
}

// Remove an item from the store, nice and simple.
function removeItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        localStorage.removeItem(dbInfo.keyPrefix + key);
    });

    executeCallback(promise, callback);
    return promise;
}

// Set a key's value and run an optional callback once the value is set.
// Unlike Gaia's implementation, the callback function is passed the value,
// in case you want to operate on that value only after you're sure it
// saved, or something like that.
function setItem$2(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        // Convert undefined values to null.
        // https://github.com/mozilla/localForage/pull/42
        if (value === undefined) {
            value = null;
        }

        // Save the original value to pass to the callback.
        var originalValue = value;

        return new Promise$1(function (resolve, reject) {
            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    try {
                        localStorage.setItem(dbInfo.keyPrefix + key, value);
                        resolve(originalValue);
                    } catch (e) {
                        // localStorage capacity exceeded.
                        // TODO: Make this a specific error/event.
                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            reject(e);
                        }
                        reject(e);
                    }
                }
            });
        });
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance$2(options, callback) {
    callback = getCallback.apply(this, arguments);

    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        var currentConfig = this.config();
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            if (!options.storeName) {
                resolve(options.name + '/');
            } else {
                resolve(_getKeyPrefix(options, self._defaultConfig));
            }
        }).then(function (keyPrefix) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
                var key = localStorage.key(i);

                if (key.indexOf(keyPrefix) === 0) {
                    localStorage.removeItem(key);
                }
            }
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var localStorageWrapper = {
    _driver: 'localStorageWrapper',
    _initStorage: _initStorage$2,
    _support: isLocalStorageValid(),
    iterate: iterate$2,
    getItem: getItem$2,
    setItem: setItem$2,
    removeItem: removeItem$2,
    clear: clear$2,
    length: length$2,
    key: key$2,
    keys: keys$2,
    dropInstance: dropInstance$2
};

var sameValue = function sameValue(x, y) {
    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
};

var includes = function includes(array, searchElement) {
    var len = array.length;
    var i = 0;
    while (i < len) {
        if (sameValue(array[i], searchElement)) {
            return true;
        }
        i++;
    }

    return false;
};

var isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};

// Drivers are stored here when `defineDriver()` is called.
// They are shared across all instances of localForage.
var DefinedDrivers = {};

var DriverSupport = {};

var DefaultDrivers = {
    INDEXEDDB: asyncStorage,
    WEBSQL: webSQLStorage,
    LOCALSTORAGE: localStorageWrapper
};

var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

var OptionalDriverMethods = ['dropInstance'];

var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

var DefaultConfig = {
    description: '',
    driver: DefaultDriverOrder.slice(),
    name: 'localforage',
    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
    // we can use without a prompt.
    size: 4980736,
    storeName: 'keyvaluepairs',
    version: 1.0
};

function callWhenReady(localForageInstance, libraryMethod) {
    localForageInstance[libraryMethod] = function () {
        var _args = arguments;
        return localForageInstance.ready().then(function () {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
        });
    };
}

function extend() {
    for (var i = 1; i < arguments.length; i++) {
        var arg = arguments[i];

        if (arg) {
            for (var _key in arg) {
                if (arg.hasOwnProperty(_key)) {
                    if (isArray(arg[_key])) {
                        arguments[0][_key] = arg[_key].slice();
                    } else {
                        arguments[0][_key] = arg[_key];
                    }
                }
            }
        }
    }

    return arguments[0];
}

var LocalForage = function () {
    function LocalForage(options) {
        _classCallCheck(this, LocalForage);

        for (var driverTypeKey in DefaultDrivers) {
            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                var driver = DefaultDrivers[driverTypeKey];
                var driverName = driver._driver;
                this[driverTypeKey] = driverName;

                if (!DefinedDrivers[driverName]) {
                    // we don't need to wait for the promise,
                    // since the default drivers can be defined
                    // in a blocking manner
                    this.defineDriver(driver);
                }
            }
        }

        this._defaultConfig = extend({}, DefaultConfig);
        this._config = extend({}, this._defaultConfig, options);
        this._driverSet = null;
        this._initDriver = null;
        this._ready = false;
        this._dbInfo = null;

        this._wrapLibraryMethodsWithReady();
        this.setDriver(this._config.driver)["catch"](function () {});
    }

    // Set any config values for localForage; can be called anytime before
    // the first API call (e.g. `getItem`, `setItem`).
    // We loop through options so we don't overwrite existing config
    // values.


    LocalForage.prototype.config = function config(options) {
        // If the options argument is an object, we use it to set values.
        // Otherwise, we return either a specified config value or all
        // config values.
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            // If localforage is ready and fully initialized, we can't set
            // any new configuration values. Instead, we return an error.
            if (this._ready) {
                return new Error("Can't call config() after localforage " + 'has been used.');
            }

            for (var i in options) {
                if (i === 'storeName') {
                    options[i] = options[i].replace(/\W/g, '_');
                }

                if (i === 'version' && typeof options[i] !== 'number') {
                    return new Error('Database version must be a number.');
                }

                this._config[i] = options[i];
            }

            // after all config options are set and
            // the driver option is used, try setting it
            if ('driver' in options && options.driver) {
                return this.setDriver(this._config.driver);
            }

            return true;
        } else if (typeof options === 'string') {
            return this._config[options];
        } else {
            return this._config;
        }
    };

    // Used to define a custom driver, shared across all instances of
    // localForage.


    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
        var promise = new Promise$1(function (resolve, reject) {
            try {
                var driverName = driverObject._driver;
                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

                // A driver name should be defined and not overlap with the
                // library-defined, default drivers.
                if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                }

                var driverMethods = LibraryMethods.concat('_initStorage');
                for (var i = 0, len = driverMethods.length; i < len; i++) {
                    var driverMethodName = driverMethods[i];

                    // when the property is there,
                    // it should be a method even when optional
                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                        reject(complianceError);
                        return;
                    }
                }

                var configureMissingMethods = function configureMissingMethods() {
                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                        return function () {
                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                            var promise = Promise$1.reject(error);
                            executeCallback(promise, arguments[arguments.length - 1]);
                            return promise;
                        };
                    };

                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                        var optionalDriverMethod = OptionalDriverMethods[_i];
                        if (!driverObject[optionalDriverMethod]) {
                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                        }
                    }
                };

                configureMissingMethods();

                var setDriverSupport = function setDriverSupport(support) {
                    if (DefinedDrivers[driverName]) {
                        console.info('Redefining LocalForage driver: ' + driverName);
                    }
                    DefinedDrivers[driverName] = driverObject;
                    DriverSupport[driverName] = support;
                    // don't use a then, so that we can define
                    // drivers that have simple _support methods
                    // in a blocking manner
                    resolve();
                };

                if ('_support' in driverObject) {
                    if (driverObject._support && typeof driverObject._support === 'function') {
                        driverObject._support().then(setDriverSupport, reject);
                    } else {
                        setDriverSupport(!!driverObject._support);
                    }
                } else {
                    setDriverSupport(true);
                }
            } catch (e) {
                reject(e);
            }
        });

        executeTwoCallbacks(promise, callback, errorCallback);
        return promise;
    };

    LocalForage.prototype.driver = function driver() {
        return this._driver || null;
    };

    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
        return getDriverPromise;
    };

    LocalForage.prototype.getSerializer = function getSerializer(callback) {
        var serializerPromise = Promise$1.resolve(localforageSerializer);
        executeTwoCallbacks(serializerPromise, callback);
        return serializerPromise;
    };

    LocalForage.prototype.ready = function ready(callback) {
        var self = this;

        var promise = self._driverSet.then(function () {
            if (self._ready === null) {
                self._ready = self._initDriver();
            }

            return self._ready;
        });

        executeTwoCallbacks(promise, callback, callback);
        return promise;
    };

    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
        var self = this;

        if (!isArray(drivers)) {
            drivers = [drivers];
        }

        var supportedDrivers = this._getSupportedDrivers(drivers);

        function setDriverToConfig() {
            self._config.driver = self.driver();
        }

        function extendSelfWithDriver(driver) {
            self._extend(driver);
            setDriverToConfig();

            self._ready = self._initStorage(self._config);
            return self._ready;
        }

        function initDriver(supportedDrivers) {
            return function () {
                var currentDriverIndex = 0;

                function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers.length) {
                        var driverName = supportedDrivers[currentDriverIndex];
                        currentDriverIndex++;

                        self._dbInfo = null;
                        self._ready = null;

                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }

                    setDriverToConfig();
                    var error = new Error('No available storage method found.');
                    self._driverSet = Promise$1.reject(error);
                    return self._driverSet;
                }

                return driverPromiseLoop();
            };
        }

        // There might be a driver initialization in progress
        // so wait for it to finish in order to avoid a possible
        // race condition to set _dbInfo
        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
            return Promise$1.resolve();
        }) : Promise$1.resolve();

        this._driverSet = oldDriverSetDone.then(function () {
            var driverName = supportedDrivers[0];
            self._dbInfo = null;
            self._ready = null;

            return self.getDriver(driverName).then(function (driver) {
                self._driver = driver._driver;
                setDriverToConfig();
                self._wrapLibraryMethodsWithReady();
                self._initDriver = initDriver(supportedDrivers);
            });
        })["catch"](function () {
            setDriverToConfig();
            var error = new Error('No available storage method found.');
            self._driverSet = Promise$1.reject(error);
            return self._driverSet;
        });

        executeTwoCallbacks(this._driverSet, callback, errorCallback);
        return this._driverSet;
    };

    LocalForage.prototype.supports = function supports(driverName) {
        return !!DriverSupport[driverName];
    };

    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
        extend(this, libraryMethodsAndProperties);
    };

    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
        var supportedDrivers = [];
        for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
                supportedDrivers.push(driverName);
            }
        }
        return supportedDrivers;
    };

    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
        // Add a stub for each driver API method that delays the call to the
        // corresponding driver method until localForage is ready. These stubs
        // will be replaced by the driver methods as soon as the driver is
        // loaded, so there is no performance impact.
        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
            callWhenReady(this, LibraryMethods[i]);
        }
    };

    LocalForage.prototype.createInstance = function createInstance(options) {
        return new LocalForage(options);
    };

    return LocalForage;
}();

// The actual localForage object that we expose as a module or via a
// global. It's extended by pulling in one of our other libraries.


var localforage_js = new LocalForage();

module.exports = localforage_js;

},{"3":3}]},{},[4])(4)
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "28S4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OLIGO_SUMMARY_BAR_MANAGER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OligoSummaryBarManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__oligo_summary_bar_manager_scss__ = __webpack_require__("RYtm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__oligo_summary_bar_manager_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__oligo_summary_bar_manager_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


function isElementInViewport(rect, $window, documentElement) {
    return rect.top >= 0 && rect.top <= ($window.innerHeight || documentElement.clientHeight);
}

var OligoSummaryBarManagerController = function OligoSummaryBarManagerController() {
    _classCallCheck(this, OligoSummaryBarManagerController);

    this.floatingBarVisible = true;
};

var OLIGO_SUMMARY_BAR_MANAGER_NAME = 'oligoSummaryBarManager';
var OligoSummaryBarManager = function OligoSummaryBarManager($document, $window, $compile) {
    return {
        template: __webpack_require__("pDM8"),
        controller: OligoSummaryBarManagerController,
        controllerAs: 'oligoSummaryManager',
        transclude: true,
        scope: {
            onCartStateChange: '&',
            cartProcessing: '<'
        },
        bindToController: true,
        link: function link($scope, element, attrs, ctrl) {
            var controller = ctrl;
            var document = $document[0];
            var documentElement = document.documentElement;
            var footerJQ = $document.find('.globalFooter .footer');
            if (footerJQ.length <= 0) {
                footerJQ = $document.find('.footer');
            }
            var footer = footerJQ[0];
            if (footer) {
                var oligoSummaryBarPermTemplate = '\n        <oligo-summary-bar class="oligo-summary-bar__permanent"\n                           cart-processing="oligoSummaryManager.cartProcessing"\n                           on-cart-state-change="oligoSummaryManager.onCartStateChange({state})">\n        </oligo-summary-bar>';
                var linkFn = $compile(oligoSummaryBarPermTemplate);
                var content = linkFn($scope);
                footerJQ.before(content);
                var summaryBarHeight = content[0].getBoundingClientRect().height;
                content.find('.loader-container').css('height', summaryBarHeight + 'px').css('top', '-' + summaryBarHeight + 'px');
                var hideFloatingBar = function hideFloatingBar() {
                    var footerRect = footer.getBoundingClientRect();
                    var footerVisible = isElementInViewport(footerRect, $window, documentElement);
                    $scope.$apply(function () {
                        controller.floatingBarVisible = !footerVisible;
                    });
                };
                var watchVerticalScroll = function () {
                    var lastScrollHeight = documentElement.scrollHeight;
                    return function () {
                        var newScrollHeight = documentElement.scrollHeight;
                        if (lastScrollHeight !== newScrollHeight) {
                            lastScrollHeight = newScrollHeight;
                            hideFloatingBar();
                        }
                    };
                }();
                var intervalId = $window.setInterval(watchVerticalScroll, 200);
                $document.on('scroll', hideFloatingBar);
                $window.addEventListener('resize', hideFloatingBar);
                $scope.$on('$destroy', function () {
                    $document.off('scroll', hideFloatingBar);
                    $window.removeEventListener('resize', hideFloatingBar);
                    $window.clearInterval(intervalId);
                });
            }
        }
    };
};

/***/ }),

/***/ "2iCl":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-35Thin.woff";

/***/ }),

/***/ "2ojO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ANALYTICS_SERVICE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AnalyticsServiceFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__("lsdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__("PTRJ");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BulkUploadAnalyticsE;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function createEvent(eventType, params) {
    var event = null;
    if (Object(__WEBPACK_IMPORTED_MODULE_1__components_common__["a" /* isIE */])()) {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventType, true, true, params);
    } else {
        event = new CustomEvent(eventType, {
            detail: params
        });
    }
    return event;
}
var BulkUploadAnalyticsEventScopeMap = (_BulkUploadAnalyticsE = {}, _defineProperty(_BulkUploadAnalyticsE, __WEBPACK_IMPORTED_MODULE_0__models__["k" /* ScopeEvents */].BULK_UPLOAD_SHOW, 'bulktool: Bulk Upload'), _defineProperty(_BulkUploadAnalyticsE, __WEBPACK_IMPORTED_MODULE_0__models__["k" /* ScopeEvents */].BULK_UPLOAD_IMPORT, 'bulktool: Import'), _BulkUploadAnalyticsE);

var AnalyticsServiceImpl = function () {
    function AnalyticsServiceImpl($window, $document) {
        _classCallCheck(this, AnalyticsServiceImpl);

        this.$window = $window;
        this.$document = $document;
    }

    _createClass(AnalyticsServiceImpl, [{
        key: 'bootstrap',
        value: function bootstrap($scope) {
            var $window = this.$window,
                $document = this.$document;
            var window = $window.window;
            var digitalData = window.digitalData;

            if (!digitalData) {
                return;
            }
            var page = digitalData.page;

            if (!page) {
                return;
            }
            var toolName = 'Custom Standard DNA Oligos';
            page.type = 'product tool';
            page.toolName = toolName;
            $scope.$on(__WEBPACK_IMPORTED_MODULE_0__models__["k" /* ScopeEvents */].CART_ADD, function (event, projects, sku) {
                var allOligos = projects.reduce(function (acc, next) {
                    return [].concat(_toConsumableArray(acc), _toConsumableArray(next.oligos || []));
                }, []);
                var analyticsCartItems = allOligos.map(function (oligo) {
                    var pricing = oligo.pricing;

                    var quantity = 1;
                    return {
                        addMethod: '',
                        categoryId: '',
                        categoryName: toolName,
                        catalogNumber: sku,
                        designId: sku,
                        title: toolName,
                        lineName: 'invitrogen',
                        uom: 'EA',
                        quantity: '' + quantity,
                        price: pricing && pricing.available ? '' + pricing.amount.toFixed(2) : ''
                    };
                });
                var cartAddAnalyticsEventItem = { products: analyticsCartItems };
                $document.get(0).dispatchEvent(createEvent('cartAdd', cartAddAnalyticsEventItem));
            });
            Object.keys(BulkUploadAnalyticsEventScopeMap).forEach(function (scopeEventKey) {
                $scope.$on(scopeEventKey, function () {
                    var bulkUploadAnalyticsEventItem = {
                        CustomLink: {
                            linkName: BulkUploadAnalyticsEventScopeMap[scopeEventKey]
                        }
                    };
                    $document.get(0).dispatchEvent(createEvent('customLinkClicks', bulkUploadAnalyticsEventItem));
                });
            });
        }
    }]);

    return AnalyticsServiceImpl;
}();

var ANALYTICS_SERVICE_NAME = 'analyticsService';
var AnalyticsServiceFactory = function AnalyticsServiceFactory($window, $document) {
    return new AnalyticsServiceImpl($window, $document);
};

/***/ }),

/***/ "2p1q":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("lDLk");
var createDesc = __webpack_require__("fU25");
module.exports = __webpack_require__("bUqO") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "3FiO":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-35Thin.woff2";

/***/ }),

/***/ "3u5d":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-45Light.svg";

/***/ }),

/***/ "49qz":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("oeih");
var defined = __webpack_require__("/whu");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "4fv2":
/***/ (function(module, exports) {

module.exports = "../fonts/n-a.eot";

/***/ }),

/***/ "4lrW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5he4":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-55Roman.svg";

/***/ }),

/***/ "6TBy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6fib":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-35Thin.ttf";

/***/ }),

/***/ "72SL":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-75Bold.ttf";

/***/ }),

/***/ "7YZo":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-45Light.woff2";

/***/ }),

/***/ "7ctU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7gX0":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "7mlz":
/***/ (function(module, exports) {

!function(e){var n={};function t(o){if(n[o])return n[o].exports;var i=n[o]={i:o,l:!1,exports:{}};return e[o].call(i.exports,i,i.exports,t),i.l=!0,i.exports}t.m=e,t.c=n,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:o})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(t.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var i in e)t.d(o,i,function(n){return e[n]}.bind(null,i));return o},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=14)}([function(e,n){e.exports='<div class="sequence-textbox" ng-click="sequenceTextbox.showInputBox(true)" ng-class="{ \'invalid\': sequenceTextbox.showError }">\r\n  <div class="sequence-textbox__placeholder"\r\n       id="sequence-placeholder" \r\n       ng-hide="sequenceTextbox.sequence.length > 0"\r\n       ng-click="sequenceTextbox.hideInputPlaceholder()">{{ sequenceTextbox.displayPlaceholder }}\r\n  </div>\r\n  <div class="sequence-textbox__container">\r\n    <div contenteditable="true"\r\n         id="sequence-textbox"\r\n         class="sequence-textbox__content"\r\n         ng-show="!sequenceTextbox.validateSequence || sequenceTextbox.shouldShowInputBox"\r\n         ng-model="sequenceTextbox.sequence"\r\n         ng-blur="sequenceTextbox.formatSequenceBlock()"\r\n         ng-keydown="sequenceTextbox.preventNonAllowableKeys($event)"\r\n         ng-paste="sequenceTextbox.preventFormattedData($event)">\r\n    </div>\r\n    <div class="sequence-textbox__content"\r\n         ng-hide="!sequenceTextbox.validateSequence || sequenceTextbox.shouldShowInputBox">\r\n      <span class="sequence-textbox__block"\r\n            ng-repeat="block in sequenceTextbox.sequenceBlock track by $index"\r\n            ng-bind-html="block">\r\n      </span>\r\n    </div>\r\n  </div>\r\n</div>\r\n'},function(e,n,t){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.detectEllipsisOnTextOverflow=function(){return{restrict:"A",scope:{detectEllipsisOnTextOverflow:"@"},link:function(e,n){n.on("mouseenter",function(){n[0].offsetHeight<n[0].scrollHeight-1&&(n[0].title=e.detectEllipsisOnTextOverflow)}),n.on("mouseleave",function(){n[0].offsetHeight<n[0].scrollHeight-1&&(n[0].title=e.detectEllipsisOnTextOverflow)})}}}},function(e,n){e.exports='<div class="mbp__container">\r\n  <div class="mbp__header">\r\n      <h4 class="mbp__title">{{mixBasesPanel.header}}</h4>\r\n    <span class="mbp__disclaimertips">\r\n      <p class="mbp__tips">{{mixBasesPanel.description}}</p>\r\n    </span>\r\n    <button class="close_btn" ng-click="mixBasesPanel.onClose()">&times;</button>\r\n  </div>\r\n  <div class="mbp__baseContainer">\r\n    <div  class="mbp__bases">\r\n      <div ng-repeat="base in mixBasesPanel.bases" class="mbp__base">\r\n        <mix-bases-input base="base" />\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>'},function(e,n,t){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(){};n.MixBasesPanelController=o,n.MixBasesPanel={template:t(2),controller:o,controllerAs:"mixBasesPanel",bindings:{header:"@",description:"@",bases:"<",onClose:"&"}}},function(e,n){e.exports='<div class="mbi__container">\r\n  <p class="mbi__title">{{mixBasesInput.base.name}}</p>\r\n  <button class="mbi__btn" ng-click="mixBasesInput.onSymbolClick(mixBasesInput.base.value)">\r\n    {{mixBasesInput.base.value}}\r\n  </button>\r\n</div>\r\n'},function(e,n,t){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(){function e(e){this.$scope=e}return e.prototype.onSymbolClick=function(e){this.$scope.$emit("mix-base-selected",e)},e}();n.MixBasesInputController=o,o.$inject=["$scope"],n.MixBasesInput={template:t(4),controller:o,controllerAs:"mixBasesInput",bindings:{base:"<"}}},function(e,n,t){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(){function e(e){var n=this;this.validateBasePair=function(e){var t=function(n){return n.toUpperCase()===e.toUpperCase()},o=n.whitelist.filter(function(e){return n.baselist.indexOf(e.toUpperCase())<0}).filter(t).length,i=n.baselist.filter(t).length;return o>0?'<span class="sequence-textbox__basePair--bold">'+e+"</span>":i<=0?(n.invalidList.push(e),'<span class="sequence-textbox__basePair--invalid">'+e+"</span>"):"<span>"+e+"</span>"},this.showInputBox=function(e){},this.hideInputPlaceholder=function(){n.displayPlaceholder=""},this.sequenceOnChange=function(){n.sequence?n.displayPlaceholder="":n.displayPlaceholder=n.placeholder,n.$scope.$emit(n.sequenceId+"-onChange",n.sequence)},this.formatSequenceBlock=function(){if(n.sequence&&(n.sequence=n.sequence.replace(/\<.*?\>/g,""),n.sequence=n.sequence.trim()),n.$scope.$emit(n.sequenceId,n.sequence),n.validateSequence){if(n.invalidMin=!1,n.invalidMax=!1,n.invalidList=[],n.sequence){n.sequence=n.sequence.replace(/\s/g,""),n.sequenceBlock=[];for(var e="",t=0,o="",i=!1,r=0,s=0,c=0;c<n.sequence.length;c++){var l=n.sequence[c];"["===l?(r++,i||(o=""),i=!0):"]"===l&&r===++s&&(i=!1),o+=l,i&&c===n.sequence.length-1&&(i=!1),i||(t%n.blockNum==0&&0!==c&&(n.sequenceBlock.push(e),e=""),e+=n.validateBasePair(o),t+=1,o="")}n.sequenceBlock.push(e),n.minLength&&t<n.minLength&&(n.invalidMin=!0),n.maxLength&&t>n.maxLength&&(n.invalidMax=!0)}else n.sequenceBlock=[];n.err={invalidLength:{min:n.invalidMin,max:n.invalidMax},invalidList:n.invalidList.filter(function(e,n,t){return t.indexOf(e)===n})},n.showInputBox(!1)}},this.sequenceBlock=[],this.shouldShowInputBox=!1,this.baselist=["A","C","G","T"],this.invalidMin=!1,this.invalidMax=!1,this.invalidList=[],this.$scope=e,this.displayPlaceholder=this.placeholder,e.$watch(function(){return n.text},function(e){n.sequence=e,n.formatSequenceBlock()}),e.$watch(function(){return n.sequence},function(){n.sequenceOnChange()}),e.$watch(function(){return{whiteList:n.whitelist,blockNum:n.blockNum,minLength:n.minLength,maxLength:n.maxLength}},function(){n.formatSequenceBlock()},!0)}return e.prototype.preventNonAllowableKeys=function(e){if(this.disable)return e.preventDefault(),void e.stopPropagation();var n=e.which,t=e.target;switch(n){case 13:e.preventDefault(),e.stopPropagation(),t.blur()}},e.prototype.preventFormattedData=function(e){try{e.preventDefault(),e.stopPropagation();var n="",t=e.originalEvent||e;if(t.clipboardData)n=t.clipboardData.getData("text/plain"),this.text=n,document.execCommand("insertHTML",!1,n);else if(window.clipboardData){this.text=n,n=window.clipboardData.getData("text"),this.text=n;var o=window.getSelection();if(!o.rangeCount)return;o.getRangeAt(0).insertNode(document.createTextNode(n))}}catch(e){console.error(e)}},e}();n.SequenceTextboxController=o,o.$inject=["$scope"];n.SequenceTextBoxFactory=function(e,n){return{template:t(0),controller:o,controllerAs:"sequenceTextbox",scope:{title:"@",placeholder:"@",blockNum:"<",minLength:"<",maxLength:"<",whitelist:"<",err:"=",sequenceId:"@",text:"<",validateSequence:"<",onFocus:"&",onBlur:"&",disable:"<",showError:"<"},bindToController:!0,replace:!1,link:function(t,o,i,r){var s=n[0].body,c=o[0],l=c.querySelector(".sequence-textbox__container"),a=c.querySelector(".sequence-textbox__content"),u=r,d=!1,p=function(){d=!0},f=function(){u.onBlur&&u.onBlur({id:u.sequenceId}),d=!1},b=function(e){u.shouldShowInputBox?a.focus():t.$$phase?u.showInputBox(!0):t.$apply(function(){return u.showInputBox(!0)})},h=function(){u.onFocus&&u.onFocus({id:u.sequenceId}),d||function(e,n){var t,o,i=n.textContent;!i||i.length<=0||(e.createTextRange?((t=e.createTextRange()).moveToElementText(n),t.select()):window.getSelection&&(o=window.getSelection(),(t=document.createRange()).selectNodeContents(n),o.removeAllRanges(),o.addRange(t)))}(s,a)};a.addEventListener("focus",h),a.addEventListener("blur",f),[c,l].forEach(function(e){e.addEventListener("focus",b)}),[c,a].forEach(function(e){e.addEventListener("mousedown",p)}),t.$on("$destroy",function(){a.removeEventListener("focus",h),a.removeEventListener("blur",f),[c,l].forEach(function(e){e.removeEventListener("focus",b)}),[c,a].forEach(function(e){e.removeEventListener("mousedown",p)})}),u.showInputBox=function(n){!u.shouldShowInputBox&&n&&e(function(){a.focus()},0),u.shouldShowInputBox=n}}}},n.SequenceTextBoxFactory.$inject=["$timeout","$document"],n.SequenceTextbox={template:t(0),controller:o,controllerAs:"sequenceTextbox",bindings:{title:"@",placeholder:"@",blockNum:"<",minLength:"<",maxLength:"<",whitelist:"<",err:"=",sequenceId:"@",text:"<",validateSequence:"<",onFocus:"&",onBlur:"&",disable:"<",showError:"<"}}},function(e,n,t){"use strict";function o(e){for(var t in e)n.hasOwnProperty(t)||(n[t]=e[t])}Object.defineProperty(n,"__esModule",{value:!0}),o(t(6)),o(t(5)),o(t(3))},function(e,n){e.exports='<div class="dropdown_label_btn">\r\n  <div class="oligo-and-researcher-name-label-box" tabindex="-1">\r\n    <span class="oligo-and-researcher-name"> {{richDropdown.dropdownTopic}} </span>\r\n    <span class="oligo-hint">\r\n      <span class="oligo-hint-icon" ng-if="richDropdown.hintUrl" ng-click="richDropdown.openInWindow($event)" tabindex="-1">\r\n        <em class="icon-16-question-mono"></em>\r\n      </span>\r\n    </span>\r\n  </div>\r\n  <div class="dropdown-btn" ng-class="{ \'dropdown-btn__disabled\': richDropdown.disabled }"\r\n    ng-click="richDropdown.toggleDropdown()" tabindex="-1">\r\n    <span class="dropdown-btn__indicator"></span>\r\n    <div class="dropdown-btn__drop-area">\r\n      <div class="dropdown-btn__text-area" tabindex="-1">\r\n        <div class="dropdown-btn__selection">{{richDropdown.selectedTitle}}</div>\r\n      </div>\r\n      <div class="dropdown-arrow" tabindex="-1">&#9662;</div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div>\r\n  <div class="dropdown-content" ng-if="richDropdown.isOpen" tabindex="-1">\r\n    <div class="dropdown-option-items">\r\n      <div ng-repeat="opt in richDropdown.options">\r\n        <div class="dropdown-option"\r\n          ng-class="{ \'dropdown-option__disabled\': opt.disabled, \'dropdown-option__selected\': opt.selected }"\r\n          ng-click="richDropdown.select($event, opt)" ng-disabled="opt.disabled">\r\n          <div class="dropdown-option__item">\r\n            <div class="dropdown-option__title">{{opt.title}}</div>\r\n            <div class="dropdown-option__description">{{opt.description}}</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>'},function(e,n,t){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var o=function(){function e(e){this.$window=e,this.isOpen=!1}return e.prototype.toggleDropdown=function(){this.dropdownObj.disabled||(this.isOpen=!this.isOpen)},e.prototype.select=function(e,n){n.disabled?e.stopPropagation():(this.dropdownObj.setSelected(n),this.closeDropdown())},e.prototype.closeDropdown=function(){this.isOpen=!1},e.prototype.openInWindow=function(e){if(this.hintUrl){e.stopPropagation();var n=this.$window.open(this.hintUrl,"DropdownInfo",this.hintOptions||"width=500,height=500,alwaysRaised,scrollbars");n.closed||n.focus()}},Object.defineProperty(e.prototype,"dropdownTopic",{get:function(){return this.dropdownObj.topic},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"selectedTitle",{get:function(){return this.dropdownObj.selected.title},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"options",{get:function(){return this.dropdownObj.options},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"disabled",{get:function(){return this.dropdownObj.disabled},enumerable:!0,configurable:!0}),e}();n.RichDropdownController=o,n.richDropdown=function(e,n){return{controller:o,controllerAs:"richDropdown",transclude:!1,bindToController:!0,template:t(8),replace:!1,link:function(t,o,i,r){var s=function(){t.$apply(function(){return r.closeDropdown()})};t.$on("$destroy",function(){n.off("click",s)}),t.$watch(function(){return r.isOpen},function(t){t?e(function(){var e=o[0].querySelector(".dropdown-content"),t=e.getBoundingClientRect(),i=n[0].body.getBoundingClientRect(),r=t.bottom-i.bottom,c=i.bottom-t.top;e.style.height=r>0?c+"px":null,n.on("click",s)}):n.off("click",s)})},scope:{dropdownObj:"<",hintUrl:"<",hintOptions:"<"}}},o.$inject=["$window"],n.richDropdown.$inject=["$timeout","$document","$window"]},function(e,n,t){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.autoFocus=function(e){return{restrict:"A",link:function(n,t,o){o.ngShow&&n.$watch(o.ngShow,function(n){n&&e(function(){t[0].focus()},0)}),o.ngHide&&n.$watch(o.ngHide,function(n){n||e(function(){t[0].focus()},0)})}}},n.autoFocus.$inject=["$timeout"]},function(e,n,t){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.contenteditable=function(e){return{restrict:"A",require:"?ngModel",link:function(n,t,o,i){if(i){i.$render=function(){t.html(e.getTrustedHtml(i.$viewValue||""))},t.on("blur keyup change",function(){n.$evalAsync(r)});var r=function(){i.$setViewValue(t.text())};r()}}}},n.contenteditable.$inject=["$sce"]},function(e,n,t){"use strict";function o(e){for(var t in e)n.hasOwnProperty(t)||(n[t]=e[t])}Object.defineProperty(n,"__esModule",{value:!0}),o(t(11)),o(t(10)),o(t(9)),o(t(1))},function(e,n){e.exports=angular},function(e,n,t){"use strict";var o=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var n={};if(null!=e)for(var t in e)Object.hasOwnProperty.call(e,t)&&(n[t]=e[t]);return n.default=e,n};Object.defineProperty(n,"__esModule",{value:!0}),t(18);var i=o(t(13)),r=t(12),s=t(7),c=t(1);n.default=void i.module("custom-components",[]).directive("contenteditable",r.contenteditable).directive("autoFocus",r.autoFocus).directive("detectEllipsisOnTextOverflow",c.detectEllipsisOnTextOverflow).directive("sequenceTextbox",s.SequenceTextBoxFactory).component("mixBasesInput",s.MixBasesInput).component("mixBasesPanel",s.MixBasesPanel).directive("richDropdown",r.richDropdown)},,,,function(e,n){}]);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "7q5I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7wMu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CardDetailController; });
/* unused harmony export CARD_DETAIL_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card_detail_scss__ = __webpack_require__("pA9T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card_detail_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__card_detail_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_i18n__ = __webpack_require__("BOQq");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var CardDetailController = function CardDetailController($scope, $ngRedux) {
    var _this = this;

    _classCallCheck(this, CardDetailController);

    this.supportUrl = 'OligoInquiries@thermofisher.com';
    this.plateOligoCardText = 'Custom oligos are also available in multi-well plates.\n  Orders of at least 24 oligos can be delivered in 96-well plates and at least 192 oligos in 384-well plates.';
    this.valueOligoCardText = 'For simple, non-modified Oligos consider our';
    this.supportCardText = 'Our Oligo Inquiries team is here should you have questions or require assistance placing your order. Please contact our technical team at';
    this.plateOligoLinkText = 'Plate Oligos ordering tool';
    this.valueOligoLinkText = 'Value Oligos';
    this.supportLinkText = 'OligoInquiries@thermofisher.com';
    this.plateOligoUrl = '/store/v2/oligos-dna';
    this.mapStateToThis = function (state) {
        var world = state.world;
        var appState = world.appState,
            vocabulary = world.vocabulary;

        _this.plateOligoCardText = vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].APP_PLATE_OLIGO_CARD_TEXT] || _this.plateOligoCardText;
        _this.valueOligoCardText = vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].APP_VALUE_OLIGO_CARD_TEXT] || _this.valueOligoCardText;
        _this.supportCardText = vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].APP_SUPPORT_CARD_TEXT] || _this.supportCardText;
        _this.plateOligoLinkText = vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].APP_PLATE_OLIGO_CARD_LINK_TEXT] || _this.plateOligoLinkText;
        _this.valueOligoLinkText = vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].APP_VALUE_OLIGO_CARD_LINK_TEXT] || _this.valueOligoLinkText;
        _this.supportUrl = vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].APP_SUPPORT_EMAIL] || _this.supportUrl;
        _this.supportLinkText = vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].APP_SUPPORT_EMAIL] || _this.supportLinkText;
        _this.plateOligoUrl = _this.urlPath || _this.plateOligoUrl;
        if (_this.supportLinkText.includes('mailto:')) {
            _this.supportLinkText = _this.supportLinkText.replace('mailto:', '');
        }
        return {
            appState: appState,
            vocabulary: vocabulary
        };
    };
    var unsubscribeRedux = $ngRedux.connect(this.mapStateToThis.bind(this))(this);
    $scope.$on('$destroy', function () {
        unsubscribeRedux();
    });
};
var CARD_DETAIL_NAME = 'cardDetail';
var CardDetail = function CardDetail($timeout, $document, $window) {
    return {
        template: __webpack_require__("/a58"),
        controller: CardDetailController,
        controllerAs: 'cardDetail',
        restrict: 'E',
        bindToController: true,
        transclude: true,
        scope: {
            urlPath: '<'
        },
        link: function link(ctrl) {
            var controller = ctrl;
            var urlPath = controller.urlPath;
        }
    };
};

/***/ }),

/***/ "7ylX":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("DIVP");
var dPs = __webpack_require__("twxM");
var enumBugKeys = __webpack_require__("QKXm");
var IE_PROTO = __webpack_require__("mZON")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("jhxf")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("d075").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "8aOi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8e5k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "93wI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9cxE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9l6V":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/app/img/oligo-label-sample.png";

/***/ }),

/***/ "9vb1":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("bN1p");
var ITERATOR = __webpack_require__("kkCw")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "A0Jf":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-56Italic.ttf";

/***/ }),

/***/ "A2Ll":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AFu3":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+XqU");
module.exports = 'ngSanitize';


/***/ }),

/***/ "B0C/":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-56Italic.woff";

/***/ }),

/***/ "B4Cs":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1A13");
__webpack_require__("beEN");
module.exports = __webpack_require__("7gX0").Array.from;


/***/ }),

/***/ "BOQq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DictionaryKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PlaceHolderKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return replacePlaceHolders; });
var DictionaryKeys = {
    APP_HEADER_TITLE: 'APP_HEADER_TITLE',
    APP_HEADER_DESC: 'APP_HEADER_DESC',
    APP_HEADER_BULK_UPLOAD_BUTTON: 'APP_HEADER_BULK_UPLOAD_BUTTON',
    APP_FOOTER_ADD_PROJECT_BUTTON: 'APP_FOOTER_ADD_PROJECT_BUTTON',
    APP_FOOTER_ADD_PROJECT_EXCEED_MAX_OLIGO_HINT: 'APP_FOOTER_ADD_PROJECT_EXCEED_MAX_OLIGO_HINT',
    APP_FOOTER_ADD_TO_CART_BUTTON: 'APP_FOOTER_ADD_TO_CART_BUTTON',
    APP_FOOTER_ADD_TO_CART_EXCEED_MAX_OLIGO_HINT: 'APP_FOOTER_ADD_TO_CART_EXCEED_MAX_OLIGO_HINT',
    APP_FOOTER_ADD_TO_CART_INVALID_OLIGO_HINT: 'APP_FOOTER_ADD_TO_CART_INVALID_OLIGO_HINT',
    APP_FOOTER_TOTAL_PRICE_TITLE: 'APP_FOOTER_TOTAL_PRICE_TITLE',
    APP_FOOTER_OLIGO_COUNT_TITLE: 'APP_FOOTER_OLIGO_COUNT_TITLE',
    APP_PLATE_OLIGO_CARD_TEXT: 'APP_PLATE_OLIGO_CARD_TEXT',
    APP_VALUE_OLIGO_CARD_TEXT: 'APP_VALUE_OLIGO_CARD_CONTENT',
    APP_SUPPORT_CARD_TEXT: 'APP_SUPPORT_CARD_TEXT',
    APP_PLATE_OLIGO_CARD_LINK_TEXT: 'APP_PLATE_OLIGO_CARD_LINK_TEXT',
    APP_VALUE_OLIGO_CARD_LINK_TEXT: 'APP_VALUE_OLIGO_CARD_LINK_TEXT',
    CONFIG_SAMPLE_LABEL_LINK_TEXT: 'CONFIG_SAMPLE_LABEL_LINK_TEXT',
    CONFIG_MIXED_BASED_LINK_TEXT: 'CONFIG_MIXED_BASED_LINK_TEXT',
    CONFIG_SHOW_MORE_OPTION_LINK_TEXT: 'CONFIG_SHOW_MORE_OPTION_LINK_TEXT',
    CONFIG_SHOW_LESS_OPTION_LINK_TEXT: 'CONFIG_SHOW_LESS_OPTION_LINK_TEXT',
    CONFIG_COLLAPSED_UNNANMED_OLIGO: 'CONFIG_COLLAPSED_UNNANMED_OLIGO',
    CONFIG_COLLAPSED_UNNANMED_RESEARCHER: 'CONFIG_COLLAPSED_UNNANMED_RESEARCHER',
    CONFIG_COLLAPSED_SEQUENCE: 'CONFIG_COLLAPSED_SEQUENCE',
    CONFIG_COLLAPSED_EMPTY_SEQUENCE: 'CONFIG_COLLAPSED_EMPTY_SEQUENCE',
    CONFIG_BASE_COUNT: 'CONFIG_BASE_COUNT',
    CONFIG_MIN_YIELD: 'CONFIG_MIN_YIELD',
    CONFIG_PRICE_TITLE: 'CONFIG_PRICE_TITLE',
    CONFIG_PRICE_DESC: 'CONFIG_PRICE_DESC',
    PROJECT_HEADER_TITLE: 'PROJECT_HEADER_TITLE',
    PROJECT_HEADER_PREFERENCE_BUTTON: 'PROJECT_HEADER_PREFERENCE_BUTTON',
    PROJECT_FOOTER_ADD_OLIGO_BUTTON: 'PROJECT_FOOTER_ADD_OLIGO_BUTTON',
    PROJECT_FOOTER_ADD_OLIGO_EXCEED_MAX_OLIGO_HINT: 'PROJECT_FOOTER_ADD_OLIGO_EXCEED_MAX_OLIGO_HINT',
    PROJECT_DELETE_POPOVER_TITLE: 'PROJECT_DELETE_POPOVER_TITLE',
    PROJECT_DELETE_POPOVER_DESC: 'PROJECT_DELETE_POPOVER_DESC',
    PROJECT_DELETE_POPOVER_OK_BUTTON: 'PROJECT_DELETE_POPOVER_OK_BUTTON',
    PROJECT_DELETE_POPOVER_CANCEL_BUTTON: 'PROJECT_DELETE_POPOVER_CANCEL_BUTTON',
    PROJECT_PREFERENCE_POPOVER_TITLE: 'PROJECT_PREFERENCE_POPOVER_TITLE',
    PROJECT_PREFERENCE_POPOVER_APPLY_BUTTON: 'PROJECT_PREFERENCE_POPOVER_APPLY_BUTTON',
    PROJECT_OLIGO_IMPORT_MODAL_TITLE: 'PROJECT_OLIGO_IMPORT_MODAL_TITLE',
    PROJECT_OLIGO_IMPORT_MODAL_OK_BUTTON: 'PROJECT_OLIGO_IMPORT_MODAL_OK_BUTTON',
    PROJECT_OLIGO_IMPORT_MODAL_CANCEL_BUTTON: 'PROJECT_OLIGO_IMPORT_MODAL_CANCEL_BUTTON',
    PROJECT_OLIGO_IMPORT_MODAL_DOWNLOAD_TEMPLATE_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_DOWNLOAD_TEMPLATE_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_UPLOAD_FILE_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_UPLOAD_FILE_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_ERROR_ACCEPT_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_ERROR_ACCEPT_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_SHOW_PREFERENCES_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_SHOW_PREFERENCES_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_HIDE_PREFERENCES_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_HIDE_PREFERENCES_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_DRAG_AREA_INSTRUCTIONS: 'PROJECT_OLIGO_IMPORT_MODAL_DRAG_AREA_INSTRUCTIONS',
    PROJECT_OLIGO_IMPORT_MODAL_TOP_LEVEL_INSTRUCTIONS: 'PROJECT_OLIGO_IMPORT_MODAL_TOP_LEVEL_INSTRUCTIONS',
    PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_MAX_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_MAX_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_OLIGO_SAMPLE_DATA_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_OLIGO_SAMPLE_DATA_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_OLIGO_PREFERENCE_HINT_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_OLIGO_PREFERENCE_HINT_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_MAX_REACHED_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_MAX_REACHED_TEXT',
    PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EMPTY_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EMPTY_TEXT',
    PROJECT_OLIGO_IMPORT_MODAL_MULTIPLE_FILES_UNSUPPORTED_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_MULTIPLE_FILES_UNSUPPORTED_TEXT',
    PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EXTENSION_UNSUPPORTED_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EXTENSION_UNSUPPORTED_TEXT',
    PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_TEXT',
    PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_OK_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_OK_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_CANCEL_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_CANCEL_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_OK_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_OK_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_CANCEL_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_CANCEL_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_TEXT',
    PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_MISSING_REQUIRED_ONLY_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_MISSING_REQUIRED_ONLY_TEXT',
    PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_CONFIG_INCORRECT_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_CONFIG_INCORRECT_TEXT',
    PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_TEXT',
    PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_MISSING_REQUIRED_ONLY_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_MISSING_REQUIRED_ONLY_TEXT',
    PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_CONFIG_INCORRECT_ONLY_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_CONFIG_INCORRECT_ONLY_TEXT',
    PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ERROR_REGION_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ERROR_REGION_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_OK_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_OK_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_CANCEL_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_CANCEL_LABEL',
    PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_TEXT',
    CONFIG_OLIGO_DELETE_POPOVER_TITLE: 'CONFIG_OLIGO_DELETE_POPOVER_TITLE',
    CONFIG_OLIGO_DELETE_POPOVER_DESC: 'CONFIG_OLIGO_DELETE_POPOVER_DESC',
    CONFIG_OLIGO_DELETE_POPOVER_OK_BUTTON: 'CONFIG_OLIGO_DELETE_POPOVER_OK_BUTTON',
    CONFIG_OLIGO_DELETE_POPOVER_CANCEL_BUTTON: 'CONFIG_OLIGO_DELETE_POPOVER_CANCEL_BUTTON',
    CONFIG_TAT_SHIP_BY: 'CONFIG_TAT_SHIPBY',
    CONFIG_TAT_CUTOFF: 'CONFIG_TAT_COUNTDOWN',
    CONFIG_SCROLL_TO_VIEW_TEXT: 'CONFIG_SCROLL_TO_VIEW_TEXT',
    LOADING_RETRIEVE_PRICE_DESC: 'LOADING_RETRIEVE_PRICE_DESC',
    LOADING_VALIDATE_CONFIG_DESC: 'LOADING_VALIDATE_CONFIG_DESC',
    MSG_INVALID_BASES: 'CONFIG_OLIGO_INVALID_BASE_PAIR',
    MSG_MIN_SEQ: 'MSG_MIN_SEQ',
    MSG_MAX_SEQ: 'MSG_MAX_SEQ',
    MIXED_BASE_POPOVER_OK_LABEL: 'MIXED_BASE_POPOVER_OK',
    MIXED_BASE_POPOVER_TITLE: 'MIXED_BASE_POPOVER_TITLE',
    MIXED_BASE_POPOVER_DESC: 'MIXED_BASE_POPOVER_DESC',
    MIXED_BASE_POPOVER_DISCLAIMER_TITLE: 'MIXED_BASE_POPOVER_DISCLAIMER_TITLE',
    MIXED_BASE_POPOVER_DISCLAIMER_TPL: 'MIXED_BASE_POPOVER_DISCLAIMER_TPL',
    MIXED_BASE_PANEL_DISCLAIMER_LABEL: 'MIXED_BASE_PANEL_DISCLAIMER_LABEL',
    TEMPLATE_COL_HEADER_OLIGO_NAME: 'TEMPLATE_COL_HEADER_OLIGO_NAME',
    TEMPLATE_COL_HEADER_OLIGO_SEQUENCE: 'TEMPLATE_COL_HEADER_OLIGO_SEQUENCE',
    TEMPLATE_COL_HEADER_RESEARCHER_NAME: 'TEMPLATE_COL_HEADER_RESEARCHER_NAME',
    TEMPLATE_COL_HEADER_SCALE: 'TEMPLATE_COL_HEADER_SCALE',
    TEMPLATE_COL_HEADER_PRIME_5_MOD: 'TEMPLATE_COL_HEADER_PRIME_5_MOD',
    TEMPLATE_COL_HEADER_PRIME_3_MOD: 'TEMPLATE_COL_HEADER_PRIME_3_MOD',
    TEMPLATE_COL_HEADER_PURIFICATION: 'TEMPLATE_COL_HEADER_PURIFICATION',
    TEMPLATE_COL_HEADER_SPECIAL_HANDLING: 'TEMPLATE_COL_HEADER_SPECIAL_HANDLING',
    ERROR_MISSING_REQUIRED_GENERIC_MESSAGE: 'ERROR_MISSING_REQUIRED_GENERIC_MESSAGE',
    ERROR_MISSING_REQUIRED_RESEARCHER_NAME_ONLY: 'ERROR_MISSING_REQUIRED_RESEARCHER_NAME_ONLY',
    ERROR_MISSING_REQUIRED_OLIGO_RESEARCHER_NAME_ONLY: 'ERROR_MISSING_REQUIRED_OLIGO_RESEARCHER_NAME_ONLY',
    ERROR_MISSING_REQUIRED_SEQUENCE_ONLY: 'ERROR_MISSING_REQUIRED_SEQUENCE_ONLY',
    ERROR_MISSING_REQUIRED_OLIGO_NAME_ONLY: 'ERROR_MISSING_REQUIRED_OLIGO_NAME_ONLY',
    ERROR_INCORRECT_CONFIGURATION: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_CONFIG_INCORRECT_ONLY_TEXT',
    APP_SUPPORT_EMAIL: 'APP_SUPPORT_EMAIL',
    PROJECT_FOOTER_No_OF_OLIGO_LABEL: 'PROJECT_FOOTER_No_OF_OLIGO_LABEL',
    ERROR_INVALID_CONFIGURATION: 'ERROR_INVALID_CONFIGURATION',
    CONFIG_OLIGO_NAME_PLACEHOLDER: 'CONFIG_OLIGO_NAME_PLACEHOLDER',
    CONFIG_RESEARCHER_NAME_PLACEHOLDER: 'CONFIG_RESEARCHER_NAME_PLACEHOLDER',
    CONFIG_OLIGO_SEQUENCE_PLACEHOLDER: 'CONFIG_OLIGO_SEQUENCE_PLACEHOLDER',
    TOOLTIP_TEXT_SCALE_DROPDOWN: 'TOOLTIP_TEXT_SCALE_DROPDOWN',
    TOOLTIP_TEXT_PURIFICATION_DROPDOWN: 'TOOLTIP_TEXT_PURIFICATION_DROPDOWN',
    NOTIFICATION_HEADER: 'NOTIFICATION_HEADER',
    SESSION_EXPIRED_MSG: 'SESSION_EXPIRED_MSG',
    SIGN_IN_OK_LABEL: 'SIGN_IN_OK_LABEL',
    UNABLE_TO_FULFIL_REQUEST_MSG: 'UNABLE_TO_FULFIL_REQUEST_MSG'
};
var PlaceHolderKeys = {
    BULK_UPLOAD_URL: 'BULK_UPLOAD_URL',
    PLATE_OLIGO_URL: 'PLATE_OLIGO_URL',
    VALUE_OLIGO_URL: 'VALUE_OLIGO_URL',
    PROJECT_NUMBER: 'PROJECT_NUMBER',
    OLIGO_COUNT: 'OLIGO_COUNT',
    INVALID_BASES: 'BASES',
    MIN_LENGTH: 'MIN_LENGTH',
    MAX_LENGTH: 'MAX_LENGTH',
    SHIP_BY_DATE: 'SHIP_BY_DATE',
    CUTOFF_COUNTDOWN: 'CUTOFF_COUNTDOWN',
    MAX_OLIGO_COUNT: 'MAX_OLIGO_COUNT',
    DOWNLOAD_TEMPLATE_URL: 'DOWNLOAD_TEMPLATE_URL',
    SUPPORTED_TEMPLATE_EXTENSIONS: 'SUPPORTED_TEMPLATE_EXTENSIONS',
    OLIGO_INDEX: 'OLIGO_INDEX'
};
var replacePlaceHolders = function replacePlaceHolders(target, dict) {
    if (!target) {
        return '';
    }
    return Object.keys(dict).reduce(function (acc, key) {
        var value = dict[key];
        return acc.replace('{{' + key + '}}', value);
    }, target);
};

/***/ }),

/***/ "BReQ":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-65Medium.eot";

/***/ }),

/***/ "BbyF":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("oeih");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "BzQJ":
/***/ (function(module, exports) {

module.exports = "<div id=\"{{projectImportModal.MODAL_ID}}\" class=\"modal hide fade project-import-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"project-import-modal__title\" aria-hidden=\"true\">\n  <div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"project-import-modal__title\">{{projectImportModal.IMPORT_OLIGO_PROJECT_TITLE}}</h3>\n    <span class=\"close\" ng-click=\"projectImportModal.close()\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"\n        xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\"\n          d=\"M19.6986 3L12.0005 10.6981L4.30138 3L3 4.30138L10.6981 12.0005L3 19.6986L4.30138 21L12.0005 13.3019L19.6986 21L21 19.6986L13.3019 12.0005L21 4.30138L19.6986 3Z\"\n          fill=\"#1B1B1D\" />\n      </svg>\n    </span>\n  </div>\n  <div class=\"modal-body project-import-modal__body\">\n    <input tabindex=\"-1\"\n           id=\"file-open-os\"\n           type=\"file\"\n           accept=\"{{projectImportModal.supportedFileExtensions.join(',')}}\"\n           onchange=\"angular.element(this).scope().projectImportModal.filesChanged(angular.element(this), this.files)\">\n    <div class=\"project-import-modal__notification-container\">\n      <fancy-message-pane state=\"projectImportModal.notificationState\"\n                          message=\"projectImportModal.topLevelInstructions()\"\n                          ng-if=\"projectImportModal.notificationMessages.length <= 0\">\n      </fancy-message-pane>\n      <fancy-message-pane state=\"projectImportModal.notificationState\"\n                          message=\"projectImportModal.notificationMessages.join('\\n')\"\n                          closeable=\"true\"\n                          on-close=\"projectImportModal.clearNotifications()\"\n                          ng-if=\"projectImportModal.notificationMessages.length > 0\">\n      </fancy-message-pane>\n    </div>\n    <div class=\"project-import-modal__tool-container\">\n      <div class=\"project-import-modal__tool-left\">\n        <a class=\"project-import-modal__tool-download\" ng-href=\"{{projectImportModal.templateURL}}\" target=\"_blank\">\n          <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 12.9348V15H1V12.9348H15ZM7.89 12.9348L1.07 5.07092H5V1H11V5.07092H14.7L7.89 12.9348ZM5.43 7.05674L7.88 9.88653L10.33 7.05674H9V2.98582H7V7.05674H5.43Z\" fill=\"#0071D0\"/>\n          </svg>\n          <span class=\"download-template-text\">{{projectImportModal.IMPORT_OLIGO_PROJECT_DOWNLOAD_TEMPLATE_LABEL}}</span>\n        </a>\n        <a class=\"project-import-modal__tool-upload\" href=\"\" ng-click=\"projectImportModal.openFileBrowser()\">\n          <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.64008 13.1349H14.3601V15.1949H1.64008V13.1349ZM5.00008 8.54493H1.33008L8.00008 0.804932L14.6701 8.54493H10.6701V11.9249H5.00008V8.54493ZM10.4301 6.59493L8.00008 3.78493L5.57008 6.59493H6.93008V9.98493H8.74008V6.59493H10.4301Z\" fill=\"#0071D0\"/>\n          </svg>\n          <span class=\"upload-template-text\">{{projectImportModal.IMPORT_OLIGO_PROJECT_UPLOAD_FILE_LABEL}}</span>\n        </a>\n      </div>\n      <div class=\"project-import-modal__view-sample\">\n        <a href=\"\"\n           class=\"project-import-modal__item-info--popover\"\n           ng-attr-title=\"{{projectImportModal.IMPORT_OLIGO_PROJECT_OLIGO_SAMPLE_DATA_LABEL}}\"\n           ng-attr-data-content=\"{{projectImportModal.sampleDataContent}}\">\n          {{projectImportModal.IMPORT_OLIGO_PROJECT_OLIGO_SAMPLE_DATA_LABEL}}\n        </a>\n      </div>\n    </div>\n    <div class=\"project-import-modal__drop-container-oligo-count\">\n      <div class=\"project-import-modal__drop-container\">\n        <drag-and-drop class=\"project-import-modal__drop-area\"\n                      ng-click=\"projectImportModal.activateTextArea()\"\n                      data-show-dnd-area=\"!projectImportModal.textAreaActive\"\n                      data-disable=\"false\"\n                      data-processor=\"projectImportModal.dndProcessor\"\n                      data-ng-attr-empty=\"!projectImportModal.textAreaActive\">\n          <div class=\"project-import-modal__dnd-overlay top-left\" ng-if=\"!projectImportModal.textAreaActive\">\n            <div ng-bind-html=\"projectImportModal.IMPORT_OLIGO_PROJECT_DRAG_AREA_INSTRUCTIONS\"></div>\n          </div>\n          <div class=\"project-import-modal__data-container\" ng-if=\"projectImportModal.textAreaActive\">\n            <div class=\"project-import-modal__row-area\">\n              <div class=\"project-import-modal__text-header\">\n                <span>A</span> <!-- dummy header -->\n              </div>\n              <textarea disabled=\"true\"\n                        class=\"project-import-modal__text-area--rowno\"\n                        ng-style=\"{ width: ((((projectImportModal.textAreaNoOfLines+'').split('').length - 1) * 7) + 20) + 'px' }\"\n                        ng-model=\"projectImportModal.textAreaRowNumbers\">\n              </textarea>\n            </div>\n            <div class=\"project-import-modal__paste-area\">\n              <div class=\"project-import-modal__text-header\">\n                <span ng-repeat=\"templateColumnDef in projectImportModal.templateColumnDefs\">\n                  <span>{{templateColumnDef.name}}</span>\n                  <span ng-if=\"$index < (projectImportModal.templateColumnDefs.length - 1)\">,</span>\n                </span>\n              </div>\n              <textarea class=\"project-import-modal__text-area\"\n                        spellcheck=\"false\"\n                        ng-blur=\"projectImportModal.onTextAreaBlur()\"\n                        ng-trim=\"false\"\n                        ng-model=\"projectImportModal.templateTextContent\">\n              </textarea>\n            </div>\n          </div>\n        </drag-and-drop>\n      </div>\n      <div class=\"project-import-modal__item-info-container project-import-modal__tool-container\">\n        <div class=\"project-import-modal__tool-toggle-preferences--container\"\n            ng-if=\"projectImportModal.preferenceToggleSupported\">\n          <a class=\"project-import-modal__tool-toggle-preferences\" href=\"\"\n            ng-click=\"projectImportModal.togglePreferences()\">\n            <div ng-if=\"!projectImportModal.preferencesShown\">\n              <span>+</span>\n              <span>{{projectImportModal.IMPORT_OLIGO_PROJECT_SHOW_PREFERENCES_LABEL}}</span>\n            </div>\n            <div ng-if=\"projectImportModal.preferencesShown\">\n              <span>-</span>\n              <span>{{projectImportModal.IMPORT_OLIGO_PROJECT_HIDE_PREFERENCES_LABEL}}</span>\n            </div>\n          </a>\n          <a href=\"\" class=\"dropdown-btn__hint project-import-modal__tool-toggle-preferences--hint\"></a>\n        </div>\n        <div class=\"project-import-modal__item-info\">\n          <div>\n            <span class=\"oligo-count-label\">{{projectImportModal.IMPORT_OLIGO_PROJECT_OLIGO_COUNT_LABEL}}</span>\n            <span><span class=\"oligo-count\" ng-class=\"{ error: projectImportModal.isExceedingItemLimit() }\">{{projectImportModal.noOfLineItems}}</span><span>/</span><span class=\"max-oligo-count\">{{projectImportModal.maxNoOfOligos}}</span></span>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"project-import-modal__preferences-info\">\n      <div class=\"project-import-modal__preferences-hint\"\n          ng-if=\"projectImportModal.initialPreference\"\n          ng-show=\"projectImportModal.preferencesShown\">\n        <div class=\"oligo-preference-label\" ng-bind-html=\"projectImportModal.IMPORT_OLIGO_PROJECT_OLIGO_PREFERENCE_HINT_LABEL\"></div>\n      </div>\n      <div class=\"project-import-modal__preferences-container\"\n          ng-if=\"projectImportModal.initialPreference\"\n          ng-show=\"projectImportModal.preferencesShown\">\n        <oligo-config-preference preference=\"projectImportModal.initialPreference\"\n                                change-handler=\"projectImportModal.preferenceChangeHandler\"\n                                from-bulk=true>\n        </oligo-config-preference>\n        <div class=\"project-import-modal__oligo-config-spacer\">\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\"\n            class=\"btn btn-outline-primary\"\n            ng-click=\"projectImportModal.cancel()\">{{projectImportModal.IMPORT_OLIGO_PROJECT_CANCEL_LABEL}}</button>\n    <button type=\"button\"\n            class=\"btn btn-danger\"\n            ng-disabled=\"!projectImportModal.isContentValid()\"\n            ng-click=\"projectImportModal.ok()\">{{projectImportModal.IMPORT_OLIGO_PROJECT_OK_LABEL}}</button>\n  </div>\n  <div class=\"loader-container\" ng-if=\"projectImportModal.busy\">\n    <div class=\"loader\"></div>\n  </div>\n</div>";

/***/ }),

/***/ "CJdc":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-65Medium.svg";

/***/ }),

/***/ "CSJv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DIVP":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("UKM+");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "DPSk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return world; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__("NKgu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__("lsdx");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



function getFirstOligoInOligos(projectIdx, oligos) {
    if (oligos && oligos.length > 0) {
        var _oligos = _slicedToArray(oligos, 1),
            oligo = _oligos[0];

        var id = oligo.id;

        return { id: id, projectIdx: projectIdx };
    }
    return undefined;
}
function getFirstOligoInProjects(projects) {
    if (projects && projects.length > 0) {
        var _projects = _slicedToArray(projects, 1),
            project = _projects[0];

        var oligos = project.oligos;

        return getFirstOligoInOligos(project.index, oligos);
    }
    return undefined;
}
var updateAppState = function updateAppState(state, action) {
    var appState = action.payload;
    return Object.assign({}, state, { appState: appState });
};
var updateWorldData = function updateWorldData(state, action) {
    var worldData = action.payload;
    return Object.assign({}, state, worldData);
};
var loadWorldItem = function loadWorldItem(state, action, oligoInFocus) {
    state = action.payload;
    if (oligoInFocus && !state.oligoInFocus) {
        state.oligoInFocus = Object.assign({}, oligoInFocus);
    }
    if (oligoInFocus && state.oligoInFocus && state.oligoInFocus.id !== oligoInFocus.id) {
        state.oligoInFocus = Object.assign({}, oligoInFocus);
    }
    return state;
};
var deleteProject = function deleteProject(state, action, oligoInFocus) {
    var projectIdx = action.payload.index;

    if (oligoInFocus && oligoInFocus.projectIdx === projectIdx) {
        oligoInFocus = undefined;
        return Object.assign({}, state, { oligoInFocus: oligoInFocus });
    }
    return state;
};
var addOligo = function addOligo(state, action) {
    var _action$payload = action.payload,
        projectIdx = _action$payload.projectIdx,
        oligos = _action$payload.oligos;

    var oligoInFocus = getFirstOligoInOligos(projectIdx, oligos);
    return Object.assign({}, state, { oligoInFocus: oligoInFocus });
};
var deleteOligo = function deleteOligo(state, action, oligoInFocus) {
    var id = action.payload.id;

    if (oligoInFocus && oligoInFocus.id === id) {
        oligoInFocus = undefined;
        return Object.assign({}, state, { oligoInFocus: oligoInFocus });
    }
    return state;
};
var world = function world() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__models__["l" /* WORLD_INITIAL */];
    var action = arguments[1];

    if (!action || !action.type) {
        return state;
    }
    var type = action.type;
    var _state = state,
        oligoInFocus = _state.oligoInFocus;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["g" /* UPDATE_APP_STATE */]:
            state = updateAppState(state, action);
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["j" /* UPDATE_WORLD_DATA */]:
            state = updateWorldData(state, action);
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["f" /* LOAD_WORLD_ITEM */]:
            state = loadWorldItem(state, action, oligoInFocus);
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["e" /* LOAD_PROJECTS */]:
            oligoInFocus = getFirstOligoInProjects(action.payload);
            state = Object.assign({}, state, { oligoInFocus: oligoInFocus });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["b" /* ADD_PROJECT */]:
            oligoInFocus = getFirstOligoInProjects([action.payload]);
            state = Object.assign({}, state, { oligoInFocus: oligoInFocus });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["d" /* DELETE_PROJECT */]:
            state = deleteProject(state, action, oligoInFocus);
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["a" /* ADD_OLIGO */]:
            state = addOligo(state, action);
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["c" /* DELETE_OLIGO */]:
            state = deleteOligo(state, action, oligoInFocus);
            break;
        default:
            break;
    }
    return state;
};

/***/ }),

/***/ "Ds5P":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("OzIq");
var core = __webpack_require__("7gX0");
var hide = __webpack_require__("2p1q");
var redefine = __webpack_require__("R3AP");
var ctx = __webpack_require__("rFzY");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "EieL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Epvr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FryR":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("/whu");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "G4dH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OligoConfigDetailController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OLIGO_CONFIG_DETAIL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OligoConfigDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__oligo_config_detail_scss__ = __webpack_require__("8e5k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__oligo_config_detail_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__oligo_config_detail_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__("wuJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("lsdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_i18n__ = __webpack_require__("BOQq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_util__ = __webpack_require__("jQAO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_oligo_modal_support_oligo_modal_support__ = __webpack_require__("z/Xr");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var MIXED_BASE_SELECTED = 'mix-base-selected';
var DisplayTypes = __WEBPACK_IMPORTED_MODULE_2__models__["f" /* OligoDisplayTypes */];
function singleSelectionClientParamDefToSelectionItems(selectionDef) {
    var options = selectionDef.value,
        selected = selectionDef.selected;

    return options.map(function (option) {
        var id = option.id,
            name = option.name,
            descriptions = option.descriptions;

        var displayName = descriptions && descriptions.length > 0 ? descriptions.join(' ') : name;
        return { id: id, name: displayName, selected: selected ? selected.id === id : false, paramDef: option };
    });
}
function multiSelectionClientParamDefToSelectionItems(selectionDef) {
    var options = selectionDef.value,
        selected = selectionDef.selected;

    return options.map(function (option) {
        var id = option.id,
            name = option.name,
            descriptions = option.descriptions;

        var displayName = descriptions && descriptions.length > 0 ? descriptions.join(' ') : name;
        var found = selected.find(function (selectedOption) {
            return selectedOption.id === id;
        });
        return { id: id, name: displayName, selected: found ? true : false, paramDef: option };
    });
}
function sortByEnabled(dropdown, paramDef) {
    var noneParamDef = paramDef.value.find(function (value) {
        return value && typeof value.id === 'string' && value.id.length === 0;
    });
    dropdown.options.sort(function (dropdownContent1, dropdownContent2) {
        if (noneParamDef && noneParamDef.name === dropdownContent1.title) {
            return -1;
        } else if (noneParamDef && noneParamDef.name === dropdownContent2.title) {
            return 1;
        } else if (dropdownContent1.disabled === dropdownContent2.disabled) {
            return dropdownContent1.title.localeCompare(dropdownContent2.title);
        } else if (!dropdownContent1.disabled && dropdownContent2.disabled) {
            return -1;
        } else {
            return 1;
        }
    });
    return dropdown;
}
function textInputConstraintsFrom(definition) {
    return {
        length: (definition.textLimits || []).reduce(function (constraints, textLimitsDef) {
            var min = textLimitsDef.min,
                max = textLimitsDef.max;

            if (min > constraints.min) {
                constraints.min = min;
            }
            if (max < constraints.max) {
                constraints.max = max;
            }
            return constraints;
        }, { min: 0, max: Infinity }),
        symbols: {
            valid: (definition.textSymbols || []).reduce(function (validSymbols, symbolsDef) {
                validSymbols = validSymbols.concat(symbolsDef.valid);
                return validSymbols;
            }, [])
        }
    };
}
function oligoPropertiesCalculator($q, $timeout, oligoAnalysis, delay) {
    var timeoutSubscription = void 0;
    var deferred = void 0;
    return function (opticalDensity, sequence, delayOverride) {
        if (timeoutSubscription) {
            $timeout.cancel(timeoutSubscription);
            if (deferred) {
                deferred.resolve({ ignore: true });
            }
        }
        deferred = $q.defer();
        timeoutSubscription = $timeout(function () {
            if (!sequence || sequence.length <= 0) {
                deferred.resolve({ ignore: false });
                timeoutSubscription = null;
            } else {
                oligoAnalysis.getOligoSequenceCalculations(sequence.toUpperCase(), opticalDensity).then(function (data) {
                    deferred.resolve({ ignore: false, data: data });
                }, deferred.reject).finally(function () {
                    timeoutSubscription = null;
                });
            }
        }, typeof delayOverride === 'number' ? delayOverride : delay);
        return deferred.promise;
    };
}
function cutoffTimeDurationCalculator($interval, calculator, interval) {
    var intervalSubscriber = void 0;
    return {
        subscribe: function subscribe(cutoffTimeUnix, subscriber) {
            if (intervalSubscriber) {
                $interval.cancel(intervalSubscriber);
            }
            if (cutoffTimeUnix < 0) {
                subscriber(null);
                return;
            }
            var computeDuration = function () {
                var duration = void 0;
                return function () {
                    duration = calculator.getRemainingCutoffTime(cutoffTimeUnix);
                    var rollOver = duration.secs < 0 || duration.mins < 0 || duration.hrs < 0;
                    if (rollOver) {
                        cutoffTimeUnix = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["addDays"])(new Date(cutoffTimeUnix), 1).getTime();
                        duration = calculator.getRemainingCutoffTime(cutoffTimeUnix);
                        duration.rollOver = rollOver;
                    }
                    subscriber(duration);
                };
            }();
            computeDuration();
            intervalSubscriber = $interval(computeDuration, interval);
        },
        unsubscribe: function unsubscribe() {
            if (!intervalSubscriber) {
                return;
            }
            $interval.cancel(intervalSubscriber);
            intervalSubscriber = null;
        }
    };
}
function trimSpacesConvertUpper(text) {
    return text.trim().replace(/\s|\r?\n|\r/g, '').toUpperCase();
}
function textToBlocks(text, blockNum) {
    var sequenceBlock = [];
    if (!text) {
        return sequenceBlock;
    }
    text = trimSpacesConvertUpper(text);
    if (text.length <= 0) {
        return sequenceBlock;
    }
    var block = '';
    var basesGroupCount = 0;
    var basesGroup = '';
    var insideGroup = false;
    var numOpeningBrace = 0;
    var numClosingBrace = 0;
    for (var i = 0; i < text.length; i++) {
        var currentBp = text[i];
        if (currentBp === '[') {
            numOpeningBrace++;
            if (!insideGroup) {
                basesGroup = '';
            }
            insideGroup = true;
        } else if (currentBp === ']') {
            numClosingBrace++;
            if (numOpeningBrace === numClosingBrace) {
                insideGroup = false;
            }
        }
        basesGroup = basesGroup + currentBp;
        if (insideGroup && i === text.length - 1) {
            insideGroup = false;
        }
        if (!insideGroup) {
            if (basesGroupCount % blockNum === 0 && i !== 0) {
                sequenceBlock.push(block);
                block = '';
            }
            block += basesGroup;
            basesGroupCount = basesGroupCount + 1;
            basesGroup = '';
        }
    }
    sequenceBlock.push(block);
    return sequenceBlock;
}
function toLocaleDateString(date, locale, formatAsOptions, formatAsString) {
    try {
        return date.toLocaleDateString(locale, formatAsOptions);
    } catch (e) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["format"])(date, formatAsString);
    }
}
var OLIGO_PROPS_CALC_DELAY = 1000;
var CUTOFF_TIME_UPDATE_INTERVAL = 60000;
var SHIP_FORMAT_OPTIONS = { month: 'long', day: 'numeric' };
var SHIP_FORMAT_STRING = 'MMMM D';
var OligoConfigDetailController = function () {
    function OligoConfigDetailController($scope, $q, $timeout, $interval, $ngRedux, oligoActions, worldActions, oligoAnalysis, oligoModalSupport) {
        var _this = this;

        _classCallCheck(this, OligoConfigDetailController);

        this.oligoModalSupport = oligoModalSupport;
        this.updateOligo = null;
        this.deleteOligo = null;
        this.updateAppState = null;
        this.updateOligoDisplayState = null;
        this.onComponentLayout = null;
        this.mixedBasesPanelProps = {
            data: {
                bases: []
            },
            visible: false,
            rect: {
                right: 0,
                height: 0,
                width: 0,
                top: 0
            }
        };
        this.loading = false;
        this.validBases3Prime = [];
        this.textToBlocks = textToBlocks;
        this.formatAmount = __WEBPACK_IMPORTED_MODULE_4__models_util__["e" /* formatAmount */];
        this.appState = __WEBPACK_IMPORTED_MODULE_2__models__["b" /* AppStates */].DRAFT;
        this.language = 'en';
        this.country = 'us';
        this.SAMPLE_LABEL = 'See sample label';
        this.MIXED_BASES_LABEL = 'Add Mixed Bases';
        this.MIXED_BASES_PANEL_TITLE = 'Mixed bases';
        this.MIXED_BASES_PANEL_DESC = 'Click on a mixed base single letter code to add it to your sequence';
        this.BASE_COUNT_LABEL = 'Base Count';
        this.MIN_YIELD_LABEL = 'Minimum Yield';
        this.PRICE_LABEL = 'PRICE';
        this.PRICE_DESC = 'Product pricing is available in the shopping cart.';
        this.PRICE_LOADING_LABEL = 'Calculating price...';
        this.SHOW_MORE_OPTION_LABEL = 'Show more options';
        this.SHOW_LESS_OPTION_LABEL = 'Show fewer options';
        this.UNNAMED_OLIGO_LABEL = 'Unnamed Oligo';
        this.UNNAMED_RESEARCHER_LABEL = 'Unnamed Researcher';
        this.SEQUENCE_LABEL = 'Oligo Sequence';
        this.SEQUENCE_EMPTY_LABEL = 'EMPTY';
        this.DELETE_POPOVER_TITLE_OLIGO = 'Delete Oligo(s)';
        this.DELETE_POPOVER_DESC_OLIGO = 'Are you sure you want to delete the oligo(s)? This action cannot be undone.';
        this.POPOVER_LABEL_DELETE_CONFIRM = 'Yes';
        this.POPOVER_CANCEL_LABEL = 'Cancel';
        this.TAT_SHIP_BY_LABEL_TPL = '<span class="turnaround-time">Ship by <span class="date-time">{{SHIP_BY_DATE}}.</span></span>';
        this.TAT_CUTOFF_LABEL_TPL = '<span class="turnaround-time">Order within <span class="date-time">{{CUTOFF_COUNTDOWN}}.</span></span>';
        this.TAT_SHIP_BY_LABEL = '';
        this.TAT_CUTOFF_LABEL = '';
        this.INVALID_BP_MSG = 'not a recognized base.';
        this.SEQUENCE_TOO_SHORT_MSG_TPL = 'You must enter at least {{MIN_LENGTH}} base pairs.';
        this.SEQUENCE_TOO_LONG_MSG_TPL = 'A maximum of {{MAX_LENGTH}} bases is allowed for the selected scale and options.';
        this.SEQUENCE_TOO_SHORT_MSG = '';
        this.SEQUENCE_TOO_LONG_MSG = '';
        this.MIXED_BASES_POPOVER_OK_LABEL = 'Ok';
        this.MIXED_BASES_PANEL_DISCLAIMER_LABEL = 'Important note on adding mixed/randomized bases to your oligo ';
        this.MIXED_BASES_POPOVER_DISCLAIMER_TITLE = 'Important note on adding mixed/randomized bases to your oligo ';
        this.MIXED_BASES_POPOVER_DISCLAIMER_TPL = '\n    <p>\n    Thermo Fisher offers mixed or randomized base pairs for designing custom oligos.\n    We offer two processes for randomization: automated mixing and hand mixing. When ordering oligos on thermofisher.com, the default is automated mixing.\n    </p>\n    <p>\n    Automated mixing uses machine mixing for adding degenerate or random bases into the oligo during synthesis.\n    This service is at no additional charge to the oligo and can be added at all base sites except at the 3\u2019 end.\n    The synthesizer disperses an equal ratio of the bases but due to differing binding affinities between A, C, G, and T, some bases may couple more frequently than others.\n    <strong>As a result, we do not guarantee an equal ratio of the bases in oligos being synthesized using automated mixing.</strong>\n    </p>\n    <p>\n    If you need an equal or specific ratio of bases, we suggest our hand-mixing option offered through our Specialty Oligo Services Lab.\n    Pricing varies for hand-mixing options and can be quoted through our Oligo Inquiries Team.\n    For a quote on hand-mixing, you can contact <a href="mailto:{{APP_SUPPORT_EMAIL}}">{{APP_SUPPORT_EMAIL}}</a>\n    </p>\n  ';
        this.ERROR_INVALID_CONFIGURATION = 'Invalid configuration';
        this.OLIGO_NAME_PLACEHOLDER = 'Oligo Name Placeholder';
        this.RESEARCHER_NAME_PLACEHOLDER = 'Researcher Name Placeholder';
        this.OLIGO_SEQUENCE_PLACEHOLDER = 'Input oligo sequence (5’ to 3’) and press `Enter` or select configuration options to refresh price.';
        this.SCALE_TOOLTIP_TEXT = 'Please choose configurations from left to right starting with synthesis scale.';
        this.PURIFICATION_TOOLTIP_TEXT = 'Purification options are dependent on synthesis scale. They also determine availability of 3’ Mods and 5’ Mods.';
        this.mapStateToThis = function (state) {
            var world = state.world;
            var appState = world.appState,
                language = world.language,
                sequenceCodes = world.sequenceCodes,
                vocabulary = world.vocabulary,
                oligoInFocus = world.oligoInFocus,
                clientConfig = world.clientConfig,
                country = world.countryCode;

            var validBases3Prime = clientConfig.validBases3Prime || [];
            _this.mixedBasesPanelProps.data.bases = _this.getMixedBasesData(sequenceCodes);
            _this.synchDisclaimerText();
            return {
                appState: appState,
                oligoInFocus: oligoInFocus,
                validBases3Prime: validBases3Prime,
                language: language,
                country: country,
                SAMPLE_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_SAMPLE_LABEL_LINK_TEXT, _this.SAMPLE_LABEL, world),
                MIXED_BASES_POPOVER_OK_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].MIXED_BASE_POPOVER_OK_LABEL, _this.MIXED_BASES_POPOVER_OK_LABEL, world),
                MIXED_BASES_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_MIXED_BASED_LINK_TEXT, _this.MIXED_BASES_LABEL, world),
                MIXED_BASES_PANEL_TITLE: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].MIXED_BASE_POPOVER_TITLE, _this.MIXED_BASES_PANEL_TITLE, world),
                MIXED_BASES_PANEL_DESC: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].MIXED_BASE_POPOVER_DESC, _this.MIXED_BASES_PANEL_DESC, world),
                MIXED_BASES_POPOVER_DISCLAIMER_TITLE: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].MIXED_BASE_POPOVER_DISCLAIMER_TITLE, _this.MIXED_BASES_POPOVER_DISCLAIMER_TITLE, world),
                MIXED_BASES_POPOVER_DISCLAIMER_TPL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].MIXED_BASE_POPOVER_DISCLAIMER_TPL, _this.MIXED_BASES_POPOVER_DISCLAIMER_TPL, world),
                MIXED_BASES_PANEL_DISCLAIMER_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].MIXED_BASE_PANEL_DISCLAIMER_LABEL, _this.MIXED_BASES_PANEL_DISCLAIMER_LABEL, world),
                BASE_COUNT_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_BASE_COUNT, _this.BASE_COUNT_LABEL, world),
                MIN_YIELD_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_MIN_YIELD, _this.MIN_YIELD_LABEL, world),
                PRICE_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_PRICE_TITLE, _this.PRICE_LABEL, world),
                PRICE_LOADING_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].LOADING_RETRIEVE_PRICE_DESC, _this.PRICE_LOADING_LABEL, world),
                PRICE_DESC: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_PRICE_DESC, _this.PRICE_DESC, world),
                SEQUENCE_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_COLLAPSED_SEQUENCE, _this.SEQUENCE_LABEL, world),
                SEQUENCE_EMPTY_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_COLLAPSED_EMPTY_SEQUENCE, _this.SEQUENCE_EMPTY_LABEL, world),
                SHOW_MORE_OPTION_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_SHOW_MORE_OPTION_LINK_TEXT, _this.SHOW_MORE_OPTION_LABEL, world),
                SHOW_LESS_OPTION_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_SHOW_LESS_OPTION_LINK_TEXT, _this.SHOW_LESS_OPTION_LABEL, world),
                UNNAMED_OLIGO_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_COLLAPSED_UNNANMED_OLIGO, _this.UNNAMED_OLIGO_LABEL, world),
                UNNAMED_RESEARCHER_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_COLLAPSED_UNNANMED_RESEARCHER, _this.UNNAMED_RESEARCHER_LABEL, world),
                DELETE_POPOVER_TITLE_OLIGO: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_OLIGO_DELETE_POPOVER_TITLE, _this.DELETE_POPOVER_TITLE_OLIGO, world),
                DELETE_POPOVER_DESC_OLIGO: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_OLIGO_DELETE_POPOVER_DESC, _this.DELETE_POPOVER_DESC_OLIGO, world),
                POPOVER_LABEL_DELETE_CONFIRM: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_OLIGO_DELETE_POPOVER_OK_BUTTON, _this.POPOVER_LABEL_DELETE_CONFIRM, world),
                POPOVER_CANCEL_LABEL: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_OLIGO_DELETE_POPOVER_CANCEL_BUTTON, _this.POPOVER_CANCEL_LABEL, world),
                ERROR_INVALID_CONFIGURATION: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].ERROR_INVALID_CONFIGURATION, _this.ERROR_INVALID_CONFIGURATION, world),
                OLIGO_NAME_PLACEHOLDER: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_OLIGO_NAME_PLACEHOLDER, _this.OLIGO_NAME_PLACEHOLDER, world),
                RESEARCHER_NAME_PLACEHOLDER: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_RESEARCHER_NAME_PLACEHOLDER, _this.RESEARCHER_NAME_PLACEHOLDER, world),
                OLIGO_SEQUENCE_PLACEHOLDER: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_OLIGO_SEQUENCE_PLACEHOLDER, _this.OLIGO_SEQUENCE_PLACEHOLDER, world),
                SCALE_TOOLTIP_TEXT: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].TOOLTIP_TEXT_SCALE_DROPDOWN, _this.SCALE_TOOLTIP_TEXT, world),
                PURIFICATION_TOOLTIP_TEXT: _this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].TOOLTIP_TEXT_PURIFICATION_DROPDOWN, _this.PURIFICATION_TOOLTIP_TEXT, world),
                INVALID_BP_MSG: _this.getInvalidBpMsg(world),
                SEQUENCE_TOO_SHORT_MSG_TPL: _this.getSequenceTooShortMsgTpl(world),
                SEQUENCE_TOO_LONG_MSG_TPL: _this.getSequenceTooLongMsgTpl(world),
                TAT_SHIP_BY_LABEL_TPL: _this.getTatShipByLabelTpl(world),
                TAT_CUTOFF_LABEL_TPL: _this.getTatCutoffLabelTpl(world)
            };
        };
        var bindDispatchers = function bindDispatchers(dispatch) {
            _this.updateOligo = function (request) {
                return dispatch(oligoActions.updateOligo(request));
            };
            _this.deleteOligo = function (request) {
                return dispatch(oligoActions.deleteOligo(request));
            };
            _this.updateAppState = function (request) {
                return dispatch(worldActions.updateAppState(request));
            };
            _this.updateOligoDisplayState = function (request) {
                return dispatch(oligoActions.updateOligoDisplayState(request));
            };
        };
        var unsubscribeRedux = $ngRedux.connect(this.mapStateToThis.bind(this), bindDispatchers)(this);
        var calculateOligoProperties = oligoPropertiesCalculator($q, $timeout, oligoAnalysis, OLIGO_PROPS_CALC_DELAY);
        var cutoffTimeDurationSubscription = cutoffTimeDurationCalculator($interval, oligoAnalysis, CUTOFF_TIME_UPDATE_INTERVAL);
        var scopeWatchers = [];
        $scope.$on('$destroy', function () {
            scopeWatchers.forEach(function (unwatch) {
                return unwatch();
            });
            scopeWatchers.length = 0;
            cutoffTimeDurationSubscription.unsubscribe();
            unsubscribeRedux();
        });
        $scope.$on(MIXED_BASE_SELECTED, function (event, selected) {
            if (!_this.oligo || !selected || selected.length <= 0) {
                return;
            }
            var definition = _this.oligo.definition;
            var basic = definition.basic;
            var oligoValue = basic.oligoValue;

            var sequence = '' + oligoValue.value + selected.toUpperCase();
            _this.publishOligoUpdate(oligoValue.id, [{ id: oligoValue.id, value: sequence }]);
        });
        function cleanupWatchers(watchers) {
            watchers.forEach(function (unwatch) {
                return unwatch();
            });
            watchers.length = 0;
        }
        function createOligoConfigData(definition, basic, advanced, index, displayType, moreOptions, turnAroundDate, language, data) {
            var constraints = textInputConstraintsFrom(basic.oligoValue);
            return {
                index: index,
                displayType: displayType,
                moreOptions: moreOptions,
                properties: {
                    tm: {
                        available: false
                    },
                    gc: {
                        available: false
                    },
                    yieldAmount: {
                        available: false
                    },
                    numBases: basic.oligoValue ? __WEBPACK_IMPORTED_MODULE_4__models_util__["b" /* countSequenceLength */](basic.oligoValue.value) : 0,
                    turnAroundTimeDisplay: turnAroundDate ? toLocaleDateString(turnAroundDate, language, SHIP_FORMAT_OPTIONS, SHIP_FORMAT_STRING) : null
                },
                researcherName: {
                    definition: basic.researcherName
                },
                oligoName: {
                    definition: basic.oligoName
                },
                oligoValue: {
                    constraints: constraints,
                    definition: basic.oligoValue,
                    possibleErrors: {
                        invalidLength: {
                            max: data ? data.oligoValue.possibleErrors ? data.oligoValue.possibleErrors.invalidLength.max : false : false,
                            min: data ? data.oligoValue.possibleErrors ? data.oligoValue.possibleErrors.invalidLength.min : false : false
                        },
                        invalidList: data ? data.oligoValue.possibleErrors ? data.oligoValue.possibleErrors.invalidList : [] : [],
                        otherErrors: basic.oligoValue.errors ? [].concat(_toConsumableArray(basic.oligoValue.errors)) : []
                    }
                },
                scale: {
                    definition: basic.scale,
                    items: __WEBPACK_IMPORTED_MODULE_4__models_util__["g" /* selectionClientParamDefToDropDownContent */](basic.scale)
                },
                purification: {
                    definition: basic.purification,
                    items: __WEBPACK_IMPORTED_MODULE_4__models_util__["g" /* selectionClientParamDefToDropDownContent */](basic.purification)
                },
                format: {
                    definition: basic.format,
                    items: __WEBPACK_IMPORTED_MODULE_4__models_util__["g" /* selectionClientParamDefToDropDownContent */](basic.format)
                },
                prime3Mod: {
                    definition: basic.prime3Mod,
                    items: sortByEnabled(__WEBPACK_IMPORTED_MODULE_4__models_util__["g" /* selectionClientParamDefToDropDownContent */](basic.prime3Mod), basic.prime3Mod)
                },
                prime5Mod: {
                    definition: basic.prime5Mod,
                    items: sortByEnabled(__WEBPACK_IMPORTED_MODULE_4__models_util__["g" /* selectionClientParamDefToDropDownContent */](basic.prime5Mod), basic.prime5Mod)
                },
                delivery: {
                    definition: basic.delivery,
                    items: singleSelectionClientParamDefToSelectionItems(basic.delivery),
                    selectedId: basic.delivery.selected.id
                },
                handling: {
                    definition: advanced.handling,
                    items: multiSelectionClientParamDefToSelectionItems(advanced.handling)
                },
                alternate: {
                    definition: advanced.alternate,
                    items: multiSelectionClientParamDefToSelectionItems(advanced.alternate)
                },
                invalid: definition.status.state !== __WEBPACK_IMPORTED_MODULE_2__models__["g" /* OligoStates */].VALID
            };
        }
        $scope.$watch(function () {
            return _this.oligo;
        }, function (oligo) {
            if (!oligo) {
                return;
            }
            cleanupWatchers(scopeWatchers);
            var definition = oligo.definition,
                index = oligo.index,
                pricing = oligo.pricing,
                oligoDisplayType = oligo.displayType,
                configDisplayType = oligo.configDisplayType;
            var basic = definition.basic,
                advanced = definition.advanced,
                properties = definition.properties;
            var turnaroundTime = properties.turnaroundTime;
            var shipInXDays = turnaroundTime.shipInXDays,
                cutoffUnixTime = turnaroundTime.cutoffUnixTime;

            var turnAroundDate = shipInXDays < 0 ? null : Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["addDays"])(new Date(), shipInXDays);
            var displayType = _this.data ? _this.data.displayType || DisplayTypes.DETAILS : oligoDisplayType;
            var moreOptions = _this.data ? _this.data.moreOptions || false : configDisplayType === __WEBPACK_IMPORTED_MODULE_2__models__["e" /* OligoConfigDisplayTypes */].ADVANCED;
            var constraints = textInputConstraintsFrom(basic.oligoValue);
            var data = createOligoConfigData(definition, basic, advanced, index, displayType, moreOptions, turnAroundDate, _this.language, _this.data);
            _this.updateSequenceMessages(constraints);
            var updateOligoProps = function updateOligoProps(response) {
                if (response.ignore) {
                    return;
                }
                var calculationData = response.data;
                var oligoProps = data.properties;

                if (calculationData) {
                    var gc = calculationData.gc,
                        tm = calculationData.tm,
                        yieldAmount = calculationData.yield;

                    oligoProps.gc.value = parseInt(gc, 10);
                    oligoProps.gc.available = true;
                    oligoProps.tm.at1M = parseFloat(tm.mt10Prime);
                    oligoProps.tm.at50mM = parseFloat(tm.mt5Prime);
                    oligoProps.tm.available = true;
                    oligoProps.yieldAmount.ug = parseFloat(yieldAmount.ug);
                    oligoProps.yieldAmount.nmole = parseFloat(yieldAmount.nmole);
                    oligoProps.yieldAmount.available = true;
                } else {
                    oligoProps.gc.available = false;
                    oligoProps.tm.available = false;
                    oligoProps.yieldAmount.available = false;
                }
            };
            $timeout(function () {
                var textInputWatchers = [data.researcherName, data.oligoName, data.oligoValue].map(function (textData) {
                    return function (textInputData) {
                        return $scope.$on(textInputData.definition.id, function (event, newText) {
                            var paramDefId = textInputData.definition.id;

                            if (newText && paramDefId === basic.oligoValue.id) {
                                newText = trimSpacesConvertUpper(newText);
                            }
                            var parameters = [{ id: paramDefId, value: newText }];
                            _this.publishOligoUpdate(paramDefId, parameters);
                        });
                    }(textData);
                });
                scopeWatchers = scopeWatchers.concat(textInputWatchers);
                var textChangeWatchers = [data.researcherName, data.oligoName, data.oligoValue].map(function (textData) {
                    return function (textInputData) {
                        return $scope.$on(textInputData.definition.id + '-onChange', function (event, sequence) {
                            var updateAppState = _this.updateAppState,
                                appState = _this.appState;

                            if (!updateAppState || appState === __WEBPACK_IMPORTED_MODULE_2__models__["b" /* AppStates */].EDIT) {
                                return;
                            }
                            updateAppState(__WEBPACK_IMPORTED_MODULE_2__models__["b" /* AppStates */].EDIT);
                        });
                    }(textData);
                });
                scopeWatchers = scopeWatchers.concat(textChangeWatchers);
                var selectionWatchers = [data.scale, data.purification, data.format, data.prime3Mod, data.prime5Mod].map(function (dropdownData) {
                    return function (selectionData) {
                        return $scope.$watch(function () {
                            return selectionData.items.selected;
                        }, function (selected, oldSelected) {
                            if (selected === oldSelected) {
                                return;
                            }
                            var selectedParamDef = selectionData.definition.value.find(function (paramDef) {
                                return paramDef.name === selected.title;
                            });
                            var paramDefId = selectionData.definition.id;

                            var parameters = [{ id: selectedParamDef.id, value: selectedParamDef.id }];
                            _this.publishOligoUpdate(paramDefId, parameters);
                        });
                    }(dropdownData);
                });
                scopeWatchers = scopeWatchers.concat(selectionWatchers);
                scopeWatchers.push($scope.$on(data.oligoValue.definition.id + '-onChange', function (event, sequence) {
                    if (!sequence || sequence.length <= 0) {
                        return;
                    }
                    sequence = trimSpacesConvertUpper(sequence);
                    if (sequence.length <= 0) {
                        return;
                    }
                    calculateOligoProperties(properties.opticalDensity, sequence).then(updateOligoProps, console.error);
                    data.properties.numBases = sequence ? __WEBPACK_IMPORTED_MODULE_4__models_util__["b" /* countSequenceLength */](sequence) : 0;
                }));
                _this.highlightLastBaseIfMixedBase();
            });
            calculateOligoProperties(properties.opticalDensity, data.oligoValue.definition.value, 0).then(updateOligoProps, console.error);
            cutoffTimeDurationSubscription.subscribe(cutoffUnixTime, function (duration) {
                if (!data || !duration) {
                    return;
                }
                data.properties.cutoffTimeDuration = duration;
                if (turnAroundDate && duration.rollOver) {
                    data.properties.turnAroundTimeDisplay = toLocaleDateString(Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["addDays"])(turnAroundDate, 1), _this.language, SHIP_FORMAT_OPTIONS, SHIP_FORMAT_STRING);
                }
            });
            var tatWatcher = $scope.$watch(function () {
                return data.properties;
            }, function (updateProperties) {
                if (updateProperties.turnAroundTimeDisplay) {
                    _this.TAT_SHIP_BY_LABEL = __WEBPACK_IMPORTED_MODULE_3__models_i18n__["c" /* replacePlaceHolders */](_this.TAT_SHIP_BY_LABEL_TPL, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__models_i18n__["b" /* PlaceHolderKeys */].SHIP_BY_DATE, updateProperties.turnAroundTimeDisplay));
                }
                if (updateProperties.cutoffTimeDuration) {
                    var cutoffText = '';
                    if (updateProperties.cutoffTimeDuration.hrs > 0) {
                        cutoffText = cutoffText + ' ' + updateProperties.cutoffTimeDuration.hrs + ' hr';
                    }
                    cutoffText = cutoffText + ' ' + (updateProperties.cutoffTimeDuration.mins + 1) + ' min';
                    _this.TAT_CUTOFF_LABEL = __WEBPACK_IMPORTED_MODULE_3__models_i18n__["c" /* replacePlaceHolders */](_this.TAT_CUTOFF_LABEL_TPL, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__models_i18n__["b" /* PlaceHolderKeys */].CUTOFF_COUNTDOWN, cutoffText));
                }
            }, true);
            scopeWatchers.push(tatWatcher);
            var possibleErrorsWatcher = $scope.$watch(function () {
                return data.oligoValue.possibleErrors;
            }, function (possibleErrors) {
                if (!possibleErrors) {
                    return;
                }
                possibleErrors.otherErrors = basic.oligoValue.errors ? [].concat(_toConsumableArray(basic.oligoValue.errors)) : [];
            });
            scopeWatchers.push(possibleErrorsWatcher);
            _this.data = data;
            _this.price = pricing ? pricing : {
                amount: 0,
                available: properties.pricing.supported,
                currency: ''
            };
        });
    }

    _createClass(OligoConfigDetailController, [{
        key: 'updateSequenceMessages',
        value: function updateSequenceMessages(constraints) {
            if (constraints && constraints.length) {
                this.SEQUENCE_TOO_SHORT_MSG = __WEBPACK_IMPORTED_MODULE_3__models_i18n__["c" /* replacePlaceHolders */](this.SEQUENCE_TOO_SHORT_MSG_TPL, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__models_i18n__["b" /* PlaceHolderKeys */].MIN_LENGTH, '' + constraints.length.min));
                this.SEQUENCE_TOO_LONG_MSG = __WEBPACK_IMPORTED_MODULE_3__models_i18n__["c" /* replacePlaceHolders */](this.SEQUENCE_TOO_LONG_MSG_TPL, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__models_i18n__["b" /* PlaceHolderKeys */].MAX_LENGTH, '' + constraints.length.max));
            }
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.data = null;
            this.oligo = null;
            this.price = null;
            this.updateOligo = null;
            this.deleteOligo = null;
            this.updateAppState = null;
            this.oligoModalSupport = null;
        }
    }, {
        key: 'mixedBasesPanelClose',
        value: function mixedBasesPanelClose() {
            this.mixedBasesPanelProps.visible = false;
        }
    }, {
        key: 'hasPossibleTextErrors',
        value: function hasPossibleTextErrors(possibleErrors) {
            var invalidLength = possibleErrors.invalidLength,
                invalidList = possibleErrors.invalidList,
                otherErrors = possibleErrors.otherErrors;

            if (invalidList && invalidList.length > 0) {
                return true;
            }
            if (otherErrors && otherErrors.length > 0) {
                return true;
            }
            if (invalidLength) {
                return invalidLength.min || invalidLength.max;
            }
            return false;
        }
    }, {
        key: 'toggleDisplayType',
        value: function toggleDisplayType() {
            if (!this.data) {
                return;
            }
            var displayType = this.data.displayType === DisplayTypes.DETAILS ? DisplayTypes.SUMMARY : DisplayTypes.DETAILS;
            if (displayType === DisplayTypes.SUMMARY) {
                this.mixedBasesPanelProps.visible = false;
            }
            this.data.displayType = displayType;
            this.focusOligoName();
            var oligo = this.oligo,
                projectIdx = this.projectIdx,
                updateOligoDisplayState = this.updateOligoDisplayState;
            var moreOptions = this.data.moreOptions;

            if (oligo && updateOligoDisplayState) {
                var oligoIdx = oligo.index;

                updateOligoDisplayState({
                    displayType: displayType,
                    oligoIdx: oligoIdx,
                    projectIdx: projectIdx,
                    configDisplayType: moreOptions ? __WEBPACK_IMPORTED_MODULE_2__models__["e" /* OligoConfigDisplayTypes */].ADVANCED : __WEBPACK_IMPORTED_MODULE_2__models__["e" /* OligoConfigDisplayTypes */].BASIC
                });
            }
        }
    }, {
        key: 'toggleMoreOptions',
        value: function toggleMoreOptions() {
            if (!this.data) {
                return;
            }
            var moreOptions = !this.data.moreOptions;
            this.data.moreOptions = moreOptions;
            var displayType = this.data.displayType;
            var oligo = this.oligo,
                projectIdx = this.projectIdx,
                updateOligoDisplayState = this.updateOligoDisplayState;

            if (oligo && updateOligoDisplayState) {
                var oligoIdx = oligo.index;

                updateOligoDisplayState({
                    oligoIdx: oligoIdx,
                    displayType: displayType,
                    projectIdx: projectIdx,
                    configDisplayType: moreOptions ? __WEBPACK_IMPORTED_MODULE_2__models__["e" /* OligoConfigDisplayTypes */].ADVANCED : __WEBPACK_IMPORTED_MODULE_2__models__["e" /* OligoConfigDisplayTypes */].BASIC
                });
            }
        }
    }, {
        key: 'selectionToggled',
        value: function selectionToggled(toggleSelectionData) {
            var paramDefId = toggleSelectionData.definition.id;

            var parameters = void 0;
            var radioSelectionData = toggleSelectionData;
            var selectedId = radioSelectionData.selectedId;

            if (selectedId) {
                parameters = [{ id: selectedId, value: selectedId }];
            } else {
                parameters = toggleSelectionData.items.filter(function (item) {
                    return item.selected;
                }).map(function (item) {
                    return { id: item.id, value: item.id };
                });
            }
            this.publishOligoUpdate(paramDefId, parameters);
        }
    }, {
        key: 'onTextFieldBlur',
        value: function onTextFieldBlur(textFieldId) {
            var oligo = this.oligo,
                updateAppState = this.updateAppState,
                appState = this.appState;

            if (!updateAppState || !oligo) {
                return;
            }
            var ignoreStateChange = appState === __WEBPACK_IMPORTED_MODULE_2__models__["b" /* AppStates */].UPDATE || appState === __WEBPACK_IMPORTED_MODULE_2__models__["b" /* AppStates */].DRAFT;
            if (ignoreStateChange) {
                return;
            }
            updateAppState(__WEBPACK_IMPORTED_MODULE_2__models__["b" /* AppStates */].DRAFT);
        }
    }, {
        key: 'publishOligoUpdate',
        value: function publishOligoUpdate(paramDefId, parameters) {
            var _childParentMapping,
                _this2 = this;

            var projectIdx = this.projectIdx,
                oligo = this.oligo,
                updateOligo = this.updateOligo;

            if (!updateOligo || !oligo) {
                return;
            }
            var definition = oligo.definition;
            var basic = definition.basic,
                advanced = definition.advanced;

            var basicId = basic.id || 'basic';
            var advancedId = advanced.id || 'advanced';
            var childParentMapping = (_childParentMapping = {}, _defineProperty(_childParentMapping, basic.researcherName.id, basicId), _defineProperty(_childParentMapping, basic.oligoName.id, basicId), _defineProperty(_childParentMapping, basic.oligoValue.id, basicId), _defineProperty(_childParentMapping, basic.scale.id, basicId), _defineProperty(_childParentMapping, basic.purification.id, basicId), _defineProperty(_childParentMapping, basic.format.id, basicId), _defineProperty(_childParentMapping, basic.prime3Mod.id, basicId), _defineProperty(_childParentMapping, basic.prime5Mod.id, basicId), _defineProperty(_childParentMapping, basic.delivery.id, basicId), _defineProperty(_childParentMapping, advanced.alternate.id, advancedId), _defineProperty(_childParentMapping, advanced.handling.id, advancedId), _childParentMapping);
            var request = {
                parameters: parameters,
                projectIdx: projectIdx,
                oligoIdx: oligo.index,
                parentParameterDefId: childParentMapping[paramDefId],
                parameterDefId: paramDefId
            };
            this.loading = true;
            updateOligo(request).finally(function () {
                return _this2.loading = false;
            });
        }
    }, {
        key: 'publishOligoDelete',
        value: function publishOligoDelete() {
            var _this3 = this;

            var projectIdx = this.projectIdx,
                oligo = this.oligo,
                deleteOligo = this.deleteOligo,
                oligoModalSupport = this.oligoModalSupport;

            if (!oligo || !deleteOligo || !oligoModalSupport) {
                return;
            }
            var id = oligo.id,
                index = oligo.index;

            oligoModalSupport.show({
                title: this.DELETE_POPOVER_TITLE_OLIGO,
                content: this.DELETE_POPOVER_DESC_OLIGO,
                okLabel: this.POPOVER_LABEL_DELETE_CONFIRM,
                cancelLabel: this.POPOVER_CANCEL_LABEL,
                type: __WEBPACK_IMPORTED_MODULE_5__components_oligo_modal_support_oligo_modal_support__["g" /* OligoModalTypes */].CONFIRM
            }).then(function (status) {
                switch (status) {
                    case __WEBPACK_IMPORTED_MODULE_5__components_oligo_modal_support_oligo_modal_support__["f" /* OligoModalSupportStatuses */].OK:
                        _this3.loading = true;
                        deleteOligo({ id: id, index: index, projectIdx: projectIdx }).finally(function () {
                            return _this3.loading = false;
                        });
                        break;
                    case __WEBPACK_IMPORTED_MODULE_5__components_oligo_modal_support_oligo_modal_support__["f" /* OligoModalSupportStatuses */].CANCEL:
                    case __WEBPACK_IMPORTED_MODULE_5__components_oligo_modal_support_oligo_modal_support__["f" /* OligoModalSupportStatuses */].CLOSE:
                    default:
                        break;
                }
            });
        }
    }, {
        key: 'showMixedBasesDisclaimer',
        value: function showMixedBasesDisclaimer() {
            var oligoModalSupport = this.oligoModalSupport;

            if (!oligoModalSupport) {
                return;
            }
            oligoModalSupport.show({
                title: this.MIXED_BASES_POPOVER_DISCLAIMER_TITLE,
                content: this.MIXED_BASES_POPOVER_DISCLAIMER_TPL,
                okLabel: this.MIXED_BASES_POPOVER_OK_LABEL,
                type: __WEBPACK_IMPORTED_MODULE_5__components_oligo_modal_support_oligo_modal_support__["g" /* OligoModalTypes */].INFO
            });
        }
    }, {
        key: 'isUpdateInProgress',
        value: function isUpdateInProgress() {
            return this.appState === __WEBPACK_IMPORTED_MODULE_2__models__["b" /* AppStates */].UPDATE;
        }
    }, {
        key: 'highlightLastBaseIfMixedBase',
        value: function highlightLastBaseIfMixedBase() {}
    }, {
        key: 'synchDisclaimerText',
        value: function synchDisclaimerText() {}
    }, {
        key: 'focusOligoName',
        value: function focusOligoName() {}
    }, {
        key: 'getMixedBasesData',
        value: function getMixedBasesData(sequenceCodes) {
            return sequenceCodes.map(function (seqCode) {
                return { name: seqCode.name, value: seqCode.iupac };
            });
        }
    }, {
        key: 'getVocabularyValue',
        value: function getVocabularyValue(key, defaultValue, world) {
            var vocabulary = world.vocabulary;

            return vocabulary[key] || defaultValue;
        }
    }, {
        key: 'getInvalidBpMsg',
        value: function getInvalidBpMsg(world) {
            return __WEBPACK_IMPORTED_MODULE_3__models_i18n__["c" /* replacePlaceHolders */](this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].MSG_INVALID_BASES, this.INVALID_BP_MSG, world), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__models_i18n__["b" /* PlaceHolderKeys */].INVALID_BASES, ''));
        }
    }, {
        key: 'getSequenceTooShortMsgTpl',
        value: function getSequenceTooShortMsgTpl(world) {
            return this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].MSG_MIN_SEQ, this.SEQUENCE_TOO_SHORT_MSG_TPL, world);
        }
    }, {
        key: 'getSequenceTooLongMsgTpl',
        value: function getSequenceTooLongMsgTpl(world) {
            return this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].MSG_MAX_SEQ, this.SEQUENCE_TOO_LONG_MSG_TPL, world);
        }
    }, {
        key: 'getTatShipByLabelTpl',
        value: function getTatShipByLabelTpl(world) {
            return this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_TAT_SHIP_BY, this.TAT_SHIP_BY_LABEL_TPL, world);
        }
    }, {
        key: 'getTatCutoffLabelTpl',
        value: function getTatCutoffLabelTpl(world) {
            return this.getVocabularyValue(__WEBPACK_IMPORTED_MODULE_3__models_i18n__["a" /* DictionaryKeys */].CONFIG_TAT_CUTOFF, this.TAT_CUTOFF_LABEL_TPL, world);
        }
    }, {
        key: 'showDetails',
        get: function get() {
            return this.data ? this.data.displayType === DisplayTypes.DETAILS : false;
        }
    }]);

    return OligoConfigDetailController;
}();
var OLIGO_CONFIG_DETAIL_NAME = 'oligoConfigDetail';
var OligoConfigDetail = function OligoConfigDetail($compile, $timeout) {
    return {
        template: __webpack_require__("ojCD"),
        controller: OligoConfigDetailController,
        controllerAs: 'oligoConfig',
        transclude: true,
        scope: {
            oligo: '<',
            projectIdx: '<',
            onComponentLayout: '&'
        },
        bindToController: true,
        link: function link($scope, $element, attrs, ctrl) {
            var controller = ctrl;
            var notifyComponentLayoutChange = function notifyComponentLayoutChange() {
                var onComponentLayout = controller.onComponentLayout,
                    oligo = controller.oligo;

                if (onComponentLayout && oligo) {
                    onComponentLayout({ data: oligo });
                }
            };
            var configMainJQ = $element.find('.oligo-config-main').parent().parent();
            var mixBasesJQ = configMainJQ.find('.mix-bases-panel .mbp__container');
            var mixedBasesPanelProps = controller.mixedBasesPanelProps,
                validBases3Prime = controller.validBases3Prime;

            var focusOligoName = function focusOligoName() {
                var focusTimeoutInterval = 200;
                setTimeout(function () {
                    var showDetailsJQ = configMainJQ.find('.oligo-config-main-show-details');
                    var oligoNameJQ = showDetailsJQ.find('.oligo-config-name .sequence-textbox-root .sequence-textbox__content');
                    if (oligoNameJQ.length > 0) {
                        oligoNameJQ.focus();
                    }
                }, focusTimeoutInterval);
            };
            var attachMixBasesDisclaimerLabel = function attachMixBasesDisclaimerLabel() {
                var mixBasesHeadingJQ = mixBasesJQ.find('.mbp__header');
                var mixBasesDisclaimerJQ = mixBasesHeadingJQ.find('.mbp__disclaimertips');
                var disclaimerJQ = $compile('\n          <a class="mbp__disclaimer" style="font-size: 12px; text-decoration: underline;" href="" ng-click="oligoConfig.showMixedBasesDisclaimer()">\n            ' + controller.MIXED_BASES_PANEL_DISCLAIMER_LABEL + '\n          </a>\n        ')($scope);
                mixBasesDisclaimerJQ.append(disclaimerJQ);
                return function () {
                    disclaimerJQ.text(controller.MIXED_BASES_PANEL_DISCLAIMER_LABEL);
                };
            };
            var highlightLastBaseIfMixedBase = function highlightLastBaseIfMixedBase() {
                var sequenceTextBoxSelector = ['.oligo-config-sequence-info__value', '.sequence-textbox-root', '.sequence-textbox__content'].join(' ');
                var invalidBpClass = 'sequence-textbox__basePair--invalid';
                var invalid3PrimeMixBpClass = 'sequence-textbox__basePair--3prime';
                var showDetailsJQ = configMainJQ.find('.oligo-config-main-show-details');
                var prevLastMixBpJQ = showDetailsJQ.find(sequenceTextBoxSelector + ' .' + invalid3PrimeMixBpClass);
                if (prevLastMixBpJQ.length > 0) {
                    prevLastMixBpJQ.each(function (index, prevLastBpEl) {
                        prevLastBpEl.className = prevLastBpEl.className.split(' ').filter(function (className) {
                            return className !== invalid3PrimeMixBpClass && className !== invalidBpClass;
                        }).join(' ');
                    });
                }
                var lastMixBpSelector = [sequenceTextBoxSelector, '.sequence-textbox__block:last-child', '.sequence-textbox__basePair--bold:last-child'].join(' ');
                var lastMixBpJQ = configMainJQ.find(lastMixBpSelector);
                if (lastMixBpJQ.length > 0) {
                    var base = lastMixBpJQ[0].textContent || '';
                    var valid3PrimeBaseIdx = validBases3Prime.indexOf(base.toUpperCase());
                    var invalid3PrimeBase = valid3PrimeBaseIdx < 0;
                    if (invalid3PrimeBase) {
                        lastMixBpJQ.addClass(invalidBpClass + ' ' + invalid3PrimeMixBpClass);
                    }
                }
            };
            var unwatchMixBasesToggle = $scope.$watch(function () {
                return mixedBasesPanelProps.visible;
            }, function (visible) {
                if (!visible) {
                    return;
                }
                var showDetailsJQ = configMainJQ.find('.oligo-config-main-show-details');
                var oligoConfigBasicJQ = showDetailsJQ.find('.oligo-config-basic');
                var oligoConfigSelectionContainerJQ = oligoConfigBasicJQ.find('.oligo-config-selection-container');
                var col1El = oligoConfigSelectionContainerJQ.find('.oligo-synthesis-scale')[0];
                var col2El = oligoConfigSelectionContainerJQ.find('.oligo-synthesis-scale')[1];
                var col3El = oligoConfigSelectionContainerJQ.find('.oligo-synthesis-scale')[2];
                var col4El = oligoConfigSelectionContainerJQ.find('.oligo-synthesis-scale')[3];
                var oligoConfigSelContainerWidth = oligoConfigSelectionContainerJQ[0].offsetWidth;
                var elementRect = configMainJQ[0].getBoundingClientRect();
                var col3MarginLeftStr = window.getComputedStyle(col3El).marginLeft;
                var col3MarginLeft = parseInt(col3MarginLeftStr, 10);
                var mixBasesRectWidth = oligoConfigSelContainerWidth + 50;
                var mixBasesRectHeight = elementRect.height / 2 + 187;
                mixBasesJQ.css('width', mixBasesRectWidth + 'px');
                mixedBasesPanelProps.rect = {
                    right: elementRect.width - (mixBasesRectWidth + 80),
                    height: mixBasesRectHeight - 200,
                    width: mixBasesRectWidth,
                    top: col1El.offsetTop
                };
            });
            var oligoLabelJQ = void 0;
            var scaleLabelJQ = void 0;
            var notifyDisplayTypeChange = function notifyDisplayTypeChange(displayType) {
                if (displayType !== DisplayTypes.DETAILS) {
                    if (oligoLabelJQ) {
                        oligoLabelJQ.popover('destroy');
                        oligoLabelJQ = null;
                    }
                    if (scaleLabelJQ) {
                        scaleLabelJQ.popover('destroy');
                        scaleLabelJQ = null;
                    }
                    return;
                }
                setTimeout(function () {
                    var oligoLabel = $element.find('.oligo-config-sample-label');
                    if (oligoLabel.popover) {
                        var popover = {
                            html: true,
                            placement: 'bottom',
                            trigger: 'hover'
                        };
                        oligoLabel.popover(popover);
                        oligoLabelJQ = oligoLabel;
                    }
                    var scaleLabel = $element.find('.oligo-scale-dropdown-tooltiptext__scale-info--popover');
                    if (scaleLabel.popover) {
                        var _popover = {
                            html: true,
                            placement: 'bottom',
                            trigger: 'hover'
                        };
                        scaleLabel.popover(_popover);
                        scaleLabelJQ = scaleLabel;
                    }
                    highlightLastBaseIfMixedBase();
                });
            };
            controller.synchDisclaimerText = attachMixBasesDisclaimerLabel();
            controller.highlightLastBaseIfMixedBase = highlightLastBaseIfMixedBase;
            controller.focusOligoName = focusOligoName;
            var unwatchOligoFocus = $scope.$watch(function () {
                return controller.oligoInFocus;
            }, function (target) {
                var oligo = controller.oligo;

                if (!oligo || !target) {
                    return;
                }
                if (oligo.id === target.id) {
                    focusOligoName();
                }
            });
            $timeout(function () {
                var unwatchDisplayTypeToggle = $scope.$watch(function () {
                    return controller.data ? controller.data.displayType : DisplayTypes.DETAILS;
                }, notifyDisplayTypeChange);
                var unwatchPanelToggles = $scope.$watchGroup([function () {
                    return controller.data ? controller.data.displayType : DisplayTypes.DETAILS;
                }, function () {
                    return controller.data ? controller.data.moreOptions : false;
                }], notifyComponentLayoutChange);
                $scope.$on('$destroy', function () {
                    if (oligoLabelJQ) {
                        oligoLabelJQ.popover('destroy');
                        oligoLabelJQ = null;
                    }
                    if (scaleLabelJQ) {
                        scaleLabelJQ.popover('destroy');
                        scaleLabelJQ = null;
                    }
                    unwatchPanelToggles();
                    unwatchMixBasesToggle();
                    unwatchDisplayTypeToggle();
                    unwatchOligoFocus();
                    controller.highlightLastBaseIfMixedBase = function () {};
                    controller.focusOligoName = function () {};
                });
            });
        }
    };
};

/***/ }),

/***/ "GKUe":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-65Medium.woff";

/***/ }),

/***/ "HHRE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_OLIGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_OLIGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_OLIGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OLIGO_ACTIONS_SERVICE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OligoActionsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__("lsdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_util__ = __webpack_require__("jQAO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__world_actions__ = __webpack_require__("q8Iw");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var ADD_OLIGO = 'ADD_OLIGO';
var UPDATE_OLIGO = 'UPDATE_OLIGO';
var DELETE_OLIGO = 'DELETE_OLIGO';
function namesParamDefUpdater($q, projectService) {
    return function (updatedParamDefId, updatedParam, oligoItem) {
        var deferred = $q.defer();
        var oligoParamDefs = oligoItem.definition;
        var _oligoParamDefs$basic = oligoParamDefs.basic,
            origOligoName = _oligoParamDefs$basic.oligoName,
            origResearcherName = _oligoParamDefs$basic.researcherName;

        projectService.oligoNamesDefinition(updatedParam).then(function (updatedParamDefs) {
            var previousStatus = oligoParamDefs.status;
            var prevViolatingIds = previousStatus.violatingParamIds;
            var _updatedParamDefs = updatedParamDefs,
                newStatus = _updatedParamDefs.status;
            var newViolatingIds = newStatus.violatingParamIds;
            var _updatedParamDefs$bas = updatedParamDefs.basic,
                oligoName = _updatedParamDefs$bas.oligoName,
                researcherName = _updatedParamDefs$bas.researcherName;

            var prevViolationsNotNameRelated = prevViolatingIds.filter(function (paramDefId) {
                return paramDefId !== researcherName.id && paramDefId !== oligoName.id;
            });
            var remainingViolatingIds = [].concat(_toConsumableArray(prevViolationsNotNameRelated), _toConsumableArray(newViolatingIds));
            var state = remainingViolatingIds.length > 0 ? __WEBPACK_IMPORTED_MODULE_0__models__["g" /* OligoStates */].INVALID : __WEBPACK_IMPORTED_MODULE_0__models__["g" /* OligoStates */].VALID;
            updatedParamDefs = Object.assign({}, oligoParamDefs, {
                basic: Object.assign({}, oligoParamDefs.basic, { oligoName: Object.assign({}, oligoName, {
                        pristine: origOligoName.pristine && updatedParamDefId !== oligoName.id
                    }), researcherName: Object.assign({}, researcherName, {
                        pristine: origResearcherName.pristine && updatedParamDefId !== researcherName.id
                    }) })
            }, {
                status: {
                    state: state,
                    violatingParamIds: remainingViolatingIds
                }
            });
            var id = oligoItem.id,
                index = oligoItem.index,
                displayType = oligoItem.displayType,
                configDisplayType = oligoItem.configDisplayType;

            var oligo = {
                id: id,
                index: index,
                displayType: displayType,
                configDisplayType: configDisplayType,
                pricing: oligoItem.pricing,
                definition: updatedParamDefs,
                parameter: updatedParam
            };
            deferred.resolve(oligo);
        }, deferred.reject);
        return deferred.promise;
    };
}
function paramDefUpdater($q, projectService, pricingService) {
    return function (dispatch, projectIdx, updatedParam, oligoItem) {
        var deferred = $q.defer();
        projectService.oligoParameterDefinition(updatedParam).then(function (updatedParamDefs) {
            var id = oligoItem.id,
                index = oligoItem.index,
                displayType = oligoItem.displayType,
                configDisplayType = oligoItem.configDisplayType;

            var oligo = {
                id: id,
                index: index,
                displayType: displayType,
                configDisplayType: configDisplayType,
                parameter: updatedParam,
                definition: updatedParamDefs
            };
            var basic = updatedParamDefs.basic,
                properties = updatedParamDefs.properties;
            var pricingProps = properties.pricing;
            var pricingSupported = pricingProps.supported;

            var oligoValueDefined = basic.oligoValue.value ? basic.oligoValue.value.length > 0 : false;
            if (pricingSupported && oligoValueDefined) {
                oligo.pricing = {
                    amount: 0,
                    available: pricingSupported,
                    currency: '',
                    loading: true
                };
                dispatch({ type: UPDATE_OLIGO, payload: { projectIdx: projectIdx, oligo: oligo } });
                pricingService.priceForOligo(oligo).then(function (pricing) {
                    var oligoWithPrice = Object.assign({}, oligo, { pricing: pricing });
                    deferred.resolve(oligoWithPrice);
                }, deferred.reject);
            } else {
                deferred.resolve(oligo);
            }
        }, deferred.reject);
        return deferred.promise;
    };
}
function useAsTemplate(template) {
    return function (oligo) {
        if (!template) {
            return oligo;
        }
        try {
            var researcherName = template.definition.basic.researcherName;

            if (researcherName.invalid) {
                return oligo;
            }
            var researcherNameParam = template.parameter.basic.researcherName;

            oligo.definition.basic.researcherName = Object(__WEBPACK_IMPORTED_MODULE_1__models_util__["c" /* deepClone */])(researcherName);
            oligo.parameter.basic.researcherName = Object(__WEBPACK_IMPORTED_MODULE_1__models_util__["c" /* deepClone */])(researcherNameParam);
        } catch (e) {
            console.error(e);
        }
        return oligo;
    };
}
var OLIGO_ACTIONS_SERVICE_NAME = 'OligoActionsService';
var OligoActionsService = function OligoActionsService($q, projectService, pricingService) {
    var updateParamDefs = paramDefUpdater($q, projectService, pricingService);
    var updateNameParamDefs = namesParamDefUpdater($q, projectService);
    return {
        addOligo: function addOligo(request) {
            return function (dispatch, getState, extraArgs) {
                var deferred = $q.defer();
                var nextIdx = request.nextIdx,
                    projectIdx = request.projectIdx,
                    projectId = request.projectId,
                    preference = request.preference,
                    quantity = request.quantity;

                var newOligoRequests = Array.from(Array(quantity || 1).keys()).map(function (key) {
                    var index = nextIdx + key;
                    var id = Object(__WEBPACK_IMPORTED_MODULE_1__models_util__["f" /* generateId */])() + '_' + index + '_' + projectId;
                    var addRequest = { index: index, preference: preference, id: id };
                    return projectService.newOligoItem(addRequest);
                });
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__world_actions__["a" /* UPDATE_APP_STATE */], payload: __WEBPACK_IMPORTED_MODULE_0__models__["b" /* AppStates */].UPDATE });
                $q.all(newOligoRequests).then(function (oligos) {
                    var prevIdx = nextIdx - 1;
                    var project = getState().projects[projectIdx];
                    var prevOligo = (project.oligos || [])[prevIdx];
                    oligos = oligos.map(useAsTemplate(prevOligo));
                    dispatch({ type: ADD_OLIGO, payload: { projectIdx: projectIdx, oligos: oligos } });
                    dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__world_actions__["a" /* UPDATE_APP_STATE */], payload: __WEBPACK_IMPORTED_MODULE_0__models__["b" /* AppStates */].DRAFT });
                    deferred.resolve(oligos);
                }, deferred.reject);
                return deferred.promise;
            };
        },
        updateOligo: function updateOligo(request) {
            return function (dispatch, getState, extraArgs) {
                var deferred = $q.defer();
                var projectIdx = request.projectIdx,
                    oligoIdx = request.oligoIdx,
                    parentParameterDefId = request.parentParameterDefId,
                    parameterDefId = request.parameterDefId,
                    parameters = request.parameters;

                var oligoItem = getState().projects[projectIdx].oligos[oligoIdx];
                var origParam = oligoItem.parameter;
                var updatedParam = {
                    basic: Object.assign({}, origParam.basic),
                    advanced: Object.assign({}, origParam.advanced)
                };
                var oligoParamDefs = oligoItem.definition;
                var paramDef = oligoParamDefs[parentParameterDefId][parameterDefId];
                var selectedObj = paramDef.selected;
                if (Array.isArray(selectedObj)) {
                    updatedParam[parentParameterDefId][parameterDefId] = parameters;
                } else {
                    updatedParam[parentParameterDefId][parameterDefId] = parameters[0];
                }
                var hasNoChange = JSON.stringify(origParam) === JSON.stringify(updatedParam);
                if (hasNoChange) {
                    deferred.resolve();
                    return deferred.promise;
                }
                var retainCurrentState = function retainCurrentState(error) {
                    dispatch({ type: UPDATE_OLIGO, payload: { projectIdx: projectIdx, oligo: Object.assign({}, oligoItem) } });
                    deferred.reject(error);
                };
                var basic = oligoParamDefs.basic;
                var oligoName = basic.oligoName,
                    researcherName = basic.researcherName;

                var isOligoNameUpdate = parameterDefId === oligoName.id;
                var isResearcherNameUpdate = parameterDefId === researcherName.id;
                var isNameParamDefsUpdate = isOligoNameUpdate || isResearcherNameUpdate;
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__world_actions__["a" /* UPDATE_APP_STATE */], payload: __WEBPACK_IMPORTED_MODULE_0__models__["b" /* AppStates */].UPDATE });
                if (isNameParamDefsUpdate) {
                    updateNameParamDefs(parameterDefId, updatedParam, oligoItem).then(function (oligo) {
                        dispatch({ type: UPDATE_OLIGO, payload: { projectIdx: projectIdx, oligo: oligo } });
                        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__world_actions__["a" /* UPDATE_APP_STATE */], payload: __WEBPACK_IMPORTED_MODULE_0__models__["b" /* AppStates */].DRAFT });
                        deferred.resolve(oligo);
                    }, retainCurrentState);
                } else {
                    updateParamDefs(dispatch, projectIdx, updatedParam, oligoItem).then(function (oligo) {
                        dispatch({ type: UPDATE_OLIGO, payload: { projectIdx: projectIdx, oligo: oligo } });
                        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__world_actions__["a" /* UPDATE_APP_STATE */], payload: __WEBPACK_IMPORTED_MODULE_0__models__["b" /* AppStates */].DRAFT });
                        deferred.resolve(oligo);
                    }, retainCurrentState);
                }
                return deferred.promise;
            };
        },
        deleteOligo: function deleteOligo(request) {
            return function (dispatch, getState, extraArgs) {
                var deferred = $q.defer();
                var projectIdx = request.projectIdx,
                    oligoIdx = request.index;

                var oligoItem = getState().projects[projectIdx].oligos[oligoIdx];
                dispatch({ type: DELETE_OLIGO, payload: request });
                deferred.resolve(oligoItem);
                return deferred.promise;
            };
        },
        updateOligoDisplayState: function updateOligoDisplayState(request) {
            return function (dispatch, getState, extraArgs) {
                var deferred = $q.defer();
                var projectIdx = request.projectIdx,
                    oligoIdx = request.oligoIdx,
                    displayType = request.displayType,
                    configDisplayType = request.configDisplayType;

                var oligoItem = getState().projects[projectIdx].oligos[oligoIdx];
                var oligo = Object.assign({}, oligoItem, { displayType: displayType,
                    configDisplayType: configDisplayType });
                dispatch({ type: UPDATE_OLIGO, payload: { projectIdx: projectIdx, oligo: oligo } });
                return deferred.promise;
            };
        }
    };
};

/***/ }),

/***/ "Heu4":
/***/ (function(module, exports) {

module.exports = "<div class=\"project-detail\">\n  <div class=\"project-header-and-project-detail\">\n    <project-header project=\"projectDetail.project\"></project-header>\n    <div class=\"project-detail__oligo\" ng-class=\"{ 'invalid': projectDetail.project.oligos[oligo.index].definition.status.state === 'INVALID' && projectDetail.project.oligos[oligo.index].displayType === 'summary'}\" ng-attr-id=\"project-detail__oligo_{{oligo.id}}\" ng-style=\"{\n                width: projectDetail.oligoDetailDimensions[oligo.index].tombstone ? projectDetail.oligoDetailDimensions[oligo.index].width + 'px' : undefined,\n                height: projectDetail.oligoDetailDimensions[oligo.index].tombstone ? projectDetail.oligoDetailDimensions[oligo.index].height + 'px' : undefined,\n            }\" ng-repeat=\"oligo in projectDetail.project.oligos track by oligo.id\">\n      <oligo-config-detail class=\"oligo-conf-detail\" ng-if=\"!projectDetail.oligoDetailDimensions[oligo.index].tombstone\"\n        project-idx=\"projectDetail.project.index\" oligo=\"oligo\"\n        on-component-layout=\"projectDetail.onOligoComponentLayout({data})\">\n      </oligo-config-detail>\n      <div class=\"project-detail__tombstone\" ng-if=\"projectDetail.oligoDetailDimensions[oligo.index].tombstone\">\n        {{projectDetail.config.tombstoneText || 'Scroll To View' }}\n      </div>\n    </div>\n  </div>\n  <project-footer project=\"projectDetail.project\">\n  </project-footer>\n</div>";

/***/ }),

/***/ "HxNt":
/***/ (function(module, exports) {

module.exports = "<div class=\"oligo-config-preference__items\">\n    <rich-dropdown ng-if=\"!oligoConfigPreference.options.scale.definition.hidden\"\n                  class=\"rich-dropdown {{oligoConfigPreference.options.scale.definition.id}} oligo-config-preference__selection\"\n                  dropdown-obj=\"oligoConfigPreference.options.scale.items\"\n                  hint-url=\"'/us/en/home/products-and-services/product-types/primers-oligos-nucleotides/invitrogen-custom-dna-oligos/popups/scale.html?CID=fl-configoligoscale'\">\n    </rich-dropdown>\n  <div class=\"right-caret-span\"><img class=\"right-caret\" src='/order/custom-standard-oligo/assets/app/img/right-caret.png' /></div>\n    <rich-dropdown ng-if=\"!oligoConfigPreference.options.purification.definition.hidden\"\n                  class=\"rich-dropdown {{oligoConfigPreference.options.purification.definition.id}} oligo-config-preference__selection oligo-config-preference__selection--middle\"\n                  dropdown-obj=\"oligoConfigPreference.options.purification.items\"\n                  hint-url=\"'/us/en/home/products-and-services/product-types/primers-oligos-nucleotides/invitrogen-custom-dna-oligos/popups/purity.html?CID=fl-configoligopurity'\">\n    </rich-dropdown>\n  <span class=\"vertical-split\"></span>\n    <rich-dropdown ng-if=\"!oligoConfigPreference.options.format.definition.hidden\"\n                  class=\"rich-dropdown {{oligoConfigPreference.options.format.definition.id}} oligo-config-preference__selection\"\n                  dropdown-obj=\"oligoConfigPreference.options.format.items\">\n    </rich-dropdown>\n</div>\n";

/***/ }),

/***/ "IQ/s":
/***/ (function(module, exports) {

module.exports = "../fonts/n-a.svg";

/***/ }),

/***/ "IRJ3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("7ylX");
var descriptor = __webpack_require__("fU25");
var setToStringTag = __webpack_require__("yYvK");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("2p1q")(IteratorPrototype, __webpack_require__("kkCw")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "KB1o":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "KJmm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OligoDisplayTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OligoConfigDisplayTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ProjectTemplateColumnDefIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartStates; });
var OligoDisplayTypes = {
    SUMMARY: 'summary',
    DETAILS: 'details'
};
var OligoConfigDisplayTypes = {
    BASIC: 'basic',
    ADVANCED: 'advanced'
};
var ProjectTemplateColumnDefIds = {
    OLIGO_VALUE: 'oligoValue',
    OLIGO_NAME: 'oligoName',
    RESEARCHER_NAME: 'researcherName',
    SCALE: 'scale',
    PRIME_3_MOD: 'prime3Mod',
    PRIME_5_MOD: 'prime5Mod',
    PURIFICATION: 'purification',
    SPECIAL_HANDLING: 'specialHandling'
};
var CartStates = {
    PROCESSING: 'processing',
    SUCCESS: 'success',
    FAILED: 'failed'
};

/***/ }),

/***/ "KOrd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("WBcL");
var toObject = __webpack_require__("FryR");
var IE_PROTO = __webpack_require__("mZON")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "KgF1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DragAndDropController */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DRAG_AND_DROP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DragAndDropCreator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__drag_and_drop_scss__ = __webpack_require__("b/d/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__drag_and_drop_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__drag_and_drop_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var DragAndDropController = function () {
    function DragAndDropController() {
        _classCallCheck(this, DragAndDropController);

        this.disable = false;
        this.dragActive = false;
        this.showDndArea = false;
    }

    _createClass(DragAndDropController, [{
        key: 'areaVisible',
        value: function areaVisible() {
            return !this.disable && (this.showDndArea || this.dragActive);
        }
    }]);

    return DragAndDropController;
}();
var DRAG_AND_DROP_NAME = 'dragAndDrop';
var DragAndDropCreator = function DragAndDropCreator($q) {
    return {
        template: __webpack_require__("fmrt"),
        restrict: 'E',
        scope: {
            disable: '<',
            showDndArea: '<',
            processor: '<'
        },
        controller: DragAndDropController,
        controllerAs: 'dndSupport',
        transclude: true,
        bindToController: true,
        link: function link($scope, element, attrs, ctrl) {
            var dndSupport = ctrl;
            element.addClass('drag-and-drop-root');
            element.on('dragover', function (event) {
                event.stopPropagation();
                event.preventDefault();
                if (dndSupport.disable) {
                    return;
                }
                var dragEvent = event.originalEvent || event;
                var dataTransfer = dragEvent.dataTransfer;
                dataTransfer.dropEffect = 'none';
                var typeList = dataTransfer.types;

                if (!typeList) {
                    return;
                }
                var types = Array.prototype.slice.call(typeList).filter(function (type) {
                    return type.indexOf('Files') >= 0;
                });
                if (types.length < 1) {
                    return;
                }
                dataTransfer.dropEffect = 'copy';
                $scope.$apply(function () {
                    return dndSupport.dragActive = true;
                });
            });
            element.on('dragleave', function (e) {
                e.stopPropagation();
                e.preventDefault();
                if (dndSupport.disable) {
                    return;
                }
                $scope.$apply(function () {
                    return dndSupport.dragActive = false;
                });
            });
            element.on('drop', function (event) {
                event.preventDefault();
                if (dndSupport.disable) {
                    return;
                }
                var dragEvent = event.originalEvent || event;
                var files = dragEvent.dataTransfer.files;
                if (!files || files.length <= 0) {
                    $scope.$apply(function () {
                        return dndSupport.dragActive = false;
                    });
                    return;
                }
                var dragAndDropProcessor = dndSupport.processor;

                if (!dragAndDropProcessor) {
                    $scope.$apply(function () {
                        return dndSupport.dragActive = false;
                    });
                    return;
                }
                dragAndDropProcessor.processDroppedFiles(files).then(function (result) {
                    dndSupport.dragActive = false;
                    dragAndDropProcessor.onDragAndDropSuccess(result);
                }, function (result) {
                    dndSupport.dragActive = false;
                    dragAndDropProcessor.onDragAndDropFailure(result);
                });
            });
        }
    };
};

/***/ }),

/***/ "Le+Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCookie;
/* unused harmony export replaceKeys */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) !== -1) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}
function replaceKeys(target, propertyKeyMap) {
    if (!target) {
        return target;
    }
    var build = {};
    for (var key in target) {
        if (target[key]) {
            var srcKey = key;
            var destKey = propertyKeyMap[srcKey] || srcKey;
            var value = target[srcKey];
            if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !Array.isArray(value)) {
                value = replaceKeys(value, propertyKeyMap);
            }
            build[destKey] = value;
        } else {
            var _srcKey = key;
            var _destKey = propertyKeyMap[_srcKey] || _srcKey;
            var _value = target[_srcKey];
            build[_destKey] = _value;
        }
    }
    return build;
}

/***/ }),

/***/ "LhTa":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("rFzY");
var IObject = __webpack_require__("Q6Nf");
var toObject = __webpack_require__("FryR");
var toLength = __webpack_require__("BbyF");
var asc = __webpack_require__("plSV");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "LqB4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = cloneOptions;
/* harmony export (immutable) */ __webpack_exports__["e"] = preferenceOptionsToPreference;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OligoConfigPreferenceController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OLIGO_CONFIG_PREFERENCE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OligoConfigPreference; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__oligo_config_preference_scss__ = __webpack_require__("8aOi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__oligo_config_preference_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__oligo_config_preference_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_util__ = __webpack_require__("jQAO");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PREFERENCE_OLIGO_SEQUENCE = 'A'.repeat(20);
function acquireOptions($q, projectService) {
    return function (request) {
        var deferred = $q.defer();
        projectService.newOligoItem(request).then(function (oligo) {
            var parameter = oligo.parameter;

            parameter.basic.oligoValue.value = PREFERENCE_OLIGO_SEQUENCE;
            projectService.oligoParameterDefinition(parameter).then(function (paramDefs) {
                var _paramDefs$basic = paramDefs.basic,
                    scale = _paramDefs$basic.scale,
                    purification = _paramDefs$basic.purification,
                    format = _paramDefs$basic.format;

                var options = {
                    scale: {
                        definition: scale,
                        items: __WEBPACK_IMPORTED_MODULE_1__models_util__["g" /* selectionClientParamDefToDropDownContent */](scale)
                    },
                    purification: {
                        definition: purification,
                        items: __WEBPACK_IMPORTED_MODULE_1__models_util__["g" /* selectionClientParamDefToDropDownContent */](purification)
                    },
                    format: {
                        definition: format,
                        items: __WEBPACK_IMPORTED_MODULE_1__models_util__["g" /* selectionClientParamDefToDropDownContent */](format)
                    }
                };
                deferred.resolve(options);
            }, deferred.reject);
        }, deferred.reject);
        return deferred.promise;
    };
}
function cloneOptions(options) {
    var scale = options.scale,
        format = options.format,
        purification = options.purification;

    var scaleDef = scale.definition ? __WEBPACK_IMPORTED_MODULE_1__models_util__["c" /* deepClone */](scale.definition) : scale.definition;
    var formatDef = format.definition ? __WEBPACK_IMPORTED_MODULE_1__models_util__["c" /* deepClone */](format.definition) : format.definition;
    var purificationDef = purification.definition ? __WEBPACK_IMPORTED_MODULE_1__models_util__["c" /* deepClone */](purification.definition) : purification.definition;
    var newOptions = {
        scale: {
            definition: scaleDef,
            items: scaleDef ? __WEBPACK_IMPORTED_MODULE_1__models_util__["g" /* selectionClientParamDefToDropDownContent */](scaleDef) : __WEBPACK_IMPORTED_MODULE_1__models_util__["d" /* defaultDropDownContent */]()
        },
        purification: {
            definition: purificationDef,
            items: purificationDef ? __WEBPACK_IMPORTED_MODULE_1__models_util__["g" /* selectionClientParamDefToDropDownContent */](purificationDef) : __WEBPACK_IMPORTED_MODULE_1__models_util__["d" /* defaultDropDownContent */]()
        },
        format: {
            definition: formatDef,
            items: formatDef ? __WEBPACK_IMPORTED_MODULE_1__models_util__["g" /* selectionClientParamDefToDropDownContent */](formatDef) : __WEBPACK_IMPORTED_MODULE_1__models_util__["d" /* defaultDropDownContent */]()
        }
    };
    return newOptions;
}
function preferenceOptionsToPreference(options) {
    var scale = options.scale,
        purification = options.purification,
        format = options.format;

    var scaleDef = scale.definition;
    var purificationDef = purification.definition;
    var formatDef = format.definition;
    var preference = {
        scale: { id: scaleDef.selected.id, value: scaleDef.selected.value },
        purification: { id: purificationDef.selected.id, value: purificationDef.selected.value },
        format: { id: formatDef.selected.id, value: formatDef.selected.value },
        isDefault: false
    };
    return preference;
}
var OligoConfigPreferenceController = function OligoConfigPreferenceController($scope, $q, projectService) {
    var _this = this;

    _classCallCheck(this, OligoConfigPreferenceController);

    this.options = {
        scale: {
            items: __WEBPACK_IMPORTED_MODULE_1__models_util__["d" /* defaultDropDownContent */]()
        },
        purification: {
            items: __WEBPACK_IMPORTED_MODULE_1__models_util__["d" /* defaultDropDownContent */]()
        },
        format: {
            items: __WEBPACK_IMPORTED_MODULE_1__models_util__["d" /* defaultDropDownContent */]()
        }
    };
    this.loading = false;
    var getOptionsDef = acquireOptions($q, projectService);
    var unwatchPreference = $scope.$watch(function () {
        return _this.preference;
    }, function (preference) {
        _this.loading = true;
        if (_this.changeHandler) {
            _this.changeHandler.onOptionChangeStart();
        }
        getOptionsDef({ preference: preference, id: '0', index: 0 }).then(function (options) {
            _this.options = options;
            if (_this.changeHandler) {
                _this.changeHandler.onOptionChangeSuccess(options);
            }
        }, function (errorCause) {
            if (_this.changeHandler) {
                _this.changeHandler.onOptionChangeFailed(errorCause);
            }
        }).finally(function () {
            return _this.loading = false;
        });
    });
    var selectionScopeWatchers = [];
    var unwatchOptions = $scope.$watch(function () {
        return _this.options;
    }, function (options) {
        if (!options) {
            return;
        }
        var latestOptions = cloneOptions(options);
        selectionScopeWatchers.forEach(function (unwatch) {
            return unwatch();
        });
        selectionScopeWatchers.length = 0;
        var selectionWatchers = [options.scale, options.purification, options.format].filter(function (dropdownData) {
            return dropdownData.definition && _typeof(dropdownData.definition) === 'object';
        }).map(function (dropdownData) {
            return function (selectionData) {
                return $scope.$watch(function () {
                    return selectionData.items.selected;
                }, function (selected, oldSelected) {
                    if (selected === oldSelected || !selectionData.definition) {
                        return;
                    }
                    var selectedParamDef = selectionData.definition.value.find(function (paramDef) {
                        return paramDef.name === selected.title;
                    });
                    selectionData.definition.selected = selectedParamDef;
                    var updatedPreference = preferenceOptionsToPreference(options);
                    _this.loading = true;
                    if (_this.changeHandler) {
                        _this.changeHandler.onOptionChangeStart();
                    }
                    getOptionsDef({ id: '0', index: 0, preference: updatedPreference }).then(function (newOptions) {
                        _this.options = newOptions;
                        latestOptions = cloneOptions(newOptions);
                        if (_this.changeHandler) {
                            _this.changeHandler.onOptionChangeSuccess(newOptions);
                        }
                    }, function (errorCause) {
                        _this.options = cloneOptions(latestOptions);
                        if (_this.changeHandler) {
                            _this.changeHandler.onOptionChangeFailed(errorCause);
                        }
                    }).finally(function () {
                        return _this.loading = false;
                    });
                });
            }(dropdownData);
        });
        selectionScopeWatchers = selectionScopeWatchers.concat(selectionWatchers);
    });
    $scope.$on('$destroy', function () {
        selectionScopeWatchers.forEach(function (unwatch) {
            return unwatch();
        });
        selectionScopeWatchers.length = 0;
        unwatchPreference();
        unwatchOptions();
    });
};
var OLIGO_CONFIG_PREFERENCE_NAME = 'oligoConfigPreference';
var OligoConfigPreference = function OligoConfigPreference() {
    return {
        template: __webpack_require__("HxNt"),
        controller: OligoConfigPreferenceController,
        controllerAs: 'oligoConfigPreference',
        restrict: 'E',
        scope: {
            preference: '<',
            changeHandler: '<',
            fromBulk: '<'
        },
        bindToController: true
    };
};

/***/ }),

/***/ "MxAL":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-56Italic.eot";

/***/ }),

/***/ "NGuR":
/***/ (function(module, exports) {

module.exports = "<div id=\"{{modalSupport.MODAL_ID}}\" class=\"modal fade oligo-modal-support\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"oligo-modal-support__title\" aria-hidden=\"true\">\n  <div class=\"modal-dialog modal-dialog-centered modal-lg\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\" id=\"oligo-modal-support__title\"> {{modalSupport.data.title}}</h5>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"modalSupport.close()\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n      <div class=\"modal-body\">\n        <div class=\"container-fluid\">\n          <fancy-message-pane ng-if=\"modalSupport.data.alertData\"\n                              state=\"modalSupport.data.alertData.state\"\n                              message=\"modalSupport.data.alertData.content\">\n          </fancy-message-pane>\n          <div ng-if=\"modalSupport.data.content && modalSupport.data.content.length > 0\"\n               ng-bind-html=\"modalSupport.data.content\">\n          </div>\n        </div>\n      </div>\n      <div class=\"modal-footer justify-content-start\">\n        <button type=\"button\"\n                class=\"btn btn-outline-primary\"\n                ng-click=\"modalSupport.cancel()\"\n                ng-if=\"modalSupport.data.type === 'CONFIRM'\">{{modalSupport.data.cancelLabel || 'Cancel'}}</button>\n        <button type=\"button\"\n                class=\"btn btn-danger\"\n                ng-click=\"modalSupport.ok()\">{{modalSupport.data.okLabel || 'Ok'}}</button>\n      </div>\n    </div>\n  </div>\n</div>";

/***/ }),

/***/ "NJMj":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-56Italic.woff2";

/***/ }),

/***/ "NKgu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__oligo_actions__ = __webpack_require__("HHRE");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__oligo_actions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__oligo_actions__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__oligo_actions__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__project_actions__ = __webpack_require__("vBqh");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__project_actions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__project_actions__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__project_actions__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__project_actions__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__world_actions__ = __webpack_require__("q8Iw");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__world_actions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__world_actions__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__root_actions__ = __webpack_require__("vH9U");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__root_actions__["a"]; });





/***/ }),

/***/ "Oqx3":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-55Roman.woff";

/***/ }),

/***/ "Or2i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OzIq":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "PHqh":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("Q6Nf");
var defined = __webpack_require__("/whu");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "PTRJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isIE;
/* unused harmony export isFF */
/* unused harmony export isSafari */
function isIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    var trident = ua.indexOf('Trident');
    var edge = ua.indexOf('Edge');
    return msie > 0 || trident > 0 || edge > 0;
}
function isFF() {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}
function isSafari() {
    return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
}

/***/ }),

/***/ "Q5iq":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-56Italic.svg";

/***/ }),

/***/ "Q6Nf":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("ydD5");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "QKXm":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "Qh14":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ReGu");
var enumBugKeys = __webpack_require__("QKXm");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "R3AP":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("OzIq");
var hide = __webpack_require__("2p1q");
var has = __webpack_require__("WBcL");
var SRC = __webpack_require__("ulTY")('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("7gX0").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "RYtm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ReGu":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("WBcL");
var toIObject = __webpack_require__("PHqh");
var arrayIndexOf = __webpack_require__("ot5s")(false);
var IE_PROTO = __webpack_require__("mZON")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "RhFG":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("kkCw")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("2p1q")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "SHe9":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("wC1N");
var ITERATOR = __webpack_require__("kkCw")('iterator');
var Iterators = __webpack_require__("bN1p");
module.exports = __webpack_require__("7gX0").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "SJEx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PRICE_RULE_TYPES */
/* unused harmony export PRICE_ACCESS_STATUSES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRICING_SERVICE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PricingServiceFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_config_service__ = __webpack_require__("biSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_util__ = __webpack_require__("jQAO");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var PRICE_RULE_TYPES = {
    ACCOUNT: 'ACCOUNT',
    LIST: 'LIST'
};
var PRICE_ACCESS_STATUSES = {
    ORDERABLE: 'Orderable',
    CONTACT_US: 'ContactUs',
    NO_PRICE: '***',
    DISTRIBUTOR: 'Distributor',
    RFQ: 'RFQ',
    PVNO: 'PVNO',
    LWTB: 'LearnWhereToBuy'
};
function hasSkuDefined(selected) {
    return typeof selected.sku === 'string' && selected.sku.length > 0 && selected.sku !== '-';
}
function scaleToProductBasedOnOligos(oligoValues) {
    return function (scaleDef) {
        return {
            catalogNumber: scaleDef.sku,
            quantity: oligoValues.reduce(function (total, paramDef) {
                total = total + Object(__WEBPACK_IMPORTED_MODULE_1__models_util__["b" /* countSequenceLength */])(paramDef.value);
                return total;
            }, 0)
        };
    };
}
function internalModProductsFromOligo(paramDef) {
    var internalModSkuMap = paramDef.internalMod;

    var internalModProducts = internalModSkuMap.filter(function (im) {
        return typeof im.sku === 'string' && im.sku.length > 0 && im.quantity > 0;
    }).map(function (im) {
        return { catalogNumber: im.sku, quantity: im.quantity };
    });
    var internalModsMap = mergeSameProducts({}, internalModProducts);
    return Object.keys(internalModsMap).map(function (sku) {
        return internalModsMap[sku];
    });
}
function mergeSameProducts(acc, nextProducts) {
    nextProducts.forEach(function (product) {
        var catalogNumber = product.catalogNumber;

        var existProduct = acc[catalogNumber];
        if (existProduct) {
            existProduct.quantity = existProduct.quantity + product.quantity;
        } else {
            acc[catalogNumber] = Object.assign({}, product);
        }
    });
    return acc;
}
function productsForOligo(oligo) {
    var definition = oligo.definition;
    var basic = definition.basic,
        advanced = definition.advanced;
    var scale = basic.scale,
        purification = basic.purification,
        format = basic.format,
        delivery = basic.delivery,
        prime3Mod = basic.prime3Mod,
        prime5Mod = basic.prime5Mod;
    var alternate = advanced.alternate,
        handling = advanced.handling;
    var oligoValue = basic.oligoValue;

    var oligoValues = [oligoValue].concat(_toConsumableArray(alternate.selected)).filter(function (paramDef) {
        return typeof paramDef.value === 'string';
    });
    var scaleProducts = [scale.selected].filter(hasSkuDefined).map(scaleToProductBasedOnOligos(oligoValues));
    var internalModProductMap = oligoValues.map(internalModProductsFromOligo).reduce(mergeSameProducts, {});
    var internalModProducts = Object.keys(internalModProductMap).map(function (key) {
        return internalModProductMap[key];
    });
    var selectionProducts = [purification.selected, format.selected, delivery.selected, prime3Mod.selected, prime5Mod.selected].concat(_toConsumableArray(handling.selected)).filter(hasSkuDefined).map(function (selected) {
        return {
            catalogNumber: selected.sku,
            quantity: oligoValues.length
        };
    });
    return [].concat(_toConsumableArray(scaleProducts), _toConsumableArray(selectionProducts), _toConsumableArray(internalModProducts));
}
function hasPriceInfo(product) {
    return product.unFormattedPrice ? _typeof(product.unFormattedPrice) === 'object' : false;
}
function productPrice(priceDetails) {
    var listPrice = priceDetails.listPrice,
        finalPrice = priceDetails.finalPrice;

    var targetPrice = typeof finalPrice === 'number' ? finalPrice : listPrice;
    return targetPrice;
}
function isPriceViewable(product) {
    var priceAccess = product.priceAccess;
    var status = priceAccess.status;

    var hasPriceViewStatus = status === PRICE_ACCESS_STATUSES.ORDERABLE || status === PRICE_ACCESS_STATUSES.PVNO;
    if (hasPriceInfo(product)) {
        var unFormattedPrice = product.unFormattedPrice;

        var targetPrice = productPrice(unFormattedPrice);
        var hasZeroPrice = targetPrice === 0;
        return hasPriceViewStatus || hasZeroPrice;
    }
    return hasPriceViewStatus;
}
function pricingResultFromProducts(products, skuQuantityMap) {
    var pricingResult = {
        available: true,
        amount: 0,
        currency: 'USD'
    };
    products = products || [];
    if (products.length > 0) {
        pricingResult = products.reduce(function (result, product) {
            var showPrice = isPriceViewable(product);
            if (showPrice) {
                var unFormattedPrice = product.unFormattedPrice,
                    catalogNumber = product.catalogNumber,
                    supplier = product.supplier;

                var currency = supplier ? supplier.currency : product.currency;
                var quantity = skuQuantityMap[catalogNumber];
                var targetPrice = productPrice(unFormattedPrice);
                result.amount = result.amount + targetPrice * quantity;
                result.currency = currency;
            }
            result.available = result.available && showPrice;
            return result;
        }, pricingResult);
    } else {
        pricingResult.available = false;
    }
    return pricingResult;
}

var PricingServiceImpl = function () {
    function PricingServiceImpl($q, $http, configService, userDetailsService) {
        _classCallCheck(this, PricingServiceImpl);

        this.$q = $q;
        this.$http = $http;
        this.configService = configService;
        this.userDetailsService = userDetailsService;
    }

    _createClass(PricingServiceImpl, [{
        key: 'pricesForOligos',
        value: function pricesForOligos(oligos) {
            var rootDeferred = this.$q.defer();
            var pricingDataMap = oligos.reduce(function (acc, oligo) {
                var id = oligo.id;
                var allSkus = acc.allSkus,
                    skusPerOligo = acc.skusPerOligo;

                var products = productsForOligo(oligo);
                var skuQuantityMap = products.reduce(function (skuQuantityMapForOligo, product) {
                    var catalogNumber = product.catalogNumber,
                        quantity = product.quantity;

                    skuQuantityMapForOligo[catalogNumber] = quantity;
                    return skuQuantityMapForOligo;
                }, {});
                skusPerOligo[id] = skuQuantityMap;
                Object.keys(skuQuantityMap).forEach(function (sku) {
                    allSkus[sku] = 1;
                });
                return acc;
            }, { allSkus: {}, skusPerOligo: {} });
            var allSkusMap = pricingDataMap.allSkus,
                skusPerOligoMap = pricingDataMap.skusPerOligo;

            var pricingResultMap = {};
            this.pricesForSkus(allSkusMap).then(function (products) {
                pricingResultMap = Object.keys(skusPerOligoMap).reduce(function (acc, oligoId) {
                    var skuQuantityMapForThisOligo = skusPerOligoMap[oligoId];
                    var productsForThisOligo = products.filter(function (product) {
                        var catalogNumber = product.catalogNumber;

                        var skuPresentInThisOligo = typeof skuQuantityMapForThisOligo[catalogNumber] === 'number';
                        return skuPresentInThisOligo;
                    });
                    var pricingResult = pricingResultFromProducts(productsForThisOligo, skuQuantityMapForThisOligo);
                    acc[oligoId] = pricingResult;
                    return acc;
                }, {});
                rootDeferred.resolve(pricingResultMap);
            }, function (e) {
                console.error(e);
                var pricingResult = {
                    amount: 0,
                    available: false,
                    currency: ''
                };
                pricingResultMap = oligos.reduce(function (acc, oligo) {
                    var id = oligo.id;

                    acc[id] = Object.assign({}, pricingResult);
                    return acc;
                }, {});
                rootDeferred.resolve(pricingResultMap);
            });
            return rootDeferred.promise;
        }
    }, {
        key: 'priceForOligo',
        value: function priceForOligo(oligo) {
            var rootDeferred = this.$q.defer();
            this.pricesForOligos([oligo]).then(function (pricingMap) {
                rootDeferred.resolve(pricingMap[oligo.id]);
            }, rootDeferred.reject);
            return rootDeferred.promise;
        }
    }, {
        key: 'pricesForSkus',
        value: function pricesForSkus(skuQuantityMap) {
            var _this = this;

            var rootDeferred = this.$q.defer();
            var getUserDetails = function getUserDetails() {
                var deferred = _this.$q.defer();
                if (!_this.userDetails) {
                    _this.userDetailsService.getUserDetails().then(function (userDetails) {
                        _this.userDetails = userDetails;
                        deferred.resolve(userDetails);
                    }, deferred.reject);
                } else {
                    deferred.resolve(_this.userDetails);
                }
                return deferred.promise;
            };
            getUserDetails().then(function (userDetails) {
                var path = _this.configService.pathFor(__WEBPACK_IMPORTED_MODULE_0__app_config_service__["a" /* API_ENDPOINTS */].GET_PRICE);
                var pricingRequest = Object.keys(skuQuantityMap).reduce(function (acc, catalogNumber) {
                    var items = acc.items;

                    var quantity = skuQuantityMap[catalogNumber];
                    items.push({ catalogNumber: catalogNumber, quantity: quantity });
                    return acc;
                }, { countryCode: userDetails.countryCode, items: [] });
                _this.$http.post(path, pricingRequest).then(function (response) {
                    var status = response.status,
                        data = response.data;

                    if (status === 200) {
                        var pricing = data.pricing;
                        var products = pricing.products;

                        rootDeferred.resolve(products);
                    } else {
                        throw new Error('Unable to retrieve prices with status code: ' + status);
                    }
                }, rootDeferred.reject);
            }, rootDeferred.reject);
            return rootDeferred.promise;
        }
    }]);

    return PricingServiceImpl;
}();

function skusNotInCache(target, cache) {
    return Object.keys(target).reduce(function (acc, sku) {
        var priceInfo = cache[sku];
        if (!priceInfo) {
            acc[sku] = target[sku];
        }
        return acc;
    }, {});
}

var InMemoryCachePricingServiceDecorator = function () {
    function InMemoryCachePricingServiceDecorator($q, delegate) {
        _classCallCheck(this, InMemoryCachePricingServiceDecorator);

        this.$q = $q;
        this.delegate = delegate;
        this.priceMap = {};
        this.remotePriceForSkus = delegate.pricesForSkus.bind(delegate);
        delegate.pricesForSkus = this.pricesForSkus.bind(this);
    }

    _createClass(InMemoryCachePricingServiceDecorator, [{
        key: 'pricesForOligos',
        value: function pricesForOligos(oligos) {
            return this.delegate.pricesForOligos(oligos);
        }
    }, {
        key: 'priceForOligo',
        value: function priceForOligo(oligo) {
            return this.delegate.priceForOligo(oligo);
        }
    }, {
        key: 'pricesForSkus',
        value: function pricesForSkus(skuQuantityMap) {
            var priceMap = this.priceMap;

            var rootDeferred = this.$q.defer();
            var oligoSkusNotInCache = skusNotInCache(skuQuantityMap, priceMap);
            var allSkuPricesCached = Object.keys(oligoSkusNotInCache).length < 1;
            var productPricesFromCache = function productPricesFromCache() {
                return Object.keys(skuQuantityMap).map(function (sku) {
                    var quantity = skuQuantityMap[sku];
                    var product = priceMap[sku];
                    return Object.assign({}, product, { quantity: quantity });
                });
            };
            if (allSkuPricesCached) {
                rootDeferred.resolve(productPricesFromCache());
            } else {
                this.remotePriceForSkus(oligoSkusNotInCache).then(function (products) {
                    if (products) {
                        products.forEach(function (product) {
                            priceMap[product.catalogNumber] = product;
                        });
                    }
                    rootDeferred.resolve(productPricesFromCache());
                }, rootDeferred.reject);
            }
            return rootDeferred.promise;
        }
    }]);

    return InMemoryCachePricingServiceDecorator;
}();

var PRICING_SERVICE_NAME = 'pricingService';
var PricingServiceFactory = function PricingServiceFactory($q, $http, configService, userDetailsService) {
    return new InMemoryCachePricingServiceDecorator($q, new PricingServiceImpl($q, $http, configService, userDetailsService));
};

/***/ }),

/***/ "Sc+s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FANCY_MESSAGE_PANE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FancyMessagePaneStates; });
/* unused harmony export FancyMessagePaneController */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FancyMessagePaneCreator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fancy_message_pane_scss__ = __webpack_require__("7q5I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fancy_message_pane_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fancy_message_pane_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var FANCY_MESSAGE_PANE_NAME = 'fancyMessagePane';
var FancyMessagePaneStates = {
    INFO: {
        id: 'info',
        name: 'Info',
        icon: 'icon-24-info-bold',
        status: 'info'
    },
    WARN: {
        id: 'warning',
        name: 'Warning',
        icon: 'icon-24-warning-bold',
        status: 'warning'
    },
    ERROR: {
        id: 'danger',
        name: 'Error',
        icon: 'icon-24-alert-bold',
        status: 'danger'
    },
    SUCCESS: {
        id: 'success',
        name: 'Success',
        icon: 'icon-24-success-bold',
        status: 'success'
    }
};
var FancyMessagePaneController = function FancyMessagePaneController() {
    _classCallCheck(this, FancyMessagePaneController);
};
var FancyMessagePaneCreator = function FancyMessagePaneCreator() {
    return {
        controllerAs: 'fancyMessagePane',
        controller: FancyMessagePaneController,
        bindToController: true,
        scope: {
            state: '<',
            message: '<',
            float: '<',
            closeable: '<',
            onClose: '&'
        },
        template: __webpack_require__("VexM"),
        transclude: false,
        link: function link($scope, $elem, attrs, ctrl) {
            $elem.addClass('fancy-message-pane-root');
        }
    };
};

/***/ }),

/***/ "St0U":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-65Medium.ttf";

/***/ }),

/***/ "SxqO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_custom_components_dist_custom_components_css__ = __webpack_require__("fZzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_custom_components_dist_custom_components_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_custom_components_dist_custom_components_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__komodo_css_icons_css__ = __webpack_require__("Epvr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__komodo_css_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__komodo_css_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__komodo_css_fonts_css__ = __webpack_require__("A2Ll");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__komodo_css_fonts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__komodo_css_fonts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__komodo_atoms_shadows_css_shadows_css__ = __webpack_require__("1SVs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__komodo_atoms_shadows_css_shadows_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__komodo_atoms_shadows_css_shadows_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__komodo_atoms_information_badge_css_information_badge_css__ = __webpack_require__("EieL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__komodo_atoms_information_badge_css_information_badge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__komodo_atoms_information_badge_css_information_badge_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__komodo_atoms_warning_badge_css_warning_badge_css__ = __webpack_require__("4lrW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__komodo_atoms_warning_badge_css_warning_badge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__komodo_atoms_warning_badge_css_warning_badge_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__komodo_atoms_danger_badge_css_danger_badge_css__ = __webpack_require__("WgTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__komodo_atoms_danger_badge_css_danger_badge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__komodo_atoms_danger_badge_css_danger_badge_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__komodo_atoms_success_badge_css_success_badge_css__ = __webpack_require__("Or2i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__komodo_atoms_success_badge_css_success_badge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__komodo_atoms_success_badge_css_success_badge_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__komodo_fonts_n_a_eot__ = __webpack_require__("4fv2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__komodo_fonts_n_a_eot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__komodo_fonts_n_a_eot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__komodo_fonts_n_a_svg__ = __webpack_require__("IQ/s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__komodo_fonts_n_a_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__komodo_fonts_n_a_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__komodo_fonts_n_a_ttf__ = __webpack_require__("wKCN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__komodo_fonts_n_a_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__komodo_fonts_n_a_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__komodo_fonts_n_a_woff__ = __webpack_require__("UOgc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__komodo_fonts_n_a_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__komodo_fonts_n_a_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__komodo_fonts_HelveticaNeueLTW01_35Thin_eot__ = __webpack_require__("Wo5r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__komodo_fonts_HelveticaNeueLTW01_35Thin_eot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__komodo_fonts_HelveticaNeueLTW01_35Thin_eot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__komodo_fonts_HelveticaNeueLTW01_45Light_eot__ = __webpack_require__("UUnl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__komodo_fonts_HelveticaNeueLTW01_45Light_eot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__komodo_fonts_HelveticaNeueLTW01_45Light_eot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__komodo_fonts_HelveticaNeueLTW01_55Roman_eot__ = __webpack_require__("bSfI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__komodo_fonts_HelveticaNeueLTW01_55Roman_eot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__komodo_fonts_HelveticaNeueLTW01_55Roman_eot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__komodo_fonts_HelveticaNeueLTW01_56Italic_eot__ = __webpack_require__("MxAL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__komodo_fonts_HelveticaNeueLTW01_56Italic_eot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__komodo_fonts_HelveticaNeueLTW01_56Italic_eot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__komodo_fonts_HelveticaNeueLTW01_65Medium_eot__ = __webpack_require__("BReQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__komodo_fonts_HelveticaNeueLTW01_65Medium_eot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__komodo_fonts_HelveticaNeueLTW01_65Medium_eot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__komodo_fonts_HelveticaNeueLTW01_75Bold_eot__ = __webpack_require__("TN9k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__komodo_fonts_HelveticaNeueLTW01_75Bold_eot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__komodo_fonts_HelveticaNeueLTW01_75Bold_eot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__komodo_fonts_HelveticaNeueLTW01_35Thin_svg__ = __webpack_require__("x/He");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__komodo_fonts_HelveticaNeueLTW01_35Thin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__komodo_fonts_HelveticaNeueLTW01_35Thin_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__komodo_fonts_HelveticaNeueLTW01_45Light_svg__ = __webpack_require__("3u5d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__komodo_fonts_HelveticaNeueLTW01_45Light_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__komodo_fonts_HelveticaNeueLTW01_45Light_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__komodo_fonts_HelveticaNeueLTW01_55Roman_svg__ = __webpack_require__("5he4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__komodo_fonts_HelveticaNeueLTW01_55Roman_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__komodo_fonts_HelveticaNeueLTW01_55Roman_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__komodo_fonts_HelveticaNeueLTW01_56Italic_svg__ = __webpack_require__("Q5iq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__komodo_fonts_HelveticaNeueLTW01_56Italic_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__komodo_fonts_HelveticaNeueLTW01_56Italic_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__komodo_fonts_HelveticaNeueLTW01_65Medium_svg__ = __webpack_require__("CJdc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__komodo_fonts_HelveticaNeueLTW01_65Medium_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__komodo_fonts_HelveticaNeueLTW01_65Medium_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__komodo_fonts_HelveticaNeueLTW01_75Bold_svg__ = __webpack_require__("vnKg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__komodo_fonts_HelveticaNeueLTW01_75Bold_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__komodo_fonts_HelveticaNeueLTW01_75Bold_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__komodo_fonts_HelveticaNeueLTW01_35Thin_ttf__ = __webpack_require__("6fib");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__komodo_fonts_HelveticaNeueLTW01_35Thin_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__komodo_fonts_HelveticaNeueLTW01_35Thin_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__komodo_fonts_HelveticaNeueLTW01_45Light_ttf__ = __webpack_require__("1kGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__komodo_fonts_HelveticaNeueLTW01_45Light_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__komodo_fonts_HelveticaNeueLTW01_45Light_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__komodo_fonts_HelveticaNeueLTW01_55Roman_ttf__ = __webpack_require__("m07I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__komodo_fonts_HelveticaNeueLTW01_55Roman_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__komodo_fonts_HelveticaNeueLTW01_55Roman_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__komodo_fonts_HelveticaNeueLTW01_56Italic_ttf__ = __webpack_require__("A0Jf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__komodo_fonts_HelveticaNeueLTW01_56Italic_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__komodo_fonts_HelveticaNeueLTW01_56Italic_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__komodo_fonts_HelveticaNeueLTW01_65Medium_ttf__ = __webpack_require__("St0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__komodo_fonts_HelveticaNeueLTW01_65Medium_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__komodo_fonts_HelveticaNeueLTW01_65Medium_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__komodo_fonts_HelveticaNeueLTW01_75Bold_ttf__ = __webpack_require__("72SL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__komodo_fonts_HelveticaNeueLTW01_75Bold_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__komodo_fonts_HelveticaNeueLTW01_75Bold_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__komodo_fonts_HelveticaNeueLTW01_35Thin_woff__ = __webpack_require__("2iCl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__komodo_fonts_HelveticaNeueLTW01_35Thin_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__komodo_fonts_HelveticaNeueLTW01_35Thin_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__komodo_fonts_HelveticaNeueLTW01_45Light_woff__ = __webpack_require__("r0Zh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__komodo_fonts_HelveticaNeueLTW01_45Light_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__komodo_fonts_HelveticaNeueLTW01_45Light_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__komodo_fonts_HelveticaNeueLTW01_55Roman_woff__ = __webpack_require__("Oqx3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__komodo_fonts_HelveticaNeueLTW01_55Roman_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__komodo_fonts_HelveticaNeueLTW01_55Roman_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__komodo_fonts_HelveticaNeueLTW01_56Italic_woff__ = __webpack_require__("B0C/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__komodo_fonts_HelveticaNeueLTW01_56Italic_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__komodo_fonts_HelveticaNeueLTW01_56Italic_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__komodo_fonts_HelveticaNeueLTW01_65Medium_woff__ = __webpack_require__("GKUe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__komodo_fonts_HelveticaNeueLTW01_65Medium_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__komodo_fonts_HelveticaNeueLTW01_65Medium_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__komodo_fonts_HelveticaNeueLTW01_75Bold_woff__ = __webpack_require__("gtsn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__komodo_fonts_HelveticaNeueLTW01_75Bold_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__komodo_fonts_HelveticaNeueLTW01_75Bold_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__komodo_fonts_HelveticaNeueLTW01_35Thin_woff2__ = __webpack_require__("3FiO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__komodo_fonts_HelveticaNeueLTW01_35Thin_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__komodo_fonts_HelveticaNeueLTW01_35Thin_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__komodo_fonts_HelveticaNeueLTW01_45Light_woff2__ = __webpack_require__("7YZo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__komodo_fonts_HelveticaNeueLTW01_45Light_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__komodo_fonts_HelveticaNeueLTW01_45Light_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__komodo_fonts_HelveticaNeueLTW01_55Roman_woff2__ = __webpack_require__("wPuX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__komodo_fonts_HelveticaNeueLTW01_55Roman_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__komodo_fonts_HelveticaNeueLTW01_55Roman_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__komodo_fonts_HelveticaNeueLTW01_56Italic_woff2__ = __webpack_require__("NJMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__komodo_fonts_HelveticaNeueLTW01_56Italic_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__komodo_fonts_HelveticaNeueLTW01_56Italic_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__komodo_fonts_HelveticaNeueLTW01_65Medium_woff2__ = __webpack_require__("WIV4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__komodo_fonts_HelveticaNeueLTW01_65Medium_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__komodo_fonts_HelveticaNeueLTW01_65Medium_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__komodo_fonts_HelveticaNeueLTW01_75Bold_woff2__ = __webpack_require__("nmiE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__komodo_fonts_HelveticaNeueLTW01_75Bold_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__komodo_fonts_HelveticaNeueLTW01_75Bold_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__app_scss__ = __webpack_require__("9cxE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_browser_ie9_scss__ = __webpack_require__("CSJv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_browser_ie9_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_browser_ie9_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_browser_ie8_scss__ = __webpack_require__("/zz5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_browser_ie8_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_browser_ie8_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__images_ie_inspect_png__ = __webpack_require__("oK86");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__images_ie_inspect_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__images_ie_inspect_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__images_ie_select_edge_png__ = __webpack_require__("TEhP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__images_ie_select_edge_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__images_ie_select_edge_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__images_oligo_label_sample_png__ = __webpack_require__("9l6V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__images_oligo_label_sample_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__images_oligo_label_sample_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__images_icon_warning_small_png__ = __webpack_require__("jGIB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__images_icon_warning_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__images_icon_warning_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__images_right_caret_png__ = __webpack_require__("xHGE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__images_right_caret_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__images_right_caret_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__images_icon_warning_large_png__ = __webpack_require__("Vdzq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__images_icon_warning_large_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__images_icon_warning_large_png__);




















































/***/ }),

/***/ "TC8l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_HEADER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ProjectHeaderController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProjectHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project_header_scss__ = __webpack_require__("UmjW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project_header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__project_header_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_i18n__ = __webpack_require__("BOQq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__oligo_modal_support_oligo_modal_support__ = __webpack_require__("z/Xr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__project_preference_project_preference__ = __webpack_require__("++bj");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var PROJECT_HEADER_NAME = 'projectHeader';
var ProjectHeaderController = function () {
    function ProjectHeaderController($scope, $ngRedux, projectActions, oligoModalSupport) {
        var _this = this;

        _classCallCheck(this, ProjectHeaderController);

        this.$scope = $scope;
        this.oligoModalSupport = oligoModalSupport;
        this.project = null;
        this.deleteProject = null;
        this.loading = false;
        this.PROJECT_PREFERENCE_LABEL = 'Set project preferences';
        this.DELETE_POPOVER_TITLE_PROJECT = 'Delete Project(s)?';
        this.DELETE_POPOVER_DESC_PROJECT = 'Are you sure you want to delete the project(s)? This action cannot be undone.';
        this.POPOVER_LABEL_DELETE_CONFIRM = 'Yes';
        this.POPOVER_CANCEL_LABEL = 'Cancel';
        this.HEADER_TITLE_TPL = 'Project {{PROJECT_NUMBER}}';
        this.HEADER_TITLE = '';
        this.showProjectPreference = false;
        var bindDispatchers = function bindDispatchers(dispatch) {
            _this.deleteProject = function (request) {
                return dispatch(projectActions.deleteProject(request));
            };
        };
        var unsubscribe = $ngRedux.connect(this.mapStateToThis.bind(this), bindDispatchers)(this);
        var unwatch = $scope.$watch(function () {
            return _this.project;
        }, function (project) {
            if (!project) {
                return;
            }
            _this.HEADER_TITLE = __WEBPACK_IMPORTED_MODULE_1__models_i18n__["c" /* replacePlaceHolders */](_this.HEADER_TITLE_TPL, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__models_i18n__["b" /* PlaceHolderKeys */].PROJECT_NUMBER, '' + (project.index + 1)));
        });
        $scope.$on('$destroy', function () {
            unwatch();
            unsubscribe();
        });
    }

    _createClass(ProjectHeaderController, [{
        key: 'showPreference',
        value: function showPreference() {
            this.showProjectPreference = !this.showProjectPreference;
            if (this.showProjectPreference) {
                this.$scope.$broadcast(__WEBPACK_IMPORTED_MODULE_3__project_preference_project_preference__["b" /* PROJECT_PREFERENCE_SHOW */], this.project);
            }
        }
    }, {
        key: 'publishProjectDelete',
        value: function publishProjectDelete() {
            var _this2 = this;

            var deleteProject = this.deleteProject,
                project = this.project,
                oligoModalSupport = this.oligoModalSupport;

            if (!deleteProject || !project || !oligoModalSupport) {
                return;
            }
            var id = project.id,
                index = project.index;

            oligoModalSupport.show({
                title: this.DELETE_POPOVER_TITLE_PROJECT,
                content: this.DELETE_POPOVER_DESC_PROJECT,
                okLabel: this.POPOVER_LABEL_DELETE_CONFIRM,
                cancelLabel: this.POPOVER_CANCEL_LABEL,
                type: __WEBPACK_IMPORTED_MODULE_2__oligo_modal_support_oligo_modal_support__["g" /* OligoModalTypes */].CONFIRM
            }).then(function (status) {
                switch (status) {
                    case __WEBPACK_IMPORTED_MODULE_2__oligo_modal_support_oligo_modal_support__["f" /* OligoModalSupportStatuses */].OK:
                        _this2.loading = true;
                        deleteProject({ id: id, index: index }).finally(function () {
                            return _this2.loading = false;
                        });
                        break;
                    case __WEBPACK_IMPORTED_MODULE_2__oligo_modal_support_oligo_modal_support__["f" /* OligoModalSupportStatuses */].CANCEL:
                    case __WEBPACK_IMPORTED_MODULE_2__oligo_modal_support_oligo_modal_support__["f" /* OligoModalSupportStatuses */].CLOSE:
                    default:
                        break;
                }
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.project = null;
            this.deleteProject = null;
            this.oligoModalSupport = null;
        }
    }, {
        key: 'mapStateToThis',
        value: function mapStateToThis(state) {
            var world = state.world;
            var vocabulary = world.vocabulary;

            var HEADER_TITLE_TPL = vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_HEADER_TITLE] || this.HEADER_TITLE_TPL;
            return {
                HEADER_TITLE_TPL: HEADER_TITLE_TPL,
                HEADER_TITLE: __WEBPACK_IMPORTED_MODULE_1__models_i18n__["c" /* replacePlaceHolders */](HEADER_TITLE_TPL, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__models_i18n__["b" /* PlaceHolderKeys */].PROJECT_NUMBER, this.project ? '' + (this.project.index + 1) : '')),
                PROJECT_PREFERENCE_LABEL: vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_HEADER_PREFERENCE_BUTTON] || this.PROJECT_PREFERENCE_LABEL,
                DELETE_POPOVER_TITLE_PROJECT: vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_DELETE_POPOVER_TITLE] || this.DELETE_POPOVER_TITLE_PROJECT,
                DELETE_POPOVER_DESC_PROJECT: vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_DELETE_POPOVER_DESC] || this.DELETE_POPOVER_DESC_PROJECT,
                POPOVER_LABEL_DELETE_CONFIRM: vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_DELETE_POPOVER_OK_BUTTON] || this.POPOVER_LABEL_DELETE_CONFIRM,
                POPOVER_CANCEL_LABEL: vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_DELETE_POPOVER_CANCEL_BUTTON] || this.POPOVER_CANCEL_LABEL
            };
        }
    }]);

    return ProjectHeaderController;
}();
var ProjectHeader = {
    template: __webpack_require__("0VzT"),
    controller: ProjectHeaderController,
    controllerAs: 'projectHeader',
    bindings: {
        project: '<'
    }
};

/***/ }),

/***/ "TEhP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/app/img/ie-select-edge.png";

/***/ }),

/***/ "TN9k":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-75Bold.eot";

/***/ }),

/***/ "TZRS":
/***/ (function(module, exports) {

module.exports = "<div id=\"{{projectImportModal.MODAL_ID}}\" class=\"modal fade project-import-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"project-import-modal__title\" aria-hidden=\"true\">\n  <div class=\"modal-dialog modal-dialog-centered modal-lg\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\" id=\"project-import-modal__title\">{{projectImportModal.IMPORT_OLIGO_PROJECT_TITLE}}</h5>\n        <span class=\"close\" ng-click=\"projectImportModal.close()\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"\n            xmlns=\"http://www.w3.org/2000/svg\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\"\n              d=\"M19.6986 3L12.0005 10.6981L4.30138 3L3 4.30138L10.6981 12.0005L3 19.6986L4.30138 21L12.0005 13.3019L19.6986 21L21 19.6986L13.3019 12.0005L21 4.30138L19.6986 3Z\"\n              fill=\"#1B1B1D\" />\n          </svg>\n        </span>\n      </div>\n      <div class=\"modal-body\">\n        <div class=\"container-fluid project-import-modal__body\">\n          <input tabindex=\"-1\"\n                 id=\"file-open-os\"\n                 type=\"file\"\n                 accept=\"{{projectImportModal.supportedFileExtensions.join(',')}}\"\n                 onchange=\"angular.element(this).scope().projectImportModal.filesChanged(this.files, angular.element(this))\">\n          <div class=\"project-import-modal__notification-container\">\n            <fancy-message-pane state=\"projectImportModal.notificationState\"\n                                message=\"projectImportModal.topLevelInstructions()\"\n                                ng-if=\"projectImportModal.notificationMessages.length <= 0\">\n            </fancy-message-pane>\n            <fancy-message-pane state=\"projectImportModal.notificationState\"\n                                message=\"projectImportModal.notificationMessages.join('\\n')\"\n                                closeable=\"true\"\n                                on-close=\"projectImportModal.clearNotifications()\"\n                                ng-if=\"projectImportModal.notificationMessages.length > 0\">\n            </fancy-message-pane>\n          </div>\n          <div class=\"project-import-modal__tool-container\">\n            <div class=\"project-import-modal__tool-left\">\n              <a class=\"project-import-modal__tool-download\" ng-href=\"{{projectImportModal.templateURL}}\" target=\"_blank\">\n                <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 12.9348V15H1V12.9348H15ZM7.89 12.9348L1.07 5.07092H5V1H11V5.07092H14.7L7.89 12.9348ZM5.43 7.05674L7.88 9.88653L10.33 7.05674H9V2.98582H7V7.05674H5.43Z\" fill=\"#0071D0\"/>\n                </svg>\n                <span class=\"download-template-text\">{{projectImportModal.IMPORT_OLIGO_PROJECT_DOWNLOAD_TEMPLATE_LABEL}}</span>\n              </a>\n              <a class=\"project-import-modal__tool-upload\" href=\"\" ng-click=\"projectImportModal.openFileBrowser()\">\n                <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.64008 13.1349H14.3601V15.1949H1.64008V13.1349ZM5.00008 8.54493H1.33008L8.00008 0.804932L14.6701 8.54493H10.6701V11.9249H5.00008V8.54493ZM10.4301 6.59493L8.00008 3.78493L5.57008 6.59493H6.93008V9.98493H8.74008V6.59493H10.4301Z\" fill=\"#0071D0\"/>\n                </svg>\n                <span class=\"upload-template-text\">{{projectImportModal.IMPORT_OLIGO_PROJECT_UPLOAD_FILE_LABEL}}</span>\n              </a>\n            </div>\n            <div class=\"project-import-modal__view-sample\">\n              <a href=\"\"\n                 class=\"project-import-modal__item-info--popover\"\n                 ng-attr-title=\"{{projectImportModal.IMPORT_OLIGO_PROJECT_OLIGO_SAMPLE_DATA_LABEL}}\"\n                 ng-attr-data-content=\"{{projectImportModal.sampleDataContent}}\">\n                {{projectImportModal.IMPORT_OLIGO_PROJECT_OLIGO_SAMPLE_DATA_LABEL}}\n              </a>\n            </div>\n          </div>\n          <div class=\"project-import-modal__drop-container-oligo-count\">\n            <div class=\"project-import-modal__drop-container\">\n              <drag-and-drop class=\"project-import-modal__drop-area\"\n                            ng-click=\"projectImportModal.activateTextArea()\"\n                            data-show-dnd-area=\"!projectImportModal.textAreaActive\"\n                            data-disable=\"false\"\n                            data-processor=\"projectImportModal.dndProcessor\"\n                            data-ng-attr-empty=\"!projectImportModal.textAreaActive\">\n                <div class=\"project-import-modal__dnd-overlay\" ng-if=\"!projectImportModal.textAreaActive\">\n                  <div ng-bind-html=\"projectImportModal.IMPORT_OLIGO_PROJECT_DRAG_AREA_INSTRUCTIONS\"></div>\n                </div>\n                <div class=\"project-import-modal__text-header\"\n                    ng-if=\"projectImportModal.textAreaActive\">\n                  <span ng-repeat=\"templateColumnDef in projectImportModal.templateColumnDefs\">\n                    <span>{{templateColumnDef.name}}</span>\n                    <span ng-if=\"$index < (projectImportModal.templateColumnDefs.length - 1)\">,</span>\n                  </span>\n                </div>\n                <textarea class=\"project-import-modal__text-area\"\n                          ng-blur=\"projectImportModal.onTextAreaBlur()\"\n                          ng-if=\"projectImportModal.textAreaActive\"\n                          ng-model=\"projectImportModal.templateTextContent\">\n                </textarea>\n              </drag-and-drop>\n            </div>\n            <div class=\"project-import-modal__item-info-container project-import-modal__tool-container\">\n              <div class=\"project-import-modal__tool-toggle-preferences--container\"\n                  ng-if=\"projectImportModal.preferenceToggleSupported\">\n                <a class=\"project-import-modal__tool-toggle-preferences\" href=\"\"\n                  ng-click=\"projectImportModal.togglePreferences()\">\n                  <div ng-if=\"!projectImportModal.preferencesShown\">\n                    <span>+</span>\n                    <span>{{projectImportModal.IMPORT_OLIGO_PROJECT_SHOW_PREFERENCES_LABEL}}</span>\n                  </div>\n                  <div ng-if=\"projectImportModal.preferencesShown\">\n                    <span>-</span>\n                    <span>{{projectImportModal.IMPORT_OLIGO_PROJECT_HIDE_PREFERENCES_LABEL}}</span>\n                  </div>\n                </a>\n                <a href=\"\" class=\"dropdown-btn__hint project-import-modal__tool-toggle-preferences--hint\"></a>\n              </div>\n              <div class=\"project-import-modal__item-info\">\n                <div>\n                  <span class=\"oligo-count-label\">{{projectImportModal.IMPORT_OLIGO_PROJECT_OLIGO_COUNT_LABEL}}</span>\n                  <span ng-class=\"{ error: projectImportModal.isExceedingItemLimit() }\"><span class=\"oligo-count\">{{projectImportModal.noOfLineItems}}</span>/<span class=\"max-oligo-count\">{{projectImportModal.maxNoOfOligos}}</span></span>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"project-import-modal__preferences-info\">\n            <div class=\"project-import-modal__preferences-hint\"\n                ng-if=\"projectImportModal.initialPreference\"\n                ng-show=\"projectImportModal.preferencesShown\">\n              <span class=\"oligo-preference-label\">{{projectImportModal.IMPORT_OLIGO_PROJECT_OLIGO_PREFERENCE_HINT_LABEL}}</span>\n            </div>\n            <div class=\"project-import-modal__preferences-container\"\n                ng-if=\"projectImportModal.initialPreference\"\n                ng-show=\"projectImportModal.preferencesShown\">\n              <oligo-config-preference preference=\"projectImportModal.initialPreference\"\n                                      change-handler=\"projectImportModal.preferenceChangeHandler\"\n                                      from-bulk=true>\n              </oligo-config-preference>\n              <div class=\"project-import-modal__oligo-config-spacer\">\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"modal-footer justify-content-start\">\n        <button type=\"button\"\n                class=\"btn btn-outline-primary\"\n                ng-click=\"projectImportModal.cancel()\">{{projectImportModal.IMPORT_OLIGO_PROJECT_CANCEL_LABEL}}</button>\n        <button type=\"button\"\n                class=\"btn btn-danger\"\n                ng-disabled=\"!projectImportModal.isContentValid()\"\n                ng-click=\"projectImportModal.ok()\">{{projectImportModal.IMPORT_OLIGO_PROJECT_OK_LABEL}}</button>\n      </div>\n    </div>\n    <div class=\"loader-container\" ng-if=\"projectImportModal.busy\">\n      <div class=\"loader\"></div>\n    </div>\n  </div>\n</div>";

/***/ }),

/***/ "U9tU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("tqSY");
module.exports = __webpack_require__("7gX0").String.repeat;


/***/ }),

/***/ "UKM+":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "UOgc":
/***/ (function(module, exports) {

module.exports = "../fonts/n-a.woff";

/***/ }),

/***/ "UUnl":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-45Light.eot";

/***/ }),

/***/ "UmjW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V3l/":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "VWgF":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("7gX0");
var global = __webpack_require__("OzIq");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("V3l/") ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "Vdzq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/app/img/icon-warning-large.png";

/***/ }),

/***/ "VexM":
/***/ (function(module, exports) {

module.exports = "<div class=\"fancy-message-pane\" data-ng-class=\"{ level4 : fancyMessagePane.float }\">\n  <div data-ng-attr-class=\"fancy-message-pane__indicator badge-{{fancyMessagePane.state.id}}\">\n  </div>\n  <div class=\"fancy-message-pane__icon-text\">\n    <div data-ng-attr-class=\"fancy-message-pane__icon-text__icon {{fancyMessagePane.state.icon}} badge-{{fancyMessagePane.state.id}}\">\n    </div>\n    <div class=\"fancy-message-pane__icon-text__text\">\n      <div>\n        <span class=\"fancy-message-pane__icon-text__text--title\"><strong>{{fancyMessagePane.state.name}}:</strong></span>\n        <span class=\"fancy-message-pane__icon-text__text--content\" data-ng-bind-html=\"fancyMessagePane.message\">\n      </div>\n      </span>\n    </div>\n  </div>\n  <button type=\"button\"\n          class=\"close fancy-message-pane__close\"\n          aria-label=\"Close\"\n          data-ng-if=\"fancyMessagePane.closeable\"\n          data-ng-click=\"fancyMessagePane.onClose()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>";

/***/ }),

/***/ "Vql9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("Ol7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__project_reducer__ = __webpack_require__("jn0I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__world_reducer__ = __webpack_require__("DPSk");



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    projects: __WEBPACK_IMPORTED_MODULE_1__project_reducer__["a" /* projects */], world: __WEBPACK_IMPORTED_MODULE_2__world_reducer__["a" /* world */]
}));

/***/ }),

/***/ "WBcL":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "WIV4":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-65Medium.woff2";

/***/ }),

/***/ "WgSQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("RhFG");
var step = __webpack_require__("KB1o");
var Iterators = __webpack_require__("bN1p");
var toIObject = __webpack_require__("PHqh");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("uc2A")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "WgTw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WjQl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_FOOTER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ProjectFooterController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProjectFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project_footer_scss__ = __webpack_require__("7ctU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project_footer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__project_footer_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_i18n__ = __webpack_require__("BOQq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_util__ = __webpack_require__("jQAO");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var PROJECT_FOOTER_NAME = 'projectFooter';
var ProjectFooterController = function () {
    function ProjectFooterController($scope, $ngRedux, oligoActions) {
        var _this = this;

        _classCallCheck(this, ProjectFooterController);

        this.project = null;
        this.addOligo = null;
        this.numOligoToAdd = '1';
        this.loading = false;
        this.reachedMaxNoOfOligos = false;
        this.ADD_OLIGO_LABEL = 'Add More Oligo(s)';
        this.MAX_OLIGO_REACHED_HINT = 'You have reached or exceeded the maximum limit of {{' + __WEBPACK_IMPORTED_MODULE_1__models_i18n__["b" /* PlaceHolderKeys */].MAX_OLIGO_COUNT + '}} oligos.';
        this.NO_OF_OLIGO_LABEL = 'No. of oligo(s) to add:';
        var bindDispatchers = function bindDispatchers(dispatch) {
            _this.addOligo = function (request) {
                return dispatch(oligoActions.addOligo(request));
            };
        };
        var unsubscribe = $ngRedux.connect(this.mapStateToThis.bind(this), bindDispatchers)(this);
        $scope.$on('$destroy', unsubscribe);
    }

    _createClass(ProjectFooterController, [{
        key: 'doAddOligo',
        value: function doAddOligo() {
            var _this2 = this;

            if (!this.addOligo || !this.project) {
                return;
            }
            if (this.cannotAddNewOligo()) {
                return;
            }
            this.onQuantityBlur();
            var quantity = parseInt(this.numOligoToAdd, 10);
            var _project = this.project,
                index = _project.index,
                oligos = _project.oligos,
                preference = _project.preference,
                projectId = _project.id;

            this.loading = true;
            this.addOligo({
                preference: preference,
                quantity: quantity,
                projectId: projectId,
                projectIdx: index,
                nextIdx: oligos.length
            }).finally(function () {
                return _this2.loading = false;
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.project = null;
            this.addOligo = null;
        }
    }, {
        key: 'onQuantityBlur',
        value: function onQuantityBlur() {
            var quantity = 1;
            try {
                var value = parseInt(this.numOligoToAdd, 10);
                if (isNaN(value) || value <= 0) {
                    this.numOligoToAdd = quantity.toString();
                }
            } catch (e) {
                this.numOligoToAdd = quantity.toString();
            }
        }
    }, {
        key: 'onQuantityKeyPress',
        value: function onQuantityKeyPress($event) {
            var which = $event.which,
                keyCode = $event.keyCode;

            var key = which || keyCode;
            var isArrowKey = key >= 37 && key <= 40;
            var isBackspaceKey = key === 8;
            var isDeleteKey = key === 46;
            var isNumKey = key >= 48 && key <= 57;
            var isValidKey = isArrowKey || isBackspaceKey || isDeleteKey || isNumKey;
            if (!isValidKey) {
                $event.preventDefault();
            }
        }
    }, {
        key: 'cannotAddNewOligo',
        value: function cannotAddNewOligo() {
            return this.loading || this.reachedMaxNoOfOligos;
        }
    }, {
        key: 'mapStateToThis',
        value: function mapStateToThis(state) {
            var projects = state.projects,
                world = state.world;
            var vocabulary = world.vocabulary,
                maxNoOfOligos = world.maxNoOfOligos;

            var totalNoOfOligos = Object(__WEBPACK_IMPORTED_MODULE_2__models_util__["a" /* countOligos */])(projects);
            var reachedMaxNoOfOligos = totalNoOfOligos >= maxNoOfOligos;
            var maxOligoReachedHint = vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_FOOTER_ADD_OLIGO_EXCEED_MAX_OLIGO_HINT] || this.MAX_OLIGO_REACHED_HINT;
            maxOligoReachedHint = __WEBPACK_IMPORTED_MODULE_1__models_i18n__["c" /* replacePlaceHolders */](maxOligoReachedHint, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__models_i18n__["b" /* PlaceHolderKeys */].MAX_OLIGO_COUNT, '' + maxNoOfOligos));
            return {
                reachedMaxNoOfOligos: reachedMaxNoOfOligos,
                ADD_OLIGO_LABEL: vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_FOOTER_ADD_OLIGO_BUTTON] || this.ADD_OLIGO_LABEL,
                MAX_OLIGO_REACHED_HINT: maxOligoReachedHint,
                NO_OF_OLIGO_LABEL: vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_FOOTER_No_OF_OLIGO_LABEL] || this.NO_OF_OLIGO_LABEL
            };
        }
    }]);

    return ProjectFooterController;
}();
var ProjectFooter = function ProjectFooter() {
    return {
        template: __webpack_require__("zHVU"),
        controller: ProjectFooterController,
        controllerAs: 'projectFooter',
        bindToController: true,
        restrict: 'E',
        scope: {
            project: '<'
        },
        link: function link($scope, $elem, attrs, ctrl) {
            var controller = ctrl;
            var addOligoButtonHintJQ = void 0;
            var unwatchOligoThreshold = $scope.$watch(function () {
                return controller.reachedMaxNoOfOligos;
            }, function (reachedThreshold) {
                if (!addOligoButtonHintJQ) {
                    var addOligoHintPopover = $elem.find('.btn.btn-outline-primary');
                    if (typeof addOligoHintPopover.popover === 'function') {
                        addOligoButtonHintJQ = addOligoHintPopover;
                    }
                }
                if (addOligoButtonHintJQ) {
                    if (reachedThreshold) {
                        var content = controller.MAX_OLIGO_REACHED_HINT;

                        var popover = {
                            content: content,
                            html: true,
                            placement: 'top',
                            trigger: 'hover'
                        };
                        addOligoButtonHintJQ.popover(popover);
                    } else {
                        addOligoButtonHintJQ.popover('destroy');
                    }
                }
            });
            $scope.$on('$destroy', function () {
                unwatchOligoThreshold();
                if (addOligoButtonHintJQ) {
                    addOligoButtonHintJQ.popover('destroy');
                    addOligoButtonHintJQ = null;
                }
            });
        }
    };
};

/***/ }),

/***/ "Wo5r":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-35Thin.eot";

/***/ }),

/***/ "WpTh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__("Ds5P");
var $find = __webpack_require__("LhTa")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("RhFG")(KEY);


/***/ }),

/***/ "XLHB":
/***/ (function(module, exports) {

module.exports = "<div id=\"{{projectPreference.MODAL_ID}}\" class=\"project-preference\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"project-preference__title\" aria-hidden=\"true\">\n    <oligo-config-preference ng-if=\"projectPreference.openedAtLeastOnce\"\n                             preference=\"projectPreference.preference\"\n                             change-handler=\"projectPreference.preferenceChangeHandler\">\n    </oligo-config-preference>\n      <button type=\"button\"\n              class=\"btn btn-danger\"\n              ng-if=\"projectPreference.openedAtLeastOnce\"\n              ng-click=\"projectPreference.applyPreference()\">\n        {{projectPreference.APPLY_PREFERENCE_LABEL}}\n      </button>\n  <div class=\"loader-container\" ng-if=\"projectPreference.loading\">\n    <div class=\"loader\"></div>\n  </div>\n</div>";

/***/ }),

/***/ "XO1R":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("ydD5");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "XSOZ":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "XdLV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SessionServiceImpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SESSION_SERVICE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SessionServiceFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_details_service__ = __webpack_require__("tcJy");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var SessionServiceImpl = function () {
    function SessionServiceImpl($q, userDetailsService) {
        _classCallCheck(this, SessionServiceImpl);

        this.$q = $q;
        this.userDetailsService = userDetailsService;
    }

    _createClass(SessionServiceImpl, [{
        key: 'isCurrentSessionValid',
        value: function isCurrentSessionValid(options) {
            var _this = this;

            if (this.userDetails) {
                var _userDetails = this.userDetails,
                    userName = _userDetails.userName,
                    userId = _userDetails.userId,
                    countryCode = _userDetails.countryCode;
                var guestUserInvalid = options.guestUserInvalid,
                    differentUserInvalid = options.differentUserInvalid,
                    differentCountryInvalid = options.differentCountryInvalid;

                return this.userDetailsService.getUserDetails().then(function (currentUser) {
                    var currentUserId = currentUser.userId,
                        currentUserName = currentUser.userName,
                        currentCountryCode = currentUser.countryCode,
                        userType = currentUser.userType,
                        isGuestUser = currentUser.isGuestUser,
                        isCSR = currentUser.isCSR;

                    var isCurrentAnonymous = currentUserName === __WEBPACK_IMPORTED_MODULE_0__user_details_service__["a" /* ANONYMOUS_USER_NAME */];
                    var isSignedIn = !isCurrentAnonymous;
                    var isGuestUserValid = guestUserInvalid && isGuestUser ? false : true;
                    var isAnonymousValid = isCurrentAnonymous === (userName === __WEBPACK_IMPORTED_MODULE_0__user_details_service__["a" /* ANONYMOUS_USER_NAME */]);
                    var isDifferentUser = isSignedIn ? currentUserId !== userId : false;
                    var isUserValid = differentUserInvalid && isDifferentUser ? false : true;
                    var isDifferentCountry = currentCountryCode ? currentCountryCode !== countryCode : false;
                    var isCountryValid = differentCountryInvalid && isDifferentCountry ? false : true;
                    var isValid = isAnonymousValid && isGuestUserValid && isUserValid && isCountryValid;
                    var isB2B = userType === 'b2b';
                    var revalidationStrategy = isSignedIn && (isCSR || isB2B) ? 'RELOAD' : 'RELOGIN';
                    return _this.$q.resolve({ isValid: isValid, isSignedIn: isSignedIn, userName: userName, revalidationStrategy: revalidationStrategy });
                }, function () {
                    var deferred = _this.$q.defer();
                    setTimeout(function () {
                        _this.isCurrentSessionValid(options).then(deferred.resolve, deferred.reject);
                    }, 5000);
                    return deferred.promise;
                });
            } else {
                return this.userDetailsService.getUserDetails().then(function (userDetails) {
                    _this.userDetails = userDetails;
                    return _this.isCurrentSessionValid(options);
                });
            }
        }
    }]);

    return SessionServiceImpl;
}();
var SESSION_SERVICE_NAME = 'sessionService';
var SessionServiceFactory = function SessionServiceFactory($q, userDetailsService) {
    return new SessionServiceImpl($q, userDetailsService);
};

/***/ }),

/***/ "XvUs":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("DIVP");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "Y1N3":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "Y1aA":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "Y1wI":
/***/ (function(module, exports) {

module.exports = "<div id=\"{{modalSupport.MODAL_ID}}\" class=\"modal hide fade oligo-modal-support\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"oligo-modal-support__title\" aria-hidden=\"true\">\n  <div class=\"modal-content\">\n    <div class=\"modal-header\">\n      <h3 class=\"modal-title\" id=\"oligo-modal-support__title\">{{modalSupport.data.title}}</h3>\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"modalSupport.close()\">\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n    </div>\n    <div class=\"modal-body\">\n      <fancy-message-pane ng-if=\"modalSupport.data.alertData\"\n                          state=\"modalSupport.data.alertData.state\"\n                          message=\"modalSupport.data.alertData.content\">\n      </fancy-message-pane>\n      <div ng-if=\"modalSupport.data.content && modalSupport.data.content.length > 0\"\n          ng-bind-html=\"modalSupport.data.content\">\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\"\n            class=\"btn btn-outline-primary\"\n            ng-click=\"modalSupport.cancel()\"\n            ng-if=\"modalSupport.data.type === 'CONFIRM'\">{{modalSupport.data.cancelLabel || 'Cancel'}}</button>\n    <button type=\"button\"\n            class=\"btn btn-danger\"\n            ng-click=\"modalSupport.ok()\">{{modalSupport.data.okLabel || 'Ok'}}</button>\n  </div>\n</div>";

/***/ }),

/***/ "ZcWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STORAGE_KEY_PRFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STORAGE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COOKIE_KEYS; });
/* harmony export (immutable) */ __webpack_exports__["d"] = hasBrowserSupport;
/* harmony export (immutable) */ __webpack_exports__["e"] = hasLocalFileSupport;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var STORAGE_KEY_PRFIX = 'tf-custom-standard-oligo';
var STORAGE_TYPE = 'asyncStorage';
var COOKIE_KEYS = {
    CK_CUSTOMER_INFO: 'CK_CUSTOMER_INFO',
    CK_LANG_CODE: 'CK_LANG_CODE',
    CK_ISO_CODE: 'CK_ISO_CODE',
    CK_DISPLAY_TYPE: 'CK_DISPLAY_TYPE',
    CK_CART_INFO: 'CK_CART_INFO',
    CK_CURRENCY_CODE: 'CK_CURRENCY_CODE',
    LT_TOKEN_ID: 'lt_token_id',
    CART_SESSION_ID: 'CartSessionID'
};
function hasBrowserSupport(propertyName) {
    return window[propertyName] && (_typeof(window[propertyName]) === 'object' || typeof window[propertyName] === 'function');
}
function hasLocalFileSupport() {
    return hasBrowserSupport('FileReader') && hasBrowserSupport('File') && hasBrowserSupport('FileList') && hasBrowserSupport('Blob');
}

/***/ }),

/***/ "b/d/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bN1p":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "bSML":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("lDLk");
var createDesc = __webpack_require__("fU25");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "bSfI":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-55Roman.eot";

/***/ }),

/***/ "bUqO":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("zgIt")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "beEN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("rFzY");
var $export = __webpack_require__("Ds5P");
var toObject = __webpack_require__("FryR");
var call = __webpack_require__("XvUs");
var isArrayIter = __webpack_require__("9vb1");
var toLength = __webpack_require__("BbyF");
var createProperty = __webpack_require__("bSML");
var getIterFn = __webpack_require__("SHe9");

$export($export.S + $export.F * !__webpack_require__("qkyc")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "biSS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_ENDPOINTS; });
/* unused harmony export AppConfigServiceImpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return APP_CONFIG_SERVICE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AppConfigServiceFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_world__ = __webpack_require__("uf0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__("Le+Z");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DEFAULT_TEMPLATE_COL;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var API_ENDPOINTS = {
    OLIGO_CONTENT: 'content',
    OLIGO_VALIDATE: 'validate',
    OLIGO_DEFAULT: 'default',
    GET_PRICE: 'pricing',
    GET_USER_DETAILS: 'userDetails',
    GET_CART_PAYLOAD: 'addToCartPayload',
    ADD_TO_CART: 'addToCart',
    ADD_TO_CART_COMMERCE: 'addToCartCommerce',
    VIEW_CART: 'viewCart',
    BULK_UPLOAD: 'bulkUpload',
    BULK_UPLOAD_OVERRIDE: 'bulkUploadOverride',
    BULK_TEMPLATE_CONTENT: 'bulkTemplateContent'
};
var DEFAULT_TEMPLATE_COLUMN_HEADER_NAMES = (_DEFAULT_TEMPLATE_COL = {}, _defineProperty(_DEFAULT_TEMPLATE_COL, __WEBPACK_IMPORTED_MODULE_0__models_world__["c" /* ProjectTemplateColumnDefIds */].OLIGO_VALUE, 'sequence'), _defineProperty(_DEFAULT_TEMPLATE_COL, __WEBPACK_IMPORTED_MODULE_0__models_world__["c" /* ProjectTemplateColumnDefIds */].OLIGO_NAME, 'sequence name'), _defineProperty(_DEFAULT_TEMPLATE_COL, __WEBPACK_IMPORTED_MODULE_0__models_world__["c" /* ProjectTemplateColumnDefIds */].RESEARCHER_NAME, 'researcher name'), _defineProperty(_DEFAULT_TEMPLATE_COL, __WEBPACK_IMPORTED_MODULE_0__models_world__["c" /* ProjectTemplateColumnDefIds */].SCALE, 'scale'), _defineProperty(_DEFAULT_TEMPLATE_COL, __WEBPACK_IMPORTED_MODULE_0__models_world__["c" /* ProjectTemplateColumnDefIds */].PRIME_5_MOD, '5\' mod'), _defineProperty(_DEFAULT_TEMPLATE_COL, __WEBPACK_IMPORTED_MODULE_0__models_world__["c" /* ProjectTemplateColumnDefIds */].PRIME_3_MOD, '3\' mod'), _defineProperty(_DEFAULT_TEMPLATE_COL, __WEBPACK_IMPORTED_MODULE_0__models_world__["c" /* ProjectTemplateColumnDefIds */].PURIFICATION, 'purification'), _defineProperty(_DEFAULT_TEMPLATE_COL, __WEBPACK_IMPORTED_MODULE_0__models_world__["c" /* ProjectTemplateColumnDefIds */].SPECIAL_HANDLING, 'special handling'), _DEFAULT_TEMPLATE_COL);
var AppConfigServiceImpl = function () {
    function AppConfigServiceImpl($q, $http) {
        _classCallCheck(this, AppConfigServiceImpl);

        this.$q = $q;
        this.$http = $http;
        this.getCookieFor = __WEBPACK_IMPORTED_MODULE_1__common__["a" /* getCookie */];
    }

    _createClass(AppConfigServiceImpl, [{
        key: 'load',
        value: function load(config) {
            var deferred = this.$q.defer();
            this.$http.get(config.path + '/' + config.name + '?id=' + config.hash).then(function (response) {
                var status = response.status,
                    data = response.data;

                if (status === 200) {
                    deferred.resolve(data);
                } else {
                    deferred.reject(response);
                }
            }, deferred.reject);
            return deferred.promise;
        }
    }, {
        key: 'setUriConfig',
        value: function setUriConfig(uriConfig) {
            this.uriConfig = uriConfig;
        }
    }, {
        key: 'pathFor',
        value: function pathFor(endpoint) {
            var path = '';
            var uriConfig = this.uriConfig;
            switch (endpoint) {
                case API_ENDPOINTS.OLIGO_CONTENT:
                case API_ENDPOINTS.OLIGO_DEFAULT:
                case API_ENDPOINTS.OLIGO_VALIDATE:
                case API_ENDPOINTS.BULK_UPLOAD:
                case API_ENDPOINTS.BULK_UPLOAD_OVERRIDE:
                case API_ENDPOINTS.BULK_TEMPLATE_CONTENT:
                case API_ENDPOINTS.ADD_TO_CART:
                case API_ENDPOINTS.GET_CART_PAYLOAD:
                    path = '' + uriConfig.contextPath + uriConfig.api.oligo[endpoint];
                    break;
                case API_ENDPOINTS.GET_PRICE:
                case API_ENDPOINTS.GET_USER_DETAILS:
                case API_ENDPOINTS.VIEW_CART:
                case API_ENDPOINTS.ADD_TO_CART_COMMERCE:
                    path = '' + uriConfig.api[endpoint];
                    break;
                default:
                    break;
            }
            return path;
        }
    }, {
        key: 'getRuleVersion',
        value: function getRuleVersion() {
            var path = this.pathFor(API_ENDPOINTS.OLIGO_CONTENT) + '?key=ruleVersion';
            var deferred = this.$q.defer();
            this.$http.get(path, { responseType: 'json' }).then(function (response) {
                var data = response.data,
                    status = response.status;

                if (status === 200) {
                    deferred.resolve(data.ruleVersion);
                } else {
                    deferred.reject();
                }
            }, deferred.reject);
            return deferred.promise;
        }
    }, {
        key: 'getAppContent',
        value: function getAppContent(langCode) {
            var _this = this;

            var worldData = this.worldData;

            if (worldData) {
                return this.$q.resolve(Object.assign({}, worldData));
            }
            var language = langCode;
            var path = '' + this.pathFor(API_ENDPOINTS.OLIGO_CONTENT);
            var deferred = this.$q.defer();
            this.$http.get(path, { responseType: 'json' }).then(function (response) {
                var data = response.data,
                    status = response.status;

                if (status === 200) {
                    var ruleVersion = data.ruleVersion,
                        mixedBases = data.mixedBases,
                        vocabulary = data.i18nTextMap,
                        templateImportSettings = data.templateImportSettings,
                        appClientConfig = data.appClientConfig;
                    var maxNoOfOligos = templateImportSettings.maxNoOfItems,
                        templateSupportedExtensions = templateImportSettings.supportedFileExtensions,
                        columns = templateImportSettings.columns;

                    var clientConfig = (typeof appClientConfig === 'undefined' ? 'undefined' : _typeof(appClientConfig)) === 'object' ? appClientConfig : JSON.parse(appClientConfig);
                    worldData = {
                        ruleVersion: ruleVersion,
                        vocabulary: vocabulary,
                        language: language,
                        clientConfig: clientConfig,
                        sequenceCodes: mixedBases.map(function (mixedBase) {
                            return {
                                iupac: mixedBase.code,
                                name: mixedBase.base
                            };
                        }),
                        maxNoOfOligos: maxNoOfOligos,
                        templateSupportedExtensions: templateSupportedExtensions,
                        templateColumnDefs: columns.map(function (columnDef) {
                            var id = columnDef.id,
                                index = columnDef.columnNo,
                                name = columnDef.name,
                                i18nKey = columnDef.i18nKey;

                            var standardName = name || DEFAULT_TEMPLATE_COLUMN_HEADER_NAMES[id];
                            return {
                                id: id,
                                index: index,
                                standardName: standardName,
                                name: vocabulary[i18nKey] || standardName
                            };
                        })
                    };
                    _this.worldData = worldData;
                    deferred.resolve(worldData);
                } else {
                    deferred.reject();
                }
            }, deferred.reject);
            return deferred.promise;
        }
    }]);

    return AppConfigServiceImpl;
}();
var APP_CONFIG_SERVICE_NAME = 'configService';
var AppConfigServiceFactory = function AppConfigServiceFactory($q, $http) {
    return new AppConfigServiceImpl($q, $http);
};

/***/ }),

/***/ "boo2":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("UKM+");
var isArray = __webpack_require__("XO1R");
var SPECIES = __webpack_require__("kkCw")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "cvnf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CART_SERVICE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CartServiceFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__("lsdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_config_service__ = __webpack_require__("biSS");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



function projectToCartRequests(allCartReqParams, project) {
    var cartRequests = project.oligos.map(function (oligo) {
        var parameter = oligo.parameter;
        var basic = parameter.basic,
            advanced = parameter.advanced;
        var oligoName = basic.oligoName,
            oligoValue = basic.oligoValue,
            researcherName = basic.researcherName,
            scale = basic.scale,
            purification = basic.purification,
            format = basic.format,
            prime3Mod = basic.prime3Mod,
            prime5Mod = basic.prime5Mod,
            delivery = basic.delivery;
        var alternate = advanced.alternate,
            handling = advanced.handling;

        return {
            oligoName: oligoName,
            oligoValue: oligoValue,
            researcherName: researcherName,
            scale: scale,
            purification: purification,
            format: format,
            prime3Mod: prime3Mod,
            prime5Mod: prime5Mod,
            delivery: delivery,
            alternate: alternate,
            handling: handling
        };
    });
    return [].concat(_toConsumableArray(allCartReqParams), _toConsumableArray(cartRequests));
}
function extractErrors(responseDocument) {
    var cartErrorMessages = [];
    var cartErrorElements = responseDocument.getElementsByTagName('Error');
    try {
        var cartErrorCount = cartErrorElements.length;
        for (var cartErrorIndex = 0; cartErrorIndex < cartErrorCount; cartErrorIndex++) {
            var cartErrorElement = cartErrorElements.item(cartErrorIndex);
            if (cartErrorElement) {
                var cartErrorMessageElements = cartErrorElement.getElementsByTagName('Message');
                var cartErrorMessageCount = cartErrorMessages.length;
                for (var cartErrorMsgIndex = 0; cartErrorMsgIndex < cartErrorMessageCount; cartErrorMsgIndex++) {
                    var cartErrorMessageElement = cartErrorMessageElements.item(cartErrorMsgIndex);
                    if (cartErrorMessageElement) {
                        cartErrorMessages.push(cartErrorMessageElement.textContent || '');
                    }
                }
            }
        }
    } catch (e) {
        console.error(e);
    }
    return cartErrorMessages;
}
function isCartSessionRoutingError(contentType, data) {
    try {
        if (contentType && contentType.indexOf('json')) {
            var cartResponseError = JSON.parse(data);
            return cartResponseError.message ? cartResponseError.message.indexOf('LtCommerceRedirectionFilter') >= 0 : false;
        }
    } catch (e) {
        return false;
    }
    return false;
}
function addToCartWithService(configService, alertService, $http, deferred) {
    var path = configService.pathFor(__WEBPACK_IMPORTED_MODULE_1__app_config_service__["a" /* API_ENDPOINTS */].ADD_TO_CART);
    var cartURL = configService.pathFor(__WEBPACK_IMPORTED_MODULE_1__app_config_service__["a" /* API_ENDPOINTS */].VIEW_CART);
    return function (cartRequest) {
        $http.post(path, cartRequest).then(function (addToCartResponse) {
            var data = addToCartResponse.data,
                status = addToCartResponse.status,
                statusText = addToCartResponse.statusText;

            if (status === 200) {
                var cartKey = data.cartKey,
                    errors = data.errorStrings;

                var dataAsString = '';
                try {
                    dataAsString = JSON.stringify(data);
                } catch (e) {
                    console.error(e);
                }
                alertService.info('<b>Cart Response Data</b>: ' + dataAsString).finally(function () {
                    deferred.resolve({ cartKey: cartKey, cartURL: cartURL, errors: errors });
                });
            } else {
                alertService.error('<b>Cart Response Status</b>: ' + statusText + '<br/><b>Cart Response Data</b>: ' + data);
                deferred.reject(addToCartResponse);
            }
        }, function (addToCartErrorResponse) {
            var data = addToCartErrorResponse.data,
                statusText = addToCartErrorResponse.statusText;

            alertService.error('<b>Cart Response Status</b>: ' + statusText + '<br/><b>Cart Response Data</b>: ' + data);
            deferred.reject(addToCartErrorResponse);
        });
        return deferred.promise;
    };
}
function addToCartWithClient(configService, alertService, $http, deferred) {
    var getCartPayloadPath = configService.pathFor(__WEBPACK_IMPORTED_MODULE_1__app_config_service__["a" /* API_ENDPOINTS */].GET_CART_PAYLOAD);
    var addToCartPath = configService.pathFor(__WEBPACK_IMPORTED_MODULE_1__app_config_service__["a" /* API_ENDPOINTS */].ADD_TO_CART_COMMERCE);
    var cartLocation = configService.pathFor(__WEBPACK_IMPORTED_MODULE_1__app_config_service__["a" /* API_ENDPOINTS */].VIEW_CART);
    var unknownError = 'Unknown Error';
    return function (cartRequest) {
        $http.post(getCartPayloadPath, cartRequest).then(function (cartPayloadResponse) {
            var cartPayloadResponseStatus = cartPayloadResponse.status,
                data = cartPayloadResponse.data,
                cartPayloadResponseStatusText = cartPayloadResponse.statusText;

            if (cartPayloadResponseStatus === 200) {
                var encrypted = data.encrypted;

                var cartRequestData = {
                    RequestXML: encrypted
                };
                $http.post(addToCartPath, cartRequestData, {
                    responseType: 'text',
                    transformRequest: function transformRequest(requestObj) {
                        var requestContentArray = [];
                        for (var key in requestObj) {
                            if (requestObj[key]) {
                                requestContentArray.push(key + '=' + requestObj[key]);
                            }
                        }
                        return requestContentArray.join('&');
                    },
                    transformResponse: function transformResponse(responseObj) {
                        return responseObj.toString();
                    },
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then(function (addToCartResponse) {
                    var cartResponseData = addToCartResponse.data,
                        headers = addToCartResponse.headers,
                        cartResponseStatus = addToCartResponse.status,
                        statusText = addToCartResponse.statusText;

                    var contentType = headers('Content-Type');
                    if (cartResponseStatus === 200) {
                        var cartURL = headers('location') || cartLocation;
                        var isHTMLContent = contentType ? contentType.indexOf('html') >= 0 : false;
                        if (isHTMLContent) {
                            alertService.error('<b>Cart Response Status</b>: Redirect due to session expiry<br/><b>Cart Request Payload</b>: ' + encrypted);
                            var sessionExpiredError = new Error('401');
                            sessionExpiredError.status = 401;
                            deferred.reject(sessionExpiredError);
                        } else {
                            try {
                                var responseDocument = new DOMParser().parseFromString(cartResponseData, 'application/xml');
                                var cartKeyElements = responseDocument.getElementsByTagName('CartKey');
                                if (cartKeyElements.length > 0) {
                                    var cartErrorMessages = extractErrors(responseDocument);
                                    var cartKeyElement = cartKeyElements.item(0);
                                    var cartKey = cartKeyElement.textContent || '';
                                    alertService.info('<b>Cart Response Data</b>: ' + cartResponseData).finally(function () {
                                        deferred.resolve({ cartKey: cartKey, cartURL: cartURL, errors: cartErrorMessages });
                                    });
                                } else {
                                    alertService.error('<b>Cart Response Data</b>: ' + cartResponseData + '<br/><b>Cart Response Status</b>: No Cart Key<br/><b>Cart Request Payload</b>: ' + encrypted);
                                    deferred.reject(new Error('No cart key!'));
                                }
                            } catch (e) {
                                console.error(e);
                                alertService.error('<b>Cart Response Data</b>: ' + cartResponseData + '<br/><b>Cart Failure Reason</b>: ' + e + '<br/><b>Cart Request Payload</b>: ' + encrypted);
                                deferred.reject(e || unknownError);
                            }
                        }
                    } else {
                        alertService.error('<b>Cart Failure Reason</b>: ' + cartResponseData + '<br/><b>Cart Response Status</b>: ' + statusText + '<br/><b>Cart Request Payload</b>: ' + encrypted);
                        if (isCartSessionRoutingError(contentType, cartResponseData)) {
                            var _sessionExpiredError = new Error('401');
                            _sessionExpiredError.status = 401;
                            deferred.reject(_sessionExpiredError);
                        } else {
                            deferred.reject(addToCartResponse);
                        }
                    }
                }, function (addToCartErrorResponse) {
                    var statusText = addToCartErrorResponse.statusText,
                        cartResponseData = addToCartErrorResponse.data,
                        headers = addToCartErrorResponse.headers;

                    var contentType = headers('Content-Type');
                    alertService.error('<b>Cart Failure Reason</b>: ' + cartResponseData + '<br/><b>Cart Response Status</b>: ' + statusText + '<br/><b>Cart Request Payload</b>: ' + encrypted);
                    if (isCartSessionRoutingError(contentType, cartResponseData)) {
                        var sessionExpiredError = new Error('401');
                        sessionExpiredError.status = 401;
                        deferred.reject(sessionExpiredError);
                    } else {
                        deferred.reject(addToCartErrorResponse);
                    }
                });
            } else {
                alertService.error('<b>Cart Payload Generation Failure Reason</b>: ' + data + '<br/><b>Cart Payload Generation Status</b>: ' + cartPayloadResponseStatusText);
                deferred.reject(cartPayloadResponse);
            }
        }, function (cartPayloadErrorResponse) {
            var data = cartPayloadErrorResponse.data,
                statusText = cartPayloadErrorResponse.statusText;

            alertService.error('<b>Cart Payload Generation Failure Reason</b>: ' + data + '<br/><b>Cart Payload Generation Status</b>: ' + statusText);
            deferred.reject(cartPayloadErrorResponse);
        });
        return deferred.promise;
    };
}

var CartServiceImpl = function () {
    function CartServiceImpl($q, $http, configService, alertService) {
        _classCallCheck(this, CartServiceImpl);

        this.$q = $q;
        this.$http = $http;
        this.configService = configService;
        this.alertService = alertService;
    }

    _createClass(CartServiceImpl, [{
        key: 'addToCart',
        value: function addToCart(request) {
            var configService = this.configService,
                alertService = this.alertService,
                $http = this.$http;

            var deferred = this.$q.defer();
            var projects = request.projects;

            var oligoCartRequests = projects.reduce(projectToCartRequests, []);
            var cartRequest = { oligoRequestArray: oligoCartRequests };
            var worldPromise = configService.getAppContent('').catch(function () {
                return Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__models__["l" /* WORLD_INITIAL */]);
            });
            return worldPromise.then(function (worldData) {
                var clientConfig = worldData.clientConfig;
                var addToCartMode = clientConfig.addToCartMode;

                var addToCartProvider = addToCartMode === __WEBPACK_IMPORTED_MODULE_0__models__["a" /* AppCartModes */].CLIENT ? addToCartWithClient : addToCartWithService;
                return addToCartProvider(configService, alertService, $http, deferred)(cartRequest);
            });
        }
    }]);

    return CartServiceImpl;
}();

var CART_SERVICE_NAME = 'cartService';
var CartServiceFactory = function CartServiceFactory($q, $http, configService, alertService) {
    return new CartServiceImpl($q, $http, configService, alertService);
};

/***/ }),

/***/ "d075":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("OzIq").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "etoP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets__ = __webpack_require__("SxqO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_object_assign__ = __webpack_require__("kLF+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_fn_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find__ = __webpack_require__("0K64");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from__ = __webpack_require__("B4Cs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_keys__ = __webpack_require__("zUDu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_fn_string_repeat__ = __webpack_require__("U9tU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_fn_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_fn_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_deepmerge__ = __webpack_require__("FCHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_deepmerge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_deepmerge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angular_sanitize__ = __webpack_require__("AFu3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angular_sanitize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_angular_sanitize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ng_redux__ = __webpack_require__("tfhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_thunk__ = __webpack_require__("bEzl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_logger__ = __webpack_require__("oSVy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__node_modules_custom_components_dist__ = __webpack_require__("7mlz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__node_modules_custom_components_dist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__node_modules_custom_components_dist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__reducers__ = __webpack_require__("Vql9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_oligo_modal_support_oligo_modal_support__ = __webpack_require__("z/Xr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_project_import_modal_project_import_modal__ = __webpack_require__("w/VF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_oligo_config_detail_oligo_config_detail__ = __webpack_require__("G4dH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_project_detail_project_detail__ = __webpack_require__("+sGE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_project_detail_project_header_project_header__ = __webpack_require__("TC8l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_project_detail_project_footer_project_footer__ = __webpack_require__("WjQl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_project_detail_project_preference_project_preference__ = __webpack_require__("++bj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_oligo_summary_bar_oligo_summary_bar__ = __webpack_require__("11R0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_oligo_summary_bar_manager_oligo_summary_bar_manager__ = __webpack_require__("28S4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_oligo_config_preference_oligo_config_preference__ = __webpack_require__("LqB4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_drag_and_drop_drag_and_drop__ = __webpack_require__("KgF1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_fancy_message_pane_fancy_message_pane__ = __webpack_require__("Sc+s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__service_app_config_service__ = __webpack_require__("biSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__service_project_service__ = __webpack_require__("pF+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__service_calculation_service__ = __webpack_require__("szND");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__service_user_details_service__ = __webpack_require__("tcJy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__service_pricing_service__ = __webpack_require__("SJEx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__service_cart_service__ = __webpack_require__("cvnf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__service_analytics_service__ = __webpack_require__("2ojO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__service_session_service__ = __webpack_require__("XdLV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__service_alert_service__ = __webpack_require__("jSz7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__actions_project_actions__ = __webpack_require__("vBqh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__actions_oligo_actions__ = __webpack_require__("HHRE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__actions_world_actions__ = __webpack_require__("q8Iw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__actions_root_actions__ = __webpack_require__("vH9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__models__ = __webpack_require__("lsdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__models_i18n__ = __webpack_require__("BOQq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__service_storage_service__ = __webpack_require__("sUA4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__models_util__ = __webpack_require__("jQAO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_card_detail_card_detail__ = __webpack_require__("7wMu");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }













































var HTTP_UNAUTHORIZED = 401;
var HTTP_FORBIDDEN = 403;
var HTTP_RESET_CONTENT = 205;
var enableStackableModals = function enableStackableModals() {
    try {
        var bsJQ = $.fn;
        if (bsJQ.modal && bsJQ.modal.Constructor) {
            var version = bsJQ.modal.Constructor.VERSION;
            if (!version) {
                var isBS2 = bsJQ.modal.toString().indexOf('bs.modal') === -1;
                if (isBS2) {
                    bsJQ.modal.Constructor.prototype.enforceFocus = function () {};
                }
            }
        }
    } catch (e) {
        console.error(e);
    }
};
var bindPageVisibility = function bindPageVisibility(document, callback) {
    var pageVisibilityKeys = {
        hidden: 'visibilitychange',
        webkitHidden: 'webkitvisibilitychange',
        mozHidden: 'mozvisibilitychange',
        msHidden: 'msvisibilitychange'
    };
    var pageVisibilityEventKey = void 0;
    var pageVisibilityStateKey = void 0;
    for (pageVisibilityStateKey in pageVisibilityKeys) {
        if (pageVisibilityStateKey in document) {
            pageVisibilityEventKey = pageVisibilityKeys[pageVisibilityStateKey];
            break;
        }
    }
    if (pageVisibilityEventKey && pageVisibilityStateKey) {
        document.addEventListener(pageVisibilityEventKey, function () {
            return callback(document[pageVisibilityStateKey]);
        }, false);
    }
};
var doLogout = function doLogout(logoutUrl, logoutDelay, onLogout) {
    console.error('User has questionable identity. Logging out...');
    var logoutFrame = document.createElement('iframe');
    logoutFrame.id = 'loggout-frame';
    logoutFrame.style.display = 'none';
    logoutFrame.style.width = '0';
    logoutFrame.style.height = '0';
    document.body.appendChild(logoutFrame);
    logoutFrame.addEventListener('load', function () {
        setTimeout(function () {
            document.body.removeChild(logoutFrame);
            onLogout();
        }, logoutDelay);
    });
    logoutFrame.src = logoutUrl;
};
var timeNow = function timeNow() {
    try {
        return Date.now();
    } catch (e) {
        return new Date().getTime();
    }
};
var logger = Object(__WEBPACK_IMPORTED_MODULE_11_redux_logger__["createLogger"])({
    collapsed: true,
    level: 'info',
    predicate: function predicate(getState, action) {
        return Object({"NODE_ENV":"production"}).ENV !== 'prod';
    }
});
var _DEPENDENCIES = ['custom-components', 'ngSanitize', __WEBPACK_IMPORTED_MODULE_9_ng_redux__["default"]];
configure.$inject = ['$logProvider', '$compileProvider', '$locationProvider', '$ngReduxProvider'];
function configure($logProvider, $compileProvider, $locationProvider, $ngReduxProvider) {
    $logProvider.debugEnabled(true);
    $compileProvider.debugInfoEnabled(true);
    $locationProvider.html5Mode(false);
    var storageKey = __WEBPACK_IMPORTED_MODULE_39__models__["i" /* STORAGE_KEY_PRFIX */];
    var storageType = __WEBPACK_IMPORTED_MODULE_39__models__["j" /* STORAGE_TYPE */];
    var sessionStorageMiddleware = Object(__WEBPACK_IMPORTED_MODULE_41__service_storage_service__["a" /* storageMiddleware */])({
        key: storageKey,
        type: storageType
    });
    var middlewares = [__WEBPACK_IMPORTED_MODULE_10_redux_thunk__["default"], sessionStorageMiddleware, logger];
    $ngReduxProvider.createStoreWith(__WEBPACK_IMPORTED_MODULE_13__reducers__["a" /* default */], middlewares);
}

var AppController = function () {
    function AppController($scope, $window, $element, $http, $ngRedux, projectActions, worldActions, rootActions, oligoModelSupportService, configService, analyticsService, userDetailService, sessionService, alertService) {
        var _this = this;

        _classCallCheck(this, AppController);

        this.loading = true;
        this.projects = [];
        this.reachedMaxNoOfOligos = false;
        this.addProject = null;
        this.updateWorldData = null;
        this.loadStorageData = null;
        this.userAgent = '';
        this.tombstoneStart = 10;
        this.config = {
            path: '',
            name: '',
            hash: ''
        };
        this.HEADER_TITLE = 'Custom Standard DNA Oligos';
        this.HEADER_DESC = 'Use the Custom Standard DNA Oligo Tool below to add your oligo sequences or benefit from our Bulk Upload option to import up to 200 oligo sequences at one time.';
        this.HEADER_DESC_TPL = '';
        this.BULK_UPLOAD_LABEL = 'Bulk Upload';
        this.ADD_PROJECT_LABEL = 'Add Another Project';
        this.DATA_LOADING_TEXT = 'We are processing your request. This may take a moment. Please wait...';
        this.CONFIG_SCROLL_TO_VIEW_TEXT = 'Scroll to view';
        this.MAX_OLIGO_REACHED_HINT = 'You have reached or exceeded the maximum limit of {{' + __WEBPACK_IMPORTED_MODULE_40__models_i18n__["b" /* PlaceHolderKeys */].MAX_OLIGO_COUNT + '}} oligos.';
        this.NOTIFICATION_HEADER_MSG_LABEL = 'Notification';
        this.SESSION_EXPIRED_MSG_LABEL = 'Your session may have expired. You may need to sign in again to your account.';
        this.SIGN_IN_OK_LABEL_MSG = 'Sign In';
        this.UNABLE_TO_FULFIL_REQUEST_MSG_LABEL = 'There was an issue fulfilling your request. We apologize for the inconvenience. Please try again.';
        this.mapStateToThis = function (state) {
            var projects = state.projects,
                world = state.world;
            var vocabulary = world.vocabulary,
                maxNoOfOligos = world.maxNoOfOligos,
                language = world.language,
                clientConfig = world.clientConfig;
            var tombstoneStart = clientConfig.tombstoneStart;

            var HEADER_DESC_TPL = vocabulary[__WEBPACK_IMPORTED_MODULE_40__models_i18n__["a" /* DictionaryKeys */].APP_HEADER_DESC] || _this.HEADER_DESC_TPL;
            var HEADER_DESC = HEADER_DESC_TPL || _this.HEADER_DESC;
            var totalNoOfOligos = Object(__WEBPACK_IMPORTED_MODULE_42__models_util__["a" /* countOligos */])(projects);
            var reachedMaxNoOfOligos = totalNoOfOligos >= maxNoOfOligos;
            var maxOligoReachedHint = vocabulary[__WEBPACK_IMPORTED_MODULE_40__models_i18n__["a" /* DictionaryKeys */].APP_FOOTER_ADD_PROJECT_EXCEED_MAX_OLIGO_HINT] || _this.MAX_OLIGO_REACHED_HINT;
            maxOligoReachedHint = __WEBPACK_IMPORTED_MODULE_40__models_i18n__["c" /* replacePlaceHolders */](maxOligoReachedHint, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_40__models_i18n__["b" /* PlaceHolderKeys */].MAX_OLIGO_COUNT, '' + maxNoOfOligos));
            return {
                projects: projects,
                reachedMaxNoOfOligos: reachedMaxNoOfOligos,
                language: language,
                tombstoneStart: tombstoneStart,
                HEADER_DESC: HEADER_DESC,
                HEADER_DESC_TPL: HEADER_DESC_TPL,
                HEADER_TITLE: vocabulary[__WEBPACK_IMPORTED_MODULE_40__models_i18n__["a" /* DictionaryKeys */].APP_HEADER_TITLE] || _this.HEADER_TITLE,
                BULK_UPLOAD_LABEL: vocabulary[__WEBPACK_IMPORTED_MODULE_40__models_i18n__["a" /* DictionaryKeys */].APP_HEADER_BULK_UPLOAD_BUTTON] || _this.BULK_UPLOAD_LABEL,
                ADD_PROJECT_LABEL: vocabulary[__WEBPACK_IMPORTED_MODULE_40__models_i18n__["a" /* DictionaryKeys */].APP_FOOTER_ADD_PROJECT_BUTTON] || _this.ADD_PROJECT_LABEL,
                DATA_LOADING_TEXT: vocabulary[__WEBPACK_IMPORTED_MODULE_40__models_i18n__["a" /* DictionaryKeys */].LOADING_VALIDATE_CONFIG_DESC] || _this.DATA_LOADING_TEXT,
                CONFIG_SCROLL_TO_VIEW_TEXT: vocabulary[__WEBPACK_IMPORTED_MODULE_40__models_i18n__["a" /* DictionaryKeys */].CONFIG_SCROLL_TO_VIEW_TEXT] || _this.CONFIG_SCROLL_TO_VIEW_TEXT,
                MAX_OLIGO_REACHED_HINT: maxOligoReachedHint,
                NOTIFICATION_HEADER_MSG_LABEL: vocabulary[__WEBPACK_IMPORTED_MODULE_40__models_i18n__["a" /* DictionaryKeys */].NOTIFICATION_HEADER] || _this.NOTIFICATION_HEADER_MSG_LABEL,
                SESSION_EXPIRED_MSG_LABEL: vocabulary[__WEBPACK_IMPORTED_MODULE_40__models_i18n__["a" /* DictionaryKeys */].SESSION_EXPIRED_MSG] || _this.SESSION_EXPIRED_MSG_LABEL,
                SIGN_IN_OK_LABEL_MSG: vocabulary[__WEBPACK_IMPORTED_MODULE_40__models_i18n__["a" /* DictionaryKeys */].SIGN_IN_OK_LABEL] || _this.SIGN_IN_OK_LABEL_MSG,
                UNABLE_TO_FULFIL_REQUEST_MSG_LABEL: vocabulary[__WEBPACK_IMPORTED_MODULE_40__models_i18n__["a" /* DictionaryKeys */].UNABLE_TO_FULFIL_REQUEST_MSG] || _this.UNABLE_TO_FULFIL_REQUEST_MSG_LABEL
            };
        };
        var bindDispatchers = function bindDispatchers(dispatch) {
            _this.addProject = function (request) {
                return dispatch(projectActions.addProject(request));
            };
            _this.updateWorldData = function (request) {
                return dispatch(worldActions.updateWorldData(request));
            };
            _this.loadStorageData = function (request) {
                return dispatch(rootActions.loadStorageData(request));
            };
        };
        var unsubscribe = $ngRedux.connect(this.mapStateToThis.bind(this), bindDispatchers)(this);
        var unwatchOligoThreshold = void 0;
        var addProjectBtnHintJQ = void 0;
        var unwatchUnexpectedException = function unwatchUnexpectedException() {};
        var $postLink = function $postLink() {
            _this.loading = true;
            configService.load(_this.config).then(function (uriConfig) {
                _this.uriConfig = uriConfig;
                configService.setUriConfig(uriConfig);
                userDetailService.getUserDetails().then(function (userDetails) {
                    var headers = $http.defaults.headers;

                    if (headers && headers.common) {
                        var userContext = Object(__WEBPACK_IMPORTED_MODULE_29__service_user_details_service__["d" /* asUserContext */])(userDetails);
                        userContext.userAgent = $window.navigator.userAgent;
                        headers.common.usercontext = JSON.stringify(userContext);
                    }
                    var countryCode = userDetails.countryCode,
                        customerType = userDetails.customerType,
                        langCode = userDetails.langCode,
                        sessionToken = userDetails.sessionToken;

                    if (!_this.loadStorageData) {
                        return;
                    }
                    _this.loadStorageData({ countryCode: countryCode, langCode: langCode, customerType: customerType, sessionToken: sessionToken }).then(function (storageData) {
                        var countryPathConfig = {
                            path: _this.config.path,
                            name: countryCode.toLowerCase() + '.json',
                            hash: _this.config.hash
                        };
                        configService.load(countryPathConfig).then(function (countryConfig) {
                            uriConfig = __WEBPACK_IMPORTED_MODULE_6_deepmerge__(uriConfig, countryConfig);
                            _this.uriConfig = uriConfig;
                            configService.setUriConfig(uriConfig);
                        }, function () {
                            console.info('No separate config found for \'' + countryCode.toUpperCase() + '\'.');
                        }).finally(function () {
                            var checkSessionValidity = true;
                            var logoutOnStaleSession = true;
                            var logoutIfSignedInOnStaleSession = false;
                            var logoutDelayMillis = 5000;
                            var sessionCheckOnTabActivation = true;
                            var guestUserInvalid = false;
                            var differentUserInvalid = false;
                            var differentCountryInvalid = true;
                            configService.getAppContent(langCode).then(function (worldData) {
                                if (!_this.updateWorldData) {
                                    return;
                                }
                                _this.updateWorldData(worldData);
                                try {
                                    checkSessionValidity = worldData.clientConfig.checkSessionOnLanding;
                                    logoutOnStaleSession = worldData.clientConfig.skipLogoutOnStaleSession !== true;
                                    logoutIfSignedInOnStaleSession = worldData.clientConfig.logoutIfSignedInOnStaleSession === true;
                                    sessionCheckOnTabActivation = worldData.clientConfig.skipSessionCheckOnTabActivation !== true;
                                    logoutDelayMillis = worldData.clientConfig.logoutDelayMillis || logoutDelayMillis;
                                    guestUserInvalid = worldData.clientConfig.guestUserInvalid || guestUserInvalid;
                                    differentUserInvalid = worldData.clientConfig.differentUserInvalid || differentUserInvalid;
                                    differentCountryInvalid = worldData.clientConfig.differentCountryInvalid !== false;
                                } catch (e) {
                                    console.error(e);
                                }
                            }).finally(function () {
                                _this.loading = false;
                                if (!_this.addProject) {
                                    return;
                                }
                                if (checkSessionValidity) {
                                    var userAccessStartEpoch = timeNow();
                                    var checkSessionValid = function checkSessionValid() {
                                        return sessionService.isCurrentSessionValid({ guestUserInvalid: guestUserInvalid, differentUserInvalid: differentUserInvalid, differentCountryInvalid: differentCountryInvalid }).then(function (response) {
                                            var isValid = response.isValid,
                                                isSignedIn = response.isSignedIn,
                                                userName = response.userName,
                                                revalidationStrategy = response.revalidationStrategy;

                                            if (!isValid) {
                                                var status = HTTP_UNAUTHORIZED;
                                                var sessionExpiredError = new Error('' + status);
                                                sessionExpiredError.status = status;
                                                var userAccessNowEpoch = timeNow();
                                                var appUsageDurationMins = ((userAccessNowEpoch - userAccessStartEpoch) / (60 * 1000)).toFixed(2);
                                                alertService.error('User session for ' + userName + ' is stale or has expired. Is signed in now: ' + isSignedIn + '. App duration Mins: ' + appUsageDurationMins);
                                                var forceLogoutOnAnonymous = logoutOnStaleSession && !isSignedIn;
                                                var forceLogoutOnLoggedUser = logoutOnStaleSession && isSignedIn && logoutIfSignedInOnStaleSession;
                                                if (forceLogoutOnAnonymous || forceLogoutOnLoggedUser) {
                                                    _this.loading = true;
                                                    doLogout(uriConfig.api.logout, logoutDelayMillis, function () {
                                                        return $scope.$apply(function () {
                                                            AppController.UNEXPECTED_EXCEPTION = sessionExpiredError;
                                                            _this.loading = false;
                                                        });
                                                    });
                                                } else {
                                                    if (revalidationStrategy === 'RELOAD') {
                                                        sessionExpiredError.status = HTTP_RESET_CONTENT;
                                                    }
                                                    AppController.UNEXPECTED_EXCEPTION = sessionExpiredError;
                                                    _this.loading = false;
                                                }
                                            }
                                        });
                                    };
                                    checkSessionValid();
                                    if (sessionCheckOnTabActivation) {
                                        bindPageVisibility($window.document, function (hidden) {
                                            if (hidden) {
                                                return;
                                            }
                                            checkSessionValid();
                                        });
                                    }
                                }
                                var hasExistingProjects = storageData.projects && storageData.projects.length > 0;
                                if (hasExistingProjects) {
                                    return;
                                }
                                var location = $window.location;
                                var href = location.href;

                                var isBulkImportOnLoad = href.indexOf(uriConfig.href.standardOligo.bulk) > 0;
                                if (isBulkImportOnLoad) {
                                    return;
                                }
                                _this.loading = true;
                                _this.addProject({ nextIdx: 0 }).finally(function () {
                                    return _this.loading = false;
                                });
                            });
                        });
                    }, function () {
                        return _this.loading = false;
                    });
                }, function () {
                    return _this.loading = false;
                });
                unwatchUnexpectedException = $scope.$watch(function () {
                    return AppController.UNEXPECTED_EXCEPTION;
                }, function (exception) {
                    if (!exception) {
                        return;
                    }
                    var error = exception;
                    switch (error.status) {
                        case HTTP_UNAUTHORIZED:
                        case HTTP_FORBIDDEN:
                        case HTTP_RESET_CONTENT:
                            oligoModelSupportService.show({
                                title: _this.NOTIFICATION_HEADER_MSG_LABEL || 'Notification',
                                content: _this.SESSION_EXPIRED_MSG_LABEL || 'Your session may have expired. You may need to sign in again to your account.',
                                okLabel: _this.SIGN_IN_OK_LABEL_MSG || 'Sign In',
                                type: __WEBPACK_IMPORTED_MODULE_14__components_oligo_modal_support_oligo_modal_support__["g" /* OligoModalTypes */].INFO
                            }).finally(function () {
                                _this.loading = true;
                                AppController.UNEXPECTED_EXCEPTION = null;
                                var location = $window.location;
                                var currentURL = location.href;

                                if (error.status === HTTP_RESET_CONTENT) {
                                    location.reload();
                                } else {
                                    location.href = '' + uriConfig.api.login + currentURL;
                                }
                            });
                            break;
                        default:
                            oligoModelSupportService.show({
                                title: _this.NOTIFICATION_HEADER_MSG_LABEL || 'Notification',
                                content: _this.UNABLE_TO_FULFIL_REQUEST_MSG_LABEL || 'There was an issue fulfilling your request. We apologize for the inconvenience. Please try again.',
                                type: __WEBPACK_IMPORTED_MODULE_14__components_oligo_modal_support_oligo_modal_support__["g" /* OligoModalTypes */].INFO
                            }).finally(function () {
                                _this.loading = false;
                                AppController.UNEXPECTED_EXCEPTION = null;
                            });
                            break;
                    }
                });
            }, function () {
                return _this.loading = false;
            });
            analyticsService.bootstrap($scope);
            unwatchOligoThreshold = $scope.$watch(function () {
                return _this.reachedMaxNoOfOligos;
            }, function (reachedThreshold) {
                if (!addProjectBtnHintJQ) {
                    var addProjectHintPopover = $element.find('.app-footer .btn.btn-outline-primary');
                    if (typeof addProjectHintPopover.popover === 'function') {
                        addProjectBtnHintJQ = addProjectHintPopover;
                    }
                }
                if (addProjectBtnHintJQ) {
                    if (reachedThreshold) {
                        var content = _this.MAX_OLIGO_REACHED_HINT;

                        var popover = {
                            content: content,
                            html: true,
                            placement: 'top',
                            trigger: 'hover'
                        };
                        addProjectBtnHintJQ.popover(popover);
                    } else {
                        addProjectBtnHintJQ.popover('destroy');
                    }
                }
            });
        };
        var unwatchScopeErrors = $scope.$on(__WEBPACK_IMPORTED_MODULE_39__models__["k" /* ScopeEvents */].ERROR, function (event, errorCause) {
            AppController.UNEXPECTED_EXCEPTION = errorCause;
        });
        $scope.$on('$destroy', function () {
            unsubscribe();
            unwatchScopeErrors();
            unwatchUnexpectedException();
            AppController.UNEXPECTED_EXCEPTION = null;
            if (unwatchOligoThreshold) {
                unwatchOligoThreshold();
            }
            if (addProjectBtnHintJQ) {
                addProjectBtnHintJQ.popover('destroy');
                addProjectBtnHintJQ = null;
            }
        });
        this.userAgent = $window.navigator.userAgent;
        this.projectImportModalSupport = new __WEBPACK_IMPORTED_MODULE_15__components_project_import_modal_project_import_modal__["d" /* ProjectImportModalSupport */]();
        this.$postLink = $postLink;
        $window.scrollTo(0, 0);
    }

    _createClass(AppController, [{
        key: 'doAddProject',
        value: function doAddProject() {
            var _this2 = this;

            if (!this.addProject) {
                return;
            }
            if (this.cannotAddNewProject()) {
                return;
            }
            this.loading = true;
            this.addProject({ nextIdx: this.projects.length }).finally(function () {
                return _this2.loading = false;
            });
        }
    }, {
        key: 'onCartStateChange',
        value: function onCartStateChange(change) {
            var state = change.state;

            switch (state) {
                case __WEBPACK_IMPORTED_MODULE_39__models__["c" /* CartStates */].PROCESSING:
                    this.loading = true;
                    break;
                default:
                    this.loading = false;
                    break;
            }
        }
    }, {
        key: 'showProjectImportModal',
        value: function showProjectImportModal() {
            this.projectImportModalSupport.open();
        }
    }, {
        key: 'onImportStateChange',
        value: function onImportStateChange(change) {
            var state = change.state;

            switch (state) {
                case __WEBPACK_IMPORTED_MODULE_15__components_project_import_modal_project_import_modal__["e" /* ProjectImportStates */].PROCESSING:
                    this.loading = true;
                    break;
                default:
                    this.loading = false;
                    break;
            }
        }
    }, {
        key: 'cannotAddNewProject',
        value: function cannotAddNewProject() {
            return this.loading || this.reachedMaxNoOfOligos;
        }
    }]);

    return AppController;
}();

AppController.NAME = 'AppController';
var GLOBAL_EXCEPTION_HANDLER_NAME = '$exceptionHandler';
var GlobalExceptionHandlerFactory = function GlobalExceptionHandlerFactory($logger) {
    return function (exception, cause) {
        $logger.error(exception, cause);
        AppController.UNEXPECTED_EXCEPTION = exception;
    };
};
GlobalExceptionHandlerFactory.$inject = ['$log'];
__WEBPACK_IMPORTED_MODULE_26__service_app_config_service__["c" /* AppConfigServiceFactory */].$inject = ['$q', '$http'];
__WEBPACK_IMPORTED_MODULE_29__service_user_details_service__["c" /* UserDetailsServiceFactory */].$inject = ['$q', '$http', __WEBPACK_IMPORTED_MODULE_26__service_app_config_service__["b" /* APP_CONFIG_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_34__service_alert_service__["b" /* AlertServiceFactory */].$inject = ['$q', __WEBPACK_IMPORTED_MODULE_29__service_user_details_service__["b" /* USER_DETAILS__SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_26__service_app_config_service__["b" /* APP_CONFIG_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_31__service_cart_service__["b" /* CartServiceFactory */].$inject = ['$q', '$http', __WEBPACK_IMPORTED_MODULE_26__service_app_config_service__["b" /* APP_CONFIG_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_34__service_alert_service__["a" /* ALERT_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_30__service_pricing_service__["b" /* PricingServiceFactory */].$inject = ['$q', '$http', __WEBPACK_IMPORTED_MODULE_26__service_app_config_service__["b" /* APP_CONFIG_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_29__service_user_details_service__["b" /* USER_DETAILS__SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_24__components_drag_and_drop_drag_and_drop__["b" /* DragAndDropCreator */].$inject = ['$q'];
__WEBPACK_IMPORTED_MODULE_16__components_oligo_config_detail_oligo_config_detail__["b" /* OligoConfigDetail */].$inject = ['$compile', '$timeout'];
__WEBPACK_IMPORTED_MODULE_17__components_project_detail_project_detail__["b" /* ProjectDetail */].$inject = ['$timeout', '$document', '$window'];
__WEBPACK_IMPORTED_MODULE_43__components_card_detail_card_detail__["a" /* CardDetail */].$inject = ['$timeout', '$document', '$window'];
__WEBPACK_IMPORTED_MODULE_43__components_card_detail_card_detail__["b" /* CardDetailController */].$inject = ['$scope', '$ngRedux'];
__WEBPACK_IMPORTED_MODULE_15__components_project_import_modal_project_import_modal__["b" /* ProjectImportModal */].$inject = ['$timeout', '$document'];
__WEBPACK_IMPORTED_MODULE_16__components_oligo_config_detail_oligo_config_detail__["c" /* OligoConfigDetailController */].$inject = ['$scope', '$q', '$timeout', '$interval', '$ngRedux', __WEBPACK_IMPORTED_MODULE_36__actions_oligo_actions__["c" /* OLIGO_ACTIONS_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_37__actions_world_actions__["c" /* WORLD_ACTIONS_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_28__service_calculation_service__["a" /* CALCULATION_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_14__components_oligo_modal_support_oligo_modal_support__["b" /* OLIGO_MODAL_SUPPORT_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_20__components_project_detail_project_preference_project_preference__["d" /* ProjectPreferenceController */].$inject = ['$scope', '$ngRedux', __WEBPACK_IMPORTED_MODULE_35__actions_project_actions__["d" /* PROJECT_ACTIONS_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_18__components_project_detail_project_header_project_header__["c" /* ProjectHeaderController */].$inject = ['$scope', '$ngRedux', __WEBPACK_IMPORTED_MODULE_35__actions_project_actions__["d" /* PROJECT_ACTIONS_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_14__components_oligo_modal_support_oligo_modal_support__["b" /* OLIGO_MODAL_SUPPORT_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_19__components_project_detail_project_footer_project_footer__["c" /* ProjectFooterController */].$inject = ['$scope', '$ngRedux', __WEBPACK_IMPORTED_MODULE_36__actions_oligo_actions__["c" /* OLIGO_ACTIONS_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_22__components_oligo_summary_bar_manager_oligo_summary_bar_manager__["b" /* OligoSummaryBarManager */].$inject = ['$document', '$window', '$compile'];
__WEBPACK_IMPORTED_MODULE_21__components_oligo_summary_bar_oligo_summary_bar__["c" /* OligoSummaryBarController */].$inject = ['$scope', '$window', '$ngRedux', __WEBPACK_IMPORTED_MODULE_31__service_cart_service__["a" /* CART_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_14__components_oligo_modal_support_oligo_modal_support__["c" /* OligoModalSupportController */].$inject = ['$scope', __WEBPACK_IMPORTED_MODULE_14__components_oligo_modal_support_oligo_modal_support__["b" /* OLIGO_MODAL_SUPPORT_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_23__components_oligo_config_preference_oligo_config_preference__["c" /* OligoConfigPreferenceController */].$inject = ['$scope', '$q', __WEBPACK_IMPORTED_MODULE_27__service_project_service__["a" /* PROJECT_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_15__components_project_import_modal_project_import_modal__["c" /* ProjectImportModalController */].$inject = ['$scope', '$timeout', '$q', '$location', '$ngRedux', __WEBPACK_IMPORTED_MODULE_35__actions_project_actions__["d" /* PROJECT_ACTIONS_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_27__service_project_service__["a" /* PROJECT_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_14__components_oligo_modal_support_oligo_modal_support__["b" /* OLIGO_MODAL_SUPPORT_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_27__service_project_service__["b" /* ProjectServiceFactory */].$inject = ['$q', '$http', __WEBPACK_IMPORTED_MODULE_26__service_app_config_service__["b" /* APP_CONFIG_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_28__service_calculation_service__["b" /* CalculationServiceFactory */].$inject = ['$q'];
__WEBPACK_IMPORTED_MODULE_14__components_oligo_modal_support_oligo_modal_support__["e" /* OligoModalSupportService */].$inject = ['$q'];
__WEBPACK_IMPORTED_MODULE_36__actions_oligo_actions__["d" /* OligoActionsService */].$inject = ['$q', __WEBPACK_IMPORTED_MODULE_27__service_project_service__["a" /* PROJECT_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_30__service_pricing_service__["a" /* PRICING_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_35__actions_project_actions__["e" /* ProjectActionsService */].$inject = ['$q', __WEBPACK_IMPORTED_MODULE_27__service_project_service__["a" /* PROJECT_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_30__service_pricing_service__["a" /* PRICING_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_37__actions_world_actions__["d" /* WorldActionsService */].$inject = ['$q'];
__WEBPACK_IMPORTED_MODULE_38__actions_root_actions__["c" /* RootActionsService */].$inject = ['$q'];
__WEBPACK_IMPORTED_MODULE_32__service_analytics_service__["b" /* AnalyticsServiceFactory */].$inject = ['$window', '$document'];
__WEBPACK_IMPORTED_MODULE_33__service_session_service__["b" /* SessionServiceFactory */].$inject = ['$q', __WEBPACK_IMPORTED_MODULE_29__service_user_details_service__["b" /* USER_DETAILS__SERVICE_NAME */]];
AppController.$inject = ['$scope', '$window', '$element', '$http', '$ngRedux', __WEBPACK_IMPORTED_MODULE_35__actions_project_actions__["d" /* PROJECT_ACTIONS_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_37__actions_world_actions__["c" /* WORLD_ACTIONS_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_38__actions_root_actions__["b" /* ROOT_ACTIONS_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_14__components_oligo_modal_support_oligo_modal_support__["b" /* OLIGO_MODAL_SUPPORT_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_26__service_app_config_service__["b" /* APP_CONFIG_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_32__service_analytics_service__["a" /* ANALYTICS_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_29__service_user_details_service__["b" /* USER_DETAILS__SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_33__service_session_service__["a" /* SESSION_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_34__service_alert_service__["a" /* ALERT_SERVICE_NAME */]];
__WEBPACK_IMPORTED_MODULE_7_angular__["module"]('Application', _DEPENDENCIES).config(configure).service(__WEBPACK_IMPORTED_MODULE_14__components_oligo_modal_support_oligo_modal_support__["b" /* OLIGO_MODAL_SUPPORT_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_14__components_oligo_modal_support_oligo_modal_support__["e" /* OligoModalSupportService */]).factory(__WEBPACK_IMPORTED_MODULE_36__actions_oligo_actions__["c" /* OLIGO_ACTIONS_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_36__actions_oligo_actions__["d" /* OligoActionsService */]).factory(__WEBPACK_IMPORTED_MODULE_35__actions_project_actions__["d" /* PROJECT_ACTIONS_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_35__actions_project_actions__["e" /* ProjectActionsService */]).factory(__WEBPACK_IMPORTED_MODULE_37__actions_world_actions__["c" /* WORLD_ACTIONS_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_37__actions_world_actions__["d" /* WorldActionsService */]).factory(__WEBPACK_IMPORTED_MODULE_38__actions_root_actions__["b" /* ROOT_ACTIONS_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_38__actions_root_actions__["c" /* RootActionsService */]).factory(__WEBPACK_IMPORTED_MODULE_27__service_project_service__["a" /* PROJECT_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_27__service_project_service__["b" /* ProjectServiceFactory */]).factory(__WEBPACK_IMPORTED_MODULE_28__service_calculation_service__["a" /* CALCULATION_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_28__service_calculation_service__["b" /* CalculationServiceFactory */]).factory(__WEBPACK_IMPORTED_MODULE_29__service_user_details_service__["b" /* USER_DETAILS__SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_29__service_user_details_service__["c" /* UserDetailsServiceFactory */]).factory(__WEBPACK_IMPORTED_MODULE_30__service_pricing_service__["a" /* PRICING_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_30__service_pricing_service__["b" /* PricingServiceFactory */]).factory(__WEBPACK_IMPORTED_MODULE_31__service_cart_service__["a" /* CART_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_31__service_cart_service__["b" /* CartServiceFactory */]).factory(__WEBPACK_IMPORTED_MODULE_26__service_app_config_service__["b" /* APP_CONFIG_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_26__service_app_config_service__["c" /* AppConfigServiceFactory */]).factory(__WEBPACK_IMPORTED_MODULE_32__service_analytics_service__["a" /* ANALYTICS_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_32__service_analytics_service__["b" /* AnalyticsServiceFactory */]).factory(__WEBPACK_IMPORTED_MODULE_33__service_session_service__["a" /* SESSION_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_33__service_session_service__["b" /* SessionServiceFactory */]).factory(__WEBPACK_IMPORTED_MODULE_34__service_alert_service__["a" /* ALERT_SERVICE_NAME */], __WEBPACK_IMPORTED_MODULE_34__service_alert_service__["b" /* AlertServiceFactory */]).factory(GLOBAL_EXCEPTION_HANDLER_NAME, GlobalExceptionHandlerFactory).directive(__WEBPACK_IMPORTED_MODULE_25__components_fancy_message_pane_fancy_message_pane__["a" /* FANCY_MESSAGE_PANE_NAME */], __WEBPACK_IMPORTED_MODULE_25__components_fancy_message_pane_fancy_message_pane__["b" /* FancyMessagePaneCreator */]).directive(__WEBPACK_IMPORTED_MODULE_24__components_drag_and_drop_drag_and_drop__["a" /* DRAG_AND_DROP_NAME */], __WEBPACK_IMPORTED_MODULE_24__components_drag_and_drop_drag_and_drop__["b" /* DragAndDropCreator */]).directive(__WEBPACK_IMPORTED_MODULE_16__components_oligo_config_detail_oligo_config_detail__["a" /* OLIGO_CONFIG_DETAIL_NAME */], __WEBPACK_IMPORTED_MODULE_16__components_oligo_config_detail_oligo_config_detail__["b" /* OligoConfigDetail */]).directive(__WEBPACK_IMPORTED_MODULE_22__components_oligo_summary_bar_manager_oligo_summary_bar_manager__["a" /* OLIGO_SUMMARY_BAR_MANAGER_NAME */], __WEBPACK_IMPORTED_MODULE_22__components_oligo_summary_bar_manager_oligo_summary_bar_manager__["b" /* OligoSummaryBarManager */]).directive(__WEBPACK_IMPORTED_MODULE_23__components_oligo_config_preference_oligo_config_preference__["a" /* OLIGO_CONFIG_PREFERENCE_NAME */], __WEBPACK_IMPORTED_MODULE_23__components_oligo_config_preference_oligo_config_preference__["b" /* OligoConfigPreference */]).directive(__WEBPACK_IMPORTED_MODULE_15__components_project_import_modal_project_import_modal__["a" /* PROJECT_IMPORT_MODAL_NAME */], __WEBPACK_IMPORTED_MODULE_15__components_project_import_modal_project_import_modal__["b" /* ProjectImportModal */]).directive(__WEBPACK_IMPORTED_MODULE_17__components_project_detail_project_detail__["a" /* PROJECT_DETAIL_NAME */], __WEBPACK_IMPORTED_MODULE_17__components_project_detail_project_detail__["b" /* ProjectDetail */]).directive(__WEBPACK_IMPORTED_MODULE_19__components_project_detail_project_footer_project_footer__["a" /* PROJECT_FOOTER_NAME */], __WEBPACK_IMPORTED_MODULE_19__components_project_detail_project_footer_project_footer__["b" /* ProjectFooter */]).directive(__WEBPACK_IMPORTED_MODULE_21__components_oligo_summary_bar_oligo_summary_bar__["a" /* OLIGO_SUMMARY_BAR_NAME */], __WEBPACK_IMPORTED_MODULE_21__components_oligo_summary_bar_oligo_summary_bar__["b" /* OligoSummaryBar */]).directive('cardDetail', __WEBPACK_IMPORTED_MODULE_43__components_card_detail_card_detail__["a" /* CardDetail */]).component(__WEBPACK_IMPORTED_MODULE_14__components_oligo_modal_support_oligo_modal_support__["a" /* OLIGO_MODAL_SUPPORT_NAME */], __WEBPACK_IMPORTED_MODULE_14__components_oligo_modal_support_oligo_modal_support__["d" /* OligoModalSupportPanel */]).component(__WEBPACK_IMPORTED_MODULE_18__components_project_detail_project_header_project_header__["a" /* PROJECT_HEADER_NAME */], __WEBPACK_IMPORTED_MODULE_18__components_project_detail_project_header_project_header__["b" /* ProjectHeader */]).component(__WEBPACK_IMPORTED_MODULE_20__components_project_detail_project_preference_project_preference__["a" /* PROJECT_PREFERENCE_NAME */], __WEBPACK_IMPORTED_MODULE_20__components_project_detail_project_preference_project_preference__["c" /* ProjectPreference */]).controller(AppController.NAME, AppController);
__WEBPACK_IMPORTED_MODULE_7_angular__["element"](document).ready(function () {
    __WEBPACK_IMPORTED_MODULE_7_angular__["bootstrap"]('.app.container', ['Application']);
    enableStackableModals();
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("0iPh")))

/***/ }),

/***/ "fU25":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "fZzp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fmrt":
/***/ (function(module, exports) {

module.exports = "<div class=\"drag-and-drop\">\n  <data-ng-transclude class=\"drag-and-drop-content\"\n                      ng-class=\"{ 'drag-and-drop-area' : dndSupport.areaVisible(),\n                                  'drag-active' : dndSupport.dragActive }\">\n  </data-ng-transclude>\n</div>";

/***/ }),

/***/ "gtsn":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-75Bold.woff";

/***/ }),

/***/ "jGIB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/app/img/icon-warning-small.png";

/***/ }),

/***/ "jQAO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = defaultDropDownContent;
/* harmony export (immutable) */ __webpack_exports__["g"] = selectionClientParamDefToDropDownContent;
/* unused harmony export hasParameterValue */
/* harmony export (immutable) */ __webpack_exports__["f"] = generateId;
/* harmony export (immutable) */ __webpack_exports__["b"] = countSequenceLength;
/* harmony export (immutable) */ __webpack_exports__["c"] = deepClone;
/* harmony export (immutable) */ __webpack_exports__["a"] = countOligos;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formatAmount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("lsdx");

function defaultDropDownContent() {
    var defaultName = 'None';
    var option = {
        title: defaultName,
        description: '',
        disabled: false,
        selected: false
    };
    var dropDown = new __WEBPACK_IMPORTED_MODULE_0__index__["d" /* DropdownObj */]();
    dropDown.options = [option];
    dropDown.disabled = false;
    dropDown.topic = defaultName;
    dropDown.setSelected(option);
    return dropDown;
}
function selectionClientParamDefToDropDownContent(selectionDef) {
    var value = selectionDef.value;

    var options = value.map(function (paramDef) {
        var option = {
            title: paramDef.name,
            disabled: paramDef.disabled,
            selected: false,
            description: paramDef.descriptions.join('\n').replace('\\n', '\n')
        };
        return option;
    });
    var selectedOption = options.find(function (option) {
        return option.title === selectionDef.selected.name;
    });
    var dropDown = new __WEBPACK_IMPORTED_MODULE_0__index__["d" /* DropdownObj */]();
    dropDown.options = options;
    dropDown.disabled = selectionDef.disabled;
    dropDown.topic = selectionDef.name;
    if (selectedOption) {
        dropDown.setSelected(selectedOption);
    }
    return dropDown;
}
function hasParameterValue(parameter) {
    return parameter.value ? parameter.value.length > 0 : false;
}
function generateId() {
    return '_' + Math.random().toString(36).substr(2, 9);
}
function countSequenceLength(sequence) {
    var internalModRegex = /\[.*?\]/gi;
    var internalMods = sequence.match(internalModRegex);
    var normalBases = sequence.replace(internalModRegex, '');
    return normalBases.length + (internalMods ? internalMods.length : 0);
}
function deepClone(source) {
    return JSON.parse(JSON.stringify(source));
}
function countOligos(projects) {
    return projects.reduce(function (noOfOligosInApp, project) {
        return project.oligos.reduce(function (noOfOligosInProject, oligo) {
            var definition = oligo.definition;
            var advanced = definition.advanced;
            var alternate = advanced.alternate;

            noOfOligosInProject++;
            noOfOligosInProject = noOfOligosInProject + alternate.selected.length;
            return noOfOligosInProject;
        }, noOfOligosInApp);
    }, 0);
}
var formatAmount = function formatAmount(amount, currency, language, country) {
    var langCode = language.toLowerCase();
    var numDecimals = 2;
    var hasDecimal = amount % 1 !== 0;
    var locale = country ? langCode + '-' + country.toUpperCase() : langCode;
    try {
        return currency + ' ' + amount.toLocaleString(locale, {
            style: 'currency',
            currency: currency,
            currencyDisplay: 'code',
            maximumFractionDigits: numDecimals,
            minimumFractionDigits: hasDecimal ? numDecimals : 0
        }).replace(currency, '').trim();
    } catch (_a) {
        return currency + ' ' + amount.toFixed(numDecimals);
    }
};

/***/ }),

/***/ "jSz7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MSTeamsAlertService */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALERT_SERVICE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AlertServiceFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common__ = __webpack_require__("PTRJ");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var TEAMS_PAYLOAD_LIMIT = 18500;
var prepareMessage = function prepareMessage(message) {
    return message.replace(/\"/g, '\'').substring(0, TEAMS_PAYLOAD_LIMIT);
};
var AlertTypes = {
    none: {
        name: 'None',
        type: 'none',
        iconUrl: '',
        themeColor: 'ffffff',
        priority: 3
    },
    info: {
        name: 'Info',
        type: 'info',
        iconUrl: 'https://teamsnodesample.azurewebsites.net/static/img/image2.png',
        themeColor: '0076d7',
        priority: 1
    },
    error: {
        name: 'Error',
        type: 'error',
        iconUrl: 'https://teamsnodesample.azurewebsites.net/static/img/image1.png',
        themeColor: 'e71316',
        priority: 2
    }
};
var MSTeamsAlertService = function () {
    function MSTeamsAlertService($q, userService, configService) {
        var _this = this;

        _classCallCheck(this, MSTeamsAlertService);

        this.$q = $q;
        this.userService = userService;
        this.configService = configService;
        this.isIEBrowser = false;
        var isIEBrowser = Object(__WEBPACK_IMPORTED_MODULE_0__components_common__["a" /* isIE */])();
        var alertForm = document.createElement('form');
        alertForm.style.display = 'none';
        alertForm.className = 'app-alert-form';
        alertForm.method = 'POST';
        alertForm.enctype = 'text/plain';
        alertForm.target = 'app-alert-frame';
        var alertInput = document.createElement('input');
        alertInput.type = 'text';
        alertInput.value = '"}';
        var alertFrame = document.createElement('iframe');
        alertFrame.tabIndex = -1;
        alertFrame.name = 'app-alert-frame';
        alertFrame.addEventListener('load', function () {
            var deferred = _this.deferred;

            if (!deferred) {
                return;
            }
            try {
                if (alertFrame.contentDocument) {
                    var responseData = alertFrame.contentDocument.body.textContent;
                    console.error(responseData);
                }
            } catch (e) {
                console.error(e);
            }
            deferred.resolve();
            return;
        });
        alertForm.appendChild(alertInput);
        alertForm.appendChild(alertFrame);
        document.body.appendChild(alertForm);
        this.alertForm = alertForm;
        this.alertInput = alertInput;
        this.isIEBrowser = isIEBrowser;
    }

    _createClass(MSTeamsAlertService, [{
        key: 'info',
        value: function info(message) {
            return this.post(AlertTypes.info, message);
        }
    }, {
        key: 'error',
        value: function error(message) {
            return this.post(AlertTypes.error, message);
        }
    }, {
        key: 'post',
        value: function post(type, message) {
            var _this2 = this;

            var deferred = this.$q.defer();
            var doNothing = function doNothing(e) {
                console.error(e);
                deferred.resolve();
                return;
            };
            this.userService.getUserDetails().then(function (user) {
                _this2.configService.getAppContent('').then(function (worldData) {
                    var clientConfig = worldData.clientConfig;
                    var alertLevel = clientConfig.alertLevel,
                        alertWebhookUrl = clientConfig.alertWebhookUrl;

                    var targetAlertType = AlertTypes[alertLevel] || AlertTypes.error;
                    if (!alertWebhookUrl) {
                        deferred.resolve();
                        return;
                    }
                    if (type.priority < targetAlertType.priority) {
                        deferred.resolve();
                        return;
                    }
                    try {
                        _this2.alertForm.action = alertWebhookUrl;
                        var hostName = window.location.hostname;
                        var userAgent = window.navigator.userAgent;
                        var userName = user.userName,
                            customerType = user.customerType,
                            ltTokenId = user.sessionToken,
                            countryCode = user.countryCode,
                            langCode = user.langCode,
                            cartSessionId = user.cartSessionId;

                        var now = new Date();
                        var actualMessage = prepareMessage(message);
                        var alertPayload = '{\n            "@type": "MessageCard",\n            "@context": "http://schema.org/extensions",\n            "themeColor": "' + type.themeColor + '",\n            "summary": "' + type.name + ' on ' + hostName + '",\n            "sections": [{\n              "activityTitle": "' + type.name + ' on ' + hostName + '",\n              "activitySubtitle": "On Custom Standard Oligo",\n              "activityImage": "' + type.iconUrl + '",\n              "facts": [{\n                "name": "Alert Date",\n                "value": "' + now.toString() + '"\n              }, {\n                "name": "Alert Date UTC",\n                "value": "' + now.toUTCString() + '"\n              }, {\n                "name": "Browser",\n                "value": "' + userAgent + '"\n              }, {\n                "name": "User",\n                "value": "' + userName + '"\n              }, {\n                "name": "User Type",\n                "value": "' + customerType + '"\n              }, {\n                "name": "Country / Language",\n                "value": "' + countryCode + ' / ' + langCode + '"\n              }, {\n                "name": "LT Token Id",\n                "value": "' + ltTokenId + '"\n              }, {\n                "name": "Cart Session Id",\n                "value": "' + cartSessionId + '"\n              }, {\n                "name": "Domain",\n                "value": "' + hostName + '"\n              }, {\n                "name": "Message",\n                "value": "' + actualMessage + '"\n              }],\n              "markdown": true\n            }],\n            "trash": "\n          ';
                        if (_this2.isIEBrowser) {
                            alertPayload = alertPayload.replace(/'/g, '\\\'').replace(/"/g, '\'').replace(/\s\s+/g, '');
                            _this2.alertInput.value = '\'}';
                        }
                        _this2.alertInput.name = alertPayload;
                        _this2.alertForm.submit();
                        return;
                    } catch (e) {
                        console.error('Error publishing alerts');
                        deferred.resolve();
                        return;
                    }
                }, doNothing);
            }, doNothing);
            this.deferred = deferred;
            return deferred.promise;
        }
    }]);

    return MSTeamsAlertService;
}();
var ALERT_SERVICE_NAME = 'appAlertService';
var AlertServiceFactory = function AlertServiceFactory($q, userService, configService) {
    return new MSTeamsAlertService($q, userService, configService);
};

/***/ }),

/***/ "jhxf":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("UKM+");
var document = __webpack_require__("OzIq").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "jn0I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projects; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__("NKgu");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }


var projects = function projects() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    if (!action || !action.type) {
        return state;
    }
    var srcProject = void 0;
    var project = void 0;
    var oligos = void 0;
    var projectIdx = void 0;
    var type = action.type;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["b" /* ADD_PROJECT */]:
            project = action.payload;
            return [].concat(_toConsumableArray(state), [project]);
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["i" /* UPDATE_PROJECT */]:
            project = action.payload;
            state = [].concat(_toConsumableArray(state));
            state.splice(project.index, 1, project);
            return state;
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["d" /* DELETE_PROJECT */]:
            var deleteProjectPayload = action.payload;

            projectIdx = deleteProjectPayload.index;
            state = [].concat(_toConsumableArray(state));
            state.splice(projectIdx, 1);
            state = state.map(function (projectItem) {
                var newIndex = projectItem.index - 1;
                return projectItem.index > projectIdx ? Object.assign({}, projectItem, {
                    index: newIndex,
                    name: projectItem.name.replace(/\d+/g, (newIndex + 1).toString())
                }) : projectItem;
            });
            return state;
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["a" /* ADD_OLIGO */]:
            var addOligoPayload = action.payload;
            var oligosToAdd = addOligoPayload.oligos;

            projectIdx = addOligoPayload.projectIdx;
            state = [].concat(_toConsumableArray(state));
            srcProject = state[projectIdx];
            oligos = srcProject.oligos;
            oligosToAdd.sort(function (oligo1, oligo2) {
                return oligo1.index - oligo2.index;
            });
            state[projectIdx] = Object.assign({}, srcProject, { oligos: [].concat(_toConsumableArray(oligos), _toConsumableArray(oligosToAdd)) });
            return state;
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["h" /* UPDATE_OLIGO */]:
            var updateOligoPayload = action.payload;
            var oligo = updateOligoPayload.oligo;

            projectIdx = updateOligoPayload.projectIdx;
            state = [].concat(_toConsumableArray(state));
            srcProject = state[projectIdx];
            oligos = [].concat(_toConsumableArray(srcProject.oligos));
            oligos.splice(oligo.index, 1, oligo);
            state[projectIdx] = Object.assign({}, srcProject, { oligos: oligos });
            return state;
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["c" /* DELETE_OLIGO */]:
            var deleteOligoPayload = action.payload;
            var oligoIdx = deleteOligoPayload.index;

            projectIdx = deleteOligoPayload.projectIdx;
            state = [].concat(_toConsumableArray(state));
            srcProject = state[projectIdx];
            oligos = [].concat(_toConsumableArray(srcProject.oligos));
            oligos.splice(oligoIdx, 1);
            oligos = oligos.map(function (oligoItem) {
                var newIndex = oligoItem.index - 1;
                return oligoItem.index > oligoIdx ? Object.assign({}, oligoItem, { index: newIndex }) : oligoItem;
            });
            state[projectIdx] = Object.assign({}, srcProject, { oligos: oligos });
            return state;
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["e" /* LOAD_PROJECTS */]:
            state = action.payload;
            return state;
        default:
            break;
    }
    return state;
};

/***/ }),

/***/ "kLF+":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("n12u");
module.exports = __webpack_require__("7gX0").Object.assign;


/***/ }),

/***/ "kYf+":
/***/ (function(module, exports) {

module.exports = "<div class=\"oligo-summary-bar\">\n  <div class=\"container oligo-summary-bar__content\">\n    <span>{{oligoSummary.OLIGO_COUNT_LABEL}}</span>\n    <span class=\"oligo-summary-bar__splitter\"></span>\n    <span ng-if=\"oligoSummary.data.price\">\n      <span ng-if=\"oligoSummary.data.price.available && !oligoSummary.data.price.loading\">\n        <span>{{oligoSummary.formatAmount(oligoSummary.data.price.amount, oligoSummary.data.price.currency, oligoSummary.language, oligoSummary.country)}}</span>\n      </span>\n      <span ng-if=\"oligoSummary.data.price.loading\">\n        <div class=\"loader\"></div>\n      </span>\n    </span>\n    <button class=\"btn btn-outline-primary btn-danger btn-popover\"\n            ng-class=\"{ disabled : oligoSummary.cannotAddToCart() }\"\n            ng-click=\"oligoSummary.addToCart()\">{{oligoSummary.ADD_TO_CART_LABEL}}</button>\n  </div>\n  <!-- The reason why we use 'visibility' here instead of ng-if is because we need to calculate the dimension of this element later -->\n  <div class=\"loader-container\" ng-style=\"{ visibility : oligoSummary.priceProcessing || oligoSummary.cartProcessing ? 'visible' : 'hidden' }\">\n  </div>\n</div>";

/***/ }),

/***/ "kkCw":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("VWgF")('wks');
var uid = __webpack_require__("ulTY");
var Symbol = __webpack_require__("OzIq").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "lDLk":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("DIVP");
var IE8_DOM_DEFINE = __webpack_require__("xZa+");
var toPrimitive = __webpack_require__("s4j0");
var dP = Object.defineProperty;

exports.f = __webpack_require__("bUqO") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "lsdx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return WORLD_INITIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ScopeEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__world__ = __webpack_require__("uf0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__param_def__ = __webpack_require__("xl2K");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__param_def__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__project__ = __webpack_require__("KJmm");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__project__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__project__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__project__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__project__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__richDropdown__ = __webpack_require__("tFcG");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__richDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sequenceTextbox__ = __webpack_require__("zmph");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__("BOQq");
/* unused harmony namespace reexport */
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__world__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__world__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__client__ = __webpack_require__("ZcWc");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__client__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__client__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__client__["d"]; });

var WORLD_INITIAL = {
    appState: __WEBPACK_IMPORTED_MODULE_0__world__["b" /* AppStates */].DRAFT,
    language: 'en',
    countryCode: 'us',
    customerType: 'b2ccmgt',
    ruleVersion: '0.0.0',
    sequenceCodes: [],
    vocabulary: {},
    templateColumnDefs: [],
    templateSupportedExtensions: ['.xls', '.csv', '.txt'],
    maxNoOfOligos: 200,
    clientConfig: {
        addToCartMode: 'server',
        tombstoneStart: 10,
        alertLevel: 'error',
        checkSessionOnLanding: true,
        storageEncoding: 'none',
        productFamilySku: '10336022',
        cartRedirectDelaySecs: 2
    }
};
var ScopeEvents = {
    ERROR: 'error',
    CART_ADD: 'cart-add',
    BULK_UPLOAD_SHOW: 'bulk-upload-show',
    BULK_UPLOAD_IMPORT: 'bulk-upload-import'
};








/***/ }),

/***/ "m07I":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-55Roman.ttf";

/***/ }),

/***/ "mZON":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("VWgF")('keys');
var uid = __webpack_require__("ulTY");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "n12u":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("Ds5P");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("oYd7") });


/***/ }),

/***/ "nmiE":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-75Bold.woff2";

/***/ }),

/***/ "oK86":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/app/img/ie-inspect.png";

/***/ }),

/***/ "oYd7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("Qh14");
var gOPS = __webpack_require__("Y1N3");
var pIE = __webpack_require__("Y1aA");
var toObject = __webpack_require__("FryR");
var IObject = __webpack_require__("Q6Nf");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("zgIt")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "oeih":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "ojCD":
/***/ (function(module, exports) {

module.exports = "<div class=\"oligo-config-main\">\n  <div class=\"oligo-config-main-show-details\" ng-if=\"oligoConfig.showDetails\">\n    <div class=\"oligo-index-and-config\">\n      <span class=\"oligo-index\" ng-click=\"oligoConfig.toggleDisplayType()\">\n        <div class=\"oligo-index-arrow\">\n          <span>\n            <em class=\"icon-16-chevron-up-bold\"></em>\n          </span>\n        </div>\n        <span class=\"oligo-count\">{{oligoConfig.data.index + 1}}.</span>\n      </span>\n      <span class=\"oligo-config-detail\">\n        <div class=\"oligo-basic-and-advanced-options\">\n          <div class=\"oligo-config-basic\">\n            <div class=\"oligo-config-info-root\">\n              <div class=\"oligo-config-name\">\n                <div class=\"oligo-and-researcher-name-label-box\">\n                  <span class=\"oligo-and-researcher-name\"> {{oligoConfig.data.oligoName.definition.name}} </span>\n                </div>\n                <sequence-textbox class=\"sequence-textbox-root\" validate-sequence=\"false\"\n                  sequence-id=\"{{oligoConfig.data.oligoName.definition.id}}\"\n                  text=\"oligoConfig.data.oligoName.definition.value\" on-blur=\"oligoConfig.onTextFieldBlur(id)\"\n                  show-error=\"!oligoConfig.data.oligoName.definition.pristine &&\n                  oligoConfig.data.oligoName.definition.errors.length > 0\"\n                  title=\"{{oligoConfig.data.oligoName.definition.name}}\" disable=\"oligoConfig.isUpdateInProgress()\" tabindex=\"0\"\n                  placeholder=\"{{oligoConfig.OLIGO_NAME_PLACEHOLDER}}\">\n                </sequence-textbox>\n                <div\n                  ng-if=\"(!oligoConfig.data.oligoName.definition.pristine && oligoConfig.data.oligoName.definition.errors.length > 0) ||\n                         (!oligoConfig.data.researcherName.definition.pristine && oligoConfig.data.researcherName.definition.errors.length > 0)\"\n                  tabindex=\"-1\">\n                  <div ng-class=\"oligo-error-label\" ng-if=\"!oligoConfig.data.oligoName.definition.pristine &&\n                                      oligoConfig.data.oligoName.definition.errors.length > 0\">\n                    <div class=\"oligo-config-info-error-container\" ng-if=\"error\"\n                      ng-repeat=\"error in oligoConfig.data.oligoName.definition.errors\">\n                      <span class=\"oligo-error-icon\"><img class=\".icon-warning\"\n                          src='/order/custom-standard-oligo/assets/app/img/icon-warning-small.png' /></span>\n                      <span class=\"oligo-error-text\">{{error}}</span>\n                    </div>\n                  </div>\n                </div>\n                <span class=\"sample-info\">\n                  <a href=\"\" ng-attr-title=\"{{oligoConfig.SAMPLE_LABEL}}\" class=\"oligo-config-sample-label\"\n                    data-content=\"<span><img src='/order/custom-standard-oligo/assets/app/img/oligo-label-sample.png'/></span>\" tabindex=\"-1\">\n                    {{oligoConfig.SAMPLE_LABEL}}\n                  </a>\n                </span>\n              </div>\n              <div class=\"oligo-researcher-name\">\n                <div class=\"oligo-and-researcher-name-label-box\">\n                  <span class=\"oligo-and-researcher-name\"> {{oligoConfig.data.researcherName.definition.name}} </span>\n                </div>\n                <sequence-textbox class=\"sequence-textbox-root\" validate-sequence=\"false\"\n                  title=\"{{oligoConfig.data.researcherName.definition.name}}\"\n                  sequence-id=\"{{oligoConfig.data.researcherName.definition.id}}\"\n                  text=\"oligoConfig.data.researcherName.definition.value\" on-blur=\"oligoConfig.onTextFieldBlur(id)\"\n                  show-error=\"!oligoConfig.data.researcherName.definition.pristine &&\n                  oligoConfig.data.researcherName.definition.errors.length > 0\"\n                  disable=\"oligoConfig.isUpdateInProgress()\"\n                  tabindex=\"0\"\n                  placeholder=\"{{oligoConfig.RESEARCHER_NAME_PLACEHOLDER}}\">\n                </sequence-textbox>\n                <div\n                  ng-if=\"(!oligoConfig.data.oligoName.definition.pristine && oligoConfig.data.oligoName.definition.errors.length > 0) ||\n                         (!oligoConfig.data.researcherName.definition.pristine && oligoConfig.data.researcherName.definition.errors.length > 0)\"\n                  tabindex=\"-1\">\n                  <div class=\"oligo-error-label\" ng-if=\"!oligoConfig.data.researcherName.definition.pristine &&\n                                    oligoConfig.data.researcherName.definition.errors.length > 0\">\n                    <div class=\"oligo-config-info-error-container\" ng-if=\"error\"\n                      ng-repeat=\"error in oligoConfig.data.researcherName.definition.errors\">\n                      <span class=\"oligo-error-icon\"><img class=\".icon-warning\"\n                        src='/order/custom-standard-oligo/assets/app/img/icon-warning-small.png' /></span>\n                      <span class=\"oligo-error-text\">{{error}}</span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"oligo-config-sequence-info\">\n              <div class=\"oligo-sequence-label-box\">\n                <span class=\"oligo-sequence-text\"> {{oligoConfig.data.oligoValue.definition.name}} </span>\n              </div>\n              <sequence-textbox class=\"sequence-textbox-root-sequence-name\" block-num=\"3\"\n                title=\"{{oligoConfig.data.oligoValue.definition.name}}\"\n                min-length=\"oligoConfig.data.oligoValue.constraints.length.min\"\n                max-length=\"oligoConfig.data.oligoValue.constraints.length.max\"\n                whitelist=\"oligoConfig.data.oligoValue.constraints.symbols.valid\"\n                err=\"oligoConfig.data.oligoValue.possibleErrors\"\n                sequence-id=\"{{oligoConfig.data.oligoValue.definition.id}}\"\n                text=\"oligoConfig.data.oligoValue.definition.value\" validate-sequence=\"true\"\n                show-error=\"oligoConfig.hasPossibleTextErrors(oligoConfig.data.oligoValue.possibleErrors)\"\n                on-blur=\"oligoConfig.onTextFieldBlur(id)\" disable=\"oligoConfig.isUpdateInProgress()\"\n                tabindex=\"0\"\n                placeholder=\"{{oligoConfig.OLIGO_SEQUENCE_PLACEHOLDER}}\">\n              </sequence-textbox>\n              <div class=\"oligo-config-info-error-container\" class=\"oligo-config-sequence-info__error\"\n                ng-if=\"oligoConfig.hasPossibleTextErrors(oligoConfig.data.oligoValue.possibleErrors)\" tabindex=\"-1\">\n                <div class=\"oligo-config-info-error\"\n                  ng-if=\"oligoConfig.data.oligoValue.possibleErrors.invalidList.length > 0 || oligoConfig.data.oligoValue.possibleErrors.invalidLength.min || oligoConfig.data.oligoValue.possibleErrors.invalidLength.max || oligoConfig.data.oligoValue.possibleErrors.otherErrors.length > 0\">\n                  <div class=\"oligo-config-error-row\" ng-if=\"oligoConfig.data.oligoValue.possibleErrors.invalidList.length > 0\">\n                    <span class=\"oligo-error-icon\"><img class=\".icon-warning\"\n                        src='/order/custom-standard-oligo/assets/app/img/icon-warning-small.png' /></span>\n                    <span\n                      class=\"oligo-config-sequence-info__error--bases\">{{oligoConfig.data.oligoValue.possibleErrors.invalidList.join('\n                      ')}}</span>\n                    <span class=\"oligo-error-text\">{{oligoConfig.INVALID_BP_MSG}}</span>\n                  </div>\n                  <div class=\"oligo-config-error-row\" ng-if=\"oligoConfig.data.oligoValue.possibleErrors.invalidLength.min\">\n                    <span class=\"oligo-error-icon\"><img class=\".icon-warning\"\n                        src='/order/custom-standard-oligo/assets/app/img/icon-warning-small.png' /></span>\n                    <span class=\"oligo-error-text\">{{oligoConfig.SEQUENCE_TOO_SHORT_MSG}}</span>\n                  </div>\n                  <div class=\"oligo-config-error-row\" ng-if=\"oligoConfig.data.oligoValue.possibleErrors.invalidLength.max\">\n                    <span class=\"oligo-error-icon\"><img class=\".icon-warning\"\n                        src='/order/custom-standard-oligo/assets/app/img/icon-warning-small.png' /></span>\n                    <span class=\"oligo-error-text\">{{oligoConfig.SEQUENCE_TOO_LONG_MSG}}</span>\n                  </div>\n                  <div class=\"oligo-config-error-row\" ng-if=\"oligoConfig.data.oligoValue.possibleErrors.otherErrors.length > 0\">\n                    <span class=\"oligo-error-icon\"><img class=\".icon-warning\"\n                        src='/order/custom-standard-oligo/assets/app/img/icon-warning-small.png' /></span>\n                    <span class=\"oligo-error-text\" ng-repeat=\"error in oligoConfig.data.oligoValue.possibleErrors.otherErrors\">{{error}}</span>\n                  </div>\n                </div>\n              </div>\n              <div class=\"oligo-config-sequence-info__detail\"  ng-if=\"!oligoConfig.hasPossibleTextErrors(oligoConfig.data.oligoValue.possibleErrors)\">\n                <div class=\"oligo-config-sequence-info__bases\">\n                  <span><button kmdPrimaryButton size=\"lg\" tabindex=\"-1\"><a href=\"\"\n                        ng-click=\"oligoConfig.mixedBasesPanelProps.visible = !oligoConfig.mixedBasesPanelProps.visible\" tabindex=\"-1\">{{oligoConfig.MIXED_BASES_LABEL}}</a></button></span>\n                  <span class=\"mixed-bases-divider\">|</span>\n                  <span class=\"oligo-config-sequence-info__basecount\">{{oligoConfig.BASE_COUNT_LABEL}}:\n                    {{oligoConfig.data.properties.numBases}}</span>\n                </div>\n                <div class=\"oligo-config-sequence-info__properties\">\n                  <span class=\"oligo-config-sequence-info__tm\">\n                    <span>Tm:</span>\n                    <span ng-if=\"oligoConfig.data.properties.tm.available\">\n                      <span>{{oligoConfig.data.properties.tm.at50mM.toFixed(1)}} (50mM),</span>\n                      <span>{{oligoConfig.data.properties.tm.at1M.toFixed(1)}} (1M)</span>\n                    </span>\n                    <span ng-if=\"!oligoConfig.data.properties.tm.available\">-</span>\n                  </span>\n                  <span class=\"oligo-config-sequence-info__gc\">\n                    <span>GC%:</span>\n                    <span\n                      ng-if=\"oligoConfig.data.properties.gc.available\">{{oligoConfig.data.properties.gc.value.toFixed(0)}}</span>\n                    <span ng-if=\"!oligoConfig.data.properties.gc.available\">-</span>\n                  </span>\n                  <div class=\"oligo-config-sequence-info__yield\">\n                    <span>{{oligoConfig.MIN_YIELD_LABEL}}:</span>\n                    <span ng-if=\"oligoConfig.data.properties.yieldAmount.available\">\n                      <span>{{oligoConfig.data.properties.yieldAmount.ug.toFixed(1)}} (µg),</span>\n                      <span>{{oligoConfig.data.properties.yieldAmount.nmole.toFixed(1)}} (nmol)</span>\n                    </span>\n                    <span ng-if=\"!oligoConfig.data.properties.yieldAmount.available\">-</span>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"oligo-config-selection-container\">\n              <div class=\"oligo-synthesis-scale\">\n                 <!-- changes for dropdown tooltip text-->\n                <div class=\"oligo-dropdown-hint\">\n                  <div class=\"oligo-scale-dropdown\">\n                    <rich-dropdown class=\"rich-dropdown {{oligoConfig.data.scale.definition.id}}\"\n                      dropdown-obj=\"oligoConfig.data.scale.items\"\n                      ng-class=\"{ error: (oligoConfig.data.scale.definition.selected.invalid && oligoConfig.data.oligoValue.definition.value.length > 0)}\"\n                      hint-url=\"'/us/en/home/products-and-services/product-types/primers-oligos-nucleotides/invitrogen-custom-dna-oligos/popups/scale.html?CID=fl-configoligoscale'\">\n                    </rich-dropdown>\n                  </div>\n                  <div class=\"oligo-scale-dropdown-tooltiptext__scale-info\"  tabindex=\"-1\">\n                    <span class=\"oligo-scale-dropdown-tooltiptext__scale-info--popover\"\n                          ng-attr-data-content=\"{{oligoConfig.SCALE_TOOLTIP_TEXT}}\">\n                      <em class=\"icon-16-info-mono\"></em>\n                    </span>\n                  </div>\n                </div>\n                <div class=\"oligo-config-info-error-container\" ng-if=\"oligoConfig.data.scale.definition.selected.invalid && oligoConfig.data.oligoValue.definition.value.length > 0\">\n                  <span class=\"oligo-error-icon\"><img class=\".icon-warning\"\n                      src='/order/custom-standard-oligo/assets/app/img/icon-warning-small.png' /></span>\n                  <span class=\"oligo-error-text\">{{oligoConfig.ERROR_INVALID_CONFIGURATION}}</span>\n                </div>\n              </div>\n              <div ng-class=\"{'right-caret-span-padding-24': !((oligoConfig.data.scale.definition.selected.invalid || oligoConfig.data.purification.definition.selected.invalid || oligoConfig.data.prime5Mod.definition.selected.invalid || oligoConfig.data.prime3Mod.definition.selected.invalid) && oligoConfig.data.oligoValue.definition.value.length > 0), 'right-caret-span-padding-7': ((oligoConfig.data.scale.definition.selected.invalid || oligoConfig.data.purification.definition.selected.invalid || oligoConfig.data.prime5Mod.definition.selected.invalid || oligoConfig.data.prime3Mod.definition.selected.invalid) && oligoConfig.data.oligoValue.definition.value.length > 0)}\"><img class=\"right-caret\" src='/order/custom-standard-oligo/assets/app/img/right-caret.png' /></div>\n              <div class=\"oligo-synthesis-scale\">\n                <!-- changes for dropdown tooltip text-->\n                <div class=\"oligo-dropdown-hint\">\n                  <div class=\"oligo-scale-dropdown\">\n                    <rich-dropdown class=\"rich-dropdown {{oligoConfig.data.purification.definition.id}}\"\n                      dropdown-obj=\"oligoConfig.data.purification.items\"\n                      ng-class=\"{ error: (oligoConfig.data.purification.definition.selected.invalid && oligoConfig.data.oligoValue.definition.value.length > 0 )}\"\n                      hint-url=\"'/us/en/home/products-and-services/product-types/primers-oligos-nucleotides/invitrogen-custom-dna-oligos/popups/purity.html?CID=fl-configoligopurity'\">\n                    </rich-dropdown>\n                  </div>\n                  <div class=\"oligo-scale-dropdown-tooltiptext__scale-info\">\n                    <span class=\"oligo-scale-dropdown-tooltiptext__scale-info--popover\"\n                          ng-attr-data-content=\"{{oligoConfig.PURIFICATION_TOOLTIP_TEXT}}\">\n                      <em class=\"icon-16-info-mono\"></em>\n                    </span>\n                  </div>\n                </div>\n                <div class=\"oligo-config-info-error-container\" ng-if=\"oligoConfig.data.purification.definition.selected.invalid && oligoConfig.data.oligoValue.definition.value.length > 0\">\n                  <span class=\"oligo-error-icon\"><img class=\".icon-warning\"\n                      src='/order/custom-standard-oligo/assets/app/img/icon-warning-small.png' /></span>\n                  <span class=\"oligo-error-text\">{{oligoConfig.ERROR_INVALID_CONFIGURATION}}</span>\n                </div>\n              </div>\n              <div ng-class=\"{'right-caret-span-padding-24': !((oligoConfig.data.scale.definition.selected.invalid || oligoConfig.data.purification.definition.selected.invalid || oligoConfig.data.prime5Mod.definition.selected.invalid || oligoConfig.data.prime3Mod.definition.selected.invalid) && oligoConfig.data.oligoValue.definition.value.length > 0), 'right-caret-span-padding-7': ((oligoConfig.data.scale.definition.selected.invalid || oligoConfig.data.purification.definition.selected.invalid || oligoConfig.data.prime5Mod.definition.selected.invalid || oligoConfig.data.prime3Mod.definition.selected.invalid) && oligoConfig.data.oligoValue.definition.value.length > 0)}\"><img class=\"right-caret\" src='/order/custom-standard-oligo/assets/app/img/right-caret.png' /></div>\n              <div class=\"oligo-synthesis-scale\">\n                <div class=\"oligo-scale-dropdown\">\n                  <rich-dropdown class=\"rich-dropdown {{oligoConfig.data.prime5Mod.definition.id}}\"\n                    dropdown-obj=\"oligoConfig.data.prime5Mod.items\" ng-class=\"{ optional: oligoConfig.data.prime5Mod.definition.selected.id === '',\n                                    error: (oligoConfig.data.prime5Mod.definition.selected.invalid && oligoConfig.data.oligoValue.definition.value.length > 0)}\">\n                  </rich-dropdown>\n                </div>\n                <div class=\"oligo-config-info-error-container\" ng-if=\"oligoConfig.data.prime5Mod.definition.selected.invalid && oligoConfig.data.oligoValue.definition.value.length > 0\">\n                  <span class=\"oligo-error-icon\"><img class=\".icon-warning\"\n                      src='/order/custom-standard-oligo/assets/app/img/icon-warning-small.png' /></span>\n                  <span class=\"oligo-error-text\">{{oligoConfig.ERROR_INVALID_CONFIGURATION}}</span>\n                </div>\n              </div>\n              <div ng-class=\"{'right-caret-span-padding-24': !((oligoConfig.data.scale.definition.selected.invalid || oligoConfig.data.purification.definition.selected.invalid || oligoConfig.data.prime5Mod.definition.selected.invalid || oligoConfig.data.prime3Mod.definition.selected.invalid) && oligoConfig.data.oligoValue.definition.value.length > 0), 'right-caret-span-padding-7': ((oligoConfig.data.scale.definition.selected.invalid || oligoConfig.data.purification.definition.selected.invalid || oligoConfig.data.prime5Mod.definition.selected.invalid || oligoConfig.data.prime3Mod.definition.selected.invalid) && oligoConfig.data.oligoValue.definition.value.length > 0)}\"><img class=\"right-caret\" src='/order/custom-standard-oligo/assets/app/img/right-caret.png' /></div>\n              <div class=\"oligo-synthesis-scale\">\n                <div class=\"oligo-scale-dropdown\">\n                  <rich-dropdown class=\"rich-dropdown {{oligoConfig.data.prime3Mod.definition.id}}\"\n                    dropdown-obj=\"oligoConfig.data.prime3Mod.items\" ng-class=\"{ optional: oligoConfig.data.prime3Mod.definition.selected.id === '',\n                                  error: (oligoConfig.data.prime3Mod.definition.selected.invalid && oligoConfig.data.oligoValue.definition.value.length > 0)}\">\n                  </rich-dropdown>\n                </div>\n                <div class=\"oligo-config-info-error-container\" ng-if=\"oligoConfig.data.prime3Mod.definition.selected.invalid && oligoConfig.data.oligoValue.definition.value.length > 0\">\n                  <span class=\"oligo-error-icon\"><img class=\".icon-warning\"\n                      src='/order/custom-standard-oligo/assets/app/img/icon-warning-small.png' /></span>\n                  <span class=\"oligo-error-text\">{{oligoConfig.ERROR_INVALID_CONFIGURATION}}</span>\n                </div>\n              </div>\n            </div>\n            <div class=\"oligo-config-formulation-selection-container\">\n              <div class=\"oligo-synthesis-scale\">\n                <div class=\"oligo-scale-dropdown\">\n                  <rich-dropdown class=\"rich-dropdown {{oligoConfig.data.format.definition.id}}\"\n                    dropdown-obj=\"oligoConfig.data.format.items\"\n                    ng-class=\"{ error: (oligoConfig.data.format.definition.selected.invalid && oligoConfig.data.oligoValue.definition.value.length > 0)}\"\n                    ng-style=\"{ visibility: oligoConfig.data.format.definition.hidden ? 'hidden' : 'visible' }\">\n                  </rich-dropdown> \n                </div>\n                <div class=\"oligo-config-info-error-container\" ng-if=\"oligoConfig.data.format.definition.selected.invalid && oligoConfig.data.oligoValue.definition.value.length > 0\">\n                  <span class=\"oligo-error-icon\"><img class=\".icon-warning\"\n                      src='/order/custom-standard-oligo/assets/app/img/icon-warning-small.png' /></span>\n                  <span class=\"oligo-error-text\">{{oligoConfig.ERROR_INVALID_CONFIGURATION}}</span>\n                </div>\n              </div>\n              <div class=\"oligo-config-advanced-toggle\" ng-click=\"oligoConfig.toggleMoreOptions()\">\n                <span class=\"show-options-icon\" ng-if=\"oligoConfig.data.moreOptions\"><em\n                    class=\"icon-16-chevron-up-bold\"></em></span>\n                <span class=\"show-options-icon\" ng-if=\"!oligoConfig.data.moreOptions\"><em\n                    class=\"icon-16-chevron-down-bold\"></em></span>\n                <span class=\"show-options-label\"><a href=\"\" tabindex=\"-1\">{{ oligoConfig.data.moreOptions ? oligoConfig.SHOW_LESS_OPTION_LABEL :\n                    oligoConfig.SHOW_MORE_OPTION_LABEL }}</a></span>\n              </div>\n            </div>\n            <div class=\"oligo-config-advanced-options\" ng-if=\"oligoConfig.data.moreOptions\">\n              <div class=\"oligo-config-advanced-delivery\">\n                <div class=\"oligo-config-advanced\">\n                  <div class=\"oligo-config-alternate-oligos\">\n                    <span class=\"oligo-config-advanced-title\">{{oligoConfig.data.alternate.definition.name}}</span>\n                    <div class=\"oligo-config-advanced-items\">\n                      <label class=\"indicator-control\" ng-repeat=\"alternate in oligoConfig.data.alternate.items\"\n                        ng-disabled=\"alternate.paramDef.disabled\">{{alternate.name}}\n                        <input type=\"checkbox\" ng-model=\"alternate.selected\"\n                          ng-change=\"oligoConfig.selectionToggled(oligoConfig.data.alternate)\"\n                          ng-disabled=\"alternate.paramDef.disabled\" />\n                        <span class=\"indicator\"></span>\n                      </label>\n                    </div>\n                  </div>\n                  <div class=\"oligo-config-special-handling-options\"\n                    ng-style=\"{ visibility: oligoConfig.data.handling.definition.hidden ? 'hidden': 'visible' }\">\n                    <span class=\"oligo-config-advanced-title\">{{oligoConfig.data.handling.definition.name}}</span>\n                    <div class=\"oligo-config-advanced-items\">\n                      <label class=\"indicator-control\" ng-repeat=\"handling in oligoConfig.data.handling.items\"\n                        ng-disabled=\"handling.paramDef.disabled\">{{handling.name}}\n                        <input type=\"checkbox\" ng-class=\"{ selected: handling.selected }\" ng-model=\"handling.selected\"\n                          ng-change=\"oligoConfig.selectionToggled(oligoConfig.data.handling)\"\n                          ng-disabled=\"handling.paramDef.disabled\" />\n                        <span class=\"indicator\"></span>\n                      </label>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"oligo-config-spacer\"></div>\n            </div>\n          </div>\n        </div>\n        <div class=\"oligo-config-advanced-delivery-price\">\n          <div class=\"oligo-config-delivery\">\n            <label class=\"indicator-control\" ng-repeat=\"delivery in oligoConfig.data.delivery.items\" tabindex=\"0\"\n              ng-disabled=\"delivery.paramDef.disabled\">{{delivery.name}}\n              <input type=\"radio\" ng-class=\"{ selected: delivery.id === oligoConfig.data.delivery.selectedId }\"\n                name=\"delivery-{{oligoConfig.projectIdx}}-{{oligoConfig.data.index}}\"\n                ng-model=\"oligoConfig.data.delivery.selectedId\" ng-value=\"delivery.id\"\n                ng-change=\"oligoConfig.selectionToggled(oligoConfig.data.delivery)\"\n                ng-disabled=\"delivery.paramDef.disabled\" />\n              <span class=\"indicator\"></span>\n            </label>\n          </div>\n          <div class=\"oligo-config-pricing oligo-config-col-3\">\n            <div class=\"oligo-price\" ng-if=\"oligoConfig.price && !oligoConfig.price.loading\">\n              <div class=\"oligo-price-value\" ng-if=\"oligoConfig.price.available\">\n                <span>{{oligoConfig.formatAmount(oligoConfig.price.amount, oligoConfig.price.currency,\n                  oligoConfig.language, oligoConfig.country)}}</span>\n              </div>\n              <div class=\"oligo-price-desc\" ng-if=\"!oligoConfig.price || !oligoConfig.price.available\">\n                <span>{{oligoConfig.PRICE_DESC}}</span>\n              </div>\n            </div>\n            <div class=\"oligo-price-loader\" ng-if=\"oligoConfig.price.loading\">\n              <div>{{oligoConfig.PRICE_LOADING_LABEL}}</div>\n              <div class=\"loader\"></div>\n            </div>\n            <div>\n              <span ng-bind-html=\"oligoConfig.TAT_SHIP_BY_LABEL\">\n              </span>\n              <span ng-bind-html=\"oligoConfig.TAT_CUTOFF_LABEL\">\n              </span>\n            </div>\n          </div>\n        </div>\n      </span>\n      <div class=\"loader-container\" ng-if=\"oligoConfig.loading\">\n        <div class=\"loader\"></div>\n      </div>\n    </div>\n    <div class=\"oligo-config-close\">\n      <span class=\"btn-config-delete\" ng-click=\"oligoConfig.publishOligoDelete()\"><em\n          class=\"icon-16-bin-mono\"></em></span>\n    </div>\n  </div>\n  <div class=\"oligo-config-main-hide-details\" ng-if=\"!oligoConfig.showDetails\">\n    <div class=\"oligo-index-and-config\">\n      <span class=\"oligo-index\" ng-click=\"oligoConfig.toggleDisplayType()\">\n        <div class=\"oligo-index-arrow\">\n          <span>\n            <em class=\"icon-16-chevron-down-bold\"></em>\n          </span>\n        </div>\n        <span class=\"oligo-count\">{{oligoConfig.data.index + 1}}.</span>\n      </span>\n      <div class=\"oligo-config-summary\">\n        <div class=\"oligo-config-icon-summary-name\">\n          <span class=\"oligo-error-icon\" ng-if=\"oligoConfig.data.invalid\"><img class=\".icon-warning\" \n            src='/order/custom-standard-oligo/assets/app/img/icon-warning-large.png' /></span>\n          <span class=\"oligo-config-summary-name\">{{oligoConfig.data.oligoName.definition.value ? oligoConfig.data.oligoName.definition.value :\n            oligoConfig.UNNAMED_OLIGO_LABEL}}</span>\n        </div>\n        <div class=\"oligo-config-researchername-sequence\">\n          <div class=\"oligo-config-summary-researchername\">\n            <span>{{oligoConfig.data.researcherName.definition.value ? oligoConfig.data.researcherName.definition.value\n              :\n              oligoConfig.UNNAMED_RESEARCHER_LABEL}}</span>\n          </div>\n          <span class=\"oligo-config-summary-sequence\">\n            <span class=\"oligo-config-summary-sequence__label\">{{oligoConfig.SEQUENCE_LABEL}}:</span>\n            <span class=\"oligo-config-summary-sequence__value\">{{oligoConfig.data.oligoValue.definition.value ?\n              oligoConfig.textToBlocks(oligoConfig.data.oligoValue.definition.value, 3).join(' ') :\n              oligoConfig.SEQUENCE_EMPTY_LABEL }}</span>\n          </span>\n        </div>\n      </div>\n      <div class=\"loader-container\" ng-if=\"oligoConfig.loading\">\n        <div class=\"loader\"></div>\n      </div>\n    </div>\n    <div class=\"oligo-pricing-and-close\">\n      <div class=\"oligo-config-summary-pricing\"\n        ng-if=\"oligoConfig.price && oligoConfig.price.available && !oligoConfig.showDetails\">\n        <span>{{oligoConfig.formatAmount(oligoConfig.price.amount, oligoConfig.price.currency,\n          oligoConfig.language)}}</span>\n      </div>\n      <span class=\"oligo-config-close\">\n        <span class=\"btn-config-delete\" ng-click=\"oligoConfig.publishOligoDelete()\"><em\n            class=\"icon-16-bin-mono\"></em></span>\n      </span>\n    </div>\n  </div>\n  <mix-bases-panel class=\"mix-bases-panel\" ng-style=\"{\n    visibility: oligoConfig.mixedBasesPanelProps.visible ? 'visible': 'hidden',\n    right: oligoConfig.mixedBasesPanelProps.rect.right + 'px',\n    height: oligoConfig.mixedBasesPanelProps.rect.height + 'px',\n    top: oligoConfig.mixedBasesPanelProps.rect.top + 'px',\n    width: oligoConfig.mixedBasesPanelProps.rect.width + 'px'}\" header=\"{{oligoConfig.MIXED_BASES_PANEL_TITLE}}\"\n    description=\"{{oligoConfig.MIXED_BASES_PANEL_DESC}}\" bases=\"oligoConfig.mixedBasesPanelProps.data.bases\"\n    on-close=\"oligoConfig.mixedBasesPanelClose()\"\n    ng-class=\"{ disabled: (oligoConfig.loading)}\">\n  </mix-bases-panel>\n</div>";

/***/ }),

/***/ "ot5s":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("PHqh");
var toLength = __webpack_require__("BbyF");
var toAbsoluteIndex = __webpack_require__("zo/l");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "pA9T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pDM8":
/***/ (function(module, exports) {

module.exports = "<oligo-summary-bar class=\"oligo-summary-bar__floating\"\n                   ng-if=\"oligoSummaryManager.floatingBarVisible\"\n                   cart-processing=\"oligoSummaryManager.cartProcessing\"\n                   on-cart-state-change=\"oligoSummaryManager.onCartStateChange({state})\">\n</oligo-summary-bar>";

/***/ }),

/***/ "pF+j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RestProjectServiceImpl */
/* unused harmony export NoFileSupportRestProjectServiceImpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_SERVICE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProjectServiceFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__("lsdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_i18n__ = __webpack_require__("BOQq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_client__ = __webpack_require__("ZcWc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_util__ = __webpack_require__("jQAO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_config_service__ = __webpack_require__("biSS");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






function oligoParamToOligoServiceConfig(parameter) {
    var basic = parameter.basic,
        advanced = parameter.advanced;

    return Object.assign({}, basic, advanced);
}
function paramDefToParam(paramDef) {
    var id = paramDef.id,
        value = paramDef.value;

    return { id: id, value: value };
}
function oligoParamDefToOligoParam(paramDef) {
    var basic = paramDef.basic,
        advanced = paramDef.advanced;
    var scale = basic.scale,
        purification = basic.purification,
        format = basic.format,
        prime3Mod = basic.prime3Mod,
        prime5Mod = basic.prime5Mod,
        delivery = basic.delivery,
        researcherName = basic.researcherName,
        oligoName = basic.oligoName,
        oligoValue = basic.oligoValue;
    var alternate = advanced.alternate,
        handling = advanced.handling;

    return {
        basic: {
            researcherName: paramDefToParam(researcherName),
            oligoName: paramDefToParam(oligoName),
            oligoValue: paramDefToParam(oligoValue),
            scale: paramDefToParam(scale.selected),
            format: paramDefToParam(format.selected),
            purification: paramDefToParam(purification.selected),
            delivery: paramDefToParam(delivery.selected),
            prime3Mod: paramDefToParam(prime3Mod.selected),
            prime5Mod: paramDefToParam(prime5Mod.selected)
        },
        advanced: {
            alternate: alternate.selected.map(paramDefToParam),
            handling: handling.selected.map(paramDefToParam)
        }
    };
}
function ensureSelectedAreValid(definition) {
    var basic = definition.basic;
    var scale = basic.scale,
        purification = basic.purification,
        format = basic.format,
        prime3Mod = basic.prime3Mod,
        prime5Mod = basic.prime5Mod;

    [scale.selected, purification.selected, format.selected, prime3Mod.selected, prime5Mod.selected].filter(function (paramDef) {
        return (typeof paramDef === 'undefined' ? 'undefined' : _typeof(paramDef)) === 'object';
    }).forEach(function (paramDef) {
        return paramDef.invalid = false;
    });
    return definition;
}
function pristineSelection(definition) {
    var basic = definition.basic;
    var scale = basic.scale,
        purification = basic.purification,
        prime3Mod = basic.prime3Mod,
        prime5Mod = basic.prime5Mod,
        format = basic.format;

    [scale, purification, prime3Mod, prime5Mod, format].forEach(function (paramDef) {
        if (paramDef.selected) {
            paramDef.selected.disabled = true;
            paramDef.selected.invalid = false;
        }
        paramDef.value.forEach(function (selectionDef) {
            selectionDef.disabled = true;
        });
    });
    return definition;
}
function groupByResearcher(definitions) {
    var oligoByResearcherMap = {};
    return definitions.reduce(function (acc, next) {
        var basic = next.basic;
        var researcherName = basic.researcherName;
        var value = researcherName.value;

        var paramDefs = acc[value] || [];
        paramDefs.push(next);
        acc[value] = paramDefs;
        return acc;
    }, oligoByResearcherMap);
}
function asPlainParameter(id, value) {
    return {
        value: value,
        id: id
    };
}
var RestProjectServiceImpl = function () {
    function RestProjectServiceImpl($q, $http, configService) {
        _classCallCheck(this, RestProjectServiceImpl);

        this.$q = $q;
        this.$http = $http;
        this.configService = configService;
    }

    _createClass(RestProjectServiceImpl, [{
        key: 'oligoNamesDefinition',
        value: function oligoNamesDefinition(parameter) {
            var deferred = this.$q.defer();
            var request = {
                oligoConfig: oligoParamToOligoServiceConfig(parameter)
            };
            var path = this.configService.pathFor(__WEBPACK_IMPORTED_MODULE_4__app_config_service__["a" /* API_ENDPOINTS */].OLIGO_VALIDATE) + '?type=name';
            this.$http.post(path, request).then(function (response) {
                if (response.status === 200) {
                    deferred.resolve(response.data);
                } else {
                    deferred.reject();
                }
            }, deferred.reject);
            return deferred.promise;
        }
    }, {
        key: 'oligoParameterDefinition',
        value: function oligoParameterDefinition(parameter) {
            var deferred = this.$q.defer();
            var request = {
                oligoConfig: oligoParamToOligoServiceConfig(parameter)
            };
            var path = this.configService.pathFor(__WEBPACK_IMPORTED_MODULE_4__app_config_service__["a" /* API_ENDPOINTS */].OLIGO_VALIDATE);
            this.$http.post(path, request).then(function (response) {
                if (response.status === 200) {
                    deferred.resolve(response.data);
                } else {
                    deferred.reject();
                }
            }, deferred.reject);
            return deferred.promise;
        }
    }, {
        key: 'oligoParameterDefinitionBatch',
        value: function oligoParameterDefinitionBatch(parameters) {
            var deferred = this.$q.defer();
            var path = this.configService.pathFor(__WEBPACK_IMPORTED_MODULE_4__app_config_service__["a" /* API_ENDPOINTS */].OLIGO_VALIDATE) + '?batch=true';
            var request = Object.keys(parameters).reduce(function (acc, id) {
                var parameter = parameters[id];
                var oligoConfigMap = acc.oligoConfigMap;

                oligoConfigMap[id] = oligoParamToOligoServiceConfig(parameter);
                return acc;
            }, { oligoConfigMap: {} });
            this.$http.post(path, request).then(function (response) {
                if (response.status === 200) {
                    deferred.resolve(response.data);
                } else {
                    deferred.reject();
                }
            }, deferred.reject);
            return deferred.promise;
        }
    }, {
        key: 'newOligoItem',
        value: function newOligoItem(request) {
            var _this = this;

            var index = request.index,
                preference = request.preference;

            var path = this.configService.pathFor(__WEBPACK_IMPORTED_MODULE_4__app_config_service__["a" /* API_ENDPOINTS */].OLIGO_DEFAULT);
            var deferred = this.$q.defer();
            this.$http.get(path, { responseType: 'json' }).then(function (response) {
                if (response.status === 200) {
                    var definition = ensureSelectedAreValid(response.data);
                    var parameter = oligoParamDefToOligoParam(definition);
                    var resolveItem = function resolveItem(targetDefinition) {
                        var basic = targetDefinition.basic;
                        var oligoName = basic.oligoName,
                            oligoValue = basic.oligoValue,
                            researcherName = basic.researcherName;

                        [oligoName, oligoValue, researcherName].forEach(function (textInputParamDef) {
                            textInputParamDef.pristine = true;
                        });
                        var id = '' + (request.id || Object(__WEBPACK_IMPORTED_MODULE_3__models_util__["f" /* generateId */])() + '_' + index);
                        var item = {
                            id: id,
                            index: index,
                            parameter: parameter,
                            definition: pristineSelection(targetDefinition),
                            displayType: __WEBPACK_IMPORTED_MODULE_0__models__["f" /* OligoDisplayTypes */].DETAILS,
                            configDisplayType: __WEBPACK_IMPORTED_MODULE_0__models__["e" /* OligoConfigDisplayTypes */].BASIC
                        };
                        deferred.resolve(item);
                    };
                    if (preference && !preference.isDefault) {
                        var basic = parameter.basic;

                        basic.scale = Object.assign({}, preference.scale);
                        basic.purification = Object.assign({}, preference.purification);
                        basic.format = Object.assign({}, preference.format);
                        _this.oligoParameterDefinition(parameter).then(resolveItem, deferred.reject);
                    } else {
                        resolveItem(definition);
                    }
                } else {
                    deferred.reject();
                }
            }, deferred.reject);
            return deferred.promise;
        }
    }, {
        key: 'newProjectItem',
        value: function newProjectItem(request) {
            var index = request.index;

            var defer = this.$q.defer();
            var oligoIdx = 0;
            var projectId = '' + (request.id || Object(__WEBPACK_IMPORTED_MODULE_3__models_util__["f" /* generateId */])() + '_' + index);
            var oligoId = Object(__WEBPACK_IMPORTED_MODULE_3__models_util__["f" /* generateId */])() + '_' + oligoIdx + '_' + projectId;
            this.newOligoItem({
                index: oligoIdx,
                id: oligoId
            }).then(function (oligo) {
                var basic = oligo.parameter.basic;

                var preference = {
                    format: Object.assign({}, basic.format),
                    purification: Object.assign({}, basic.purification),
                    scale: Object.assign({}, basic.scale),
                    isDefault: true
                };
                var item = {
                    index: index,
                    preference: preference,
                    id: projectId,
                    name: 'Project ' + (index + 1),
                    oligos: [oligo]
                };
                defer.resolve(item);
            });
            return defer.promise;
        }
    }, {
        key: 'importProject',
        value: function importProject(request) {
            var _this2 = this;

            var files = request.files,
                preference = request.preference,
                fixErrorsUsingPreference = request.fixErrorsUsingPreference;

            var fileItem = files[0];
            var fileName = fileItem.name,
                file = fileItem.blob;

            var deferred = this.$q.defer();
            var targetEndpoint = fixErrorsUsingPreference ? __WEBPACK_IMPORTED_MODULE_4__app_config_service__["a" /* API_ENDPOINTS */].BULK_UPLOAD_OVERRIDE : __WEBPACK_IMPORTED_MODULE_4__app_config_service__["a" /* API_ENDPOINTS */].BULK_UPLOAD;
            var path = '' + this.configService.pathFor(targetEndpoint);
            var bulkUploadPreference = {
                scale: preference.scale.id,
                purification: preference.purification.id,
                formulation: preference.format.id,
                delivery: preference.delivery.id
            };
            var jsonData = JSON.stringify(bulkUploadPreference);
            this.$http({
                method: 'POST',
                url: path,
                headers: {
                    'Content-Type': undefined
                },
                responseType: 'json',
                data: {
                    file: file,
                    fileName: fileName,
                    jsonData: jsonData
                },
                transformRequest: function transformRequest(data) {
                    var formData = new FormData();
                    Object.keys(data).forEach(function (key) {
                        var value = data[key];
                        formData.append(key, value);
                    });
                    return formData;
                }
            }).then(function (response) {
                var status = response.status,
                    data = response.data;

                if (status === 200) {
                    _this2.processProjectImportData(data, preference).then(deferred.resolve, deferred.reject);
                } else {
                    deferred.reject();
                }
            }, deferred.reject);
            return deferred.promise;
        }
    }, {
        key: 'processProjectImportData',
        value: function processProjectImportData(data, preference) {
            var uploadErrors = data.error,
                paramDefs = data.oligosParamDefs;

            var paramDefsByResearcher = groupByResearcher(paramDefs || []);
            var projects = Object.keys(paramDefsByResearcher).map(function (key, projectIndex) {
                var projectId = Object(__WEBPACK_IMPORTED_MODULE_3__models_util__["f" /* generateId */])() + '_' + projectIndex;
                var paramDefsForResearcher = paramDefsByResearcher[key];
                var oligoItems = paramDefsForResearcher.map(function (paramDef, oligoIndex) {
                    var oligoId = Object(__WEBPACK_IMPORTED_MODULE_3__models_util__["f" /* generateId */])() + '_' + oligoIndex + '_' + projectId;
                    var parameter = oligoParamDefToOligoParam(paramDef);
                    var oligoItem = {
                        parameter: parameter,
                        id: oligoId,
                        index: oligoIndex,
                        definition: paramDef,
                        displayType: oligoIndex === 0 ? __WEBPACK_IMPORTED_MODULE_0__models__["f" /* OligoDisplayTypes */].DETAILS : __WEBPACK_IMPORTED_MODULE_0__models__["f" /* OligoDisplayTypes */].SUMMARY,
                        configDisplayType: __WEBPACK_IMPORTED_MODULE_0__models__["e" /* OligoConfigDisplayTypes */].BASIC
                    };
                    return oligoItem;
                });
                var item = {
                    id: projectId,
                    index: projectIndex,
                    preference: {
                        format: Object.assign({}, preference.format),
                        purification: Object.assign({}, preference.purification),
                        scale: Object.assign({}, preference.scale),
                        isDefault: preference.isDefault
                    },
                    name: 'Project ' + (projectIndex + 1),
                    oligos: oligoItems
                };
                return item;
            });
            var errors = (uploadErrors || []).map(function (uploadError) {
                return {
                    id: uploadError.code,
                    message: __WEBPACK_IMPORTED_MODULE_1__models_i18n__["c" /* replacePlaceHolders */](uploadError.message, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__models_i18n__["b" /* PlaceHolderKeys */].OLIGO_INDEX, '' + uploadError.lineNumber))
                };
            });
            return this.$q.resolve({ errors: errors, projects: projects });
        }
    }, {
        key: 'importProjectTemplateData',
        value: function importProjectTemplateData(request) {
            var _this3 = this;

            var deferred = this.$q.defer();
            var langCode = request.langCode || '';
            var worldPromise = this.configService.getAppContent(langCode).catch(function () {
                return Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__models__["l" /* WORLD_INITIAL */]);
            });
            worldPromise.then(function (world) {
                var vocabulary = world.vocabulary,
                    templateSupportedExtensions = world.templateSupportedExtensions;
                var files = request.files;

                if (files.length > 1) {
                    var multipleFilesUnsupportedError = {
                        id: __WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_MULTIPLE_FILES_UNSUPPORTED_TEXT,
                        message: vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_MULTIPLE_FILES_UNSUPPORTED_TEXT] || 'You may drag in or upload only 1 template file. Please review your data.'
                    };
                    deferred.reject(multipleFilesUnsupportedError);
                    return;
                }
                var fileItem = files[0];
                var fileName = fileItem.name,
                    file = fileItem.blob;

                var fileExtension = fileName.substring(fileName.lastIndexOf('.'));
                var isUnsupportedFileExtension = templateSupportedExtensions.filter(function (extension) {
                    return extension === fileExtension;
                }).length <= 0;
                if (isUnsupportedFileExtension) {
                    var unsupportedFileExtensionMessage = vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EXTENSION_UNSUPPORTED_TEXT] || 'User file format is not supported. Please review your template file. Accepted file formats: {{' + __WEBPACK_IMPORTED_MODULE_1__models_i18n__["b" /* PlaceHolderKeys */].SUPPORTED_TEMPLATE_EXTENSIONS + '}}';
                    unsupportedFileExtensionMessage = __WEBPACK_IMPORTED_MODULE_1__models_i18n__["c" /* replacePlaceHolders */](unsupportedFileExtensionMessage, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__models_i18n__["b" /* PlaceHolderKeys */].SUPPORTED_TEMPLATE_EXTENSIONS, templateSupportedExtensions.join(', ').replace(/,\s([^,]+)$/, ' and $1')));
                    var unsupportedFileExtensionError = {
                        id: __WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EXTENSION_UNSUPPORTED_TEXT,
                        message: unsupportedFileExtensionMessage
                    };
                    deferred.reject(unsupportedFileExtensionError);
                    return;
                }
                var path = '' + _this3.configService.pathFor(__WEBPACK_IMPORTED_MODULE_4__app_config_service__["a" /* API_ENDPOINTS */].BULK_TEMPLATE_CONTENT);
                _this3.$http({
                    method: 'POST',
                    url: path,
                    headers: {
                        'Content-Type': undefined
                    },
                    responseType: 'json',
                    data: {
                        file: file,
                        fileName: fileName
                    },
                    transformRequest: function transformRequest(data) {
                        var formData = new FormData();
                        Object.keys(data).forEach(function (key) {
                            var value = data[key];
                            formData.append(key, value);
                        });
                        return formData;
                    }
                }).then(function (response) {
                    var status = response.status,
                        data = response.data;

                    if (status === 200) {
                        _this3.processProjectTemplateData(data, langCode).then(deferred.resolve, deferred.reject);
                    } else {
                        deferred.reject();
                    }
                }, deferred.reject);
            });
            return deferred.promise;
        }
    }, {
        key: 'processProjectTemplateData',
        value: function processProjectTemplateData(data, langCode) {
            var worldPromise = this.configService.getAppContent(langCode).catch(function () {
                return Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__models__["l" /* WORLD_INITIAL */]);
            });
            return worldPromise.then(function (world) {
                var vocabulary = world.vocabulary;
                var rawTemplateData = data.rawTemplateData,
                    uploadErrors = data.error;

                var templateData = rawTemplateData.map(function (result) {
                    var researcherName = result.researcherName,
                        oligoName = result.oligoName,
                        sequence = result.sequence,
                        scale = result.scale,
                        purification = result.purification,
                        fivePrimeMod = result.fivePrimeMod,
                        threePrimeMod = result.threePrimeMod,
                        specialHandling = result.specialHandling;

                    return {
                        researcherName: asPlainParameter(__WEBPACK_IMPORTED_MODULE_0__models__["h" /* ProjectTemplateColumnDefIds */].RESEARCHER_NAME, researcherName),
                        oligoName: asPlainParameter(__WEBPACK_IMPORTED_MODULE_0__models__["h" /* ProjectTemplateColumnDefIds */].OLIGO_NAME, oligoName),
                        oligoValue: asPlainParameter(__WEBPACK_IMPORTED_MODULE_0__models__["h" /* ProjectTemplateColumnDefIds */].OLIGO_VALUE, sequence),
                        scale: asPlainParameter(__WEBPACK_IMPORTED_MODULE_0__models__["h" /* ProjectTemplateColumnDefIds */].SCALE, scale),
                        purification: asPlainParameter(__WEBPACK_IMPORTED_MODULE_0__models__["h" /* ProjectTemplateColumnDefIds */].PURIFICATION, purification),
                        prime5Mod: asPlainParameter(__WEBPACK_IMPORTED_MODULE_0__models__["h" /* ProjectTemplateColumnDefIds */].PRIME_5_MOD, fivePrimeMod),
                        prime3Mod: asPlainParameter(__WEBPACK_IMPORTED_MODULE_0__models__["h" /* ProjectTemplateColumnDefIds */].PRIME_3_MOD, threePrimeMod),
                        specialHandling: asPlainParameter(__WEBPACK_IMPORTED_MODULE_0__models__["h" /* ProjectTemplateColumnDefIds */].SPECIAL_HANDLING, specialHandling)
                    };
                });
                var errors = (uploadErrors || []).map(function (uploadError) {
                    return {
                        id: uploadError.code,
                        message: uploadError.message
                    };
                });
                if (templateData.length <= 0) {
                    if (errors.length > 0) {
                        throw errors;
                    } else {
                        var dataEmptyError = {
                            id: __WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EMPTY_TEXT,
                            message: vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EMPTY_TEXT] || 'Empty template detected. Please review your data.'
                        };
                        throw dataEmptyError;
                    }
                } else {
                    return { errors: errors, data: templateData };
                }
            });
        }
    }]);

    return RestProjectServiceImpl;
}();
var NoFileSupportRestProjectServiceImpl = function (_RestProjectServiceIm) {
    _inherits(NoFileSupportRestProjectServiceImpl, _RestProjectServiceIm);

    function NoFileSupportRestProjectServiceImpl($q, $http, configService) {
        _classCallCheck(this, NoFileSupportRestProjectServiceImpl);

        var _this4 = _possibleConstructorReturn(this, (NoFileSupportRestProjectServiceImpl.__proto__ || Object.getPrototypeOf(NoFileSupportRestProjectServiceImpl)).call(this, $q, $http, configService));

        _this4.$q = $q;
        _this4.$http = $http;
        _this4.configService = configService;
        var importProjectForm = document.createElement('form');
        importProjectForm.id = 'no-file-support-import-form';
        importProjectForm.method = 'POST';
        importProjectForm.target = 'no-file-support-import-frame';
        importProjectForm.enctype = 'multipart/form-data';
        importProjectForm.style.display = 'none';
        var fileNameInput = document.createElement('input');
        fileNameInput.type = 'hidden';
        fileNameInput.name = 'fileName';
        var fileContentInput = document.createElement('input');
        fileContentInput.type = 'hidden';
        fileContentInput.name = 'fileContent';
        var jsonDataInput = document.createElement('input');
        jsonDataInput.type = 'hidden';
        jsonDataInput.name = 'jsonData';
        var importProjectIframe = document.createElement('iframe');
        importProjectIframe.tabIndex = -1;
        importProjectIframe.name = 'no-file-support-import-frame';
        importProjectIframe.style.display = 'none';
        importProjectIframe.addEventListener('load', function () {
            var deferred = _this4.importDeferred;

            if (!deferred) {
                return;
            }
            var responseData = importProjectIframe.contentDocument.body.textContent;
            _this4.processProjectImportData(JSON.parse(responseData), JSON.parse(jsonDataInput.value)).then(deferred.resolve, deferred.reject);
        });
        importProjectForm.appendChild(fileNameInput);
        importProjectForm.appendChild(fileContentInput);
        importProjectForm.appendChild(jsonDataInput);
        importProjectForm.appendChild(importProjectIframe);
        document.body.appendChild(importProjectForm);
        _this4.importProjectForm = importProjectForm;
        _this4.fileNameInput = fileNameInput;
        _this4.fileContentInput = fileContentInput;
        _this4.jsonDataInput = jsonDataInput;
        var fetchTemplateDataForm = document.createElement('form');
        fetchTemplateDataForm.id = 'no-file-support-template-data-form';
        fetchTemplateDataForm.method = 'POST';
        fetchTemplateDataForm.target = 'no-file-support-template-data-frame';
        fetchTemplateDataForm.enctype = 'multipart/form-data';
        fetchTemplateDataForm.style.display = 'none';
        var fetchTemplateDataFileName = document.createElement('input');
        fetchTemplateDataFileName.type = 'hidden';
        fetchTemplateDataFileName.name = 'fileName';
        var fetchTemplateDataFile = document.createElement('input');
        fetchTemplateDataFile.id = 'no-file-support-template-data-file';
        fetchTemplateDataFile.type = 'file';
        fetchTemplateDataFile.name = 'file';
        var fetchTemplateDataFrame = document.createElement('iframe');
        fetchTemplateDataFrame.tabIndex = -1;
        fetchTemplateDataFrame.name = 'no-file-support-template-data-frame';
        fetchTemplateDataFrame.style.display = 'none';
        fetchTemplateDataFrame.addEventListener('load', function () {
            var deferred = _this4.fetchTemplateDeferred,
                langeCode = _this4.langeCode;

            if (!deferred) {
                return;
            }
            var responseData = fetchTemplateDataFrame.contentDocument.body.textContent;
            _this4.processProjectTemplateData(JSON.parse(responseData), langeCode || '').then(deferred.resolve, deferred.reject);
        });
        fetchTemplateDataForm.appendChild(fetchTemplateDataFile);
        fetchTemplateDataForm.appendChild(fetchTemplateDataFileName);
        fetchTemplateDataForm.appendChild(fetchTemplateDataFrame);
        document.body.appendChild(fetchTemplateDataForm);
        _this4.fetchTemplateDataForm = fetchTemplateDataForm;
        _this4.fetchTemplateDataFileName = fetchTemplateDataFileName;
        return _this4;
    }

    _createClass(NoFileSupportRestProjectServiceImpl, [{
        key: 'importProjectTemplateData',
        value: function importProjectTemplateData(request) {
            var _this5 = this;

            var deferred = this.$q.defer();
            var langCode = request.langCode || '';
            var worldPromise = this.configService.getAppContent(langCode).catch(function () {
                return Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__models__["l" /* WORLD_INITIAL */]);
            });
            worldPromise.then(function (world) {
                var vocabulary = world.vocabulary,
                    templateSupportedExtensions = world.templateSupportedExtensions;
                var files = request.files;

                if (files.length > 1) {
                    var multipleFilesUnsupportedError = {
                        id: __WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_MULTIPLE_FILES_UNSUPPORTED_TEXT,
                        message: vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_MULTIPLE_FILES_UNSUPPORTED_TEXT] || 'You may drag in or upload only 1 template file. Please review your data.'
                    };
                    deferred.reject(multipleFilesUnsupportedError);
                    return;
                }
                var fileItem = files[0];
                var fileName = fileItem.name;

                var fileExtension = fileName.substring(fileName.lastIndexOf('.'));
                var isUnsupportedFileExtension = templateSupportedExtensions.filter(function (extension) {
                    return extension === fileExtension;
                }).length <= 0;
                if (isUnsupportedFileExtension) {
                    var unsupportedFileExtensionMessage = vocabulary[__WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EXTENSION_UNSUPPORTED_TEXT] || 'User file format is not supported. Please review your template file. Accepted file formats: {{' + __WEBPACK_IMPORTED_MODULE_1__models_i18n__["b" /* PlaceHolderKeys */].SUPPORTED_TEMPLATE_EXTENSIONS + '}}';
                    unsupportedFileExtensionMessage = __WEBPACK_IMPORTED_MODULE_1__models_i18n__["c" /* replacePlaceHolders */](unsupportedFileExtensionMessage, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__models_i18n__["b" /* PlaceHolderKeys */].SUPPORTED_TEMPLATE_EXTENSIONS, templateSupportedExtensions.join(', ').replace(/,\s([^,]+)$/, ' and $1')));
                    var unsupportedFileExtensionError = {
                        id: __WEBPACK_IMPORTED_MODULE_1__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EXTENSION_UNSUPPORTED_TEXT,
                        message: unsupportedFileExtensionMessage
                    };
                    deferred.reject(unsupportedFileExtensionError);
                    return;
                }
                var path = ('' + _this5.configService.pathFor(__WEBPACK_IMPORTED_MODULE_4__app_config_service__["a" /* API_ENDPOINTS */].BULK_TEMPLATE_CONTENT)).replace('?', '.action?');
                _this5.fetchTemplateDataFileName.value = fileName;
                _this5.fetchTemplateDataForm.action = path;
                _this5.fetchTemplateDataForm.submit();
            });
            this.fetchTemplateDeferred = deferred;
            this.langeCode = langCode;
            return deferred.promise;
        }
    }, {
        key: 'importProject',
        value: function importProject(request) {
            var deferred = this.$q.defer();
            var preference = request.preference,
                files = request.files,
                fixErrorsUsingPreference = request.fixErrorsUsingPreference;

            var _files = _slicedToArray(files, 1),
                file = _files[0];

            var bulkUploadPreference = {
                scale: preference.scale.id,
                purification: preference.purification.id,
                formulation: preference.format.id,
                delivery: preference.delivery.id
            };
            var jsonData = JSON.stringify(bulkUploadPreference);
            var targetEndpoint = fixErrorsUsingPreference ? __WEBPACK_IMPORTED_MODULE_4__app_config_service__["a" /* API_ENDPOINTS */].BULK_UPLOAD_OVERRIDE : __WEBPACK_IMPORTED_MODULE_4__app_config_service__["a" /* API_ENDPOINTS */].BULK_UPLOAD;
            var path = '' + this.configService.pathFor(targetEndpoint);
            path = fixErrorsUsingPreference ? path.replace('?', '.action?') : path + '.action';
            this.fileNameInput.value = file.name;
            this.fileContentInput.value = file.text;
            this.jsonDataInput.value = jsonData;
            this.importProjectForm.action = path;
            this.importProjectForm.submit();
            this.importDeferred = deferred;
            return deferred.promise;
        }
    }]);

    return NoFileSupportRestProjectServiceImpl;
}(RestProjectServiceImpl);
var PROJECT_SERVICE_NAME = 'projectService';
var ProjectServiceFactory = function ProjectServiceFactory($q, $http, configService) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__models_client__["e" /* hasLocalFileSupport */])() ? new RestProjectServiceImpl($q, $http, configService) : new NoFileSupportRestProjectServiceImpl($q, $http, configService);
};

/***/ }),

/***/ "pIx9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "piwb":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.memoryStorageDriver = factory());
}(this, function () { 'use strict';

    function getSerializerPromise(localForageInstance) {
        if (getSerializerPromise.result) {
            return getSerializerPromise.result;
        }
        if (!localForageInstance || typeof localForageInstance.getSerializer !== 'function') {
            Promise.reject(new Error('localforage.getSerializer() was not available! ' + 'localforage v1.4+ is required!'));
        }
        getSerializerPromise.result = localForageInstance.getSerializer();
        return getSerializerPromise.result;
    }

    function executeCallback(promise, callback) {
        if (callback) {
            promise.then(function (result) {
                callback(null, result);
            }, function (error) {
                callback(error);
            });
        }
    }

    var storageRepository = {};

    // Config the localStorage backend, using options set in the config.
    function _initStorage(options) {
        var self = this;

        var dbInfo = {};
        if (options) {
            for (var i in options) {
                dbInfo[i] = options[i];
            }
        }

        var database = storageRepository[dbInfo.name] = storageRepository[dbInfo.name] || {};
        var table = database[dbInfo.storeName] = database[dbInfo.storeName] || {};
        dbInfo.db = table;

        self._dbInfo = dbInfo;

        return getSerializerPromise(self).then(function (serializer) {
            dbInfo.serializer = serializer;
        });
    }

    function clear(callback) {
        var self = this;
        var promise = self.ready().then(function () {
            var db = self._dbInfo.db;

            for (var key in db) {
                if (db.hasOwnProperty(key)) {
                    delete db[key];
                }
            }
        });

        executeCallback(promise, callback);
        return promise;
    }

    function getItem(key, callback) {
        var self = this;

        // Cast the key to a string, as that's all we can set as a key.
        if (typeof key !== 'string') {
            console.warn(key + ' used as a key, but it is not a string.');
            key = String(key);
        }

        var promise = self.ready().then(function () {
            var db = self._dbInfo.db;
            var result = db[key];

            if (result) {
                result = self._dbInfo.serializer.deserialize(result);
            }

            return result;
        });

        executeCallback(promise, callback);
        return promise;
    }

    function iterate(iterator, callback) {
        var self = this;

        var promise = self.ready().then(function () {
            var db = self._dbInfo.db;

            var iterationNumber = 1;
            for (var key in db) {
                if (db.hasOwnProperty(key)) {
                    var value = db[key];

                    if (value) {
                        value = self._dbInfo.serializer.deserialize(value);
                    }

                    value = iterator(value, key, iterationNumber++);

                    if (value !== void 0) {
                        return value;
                    }
                }
            }
        });

        executeCallback(promise, callback);
        return promise;
    }

    function key(n, callback) {
        var self = this;
        var promise = self.ready().then(function () {
            var db = self._dbInfo.db;
            var result = null;
            var index = 0;

            for (var key in db) {
                if (db.hasOwnProperty(key)) {
                    if (n === index) {
                        result = key;
                        break;
                    }
                    index++;
                }
            }

            return result;
        });

        executeCallback(promise, callback);
        return promise;
    }

    function keys(callback) {
        var self = this;
        var promise = self.ready().then(function () {
            var db = self._dbInfo.db;
            var keys = [];

            for (var key in db) {
                if (db.hasOwnProperty(key)) {
                    keys.push(key);
                }
            }

            return keys;
        });

        executeCallback(promise, callback);
        return promise;
    }

    function length(callback) {
        var self = this;
        var promise = self.keys().then(function (keys) {
            return keys.length;
        });

        executeCallback(promise, callback);
        return promise;
    }

    function removeItem(key, callback) {
        var self = this;

        // Cast the key to a string, as that's all we can set as a key.
        if (typeof key !== 'string') {
            console.warn(key + ' used as a key, but it is not a string.');
            key = String(key);
        }

        var promise = self.ready().then(function () {
            var db = self._dbInfo.db;
            if (db.hasOwnProperty(key)) {
                delete db[key];
            }
        });

        executeCallback(promise, callback);
        return promise;
    }

    function setItem(key, value, callback) {
        var self = this;

        // Cast the key to a string, as that's all we can set as a key.
        if (typeof key !== 'string') {
            console.warn(key + ' used as a key, but it is not a string.');
            key = String(key);
        }

        var promise = self.ready().then(function () {
            // Convert undefined values to null.
            // https://github.com/mozilla/localForage/pull/42
            if (value === undefined) {
                value = null;
            }

            // Save the original value to pass to the callback.
            var originalValue = value;

            function serializeAsync(value) {
                return new Promise(function (resolve, reject) {
                    self._dbInfo.serializer.serialize(value, function (value, error) {
                        if (error) {
                            reject(error);
                        } else {
                            resolve(value);
                        }
                    });
                });
            }

            return serializeAsync(value).then(function (value) {
                var db = self._dbInfo.db;
                db[key] = value;
                return originalValue;
            });
        });

        executeCallback(promise, callback);
        return promise;
    }

    var memoryStorageDriver = {
        _driver: 'memoryStorageDriver',
        _initStorage: _initStorage,
        // _supports: function() { return true; }
        iterate: iterate,
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem,
        clear: clear,
        length: length,
        key: key,
        keys: keys
    };

    return memoryStorageDriver;

}));

/***/ }),

/***/ "plSV":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("boo2");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "q8Iw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_APP_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_WORLD_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WORLD_ACTIONS_SERVICE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return WorldActionsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project_actions__ = __webpack_require__("vBqh");

var UPDATE_APP_STATE = 'UPDATE_APP_STATE';
var UPDATE_WORLD_DATA = 'UPDATE_WORLD_DATA';
var WORLD_ACTIONS_SERVICE_NAME = 'WorldActionsService';
function updateTextDefinitions(target, vocabulary) {
    var nameI18n = target.nameLabel,
        descI18n = target.descriptionLabel;

    if (!nameI18n && !descI18n) {
        return target;
    }
    var descriptions = target.descriptions,
        name = target.name;

    if (nameI18n) {
        name = vocabulary[nameI18n] || name;
    }
    if (descI18n) {
        var desc = vocabulary[descI18n];
        descriptions = desc ? [desc] : descriptions;
    }
    return Object.assign({}, target, { name: name, descriptions: descriptions });
}
function updateSingleSelectionOptionTextDefinitions(paramDef, vocabulary) {
    var value = paramDef.value,
        selected = paramDef.selected;

    return Object.assign({}, updateTextDefinitions(paramDef, vocabulary), { selected: updateTextDefinitions(selected, vocabulary), value: value.map(function (option) {
            return Object.assign({}, updateTextDefinitions(option, vocabulary));
        }) });
}
function updateMultiSelectionOptionTextDefinitions(paramDef, vocabulary) {
    var value = paramDef.value,
        selected = paramDef.selected;

    return Object.assign({}, updateTextDefinitions(paramDef, vocabulary), { selected: selected.map(function (option) {
            return Object.assign({}, updateTextDefinitions(option, vocabulary));
        }), value: value.map(function (option) {
            return Object.assign({}, updateTextDefinitions(option, vocabulary));
        }) });
}
function translateOligoText(oligo, vocabulary) {
    var currentDefinition = oligo.definition;
    var currentBasic = currentDefinition.basic,
        currentAdvanced = currentDefinition.advanced;
    var oligoName = currentBasic.oligoName,
        oligoValue = currentBasic.oligoValue,
        researcherName = currentBasic.researcherName,
        scale = currentBasic.scale,
        purification = currentBasic.purification,
        format = currentBasic.format,
        prime5Mod = currentBasic.prime5Mod,
        prime3Mod = currentBasic.prime3Mod,
        delivery = currentBasic.delivery;
    var alternate = currentAdvanced.alternate,
        handling = currentAdvanced.handling;

    var basic = Object.assign({}, updateTextDefinitions(currentBasic, vocabulary), { oligoName: updateTextDefinitions(oligoName, vocabulary), oligoValue: updateTextDefinitions(oligoValue, vocabulary), researcherName: updateTextDefinitions(researcherName, vocabulary), scale: updateSingleSelectionOptionTextDefinitions(scale, vocabulary), purification: updateSingleSelectionOptionTextDefinitions(purification, vocabulary), format: updateSingleSelectionOptionTextDefinitions(format, vocabulary), prime5Mod: updateSingleSelectionOptionTextDefinitions(prime5Mod, vocabulary), prime3Mod: updateSingleSelectionOptionTextDefinitions(prime3Mod, vocabulary), delivery: updateSingleSelectionOptionTextDefinitions(delivery, vocabulary) });
    var advanced = Object.assign({}, updateTextDefinitions(currentAdvanced, vocabulary), { alternate: updateMultiSelectionOptionTextDefinitions(alternate, vocabulary), handling: updateMultiSelectionOptionTextDefinitions(handling, vocabulary) });
    var definition = Object.assign({}, currentDefinition, { basic: basic,
        advanced: advanced });
    return Object.assign({}, oligo, { definition: definition });
}
function translateProjectText(project, vocabulary) {
    var currentOligos = project.oligos;

    var oligos = currentOligos.map(function (oligo) {
        return translateOligoText(oligo, vocabulary);
    });
    return Object.assign({}, project, { oligos: oligos });
}
var WorldActionsService = function WorldActionsService($q) {
    return {
        updateAppState: function updateAppState(request) {
            return function (dispatch, getState, extraArgs) {
                var deferred = $q.defer();

                var _getState = getState(),
                    world = _getState.world;

                dispatch({ type: UPDATE_APP_STATE, payload: request });
                deferred.resolve(Object.assign({}, world, { appState: request }));
                return deferred.promise;
            };
        },
        updateWorldData: function updateWorldData(request) {
            return function (dispatch, getState, extraArgs) {
                var deferred = $q.defer();

                var _getState2 = getState(),
                    projects = _getState2.projects,
                    world = _getState2.world;

                var vocabulary = request.vocabulary;

                dispatch({ type: UPDATE_WORLD_DATA, payload: request });
                projects.map(function (project) {
                    return translateProjectText(project, vocabulary);
                }).forEach(function (project) {
                    dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__project_actions__["f" /* UPDATE_PROJECT */], payload: project });
                });
                deferred.resolve(Object.assign({}, world, request));
                return deferred.promise;
            };
        }
    };
};

/***/ }),

/***/ "qkyc":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("kkCw")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "r0Zh":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-45Light.woff";

/***/ }),

/***/ "rFzY":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("XSOZ");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "s4j0":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("UKM+");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "sUA4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storageMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return storageState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage__ = __webpack_require__("22C0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__("lsdx");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var StorageEncodings = {
    BINARY: 'binary',
    BLOB: 'blob',
    NONE: 'none'
};
function isCompatible(worldReference, world) {
    return world.countryCode === worldReference.countryCode && world.customerType === worldReference.customerType && world.sessionToken === worldReference.sessionToken;
}
function toBinary(target) {
    var codeUnits = new Uint16Array(target.length);
    for (var i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = target.charCodeAt(i);
    }
    return [].concat(_toConsumableArray(new Uint8Array(codeUnits.buffer))).map(function (value) {
        return String.fromCharCode(value);
    }).join('');
}
function fromBinary(target) {
    var bytes = new Uint8Array(target.length);
    for (var i = 0; i < bytes.length; i++) {
        bytes[i] = target.charCodeAt(i);
    }
    return [].concat(_toConsumableArray(new Uint16Array(bytes.buffer))).map(function (value) {
        return String.fromCharCode(value);
    }).join('');
}
var memoryStorageDriver = __webpack_require__("piwb");
var binaryStringEncodingSupported = Object(__WEBPACK_IMPORTED_MODULE_1__models__["m" /* hasBrowserSupport */])('atob') && Object(__WEBPACK_IMPORTED_MODULE_1__models__["m" /* hasBrowserSupport */])('btoa') && Object(__WEBPACK_IMPORTED_MODULE_1__models__["m" /* hasBrowserSupport */])('Uint16Array') && Object(__WEBPACK_IMPORTED_MODULE_1__models__["m" /* hasBrowserSupport */])('Uint8Array');
var blobSupported = Object(__WEBPACK_IMPORTED_MODULE_1__models__["m" /* hasBrowserSupport */])('Blob') && Object(__WEBPACK_IMPORTED_MODULE_1__models__["m" /* hasBrowserSupport */])('FileReader');
var encodeState = function encodeState(encodingType, state) {
    var encodedState = state;
    if (encodingType === StorageEncodings.BINARY && binaryStringEncodingSupported) {
        try {
            encodedState = btoa(toBinary(JSON.stringify(state)));
        } catch (e) {
            encodedState = state;
        }
    }
    if (encodingType === StorageEncodings.BLOB && blobSupported) {
        try {
            encodedState = new Blob([JSON.stringify(state)], { type: 'application/json' });
        } catch (e) {
            encodedState = state;
        }
    }
    return encodedState;
};
var decodeState = function decodeState($q, state) {
    var deferred = $q.defer();
    var decodedState = state;
    if (state) {
        if ((typeof state === 'undefined' ? 'undefined' : _typeof(state)) === 'object') {
            if (blobSupported && state instanceof window.Blob) {
                var reader = new FileReader();
                reader.addEventListener('loadend', function () {
                    try {
                        decodedState = JSON.parse(reader.result);
                    } catch (e) {
                        decodedState = state;
                    }
                    deferred.resolve(decodedState);
                });
                reader.readAsText(state);
            } else {
                decodedState = state;
                deferred.resolve(decodedState);
            }
        } else if (typeof state === 'string' && binaryStringEncodingSupported) {
            try {
                decodedState = JSON.parse(fromBinary(atob(state)));
            } catch (e) {
                decodedState = state;
            }
            deferred.resolve(decodedState);
        } else {
            deferred.resolve(decodedState);
        }
    } else {
        deferred.resolve(decodedState);
    }
    return deferred.promise;
};
var storageMiddleware = function storageMiddleware(settings) {
    var key = settings.key,
        type = settings.type;

    __WEBPACK_IMPORTED_MODULE_0_localforage__["defineDriver"](memoryStorageDriver);
    __WEBPACK_IMPORTED_MODULE_0_localforage__["config"]({
        driver: [type, memoryStorageDriver._driver],
        name: key,
        version: 1.0,
        storeName: key,
        description: 'Custom Standard Oligo store'
    });
    var driverType = void 0;
    __WEBPACK_IMPORTED_MODULE_0_localforage__["ready"](function () {
        driverType = __WEBPACK_IMPORTED_MODULE_0_localforage__["driver"]();
    });
    return function (store) {
        return function (next) {
            return function (action) {
                var result = next(action);
                var state = store.getState();
                var storageEncoding = StorageEncodings.NONE;
                if (state && state.world && state.world.clientConfig) {
                    storageEncoding = state.world.clientConfig.storageEncoding || StorageEncodings.NONE;
                }
                __WEBPACK_IMPORTED_MODULE_0_localforage__["setItem"](key, driverType === type ? encodeState(storageEncoding, state) : state);
                return result;
            };
        };
    };
};
var storageState = function storageState($q, settings) {
    var deferred = $q.defer();
    var key = settings.key,
        defaultState = settings.defaultResponse;
    var worldReference = defaultState.world;
    var _window = window,
        sessionStorage = _window.sessionStorage;

    var sessionFlagKey = key + '-session';
    var hasActiveSession = sessionStorage && sessionStorage.getItem(sessionFlagKey) === 'true';
    if (!hasActiveSession) {
        __WEBPACK_IMPORTED_MODULE_0_localforage__["clear"]().then(function () {
            sessionStorage.setItem(sessionFlagKey, 'true');
            deferred.resolve(defaultState);
        });
    } else {
        __WEBPACK_IMPORTED_MODULE_0_localforage__["getItem"](key).then(function (data) {
            decodeState($q, data).then(function (storedState) {
                var state = storedState;
                if (state && (typeof state === 'undefined' ? 'undefined' : _typeof(state)) === 'object') {
                    if (!isCompatible(worldReference, state.world)) {
                        __WEBPACK_IMPORTED_MODULE_0_localforage__["removeItem"](key).then(function () {
                            deferred.resolve(defaultState);
                        });
                    } else {
                        deferred.resolve(state);
                    }
                } else {
                    deferred.resolve(defaultState);
                }
            }, function () {
                deferred.resolve(defaultState);
            });
        });
    }
    return deferred.promise;
};

/***/ }),

/***/ "szND":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CalculationServiceImpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALCULATION_SERVICE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CalculationServiceFactory; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CalculationServiceImpl = function () {
    function CalculationServiceImpl($q) {
        _classCallCheck(this, CalculationServiceImpl);

        this.$q = $q;
    }

    _createClass(CalculationServiceImpl, [{
        key: 'getOligoSequenceCalculations',
        value: function getOligoSequenceCalculations(sequence, od) {
            var deferred = this.$q.defer();
            if (!sequence) {
                sequence = '';
            }
            sequence = sequence.toUpperCase();
            var response = {
                tm: this.calculateMeltTemperature(sequence),
                gc: this.calculateGcPercentage(sequence),
                extCoef: this.calculateExtinctionCoefficient(sequence),
                mw: this.calculateMolecularWeight(sequence),
                nmolOd: this.calculateSequenceNmoleOd(sequence),
                yield: this.calculateYield(sequence, od)
            };
            deferred.resolve(response);
            return deferred.promise;
        }
    }, {
        key: 'getRemainingCutoffTime',
        value: function getRemainingCutoffTime(cutoffTime) {
            var currentTime = new Date().getTime();
            var seconds = (cutoffTime - currentTime) / 1000;
            var mins = seconds / 60;
            var hrs = mins / 60;
            var remainHrs = Math.floor(hrs);
            var minsLeft = (remainHrs === 0 ? hrs : hrs % remainHrs) * 60;
            var remainMins = Math.floor(minsLeft);
            var secsLeft = (remainMins === 0 ? minsLeft : minsLeft % remainMins) * 60;
            var remainSecs = Math.floor(secsLeft);
            return { hrs: remainHrs, mins: remainMins, secs: remainSecs };
        }
    }, {
        key: 'calculateMeltTemperature',
        value: function calculateMeltTemperature(sequence) {
            var modifiers = {
                S_A_A: 240,
                S_A_C: 173,
                S_A_G: 208,
                S_A_T: 239,
                S_A_N: 215,
                S_C_A: 129,
                S_C_C: 266,
                S_C_G: 278,
                S_C_T: 208,
                S_C_N: 220,
                S_G_A: 135,
                S_G_C: 267,
                S_G_G: 266,
                S_G_T: 173,
                S_G_N: 210,
                S_T_A: 169,
                S_T_C: 135,
                S_T_G: 129,
                S_T_T: 240,
                S_T_N: 168,
                S_N_A: 168,
                S_N_C: 210,
                S_N_G: 220,
                S_N_T: 215,
                S_N_N: 203,
                H_A_A: 91,
                H_A_C: 65,
                H_A_G: 78,
                H_A_T: 86,
                H_A_N: 80,
                H_C_A: 58,
                H_C_C: 110,
                H_C_G: 119,
                H_C_T: 78,
                H_C_N: 91,
                H_G_A: 56,
                H_G_C: 111,
                H_G_G: 110,
                H_G_T: 65,
                H_G_N: 85,
                H_T_A: 60,
                H_T_C: 56,
                H_T_G: 58,
                H_T_T: 91,
                H_T_N: 66,
                H_N_A: 66,
                H_N_C: 85,
                H_N_G: 91,
                H_N_T: 80,
                H_N_N: 80
            };
            var oligoTM1M = 0;
            var oligoTM05M = 0;
            if (sequence) {
                var dh = 0;
                var ds = 108;
                var seq = sequence.replace('\\[.*\\]', 'N');
                var seqLen = seq.length;
                for (var i = 0; i < seqLen - 1; i++) {
                    var cLast = seq.charAt(i);
                    var cThis = seq.charAt(i + 1);
                    if (cThis !== ' ') {
                        if (cLast === 'A') {
                            if (cThis === 'A') {
                                dh += modifiers.H_A_A;
                                ds += modifiers.S_A_A;
                            } else if (cThis === 'T') {
                                dh += modifiers.H_A_T;
                                ds += modifiers.S_A_T;
                            } else if (cThis === 'G') {
                                dh += modifiers.H_A_G;
                                ds += modifiers.S_A_G;
                            } else if (cThis === 'C') {
                                dh += modifiers.H_A_C;
                                ds += modifiers.S_A_C;
                            } else {
                                dh += modifiers.H_A_N;
                                ds += modifiers.S_A_N;
                            }
                        } else if (cLast === 'T') {
                            if (cThis === 'A') {
                                dh += modifiers.H_T_A;
                                ds += modifiers.S_T_A;
                            } else if (cThis === 'T') {
                                dh += modifiers.H_T_T;
                                ds += modifiers.S_T_T;
                            } else if (cThis === 'G') {
                                dh += modifiers.H_T_G;
                                ds += modifiers.S_T_G;
                            } else if (cThis === 'C') {
                                dh += modifiers.H_T_C;
                                ds += modifiers.S_T_C;
                            } else {
                                dh += modifiers.H_T_N;
                                ds += modifiers.S_T_N;
                            }
                        } else if (cLast === 'G') {
                            if (cThis === 'A') {
                                dh += modifiers.H_G_A;
                                ds += modifiers.S_G_A;
                            } else if (cThis === 'T') {
                                dh += modifiers.H_G_T;
                                ds += modifiers.S_G_T;
                            } else if (cThis === 'G') {
                                dh += modifiers.H_G_G;
                                ds += modifiers.S_G_G;
                            } else if (cThis === 'C') {
                                dh += modifiers.H_G_C;
                                ds += modifiers.S_G_C;
                            } else {
                                dh += modifiers.H_G_N;
                                ds += modifiers.S_G_N;
                            }
                        } else if (cLast === 'C') {
                            if (cThis === 'A') {
                                dh += modifiers.H_C_A;
                                ds += modifiers.S_C_A;
                            } else if (cThis === 'T') {
                                dh += modifiers.H_C_T;
                                ds += modifiers.S_C_T;
                            } else if (cThis === 'G') {
                                dh += modifiers.H_C_G;
                                ds += modifiers.S_C_G;
                            } else if (cThis === 'C') {
                                dh += modifiers.H_C_C;
                                ds += modifiers.S_C_C;
                            } else {
                                dh += modifiers.H_C_N;
                                ds += modifiers.S_C_N;
                            }
                        } else if (cThis === 'A') {
                            dh += modifiers.H_N_A;
                            ds += modifiers.S_N_A;
                        } else if (cThis === 'T') {
                            dh += modifiers.H_N_T;
                            ds += modifiers.S_N_T;
                        } else if (cThis === 'G') {
                            dh += modifiers.H_N_G;
                            ds += modifiers.S_N_G;
                        } else if (cThis === 'C') {
                            dh += modifiers.H_N_C;
                            ds += modifiers.S_N_C;
                        } else {
                            dh += modifiers.H_N_N;
                            ds += modifiers.S_N_N;
                        }
                    }
                }
                var deltaH = dh * -100;
                var deltaS = ds * -0.1;
                oligoTM1M = deltaH / (deltaS + 1.987 * Math.log(50.0 / 4000000000.0)) - 273.15 + 16.6 * 0;
                oligoTM05M = deltaH / (deltaS + 1.987 * Math.log(50.0 / 4000000000.0)) - 273.15 + 16.6 * -1.30102999566398;
            }
            return {
                mt5Prime: oligoTM05M.toFixed(1),
                mt10Prime: oligoTM1M.toFixed(1)
            };
        }
    }, {
        key: 'calculateGcPercentage',
        value: function calculateGcPercentage(sequence) {
            var length = sequence.length;
            var gc = 0;
            if (length === 0) {
                return '0';
            }
            for (var i = 0; i < length; i++) {
                var part = sequence[i];
                if (part === 'C' || part === 'G') {
                    gc++;
                }
            }
            var gcPercentage = gc / length * 100;
            return gcPercentage.toFixed(0);
        }
    }, {
        key: 'calculateExtinctionCoefficient',
        value: function calculateExtinctionCoefficient(sequence) {
            var seqMap = function seqMap(part) {
                var map = {
                    1: 7.6,
                    2: 9.3,
                    3: 12.1,
                    4: 15.3,
                    5: 30.3,
                    6: 51.2,
                    A: 15.3,
                    AC: 7.4,
                    AT: 9.3,
                    B: 9.5,
                    C: 7.4,
                    D: 12.1,
                    DA: 15.3,
                    DB: 9.5,
                    DC: 7.4,
                    DD: 12.1,
                    DG: 11.8,
                    DH: 10.7,
                    DI: 12.25,
                    DK: 10.6,
                    DM: 11.4,
                    DN: 10.95,
                    DR: 13.6,
                    DS: 9.6,
                    DT: 11.8,
                    DV: 11.5,
                    DW: 12.3,
                    DX: 10.95,
                    DY: 8.35,
                    E: 11.8,
                    F: 15.3,
                    FC: 28.4,
                    FT: 30.3,
                    G: 11.8,
                    H: 10.7,
                    HC: 39.0,
                    HT: 40.9,
                    I: 12.25,
                    J: 7.6,
                    JC: 51.2,
                    JT: 51.2,
                    K: 10.6,
                    M: 11.4,
                    MEA: 15.3,
                    MEC: 7.3,
                    MEG: 11.8,
                    MEU: 8.7,
                    N: 10.95,
                    O: 7.4,
                    OA: 15.3,
                    OC: 7.3,
                    OG: 11.8,
                    OU: 8.7,
                    Q: 9.3,
                    R: 13.6,
                    S: 9.6,
                    T: 9.3,
                    TC: 23.6,
                    TT: 25.5,
                    U: 8.7,
                    V: 11.5,
                    W: 12.3,
                    X: 10.95,
                    Y: 8.35,
                    Z: 9.3
                };
                if (map[part]) {
                    return map[part];
                } else {
                    return 0;
                }
            };
            var mod5Map = function mod5Map(part) {
                var map = {
                    488: 21.3,
                    532: 19.4,
                    546: 21.8,
                    555: 12.0,
                    594: 38.7,
                    647: 0.0,
                    660: 0.0,
                    680: 0.0,
                    750: 0.0,
                    ACR: 0.0,
                    ALD: 0.0,
                    ALP: 0.0,
                    AMC: 0.0,
                    BDA: 0.0,
                    BDB: 0.0,
                    BDC: 0.0,
                    BDE: 0.0,
                    BDF: 0.0,
                    BDG: 0.0,
                    BDH: 0.0,
                    BDI: 0.0,
                    BDJ: 0.0,
                    BDK: 0.0,
                    BDL: 0.0,
                    BDM: 0.0,
                    BDN: 0.0,
                    BDP: 0.0,
                    BFM: 21.0,
                    BHX: 31.6,
                    BIO: 0.0,
                    BOC: 0.0,
                    BP2: 0.0,
                    BP3: 0.0,
                    BP4: 0.0,
                    BTT: 16.2,
                    CSB: 0.0,
                    CY5: 0.0,
                    DIP: 8.5,
                    FAM: 21.0,
                    FLO: 21.0,
                    GWF: 0.0,
                    GWR: 0.0,
                    HEX: 31.6,
                    HRP: 0.0,
                    MNB: 0.0,
                    OGA: 0.0,
                    OGB: 0.0,
                    OGC: 0.0,
                    OGD: 0.0,
                    PFB: 0.0,
                    PHO: 0.0,
                    PSO: 0.0,
                    RGA: 0.0,
                    RGB: 0.0,
                    RGC: 0.0,
                    ROX: 0.0,
                    RRA: 0.0,
                    TAM: 31.98,
                    TET: 16.2,
                    THL: 0.0,
                    TRX: 0.0
                };
                if (map[part]) {
                    return map[part];
                } else {
                    return 0;
                }
            };
            var mod3Map = function mod3Map(part) {
                var map = {
                    ADT: 0.0,
                    AM7: 0.0,
                    AMN: 0.0,
                    BIO: 0.0,
                    CPG: 0.0,
                    DAB: 0.0,
                    TAM: 0.0
                };
                if (map[part]) {
                    return map[part];
                } else {
                    return 0;
                }
            };
            var calcTotal = function calcTotal(text) {
                var calcResult = 0;
                for (var i = 0; i < text.length; i++) {
                    if (text[i] === '[') {
                        while (text[i] !== ']') {
                            i++;
                            if (i === text.length && text[i] !== ']') {
                                return 0;
                            }
                        }
                    } else {
                        calcResult += seqMap(text[i]);
                    }
                }
                return calcResult;
            };
            var result = 0;
            if (sequence) {
                var matches = sequence.split(',');
                if (matches[0]) {
                    result += calcTotal(matches[0]);
                }
                if (matches[1]) {
                    result += mod5Map(matches[1]);
                }
                if (matches[2]) {
                    result += mod3Map(matches[2]);
                }
            }
            return result;
        }
    }, {
        key: 'calculateMolecularWeight',
        value: function calculateMolecularWeight(sequence) {
            var seqMap = function seqMap(part) {
                var map = {
                    1: 393.4,
                    2: 394.4,
                    3: 419.4,
                    4: 403.4,
                    5: 816.71,
                    6: 945.66,
                    A: 313.2,
                    AC: 1421.72,
                    AT: 1422.71,
                    B: 307.5,
                    C: 289.2,
                    D: 315.5,
                    DA: 313.2,
                    DB: 307.5,
                    DC: 289.2,
                    DD: 315.5,
                    DG: 329.2,
                    DH: 302.2,
                    DI: 313.0,
                    DK: 316.7,
                    DM: 301.2,
                    DN: 309.0,
                    DR: 321.2,
                    DS: 309.2,
                    DT: 304.2,
                    DV: 310.5,
                    DW: 308.7,
                    DX: 309.0,
                    DY: 296.7,
                    E: 345.3,
                    F: 329.3,
                    FC: 815.72,
                    FT: 816.71,
                    G: 329.2,
                    H: 302.2,
                    HC: 1022.4,
                    HT: 1023.39,
                    I: 309.0,
                    J: 319.3,
                    JC: 944.67,
                    JT: 945.66,
                    K: 316.7,
                    M: 301.2,
                    MEA: 343.24,
                    MEC: 319.21,
                    MEG: 359.24,
                    MEU: 320.2,
                    N: 309.0,
                    O: 305.3,
                    OA: 343.24,
                    OC: 319.21,
                    OG: 359.24,
                    OU: 320.2,
                    Q: 458.41,
                    R: 321.2,
                    S: 309.2,
                    T: 304.2,
                    TC: 953.51,
                    TT: 954.5,
                    U: 290.2,
                    V: 310.5,
                    W: 308.7,
                    X: 309.0,
                    Y: 296.7,
                    Z: 320.3
                };
                if (map[part]) {
                    return map[part];
                } else {
                    return 0;
                }
            };
            var mod5Map = function mod5Map(part) {
                var map = {
                    488: 694.16,
                    532: 782.16,
                    546: 1122.16,
                    555: 993.16,
                    594: 884.16,
                    647: 1013.16,
                    660: 941.16,
                    680: 1027.95,
                    750: 1054.16,
                    ACR: 401.4,
                    ALD: 245.14,
                    ALP: 0.0,
                    AMC: 491.5,
                    BDA: 453.28,
                    BDB: 577.43,
                    BDC: 481.34,
                    BDE: 507.35,
                    BDF: 527.37,
                    BDG: 490.31,
                    BDH: 553.4,
                    BDI: 566.44,
                    BDJ: 698.58,
                    BDK: 672.57,
                    BDL: 501.33,
                    BDM: 614.49,
                    BDN: 724.62,
                    BDP: 707.57,
                    BFM: 554.5,
                    BHX: 761.1,
                    BIO: 405.0,
                    BOC: 438.38,
                    BP2: 612.0,
                    BP3: 646.0,
                    BP4: 546.0,
                    BTT: 692.2,
                    CSB: 678.6,
                    CY5: 0.0,
                    DIP: 313.21,
                    FAM: 537.46,
                    FLO: 537.46,
                    GWF: 0.0,
                    GWR: 0.0,
                    HEX: 744.13,
                    HRP: 0.0,
                    MNB: 431.38,
                    OGA: 0.0,
                    OGB: 673.67,
                    OGC: 573.5,
                    OGD: 686.65,
                    PFB: 403.33,
                    PHO: 79.98,
                    PSO: 420.4,
                    RGA: 571.95,
                    RGB: 0.0,
                    RGC: 685.17,
                    ROX: 696.82,
                    RRA: 832.96,
                    TAM: 591.65,
                    TET: 675.24,
                    THL: 327.0,
                    TRX: 881.06
                };
                if (map[part]) {
                    return map[part];
                } else {
                    return 0;
                }
            };
            var mod3Map = function mod3Map(part) {
                var map = {
                    ADT: 0.0,
                    AM7: 209.18,
                    AMN: 209.18,
                    BIO: 569.61,
                    CPG: 0.0,
                    DAB: 498.49,
                    TAM: 591.65
                };
                if (map[part]) {
                    return map[part];
                } else {
                    return 0;
                }
            };
            var calcTotal = function calcTotal(text) {
                var calcResult = 0;
                for (var i = 0; i < text.length; i++) {
                    if (text[i] === '[') {
                        while (text[i] !== ']') {
                            i++;
                            if (i === text.length && text[i] !== ']') {
                                return 0;
                            }
                        }
                    } else {
                        calcResult += seqMap(text[i]);
                    }
                }
                return calcResult;
            };
            var result = 0;
            if (sequence) {
                var matches = sequence.split(',');
                if (matches[0]) {
                    result += calcTotal(matches[0]);
                }
                if (matches[1]) {
                    result += mod5Map(matches[1]);
                }
                if (matches[2]) {
                    result += mod3Map(matches[2]);
                }
            }
            result -= 61;
            return result;
        }
    }, {
        key: 'calculateSequenceNmoleOd',
        value: function calculateSequenceNmoleOd(sequence) {
            var moleWeight = this.calculateMolecularWeight(sequence);
            var extCoef = this.calculateExtinctionCoefficient(sequence);
            var result = moleWeight / extCoef / moleWeight * 1000;
            return result.toFixed(1);
        }
    }, {
        key: 'calculateYield',
        value: function calculateYield(sequence, od) {
            var moleWeight = this.calculateMolecularWeight(sequence);
            var extCoef = this.calculateExtinctionCoefficient(sequence);
            var result = {
                ug: (moleWeight / extCoef * od).toFixed(1),
                nmole: (od / extCoef * 1000).toFixed(1)
            };
            return result;
        }
    }]);

    return CalculationServiceImpl;
}();
var CALCULATION_SERVICE_NAME = 'calculationService';
var CalculationServiceFactory = function CalculationServiceFactory($q) {
    return new CalculationServiceImpl($q);
};

/***/ }),

/***/ "tFcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownObj; });
/* unused harmony export DropdownContentObj */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dropdownContentObj = { title: '', description: '', disabled: false, selected: false };
var DropdownObj = function () {
    function DropdownObj() {
        _classCallCheck(this, DropdownObj);

        this.topic = '';
        this.selected = dropdownContentObj;
        this.options = [];
        this.disabled = false;
    }

    _createClass(DropdownObj, [{
        key: 'setSelected',
        value: function setSelected(option) {
            this.selected.selected = false;
            option.selected = true;
            this.selected = option;
        }
    }]);

    return DropdownObj;
}();
var DropdownContentObj = function DropdownContentObj() {
    _classCallCheck(this, DropdownContentObj);

    this.title = '';
    this.description = '';
    this.disabled = false;
    this.selected = false;
};

/***/ }),

/***/ "tcJy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ANONYMOUS_USER_NAME; });
/* unused harmony export CookieUserDetailsImpl */
/* unused harmony export UserTypeApiImpl */
/* unused harmony export UserTypePrimaryCookieSecondaryImpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_DETAILS__SERVICE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UserDetailsServiceFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return asUserContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_config_service__ = __webpack_require__("biSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_client__ = __webpack_require__("ZcWc");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ANONYMOUS_USER_NAME = 'anonymous';
var NEW_COOKIE_KEYS = {
    US_ID: 'usid',
    SC_ID: 'scid',
    SC_SHIP_TYPE: 'scShipType'
};
var ANONYMOUS_USER = {
    userId: 0,
    userName: ANONYMOUS_USER_NAME,
    countryCode: 'us',
    langCode: 'en',
    customerType: 'b2ccmgt',
    userType: 'b2c',
    isB2BMasterUser: false
};
var CookieUserDetailsImpl = function () {
    function CookieUserDetailsImpl($q, configService) {
        _classCallCheck(this, CookieUserDetailsImpl);

        this.$q = $q;
        this.configService = configService;
    }

    _createClass(CookieUserDetailsImpl, [{
        key: 'getUserDetails',
        value: function getUserDetails() {
            var userCookieInfo = this.getCommerceUser(this.configService.getCookieFor);
            var userName = userCookieInfo.userName,
                countryCode = userCookieInfo.countryCode,
                customerType = userCookieInfo.customerType,
                langCode = userCookieInfo.langCode,
                userIdString = userCookieInfo.userId,
                sessionToken = userCookieInfo.sessionToken,
                cartSessionId = userCookieInfo.cartSessionId;

            var user = void 0;
            if (userName === ANONYMOUS_USER_NAME) {
                user = Object.assign({}, ANONYMOUS_USER, {
                    countryCode: countryCode,
                    customerType: customerType,
                    langCode: langCode,
                    sessionToken: sessionToken,
                    cartSessionId: cartSessionId
                });
            } else {
                var userId = parseInt(userIdString, 10);
                user = Object.assign({}, ANONYMOUS_USER, {
                    countryCode: countryCode,
                    customerType: customerType,
                    langCode: langCode,
                    userName: userName,
                    sessionToken: sessionToken,
                    cartSessionId: cartSessionId,
                    userId: userId
                });
            }
            return this.$q.resolve(user);
        }
    }, {
        key: 'getCommerceUser',
        value: function getCommerceUser(getCookie) {
            var LOGIN_KEY = 'userlogin';
            var USERID_KEY = 'userkey';
            var F_NAME_KEY = 'customerName';
            var L_NAME_KEY = 'lastName';
            var CUSTOMER_TYPE_KEY = 'displayType';
            var SHIP_TO_ACCOUNT_KEY = 'shipToNumber';
            var ISB2B_KEY = 'isB2BCMGT';
            var ISB2B_MASTER_KEY = 'MasterUserType';
            var EFFECTIVE_USER_ID_KEY = 'effectiveUserKey';
            var userInfo = {
                firstName: '',
                lastName: '',
                userId: '',
                userName: '',
                userType: 'b2c',
                isB2BMasterUser: false,
                customerType: getCookie(__WEBPACK_IMPORTED_MODULE_1__models_client__["a" /* COOKIE_KEYS */].CK_DISPLAY_TYPE),
                shipToAccountNumber: 0,
                countryCode: getCookie(__WEBPACK_IMPORTED_MODULE_1__models_client__["a" /* COOKIE_KEYS */].CK_ISO_CODE),
                langCode: getCookie(__WEBPACK_IMPORTED_MODULE_1__models_client__["a" /* COOKIE_KEYS */].CK_LANG_CODE),
                sessionToken: getCookie(__WEBPACK_IMPORTED_MODULE_1__models_client__["a" /* COOKIE_KEYS */].LT_TOKEN_ID),
                cartSessionId: getCookie(__WEBPACK_IMPORTED_MODULE_1__models_client__["a" /* COOKIE_KEYS */].CART_SESSION_ID),
                scId: getCookie(NEW_COOKIE_KEYS.SC_ID),
                scShipType: getCookie(NEW_COOKIE_KEYS.SC_SHIP_TYPE)
            };
            try {
                var customerInfo = getCookie(__WEBPACK_IMPORTED_MODULE_1__models_client__["a" /* COOKIE_KEYS */].CK_CUSTOMER_INFO);
                if (!customerInfo || customerInfo.length <= 0) {
                    userInfo.userName = ANONYMOUS_USER_NAME;
                    return userInfo;
                }
                var userInfoString = decodeURIComponent(customerInfo);
                userInfoString.split(';').forEach(function (line) {
                    var key = '';
                    var value = '';
                    var entries = line.split(':');
                    if (entries.length > 0) {
                        key = entries[0];
                    }
                    if (entries.length > 1) {
                        value = entries[1];
                    }
                    switch (key) {
                        case F_NAME_KEY:
                            userInfo.firstName = value;
                            break;
                        case L_NAME_KEY:
                            userInfo.lastName = value;
                            break;
                        case USERID_KEY:
                            userInfo.userId = value;
                            break;
                        case LOGIN_KEY:
                            userInfo.userName = value;
                            break;
                        case CUSTOMER_TYPE_KEY:
                            userInfo.customerType = value;
                            break;
                        case ISB2B_KEY:
                            userInfo.userType = value === 'true' ? 'b2b' : 'b2c';
                            break;
                        case ISB2B_MASTER_KEY:
                            userInfo.isB2BMasterUser = value !== 'NONE';
                            break;
                        case SHIP_TO_ACCOUNT_KEY:
                            userInfo.shipToAccountNumber = parseInt(value, 10);
                            break;
                        case EFFECTIVE_USER_ID_KEY:
                            userInfo.isCSR = !!(parseInt(value, 10) || 0);
                            break;
                        default:
                            break;
                    }
                });
            } catch (e) {
                console.error(e);
            }
            return userInfo;
        }
    }]);

    return CookieUserDetailsImpl;
}();
var UserTypeApiImpl = function () {
    function UserTypeApiImpl($q, $http, configService) {
        _classCallCheck(this, UserTypeApiImpl);

        this.$q = $q;
        this.$http = $http;
        this.configService = configService;
    }

    _createClass(UserTypeApiImpl, [{
        key: 'getUserDetails',
        value: function getUserDetails() {
            var path = '' + this.configService.pathFor(__WEBPACK_IMPORTED_MODULE_0__app_config_service__["a" /* API_ENDPOINTS */].GET_USER_DETAILS);
            var deferred = this.$q.defer();
            this.$http.get(path, { responseType: 'json' }).then(function (response) {
                if (response.status === 200) {
                    var responseData = response.data;
                    var userInfo = responseData.data;
                    var loggedInUserId = userInfo.userId,
                        loggedInUserName = userInfo.userName,
                        guestUserId = userInfo.guestUserId,
                        country = userInfo.country,
                        userCountryCode = userInfo.countryCode,
                        lang = userInfo.lang,
                        displayType = userInfo.displayType,
                        isB2BMasterUser = userInfo.isB2BMasterUser,
                        userType = userInfo.userType,
                        scId = userInfo.scId,
                        scShipType = userInfo.scShipType,
                        effectiveUser = userInfo.effectiveUser;
                    var effectiveUserId = userInfo.effectiveUserId,
                        effectiveUserName = userInfo.effectiveUserName;

                    if (effectiveUser) {
                        effectiveUserId = effectiveUser.userId;
                        effectiveUserName = effectiveUser.userName;
                    }
                    var userId = effectiveUserId || loggedInUserId || 0;
                    var userName = effectiveUserName || loggedInUserName || ANONYMOUS_USER_NAME;
                    var countryCode = (effectiveUser ? effectiveUser.countryCode : undefined) || country || userCountryCode;
                    var langCode = lang;
                    var customerType = displayType;
                    var cartSessionId = '';
                    var sessionToken = '';
                    var isGuestUser = typeof guestUserId === 'number';
                    var isCSR = !!effectiveUserId;
                    var effectiveUserDisplayType = effectiveUser ? effectiveUser.displayType : undefined;
                    var user = {
                        userId: userId,
                        userName: userName,
                        cartSessionId: cartSessionId,
                        sessionToken: sessionToken,
                        countryCode: countryCode,
                        langCode: langCode,
                        customerType: customerType,
                        userType: userType,
                        isB2BMasterUser: isB2BMasterUser,
                        isGuestUser: isGuestUser,
                        isCSR: isCSR,
                        scId: scId,
                        scShipType: scShipType,
                        effectiveUserDisplayType: effectiveUserDisplayType
                    };
                    deferred.resolve(user);
                } else {
                    deferred.resolve(Object.assign({}, ANONYMOUS_USER, { countryCode: undefined, langCode: undefined, customerType: undefined }));
                }
            }, function () {
                deferred.resolve(Object.assign({}, ANONYMOUS_USER, { countryCode: undefined, langCode: undefined, customerType: undefined }));
            });
            return deferred.promise;
        }
    }]);

    return UserTypeApiImpl;
}();
var UserTypePrimaryCookieSecondaryImpl = function () {
    function UserTypePrimaryCookieSecondaryImpl($q, $http, configService) {
        _classCallCheck(this, UserTypePrimaryCookieSecondaryImpl);

        this.$q = $q;
        this.userApiService = new UserTypeApiImpl($q, $http, configService);
        this.userCookieService = new CookieUserDetailsImpl($q, configService);
    }

    _createClass(UserTypePrimaryCookieSecondaryImpl, [{
        key: 'getUserDetails',
        value: function getUserDetails() {
            var deferred = this.$q.defer();
            this.$q.all([this.userApiService.getUserDetails(), this.userCookieService.getUserDetails()]).then(function (userData) {
                var _userData = _slicedToArray(userData, 2),
                    apiUser = _userData[0],
                    cookieUser = _userData[1];

                var user = Object.assign({}, apiUser);
                Object.keys(user).forEach(function (key) {
                    user[key] = user[key] || cookieUser[key];
                });
                if (user.countryCode) {
                    user.countryCode = user.countryCode.toLowerCase();
                }
                if (user.langCode) {
                    user.langCode = user.langCode.toLowerCase();
                }
                if (!user.sessionToken) {
                    user.sessionToken = '' + user.userId;
                }
                if (!user.cartSessionId) {
                    user.cartSessionId = '' + user.userId;
                }
                deferred.resolve(user);
            }, deferred.reject);
            return deferred.promise;
        }
    }]);

    return UserTypePrimaryCookieSecondaryImpl;
}();
var USER_DETAILS__SERVICE_NAME = 'userDetailsService';
var UserDetailsServiceFactory = function UserDetailsServiceFactory($q, $http, configService) {
    return new UserTypePrimaryCookieSecondaryImpl($q, $http, configService);
};
var asUserContext = function asUserContext(userDetails) {
    var userName = userDetails.userName,
        userId = userDetails.userId,
        lang = userDetails.langCode,
        country = userDetails.countryCode,
        customerType = userDetails.customerType,
        isB2BMasterUser = userDetails.isB2BMasterUser,
        userType = userDetails.userType,
        scId = userDetails.scId,
        scShipType = userDetails.scShipType,
        effectiveUserDisplayType = userDetails.effectiveUserDisplayType;

    var displayType = customerType;
    var isAnonymous = userName === ANONYMOUS_USER_NAME;
    var userContext = {
        isB2BMasterUser: isB2BMasterUser,
        isAnonymous: isAnonymous,
        country: country,
        lang: lang,
        displayType: displayType,
        userType: userType,
        scId: scId,
        scShipType: scShipType,
        effectiveUserDisplayType: effectiveUserDisplayType
    };
    if (!isAnonymous) {
        userContext.userId = userId;
        userContext.userName = userName;
    }
    return userContext;
};

/***/ }),

/***/ "tmAr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tqSY":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__("xAdt")
});


/***/ }),

/***/ "twxM":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("lDLk");
var anObject = __webpack_require__("DIVP");
var getKeys = __webpack_require__("Qh14");

module.exports = __webpack_require__("bUqO") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "uc2A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("V3l/");
var $export = __webpack_require__("Ds5P");
var redefine = __webpack_require__("R3AP");
var hide = __webpack_require__("2p1q");
var Iterators = __webpack_require__("bN1p");
var $iterCreate = __webpack_require__("IRJ3");
var setToStringTag = __webpack_require__("yYvK");
var getPrototypeOf = __webpack_require__("KOrd");
var ITERATOR = __webpack_require__("kkCw")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "uf0q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AppStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppCartModes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project__ = __webpack_require__("KJmm");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__project__["d"]; });

var AppStates = {
    DRAFT: 'draft',
    EDIT: 'edit',
    UPDATE: 'update'
};
var AppCartModes = {
    CLIENT: 'client',
    SERVER: 'server'
};

/***/ }),

/***/ "ulTY":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "vBqh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_PROJECTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PROJECT_ACTIONS_SERVICE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ProjectActionsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_util__ = __webpack_require__("jQAO");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }


var ADD_PROJECT = 'ADD_PROJECT';
var UPDATE_PROJECT = 'UPDATE_PROJECT';
var DELETE_PROJECT = 'DELETE_PROJECT';
var LOAD_PROJECTS = 'LOAD_PROJECTS';
function isPricingCandidate(oligo) {
    var definition = oligo.definition;
    var basic = definition.basic,
        properties = definition.properties;
    var oligoValue = basic.oligoValue;
    var pricingProps = properties.pricing;
    var pricingSupported = pricingProps.supported;

    var oligoValueDefined = oligoValue.value ? oligoValue.value.length > 0 : false;
    return pricingSupported && oligoValueDefined;
}
function oligosUsingPreference($q, projectService, pricingService) {
    return function (preference, oligoItems) {
        var deferred = $q.defer();
        var scale = preference.scale,
            purification = preference.purification,
            format = preference.format;

        var _oligoItems$reduce = oligoItems.reduce(function (acc, oligoItem) {
            var _acc = _slicedToArray(acc, 2),
                parameters = _acc[0],
                oligos = _acc[1];

            var id = oligoItem.id;

            var parameter = Object.assign({}, oligoItem.parameter);
            parameter.basic = Object.assign({}, parameter.basic, { scale: scale }, { purification: purification }, { format: format });
            parameters[id] = parameter;
            oligos[id] = oligoItem;
            return acc;
        }, [{}, {}]),
            _oligoItems$reduce2 = _slicedToArray(_oligoItems$reduce, 2),
            parameterMap = _oligoItems$reduce2[0],
            oligoItemMap = _oligoItems$reduce2[1];

        projectService.oligoParameterDefinitionBatch(parameterMap).then(function (paramDefsMap) {
            var _Object$keys$reduce = Object.keys(oligoItemMap).reduce(function (acc, id) {
                var _acc2 = _slicedToArray(acc, 2),
                    itemList = _acc2[0],
                    itemMap = _acc2[1];

                var oligoItem = oligoItemMap[id];
                var index = oligoItem.index,
                    displayType = oligoItem.displayType,
                    configDisplayType = oligoItem.configDisplayType,
                    definition = oligoItem.definition;

                var parameter = parameterMap[id];
                var updatedParamDefs = paramDefsMap[id] || Object.assign({}, definition);
                var oligo = {
                    parameter: parameter,
                    id: id,
                    index: index,
                    displayType: displayType,
                    configDisplayType: configDisplayType,
                    definition: updatedParamDefs
                };
                itemMap[id] = oligo;
                itemList.push(oligo);
                return acc;
            }, [[], {}]),
                _Object$keys$reduce2 = _slicedToArray(_Object$keys$reduce, 2),
                updatedOligoList = _Object$keys$reduce2[0],
                updatedOligoMap = _Object$keys$reduce2[1];

            var oligosWithPrices = updatedOligoList.filter(isPricingCandidate);
            if (oligosWithPrices.length > 0) {
                pricingService.pricesForOligos(oligosWithPrices).then(function (pricingResultMap) {
                    Object.keys(pricingResultMap).forEach(function (id) {
                        var pricing = pricingResultMap[id];
                        updatedOligoMap[id].pricing = pricing;
                    });
                    var updatedOligosWithOrWithoutPrices = Object.keys(updatedOligoMap).map(function (id) {
                        return updatedOligoMap[id];
                    });
                    deferred.resolve(updatedOligosWithOrWithoutPrices);
                }, deferred.reject);
            } else {
                deferred.resolve(updatedOligoList);
            }
        }, deferred.reject);
        return deferred.promise;
    };
}
var PROJECT_ACTIONS_SERVICE_NAME = 'ProjectActionsService';
var ProjectActionsService = function ProjectActionsService($q, projectService, pricingService) {
    var updateOligosUsingPreference = oligosUsingPreference($q, projectService, pricingService);
    return {
        addProject: function addProject(request) {
            return function (dispatch, getState, extraArgs) {
                var deferred = $q.defer();
                var nextIdx = request.nextIdx;

                var addRequest = { index: nextIdx, id: Object(__WEBPACK_IMPORTED_MODULE_0__models_util__["f" /* generateId */])() + '_' + nextIdx };
                projectService.newProjectItem(addRequest).then(function (project) {
                    dispatch({ type: ADD_PROJECT, payload: project });
                    deferred.resolve(project);
                }, deferred.reject);
                return deferred.promise;
            };
        },
        updateProject: function updateProject(request) {
            return function (dispatch, getState, extraArgs) {
                var deferred = $q.defer();
                var preference = request.preference,
                    index = request.index;

                var _getState = getState(),
                    projects = _getState.projects;

                var project = projects[index];
                var oligos = project.oligos;

                updateOligosUsingPreference(preference, oligos).then(function (updatedOligos) {
                    updatedOligos.sort(function (oligo1, oligo2) {
                        return oligo1.index - oligo2.index;
                    });
                    var payload = Object.assign({}, project, { preference: preference }, { oligos: updatedOligos });
                    dispatch({ type: UPDATE_PROJECT, payload: payload });
                    deferred.resolve(payload);
                }, deferred.reject);
                return deferred.promise;
            };
        },
        deleteProject: function deleteProject(request) {
            return function (dispatch, getState, extraArgs) {
                var deferred = $q.defer();
                var index = request.index;

                var project = getState().projects[index];
                dispatch({ type: DELETE_PROJECT, payload: request });
                deferred.resolve(project);
                return deferred.promise;
            };
        },
        importProject: function importProject(request) {
            return function (dispatch, getState, extraArgs) {
                var deferred = $q.defer();
                var projects = request.projects;

                if (projects && projects.length > 0) {
                    var allOligos = projects.reduce(function (acc, project) {
                        return [].concat(_toConsumableArray(acc), _toConsumableArray(project.oligos));
                    }, []);
                    var oligosForPricing = allOligos.filter(isPricingCandidate);
                    if (oligosForPricing.length > 0) {
                        pricingService.pricesForOligos(oligosForPricing).then(function (pricingResultMap) {
                            projects = projects.map(function (project) {
                                var oligos = project.oligos;

                                var updatedOligos = oligos.map(function (oligo) {
                                    var id = oligo.id;

                                    var updatedOligo = Object.assign({}, oligo);
                                    var pricing = pricingResultMap[id];
                                    if (pricing) {
                                        updatedOligo.pricing = pricing;
                                    }
                                    return updatedOligo;
                                });
                                return Object.assign({}, project, { oligos: updatedOligos });
                            });
                            dispatch({ type: LOAD_PROJECTS, payload: projects });
                            deferred.resolve({ projects: projects });
                        }, deferred.reject);
                    } else {
                        dispatch({ type: LOAD_PROJECTS, payload: projects });
                        deferred.resolve({ projects: projects });
                    }
                } else {
                    deferred.resolve({ projects: projects });
                }
                return deferred.promise;
            };
        }
    };
};

/***/ }),

/***/ "vH9U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_WORLD_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROOT_ACTIONS_SERVICE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RootActionsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__("lsdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_storage_service__ = __webpack_require__("sUA4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__project_actions__ = __webpack_require__("vBqh");



var LOAD_WORLD_ITEM = 'LOAD_WORLD_ITEM';
var ROOT_ACTIONS_SERVICE_NAME = 'RootActionsService';
var RootActionsService = function RootActionsService($q) {
    return {
        loadStorageData: function loadStorageData(request) {
            return function (dispatch, getState, extraArgs) {
                var deferred = $q.defer();
                var countryCode = request.countryCode,
                    language = request.langCode,
                    customerType = request.customerType,
                    sessionToken = request.sessionToken;

                var defaultState = {
                    projects: [],
                    world: Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__models__["l" /* WORLD_INITIAL */], { countryCode: countryCode,
                        language: language,
                        customerType: customerType,
                        sessionToken: sessionToken })
                };
                Object(__WEBPACK_IMPORTED_MODULE_1__service_storage_service__["b" /* storageState */])($q, {
                    key: __WEBPACK_IMPORTED_MODULE_0__models__["i" /* STORAGE_KEY_PRFIX */],
                    type: __WEBPACK_IMPORTED_MODULE_0__models__["j" /* STORAGE_TYPE */],
                    defaultResponse: defaultState
                }).then(function (rootState) {
                    dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__project_actions__["c" /* LOAD_PROJECTS */], payload: rootState.projects });
                    dispatch({ type: LOAD_WORLD_ITEM, payload: rootState.world });
                    deferred.resolve(rootState);
                });
                return deferred.promise;
            };
        }
    };
};

/***/ }),

/***/ "vnKg":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-75Bold.svg";

/***/ }),

/***/ "w/VF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ProjectImportStates; });
/* unused harmony export ProjectImportModalSupportStatuses */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ProjectImportModalSupport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ProjectImportModalController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROJECT_IMPORT_MODAL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProjectImportModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project_import_modal_scss__ = __webpack_require__("tmAr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project_import_modal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__project_import_modal_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fancy_message_pane_fancy_message_pane__ = __webpack_require__("Sc+s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__oligo_config_preference_oligo_config_preference__ = __webpack_require__("LqB4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__oligo_modal_support_oligo_modal_support__ = __webpack_require__("z/Xr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_client__ = __webpack_require__("ZcWc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models__ = __webpack_require__("lsdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_i18n__ = __webpack_require__("BOQq");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var ProjectImportStates = {
    PROCESSING: 'processing',
    SUCCESS: 'success',
    FAILED: 'failed'
};
var ProjectImportModalSupportStatuses = {
    OK: 'OK',
    CANCEL: 'CANCEL',
    CLOSE: 'CLOSE'
};
var MODAL_ID = 'project-import-modal';
var SAMPLE_DATA_TEMPLATE = '\n<div class=\'project-import-modal__text-header\'>\n{{COL_HEADERS}}\n</div>\n<textarea class=\'project-import-modal__text-area\'>\nACGTACGTGCTACGT,SamplePrimer1,Jane Doe\nAGCTGTAACCGGTT,SamplePrimer2,John Doe,50N,,,DSL\nAGTTCCGGGCCAAA,SamplePrimer3,Jane Doe,50N,HEX,,HPL\n</textarea>\n';
var ErrorAlertTypes = {
    MISSING_REQUIRED_ONLY: 'MISSING_REQUIRED_ONLY',
    INCORRECT_CONFIG_ONLY: 'INCORRECT_CONFIG_ONLY',
    MIXED_ERROR: 'MIXED_ERROR'
};
var ProjectImportModalSupport = function () {
    function ProjectImportModalSupport() {
        _classCallCheck(this, ProjectImportModalSupport);
    }

    _createClass(ProjectImportModalSupport, [{
        key: 'open',
        value: function open() {
            throw new Error('Unbound!');
        }
    }, {
        key: 'listen',
        value: function listen(ctrl) {
            this.open = ctrl.open.bind(ctrl);
        }
    }]);

    return ProjectImportModalSupport;
}();
function templateLocation(countryCode, langCode, templatePath) {
    if (!countryCode || !langCode || !templatePath) {
        return undefined;
    }
    return templatePath.replace('{COUNTRY_CODE}', countryCode).replace('{LANG_CODE}', langCode);
}
function templateDataAsTextRowData(templateColumnDefs) {
    return function (data) {
        var parameterDataMap = Object.keys(data).reduce(function (acc, property) {
            var parameter = data[property];
            acc[parameter.id] = parameter;
            return acc;
        }, {});
        var rowData = templateColumnDefs.map(function (columnDef) {
            return parameterDataMap[columnDef.id].value || '';
        });
        var rowText = rowData.join(',').replace(/,+$/, '');
        return rowText;
    };
}
function templateTextDataAsFiles(textContent, templateColumnDefs, files) {
    var rowHeader = templateColumnDefs.map(function (columnDef) {
        return columnDef.standardName;
    }).join(',');
    var text = rowHeader + '\n' + textContent;
    var blob = void 0;
    try {
        blob = new Blob([text], { type: 'text/csv' });
    } catch (e) {
        blob = undefined;
    }
    var fileName = files && files.length > 0 ? files[0].name : 'paste-content.csv';
    var name = fileName.substring(0, fileName.lastIndexOf('.')) + '.csv';
    return [{ name: name, blob: blob, text: text }];
}
function alertTypeFromErrors(errors) {
    var hasMissingRequiredError = errors.filter(function (errorItem) {
        var id = errorItem.id;

        return id === __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].ERROR_MISSING_REQUIRED_GENERIC_MESSAGE || id === __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].ERROR_MISSING_REQUIRED_OLIGO_NAME_ONLY || id === __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].ERROR_MISSING_REQUIRED_OLIGO_RESEARCHER_NAME_ONLY || id === __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].ERROR_MISSING_REQUIRED_RESEARCHER_NAME_ONLY || id === __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].ERROR_MISSING_REQUIRED_SEQUENCE_ONLY;
    }).length > 0;
    var hasIncorrectConfigError = errors.filter(function (errorItem) {
        var id = errorItem.id;

        return id === __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].ERROR_INCORRECT_CONFIGURATION;
    }).length > 0;
    var alertType = ErrorAlertTypes.MIXED_ERROR;
    if (hasMissingRequiredError) {
        alertType = ErrorAlertTypes.MISSING_REQUIRED_ONLY;
    }
    if (hasIncorrectConfigError) {
        alertType = ErrorAlertTypes.INCORRECT_CONFIG_ONLY;
    }
    if (hasMissingRequiredError && hasIncorrectConfigError) {
        alertType = ErrorAlertTypes.MIXED_ERROR;
    }
    return alertType;
}
var ProjectImportModalController = function () {
    function ProjectImportModalController($scope, $timeout, $q, $location, $ngRedux, projectActions, projectService, oligoModalSupport) {
        var _this = this;

        _classCallCheck(this, ProjectImportModalController);

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$location = $location;
        this.projectService = projectService;
        this.oligoModalSupport = oligoModalSupport;
        this.MODAL_ID = MODAL_ID;
        this.MODAL_URL_PATH = '/import';
        this.IMPORT_OLIGO_PROJECT_TITLE = 'Bulk Upload';
        this.IMPORT_OLIGO_PROJECT_CANCEL_LABEL = 'Cancel';
        this.IMPORT_OLIGO_PROJECT_OK_LABEL = 'Import';
        this.IMPORT_OLIGO_PROJECT_DOWNLOAD_TEMPLATE_LABEL = 'Download template';
        this.IMPORT_OLIGO_PROJECT_UPLOAD_FILE_LABEL = 'Upload file';
        this.IMPORT_OLIGO_PROJECT_SHOW_PREFERENCES_LABEL = 'Show default preferences';
        this.IMPORT_OLIGO_PROJECT_HIDE_PREFERENCES_LABEL = 'Hide default preferences';
        this.IMPORT_OLIGO_PROJECT_DRAG_AREA_INSTRUCTIONS = '<div class=\'file-supported\'>Drag and drop your file</div><div class=\'file-supported\'>OR</div><div>Paste your copied data here</div>';
        this.IMPORT_OLIGO_PROJECT_TOP_LEVEL_INSTRUCTIONS = ['For bulk setup, <a href=\'{{' + __WEBPACK_IMPORTED_MODULE_6__models_i18n__["b" /* PlaceHolderKeys */].DOWNLOAD_TEMPLATE_URL + '}}\' target=\'_blank\'>download</a> sequence template, enter and save the sequence information prior to uploading the file.', 'Default preferences will be applied to all blank entries in the tabular form upon saving.<br/>', 'Supported template file formats for upload are {{' + __WEBPACK_IMPORTED_MODULE_6__models_i18n__["b" /* PlaceHolderKeys */].SUPPORTED_TEMPLATE_EXTENSIONS + '}}. Information being displayed is comma delimited.'].join('\n');
        this.IMPORT_OLIGO_PROJECT_OLIGO_COUNT_LABEL = 'Number of oligos: ';
        this.IMPORT_OLIGO_PROJECT_OLIGO_COUNT_MAX_LABEL = 'Maximum oligos: ';
        this.IMPORT_OLIGO_PROJECT_OLIGO_SAMPLE_DATA_LABEL = 'See sample data';
        this.IMPORT_OLIGO_PROJECT_OLIGO_PREFERENCE_HINT_LABEL = ['<div><b>Note:</b> Selected options below will be applied to all oligos where scale, purification, or formulation were not selected.</div>', '<div>This will not overwrite any existing spreadsheet selections.</div>'].join('');
        this.IMPORT_OLIGO_PROJECT_ERROR_ACCEPT_LABEL = 'Ok';
        this.IMPORT_OLIGO_PROJECT_OLIGO_COUNT_MAX_TEXT = ['You have exceeded the maximum limit of {{' + __WEBPACK_IMPORTED_MODULE_6__models_i18n__["b" /* PlaceHolderKeys */].MAX_OLIGO_COUNT + '}} oligos.', 'Please review your oligo entries before importing them.'].join(' ');
        this.IMPORT_OLIGO_PROJECT_TD_OVERWRITE_TEXT = 'This will overwrite your existing data. Are you sure you want to continue?';
        this.IMPORT_OLIGO_PROJECT_TD_OVERWRITE_OK_LABEL = 'Ok';
        this.IMPORT_OLIGO_PROJECT_TD_OVERWRITE_CANCEL_LABEL = 'Cancel';
        this.IMPORT_OLIGO_PROJECT_TD_EXT_UNSUPPORTED_TEXT = ['User file format is not supported.', 'Please review your template file.', 'Accepted file formats: {{' + __WEBPACK_IMPORTED_MODULE_6__models_i18n__["b" /* PlaceHolderKeys */].SUPPORTED_TEMPLATE_EXTENSIONS + '}}'].join(' ');
        this.IMPORT_OLIGO_PROJECT_CONFIRM_OK_LABEL = 'Import';
        this.IMPORT_OLIGO_PROJECT_CONFIRM_CANCEL_LABEL = 'Review';
        this.IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_TEXT = ['One or more oligos does not meet the minimum requirements: sequence, sequence name and researcher name.', 'One or more oligo configurations is not compatible and cannot be applied.'].join('\n');
        this.IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_MISSING_REQUIRED_ONLY_TEXT = 'One or more oligos does not meet the minimum requirements: sequence, sequence name and researcher name.';
        this.IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_CONFIG_INCORRECT_ONLY_TEXT = 'One or more oligo configurations are not compatible and cannot be applied.';
        this.IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_TEXT = ['To review your oligo configurations, click Review.', 'Otherwise, click \'Import\' and oligos without minimum requirements will not be imported and default configurations options will be applied to the problematic oligos.', 'You can continue to make changes to your oligos once they are imported into the main design tool.'].join('\n');
        this.IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_MISSING_REQUIRED_ONLY_TEXT = ['To review your oligo configurations, click Review.', 'Otherwise, click \'Import\' and oligos without minimum requirements will not be imported.', 'You can continue to make changes to your oligos once they are imported into the main design tool.'].join('\n');
        this.IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_CONFIG_INCORRECT_ONLY_TEXT = ['To review your oligo configurations, click Review.', 'Otherwise, click \'Import\' and default configurations options would be applied to the problematic oligos.', 'You can continue to make changes to your oligos once they are imported into the main design tool.'].join('\n');
        this.IMPORT_OLIGO_PROJECT_CONFIRM_ERROR_REGION_LABEL = 'Problematic oligos:';
        this.IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_OK_LABEL = 'Continue';
        this.IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_CANCEL_LABEL = 'Cancel';
        this.IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_TEXT = 'Bulk import will overwrite existing oligos information in the project.';
        this.supportedFileExtensions = [];
        this.busy = false;
        this.templateTextContent = '';
        this.textAreaActive = false;
        this.preferencesShown = true;
        this.preferenceToggleSupported = false;
        this.ready = false;
        this.isOpen = false;
        this.hasExistingProjects = false;
        this.noOfLineItems = 0;
        this.maxNoOfOligos = 200;
        this.templateColumnDefs = [];
        this.notificationState = __WEBPACK_IMPORTED_MODULE_1__fancy_message_pane_fancy_message_pane__["c" /* FancyMessagePaneStates */].INFO;
        this.notificationMessages = [];
        this.textAreaRowNumbers = '';
        this.textAreaNoOfLines = 0;
        this.importProject = null;
        var bindDispatchers = function bindDispatchers(dispatch) {
            _this.importProject = function (request) {
                return dispatch(projectActions.importProject(request));
            };
        };
        var unsubscribeRedux = $ngRedux.connect(this.mapStateToThis.bind(this), bindDispatchers)(this);
        var unwatchDelegate = $scope.$watch(function () {
            return _this.delegate;
        }, function (delegate) {
            if (!delegate) {
                return;
            }
            delegate.listen(_this);
        });
        var unwatchTemplateText = $scope.$watch(function () {
            return _this.templateTextContent;
        }, function (newContent) {
            newContent = newContent || '';
            newContent = newContent.replace(/^\s*[\r\n]/gm, '');
            var lineNumbers = [];
            var noOfNewLines = newContent.split('\n').length;
            for (var newLineNo = 0; newLineNo < noOfNewLines; newLineNo++) {
                lineNumbers.push('' + (newLineNo + 1));
            }
            _this.textAreaNoOfLines = noOfNewLines;
            _this.textAreaRowNumbers = lineNumbers.join('\n');
            var trimmedContent = newContent.trim();
            var noOfLineItems = trimmedContent.length > 0 ? trimmedContent.split('\n').length : 0;
            _this.noOfLineItems = noOfLineItems;
            if (trimmedContent.indexOf('\t') < 0) {
                return;
            }
            _this.templateTextContent = trimmedContent.replace(/\t/g, ',');
        });
        var unwatchTemplatePath = $scope.$watch(function () {
            return _this.templatePath;
        }, function (templatePath) {
            var countryCode = _this.countryCode,
                langCode = _this.langCode,
                templateURL = _this.templateURL;

            if (templateURL) {
                unwatchTemplatePath();
                return;
            }
            _this.templateURL = templateLocation(countryCode, langCode, templatePath);
        });
        var unwatchNoOfItems = $scope.$watch(function () {
            return _this.noOfLineItems;
        }, function () {
            var currentNotificationState = _this.notificationState;
            var currentNotifications = (_this.notificationMessages || []).filter(function (message) {
                return message !== _this.IMPORT_OLIGO_PROJECT_OLIGO_COUNT_MAX_TEXT;
            });
            if (_this.isExceedingItemLimit()) {
                currentNotifications = [].concat(_toConsumableArray(currentNotifications), [_this.IMPORT_OLIGO_PROJECT_OLIGO_COUNT_MAX_TEXT]);
                currentNotificationState = __WEBPACK_IMPORTED_MODULE_1__fancy_message_pane_fancy_message_pane__["c" /* FancyMessagePaneStates */].WARN;
            } else {
                currentNotificationState = currentNotifications.length > 0 ? __WEBPACK_IMPORTED_MODULE_1__fancy_message_pane_fancy_message_pane__["c" /* FancyMessagePaneStates */].WARN : __WEBPACK_IMPORTED_MODULE_1__fancy_message_pane_fancy_message_pane__["c" /* FancyMessagePaneStates */].INFO;
            }
            _this.notificationMessages = currentNotifications;
            _this.notificationState = currentNotificationState;
        });
        var openWhenReady = function openWhenReady() {
            if (_this.ready) {
                _this.open();
            } else {
                $timeout(openWhenReady, 500);
            }
        };
        $scope.$on('$locationChangeSuccess', function ($event, newUrl) {
            var pathRegex = new RegExp(_this.MODAL_URL_PATH + '$');
            var isThisPage = pathRegex.test(newUrl);
            if (isThisPage) {
                openWhenReady();
            } else if (_this.isOpen) {
                _this.close();
            }
        });
        $scope.$on('$destroy', function () {
            unsubscribeRedux();
            unwatchDelegate();
            unwatchTemplateText();
            unwatchTemplatePath();
            unwatchNoOfItems();
            _this.dndProcessor = null;
        });
        var processFiles = this.processFiles.bind(this);
        var onFileProcessingSuccess = this.onFileProcessingSuccess.bind(this);
        var onFileProcessingFail = this.onFileProcessingFail.bind(this);
        var dndProcessor = {
            processDroppedFiles: processFiles,
            onDragAndDropSuccess: onFileProcessingSuccess,
            onDragAndDropFailure: onFileProcessingFail
        };
        var preferenceChangeHandler = {
            onOptionChangeStart: function onOptionChangeStart() {
                _this.busy = true;
            },
            onOptionChangeSuccess: function onOptionChangeSuccess(newOptions) {
                _this.preference = Object(__WEBPACK_IMPORTED_MODULE_2__oligo_config_preference_oligo_config_preference__["e" /* preferenceOptionsToPreference */])(newOptions);
                _this.busy = false;
            },
            onOptionChangeFailed: function onOptionChangeFailed(error) {
                _this.busy = false;
            }
        };
        this.dndProcessor = dndProcessor;
        this.preferenceChangeHandler = preferenceChangeHandler;
        this.processFiles = processFiles;
        this.onFileProcessingSuccess = onFileProcessingSuccess;
        this.onFileProcessingFail = onFileProcessingFail;
        this.topLevelInstructions = this.topLevelInstructions.bind(this);
    }

    _createClass(ProjectImportModalController, [{
        key: 'onTextAreaBlur',
        value: function onTextAreaBlur() {
            this.textAreaActive = this.templateTextContent.trim().length > 0;
        }
    }, {
        key: 'filesChanged',
        value: function filesChanged(inputJQ, files) {
            this.inputJQ = inputJQ;
            var clearInputJQ = function clearInputJQ() {
                return inputJQ.val('');
            };
            if (files) {
                if (files.length > 0) {
                    this.processFiles(files).then(this.onFileProcessingSuccess, this.onFileProcessingFail).finally(clearInputJQ);
                }
            } else {
                this.processFilePath(inputJQ.val()).then(this.onFileProcessingSuccess, this.onFileProcessingFail).finally(clearInputJQ);
            }
        }
    }, {
        key: 'processFiles',
        value: function processFiles(fileList) {
            var templateColumnDefs = this.templateColumnDefs,
                langCode = this.langCode;

            var files = Array.prototype.slice.call(fileList).map(function (blob) {
                var name = blob.name;

                return { name: name, blob: blob };
            });
            this.busy = true;
            this.files = files;
            var asTextRowData = templateDataAsTextRowData(templateColumnDefs);
            return this.projectService.importProjectTemplateData({ files: files, langCode: langCode }).then(function (result) {
                var data = result.data,
                    errors = result.errors;

                var templateData = data.map(asTextRowData);
                return { templateData: templateData, errors: errors };
            });
        }
    }, {
        key: 'processFilePath',
        value: function processFilePath(path) {
            var templateColumnDefs = this.templateColumnDefs,
                langCode = this.langCode;

            var files = [path].map(function (name) {
                var blob = undefined;
                return { name: name, blob: blob };
            });
            this.busy = true;
            this.files = files;
            var asTextRowData = templateDataAsTextRowData(templateColumnDefs);
            return this.projectService.importProjectTemplateData({ files: files, langCode: langCode }).then(function (result) {
                var data = result.data,
                    errors = result.errors;

                var templateData = data.map(asTextRowData);
                return { templateData: templateData, errors: errors };
            });
        }
    }, {
        key: 'onFileProcessingSuccess',
        value: function onFileProcessingSuccess(data) {
            var _this2 = this;

            var noOfLineItems = this.noOfLineItems,
                IMPORT_OLIGO_PROJECT_TITLE = this.IMPORT_OLIGO_PROJECT_TITLE,
                IMPORT_OLIGO_PROJECT_TD_OVERWRITE_TEXT = this.IMPORT_OLIGO_PROJECT_TD_OVERWRITE_TEXT;
            var IMPORT_OLIGO_PROJECT_TD_OVERWRITE_OK_LABEL = this.IMPORT_OLIGO_PROJECT_TD_OVERWRITE_OK_LABEL,
                IMPORT_OLIGO_PROJECT_TD_OVERWRITE_CANCEL_LABEL = this.IMPORT_OLIGO_PROJECT_TD_OVERWRITE_CANCEL_LABEL;
            var errors = data.errors,
                templateData = data.templateData;

            this.busy = false;
            var hasCurrentData = noOfLineItems > 0;
            var promptWithExistingDataPromise = function () {
                if (hasCurrentData) {
                    return _this2.oligoModalSupport.show({
                        title: IMPORT_OLIGO_PROJECT_TITLE,
                        type: __WEBPACK_IMPORTED_MODULE_3__oligo_modal_support_oligo_modal_support__["g" /* OligoModalTypes */].CONFIRM,
                        alertData: {
                            state: __WEBPACK_IMPORTED_MODULE_1__fancy_message_pane_fancy_message_pane__["c" /* FancyMessagePaneStates */].WARN,
                            content: IMPORT_OLIGO_PROJECT_TD_OVERWRITE_TEXT
                        },
                        content: '',
                        okLabel: IMPORT_OLIGO_PROJECT_TD_OVERWRITE_OK_LABEL,
                        cancelLabel: IMPORT_OLIGO_PROJECT_TD_OVERWRITE_CANCEL_LABEL
                    }).then(function (status) {
                        return status === __WEBPACK_IMPORTED_MODULE_3__oligo_modal_support_oligo_modal_support__["f" /* OligoModalSupportStatuses */].OK;
                    });
                } else {
                    return _this2.$q.resolve(true);
                }
            }();
            return promptWithExistingDataPromise.then(function (continueImport) {
                if (!continueImport) {
                    return;
                }
                _this2.textAreaActive = templateData.length > 0;
                _this2.templateTextContent = templateData.length > 0 ? templateData.join('\n') : '';
                _this2.templateParseErrors = errors;
                _this2.noOfLineItems = templateData.length;
                _this2.notificationState = errors && errors.length > 0 ? __WEBPACK_IMPORTED_MODULE_1__fancy_message_pane_fancy_message_pane__["c" /* FancyMessagePaneStates */].WARN : __WEBPACK_IMPORTED_MODULE_1__fancy_message_pane_fancy_message_pane__["c" /* FancyMessagePaneStates */].INFO;
                _this2.notificationMessages = errors.map(function (templateError) {
                    return templateError.message;
                });
            });
        }
    }, {
        key: 'onFileProcessingFail',
        value: function onFileProcessingFail(error) {
            var IMPORT_OLIGO_PROJECT_TITLE = this.IMPORT_OLIGO_PROJECT_TITLE,
                IMPORT_OLIGO_PROJECT_ERROR_ACCEPT_LABEL = this.IMPORT_OLIGO_PROJECT_ERROR_ACCEPT_LABEL;

            this.busy = false;
            var errorMessages = [];
            var isAppErrorObject = function isAppErrorObject(targetError) {
                var oligoError = targetError;
                return oligoError && typeof oligoError.id === 'string' && typeof oligoError.message === 'string';
            };
            if (error instanceof Array) {
                errorMessages = error.filter(isAppErrorObject).map(function (appError) {
                    return appError.message;
                });
            } else {
                if (isAppErrorObject(error)) {
                    errorMessages.push(error.message);
                }
            }
            if (errorMessages.length > 0) {
                return this.oligoModalSupport.show({
                    title: IMPORT_OLIGO_PROJECT_TITLE,
                    content: '',
                    type: __WEBPACK_IMPORTED_MODULE_3__oligo_modal_support_oligo_modal_support__["g" /* OligoModalTypes */].INFO,
                    okLabel: IMPORT_OLIGO_PROJECT_ERROR_ACCEPT_LABEL,
                    alertData: {
                        state: __WEBPACK_IMPORTED_MODULE_1__fancy_message_pane_fancy_message_pane__["c" /* FancyMessagePaneStates */].WARN,
                        content: errorMessages.join('\n')
                    }
                }).then(function () {
                    return;
                });
            } else {
                return this.$q.reject(error);
            }
        }
    }, {
        key: 'noLocalFileSupportProcessFrame',
        value: function noLocalFileSupportProcessFrame(frameJQ) {
            var templateColumnDefs = this.templateColumnDefs,
                langCode = this.langCode;

            var asTextRowData = templateDataAsTextRowData(templateColumnDefs);
            var responseData = frameJQ.contents().find('body').text();
            this.projectService.processProjectTemplateData(JSON.parse(responseData), langCode).then(function (result) {
                var data = result.data,
                    errors = result.errors;

                var templateData = data.map(asTextRowData);
                return { templateData: templateData, errors: errors };
            }).then(this.onFileProcessingSuccess, this.onFileProcessingFail);
        }
    }, {
        key: 'clearNotifications',
        value: function clearNotifications() {
            this.notificationState = __WEBPACK_IMPORTED_MODULE_1__fancy_message_pane_fancy_message_pane__["c" /* FancyMessagePaneStates */].INFO;
            this.notificationMessages = [];
        }
    }, {
        key: 'isExceedingItemLimit',
        value: function isExceedingItemLimit() {
            return this.noOfLineItems > this.maxNoOfOligos;
        }
    }, {
        key: 'isContentValid',
        value: function isContentValid() {
            var templateTextContent = this.templateTextContent;

            var templateContentValid = templateTextContent ? templateTextContent.trim().length > 0 : false;
            var doesNotExceedOligoLimit = !this.isExceedingItemLimit();
            return templateContentValid && doesNotExceedOligoLimit;
        }
    }, {
        key: 'togglePreferences',
        value: function togglePreferences() {
            this.preferencesShown = !this.preferencesShown;
        }
    }, {
        key: 'topLevelInstructions',
        value: function topLevelInstructions() {
            var _I18n$replacePlaceHol;

            var IMPORT_OLIGO_PROJECT_TOP_LEVEL_INSTRUCTIONS = this.IMPORT_OLIGO_PROJECT_TOP_LEVEL_INSTRUCTIONS,
                supportedFileExtensions = this.supportedFileExtensions,
                templateURL = this.templateURL;

            return __WEBPACK_IMPORTED_MODULE_6__models_i18n__["c" /* replacePlaceHolders */](IMPORT_OLIGO_PROJECT_TOP_LEVEL_INSTRUCTIONS, (_I18n$replacePlaceHol = {}, _defineProperty(_I18n$replacePlaceHol, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["b" /* PlaceHolderKeys */].DOWNLOAD_TEMPLATE_URL, templateURL || ''), _defineProperty(_I18n$replacePlaceHol, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["b" /* PlaceHolderKeys */].SUPPORTED_TEMPLATE_EXTENSIONS, supportedFileExtensions.join(', ').replace(/,\s([^,]+)$/, ' and $1')), _I18n$replacePlaceHol));
        }
    }, {
        key: 'activateTextArea',
        value: function activateTextArea() {}
    }, {
        key: 'openFileBrowser',
        value: function openFileBrowser() {}
    }, {
        key: 'open',
        value: function open() {
            var _this3 = this;

            var deferred = this.$q.defer();
            this.showModal();
            this.resultDeferred = deferred;
            this.$scope.$emit(__WEBPACK_IMPORTED_MODULE_5__models__["k" /* ScopeEvents */].BULK_UPLOAD_SHOW);
            if (!this.oligoTemplateDef) {
                this.busy = true;
                this.projectService.newOligoItem({ id: '0', index: 0 }).then(function (templateOligo) {
                    var definition = templateOligo.definition;
                    var basic = definition.basic;
                    var scale = basic.scale,
                        purification = basic.purification,
                        format = basic.format;

                    var preference = {
                        scale: {
                            id: scale.selected.id,
                            value: scale.selected.value
                        },
                        purification: {
                            id: purification.selected.id,
                            value: purification.selected.value
                        },
                        format: {
                            id: format.selected.id,
                            value: format.selected.value
                        },
                        isDefault: true
                    };
                    _this3.initialPreference = Object.assign({}, preference);
                    _this3.preferenceTemmplate = Object.assign({}, preference);
                    _this3.oligoTemplateDef = definition;
                }).finally(function () {
                    _this3.busy = false;
                });
            }
            return deferred.promise;
        }
    }, {
        key: 'ok',
        value: function ok() {
            var _this4 = this;

            var importProject = this.importProject,
                preference = this.preference,
                oligoTemplateDef = this.oligoTemplateDef,
                files = this.files,
                templateColumnDefs = this.templateColumnDefs,
                templateTextContent = this.templateTextContent;

            if (!importProject || !preference || !oligoTemplateDef || !templateTextContent || !templateColumnDefs) {
                return;
            }
            if (templateTextContent.length <= 0) {
                return;
            }
            var request = {
                files: templateTextDataAsFiles(templateTextContent, templateColumnDefs, files),
                preference: Object.assign({}, preference, { delivery: {
                        id: oligoTemplateDef.basic.delivery.selected.id,
                        value: oligoTemplateDef.basic.delivery.selected.value
                    } })
            };
            this.busy = true;
            this.projectService.importProject(request).then(function (response) {
                var projects = response.projects,
                    importErrors = response.errors;

                var hasErrors = importErrors ? importErrors.length > 0 : false;
                if (!hasErrors) {
                    var successfulImportResponse = {
                        projects: projects,
                        status: ProjectImportModalSupportStatuses.OK
                    };
                    return successfulImportResponse;
                } else {
                    _this4.busy = false;
                    return _this4.openConfirmProjectImport(importErrors).then(function (confirmImportStatus) {
                        if (confirmImportStatus === __WEBPACK_IMPORTED_MODULE_3__oligo_modal_support_oligo_modal_support__["f" /* OligoModalSupportStatuses */].OK) {
                            _this4.busy = true;
                            return _this4.projectService.importProject(Object.assign({}, request, { fixErrorsUsingPreference: true })).then(function (confirmedImportResponse) {
                                var confirmedProjects = confirmedImportResponse.projects;

                                var confirmedProjectResponse = {
                                    status: ProjectImportModalSupportStatuses.OK,
                                    projects: confirmedProjects
                                };
                                return confirmedProjectResponse;
                            });
                        } else {
                            var reviewProjectResponse = {
                                status: ProjectImportModalSupportStatuses.CANCEL,
                                errors: importErrors
                            };
                            return reviewProjectResponse;
                        }
                    });
                }
            }).then(function (response) {
                var status = response.status,
                    projectsToImport = response.projects,
                    projectImportErrors = response.errors;

                var errorsToShow = projectImportErrors || [];
                _this4.notificationState = errorsToShow.length > 0 ? __WEBPACK_IMPORTED_MODULE_1__fancy_message_pane_fancy_message_pane__["c" /* FancyMessagePaneStates */].WARN : __WEBPACK_IMPORTED_MODULE_1__fancy_message_pane_fancy_message_pane__["c" /* FancyMessagePaneStates */].INFO;
                _this4.notificationMessages = errorsToShow.map(function (projectImportError) {
                    return '<div>' + projectImportError.message + '</div>';
                });
                if (status !== ProjectImportModalSupportStatuses.OK) {
                    return;
                }
                return _this4.openConfirmProjectOverwrite().then(function (continueImportStatus) {
                    if (continueImportStatus === __WEBPACK_IMPORTED_MODULE_3__oligo_modal_support_oligo_modal_support__["f" /* OligoModalSupportStatuses */].OK) {
                        _this4.busy = true;
                        var projects = projectsToImport;
                        return importProject({ projects: projects }).then(function () {
                            _this4.busy = false;
                            _this4.resetLocalState();
                            if (_this4.inputJQ) {
                                _this4.inputJQ.val('');
                            }
                            _this4.closeModal();
                            if (_this4.resultDeferred) {
                                _this4.resultDeferred.resolve(response);
                            }
                            _this4.$scope.$emit(__WEBPACK_IMPORTED_MODULE_5__models__["k" /* ScopeEvents */].BULK_UPLOAD_IMPORT);
                        });
                    } else {
                        return;
                    }
                });
            }).finally(function () {
                _this4.busy = false;
            });
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.closeModal();
            this.resetLocalState();
            if (this.resultDeferred) {
                this.resultDeferred.resolve({
                    status: ProjectImportModalSupportStatuses.CANCEL
                });
            }
        }
    }, {
        key: 'close',
        value: function close() {
            this.cancel();
        }
    }, {
        key: 'getJQ',
        value: function getJQ() {
            if (!this.jq) {
                this.jq = $('#' + MODAL_ID);
            }
            return this.jq;
        }
    }, {
        key: 'hideModal',
        value: function hideModal() {
            this.getJQ().modal('hide');
            this.isOpen = false;
        }
    }, {
        key: 'showModal',
        value: function showModal() {
            this.getJQ().modal({
                backdrop: 'static',
                show: true,
                keyboard: false
            });
            this.isOpen = true;
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.hideModal();
            this.$location.path('/');
        }
    }, {
        key: 'openConfirmProjectImport',
        value: function openConfirmProjectImport(errors) {
            var IMPORT_OLIGO_PROJECT_TITLE = this.IMPORT_OLIGO_PROJECT_TITLE,
                IMPORT_OLIGO_PROJECT_CONFIRM_CANCEL_LABEL = this.IMPORT_OLIGO_PROJECT_CONFIRM_CANCEL_LABEL;
            var IMPORT_OLIGO_PROJECT_CONFIRM_OK_LABEL = this.IMPORT_OLIGO_PROJECT_CONFIRM_OK_LABEL,
                IMPORT_OLIGO_PROJECT_CONFIRM_ERROR_REGION_LABEL = this.IMPORT_OLIGO_PROJECT_CONFIRM_ERROR_REGION_LABEL;
            var IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_TEXT = this.IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_TEXT,
                IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_MISSING_REQUIRED_ONLY_TEXT = this.IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_MISSING_REQUIRED_ONLY_TEXT;
            var IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_TEXT = this.IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_TEXT,
                IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_MISSING_REQUIRED_ONLY_TEXT = this.IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_MISSING_REQUIRED_ONLY_TEXT;
            var IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_CONFIG_INCORRECT_ONLY_TEXT = this.IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_CONFIG_INCORRECT_ONLY_TEXT,
                IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_CONFIG_INCORRECT_ONLY_TEXT = this.IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_CONFIG_INCORRECT_ONLY_TEXT;

            var alertType = alertTypeFromErrors(errors);
            var alertContent = IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_TEXT;
            var instructionContent = IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_TEXT;
            switch (alertType) {
                case ErrorAlertTypes.MISSING_REQUIRED_ONLY:
                    alertContent = IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_MISSING_REQUIRED_ONLY_TEXT;
                    instructionContent = IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_MISSING_REQUIRED_ONLY_TEXT;
                    break;
                case ErrorAlertTypes.INCORRECT_CONFIG_ONLY:
                    alertContent = IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_CONFIG_INCORRECT_ONLY_TEXT;
                    instructionContent = IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_CONFIG_INCORRECT_ONLY_TEXT;
                    break;
                case ErrorAlertTypes.MIXED_ERROR:
                default:
                    alertContent = IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_TEXT;
                    instructionContent = IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_TEXT;
                    break;
            }
            var errorContent = errors.map(function (errorItem) {
                var message = errorItem.message;

                return '<li>' + message + '</li>';
            }).join('');
            return this.oligoModalSupport.show({
                title: IMPORT_OLIGO_PROJECT_TITLE,
                content: '\n      <div class="project-import-modal__confirm-instruction">\n      ' + instructionContent + '\n      </div>\n      <div class="project-import-modal__confirm-error-container">\n        <div class="project-import-modal__confirm-error-label">\n        ' + IMPORT_OLIGO_PROJECT_CONFIRM_ERROR_REGION_LABEL + '\n        </div>\n        <ul class="project-import-modal__confirm-error-content">' + errorContent + '</ul>\n      </div>\n      ',
                type: __WEBPACK_IMPORTED_MODULE_3__oligo_modal_support_oligo_modal_support__["g" /* OligoModalTypes */].CONFIRM,
                okLabel: IMPORT_OLIGO_PROJECT_CONFIRM_OK_LABEL,
                cancelLabel: IMPORT_OLIGO_PROJECT_CONFIRM_CANCEL_LABEL,
                alertData: {
                    state: __WEBPACK_IMPORTED_MODULE_1__fancy_message_pane_fancy_message_pane__["c" /* FancyMessagePaneStates */].WARN,
                    content: alertContent
                }
            });
        }
    }, {
        key: 'openConfirmProjectOverwrite',
        value: function openConfirmProjectOverwrite() {
            var _this5 = this;

            var IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_CANCEL_LABEL = this.IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_CANCEL_LABEL,
                IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_OK_LABEL = this.IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_OK_LABEL;
            var IMPORT_OLIGO_PROJECT_TITLE = this.IMPORT_OLIGO_PROJECT_TITLE,
                IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_TEXT = this.IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_TEXT,
                hasExistingProjects = this.hasExistingProjects;

            return this.$q(function (resolve, reject) {
                if (hasExistingProjects) {
                    _this5.$timeout(function () {
                        _this5.oligoModalSupport.show({
                            title: IMPORT_OLIGO_PROJECT_TITLE,
                            content: '',
                            type: __WEBPACK_IMPORTED_MODULE_3__oligo_modal_support_oligo_modal_support__["g" /* OligoModalTypes */].CONFIRM,
                            okLabel: IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_OK_LABEL,
                            cancelLabel: IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_CANCEL_LABEL,
                            alertData: {
                                state: __WEBPACK_IMPORTED_MODULE_1__fancy_message_pane_fancy_message_pane__["c" /* FancyMessagePaneStates */].WARN,
                                content: IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_TEXT
                            }
                        }).then(resolve, reject);
                    }, 500);
                } else {
                    return resolve(__WEBPACK_IMPORTED_MODULE_3__oligo_modal_support_oligo_modal_support__["f" /* OligoModalSupportStatuses */].OK);
                }
            });
        }
    }, {
        key: 'resetLocalState',
        value: function resetLocalState() {
            this.files = null;
            this.templateTextContent = '';
            this.textAreaActive = false;
            this.preferencesShown = true;
            this.noOfLineItems = 0;
            this.initialPreference = this.preferenceTemmplate ? Object.assign({}, this.preferenceTemmplate) : undefined;
            this.templateParseErrors = [];
            this.clearNotifications();
        }
    }, {
        key: 'createMaxOligoLimitReachedText',
        value: function createMaxOligoLimitReachedText(vocabulary, maxNoOfOligos) {
            var text = vocabulary[__WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_MAX_REACHED_TEXT] || this.IMPORT_OLIGO_PROJECT_OLIGO_COUNT_MAX_TEXT;
            return __WEBPACK_IMPORTED_MODULE_6__models_i18n__["c" /* replacePlaceHolders */](text, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["b" /* PlaceHolderKeys */].MAX_OLIGO_COUNT, '' + maxNoOfOligos));
        }
    }, {
        key: 'createUnsupportedFileText',
        value: function createUnsupportedFileText(vocabulary, supportedFileExtensions) {
            var text = vocabulary[__WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EXTENSION_UNSUPPORTED_TEXT] || this.IMPORT_OLIGO_PROJECT_TD_EXT_UNSUPPORTED_TEXT;
            return __WEBPACK_IMPORTED_MODULE_6__models_i18n__["c" /* replacePlaceHolders */](text, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["b" /* PlaceHolderKeys */].SUPPORTED_TEMPLATE_EXTENSIONS, supportedFileExtensions.join(', ').replace(/,\s([^,]+)$/, ' and $1')));
        }
    }, {
        key: 'createSampleDataContent',
        value: function createSampleDataContent(templateColumnDefs) {
            if (templateColumnDefs.length > 0) {
                var sampleDataColumnHeaders = templateColumnDefs.map(function (columnDef) {
                    return columnDef.name;
                }).join(',');
                return SAMPLE_DATA_TEMPLATE.replace('{{COL_HEADERS}}', sampleDataColumnHeaders);
            }
            return '';
        }
    }, {
        key: 'getVocabularyOrDefault',
        value: function getVocabularyOrDefault(vocabulary, key, defaultValue) {
            return vocabulary[key] || defaultValue;
        }
    }, {
        key: 'mapStateToThis',
        value: function mapStateToThis(state) {
            var templatePath = this.templatePath;
            var ready = this.ready,
                sampleDataContent = this.sampleDataContent;
            var world = state.world,
                projects = state.projects;
            var countryCode = world.countryCode,
                langCode = world.language,
                vocabulary = world.vocabulary,
                maxNoOfOligos = world.maxNoOfOligos,
                projectTemplateColumnDefs = world.templateColumnDefs,
                supportedFileExtensions = world.templateSupportedExtensions;

            if (!ready) {
                ready = Object.keys(vocabulary).length > 0;
            }
            var hasExistingProjects = projects && projects.length > 0;
            var templateColumnDefs = [].concat(_toConsumableArray(projectTemplateColumnDefs)).sort(function (a, b) {
                return a.index - b.index;
            });
            var templateURL = templateLocation(countryCode, langCode, templatePath);
            var maxOligoLimitReachedText = this.createMaxOligoLimitReachedText(vocabulary, maxNoOfOligos);
            var unsupportedFileText = this.createUnsupportedFileText(vocabulary, supportedFileExtensions);
            sampleDataContent = this.createSampleDataContent(templateColumnDefs);
            return {
                ready: ready,
                countryCode: countryCode,
                langCode: langCode,
                maxNoOfOligos: maxNoOfOligos,
                hasExistingProjects: hasExistingProjects,
                templateColumnDefs: templateColumnDefs,
                templateURL: templateURL,
                sampleDataContent: sampleDataContent,
                supportedFileExtensions: supportedFileExtensions,
                IMPORT_OLIGO_PROJECT_TITLE: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_TITLE, this.IMPORT_OLIGO_PROJECT_TITLE),
                IMPORT_OLIGO_PROJECT_CANCEL_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_CANCEL_BUTTON, this.IMPORT_OLIGO_PROJECT_CANCEL_LABEL),
                IMPORT_OLIGO_PROJECT_OK_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_OK_BUTTON, this.IMPORT_OLIGO_PROJECT_OK_LABEL),
                IMPORT_OLIGO_PROJECT_DOWNLOAD_TEMPLATE_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_DOWNLOAD_TEMPLATE_LABEL, this.IMPORT_OLIGO_PROJECT_DOWNLOAD_TEMPLATE_LABEL),
                IMPORT_OLIGO_PROJECT_UPLOAD_FILE_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_UPLOAD_FILE_LABEL, this.IMPORT_OLIGO_PROJECT_UPLOAD_FILE_LABEL),
                IMPORT_OLIGO_PROJECT_SHOW_PREFERENCES_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_SHOW_PREFERENCES_LABEL, this.IMPORT_OLIGO_PROJECT_SHOW_PREFERENCES_LABEL),
                IMPORT_OLIGO_PROJECT_HIDE_PREFERENCES_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_HIDE_PREFERENCES_LABEL, this.IMPORT_OLIGO_PROJECT_HIDE_PREFERENCES_LABEL),
                IMPORT_OLIGO_PROJECT_DRAG_AREA_INSTRUCTIONS: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_DRAG_AREA_INSTRUCTIONS, this.IMPORT_OLIGO_PROJECT_DRAG_AREA_INSTRUCTIONS),
                IMPORT_OLIGO_PROJECT_TOP_LEVEL_INSTRUCTIONS: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_TOP_LEVEL_INSTRUCTIONS, this.IMPORT_OLIGO_PROJECT_TOP_LEVEL_INSTRUCTIONS),
                IMPORT_OLIGO_PROJECT_OLIGO_COUNT_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_LABEL, this.IMPORT_OLIGO_PROJECT_OLIGO_COUNT_LABEL),
                IMPORT_OLIGO_PROJECT_OLIGO_COUNT_MAX_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_MAX_LABEL, this.IMPORT_OLIGO_PROJECT_OLIGO_COUNT_MAX_LABEL),
                IMPORT_OLIGO_PROJECT_OLIGO_SAMPLE_DATA_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_OLIGO_SAMPLE_DATA_LABEL, this.IMPORT_OLIGO_PROJECT_OLIGO_SAMPLE_DATA_LABEL),
                IMPORT_OLIGO_PROJECT_OLIGO_PREFERENCE_HINT_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_OLIGO_PREFERENCE_HINT_LABEL, this.IMPORT_OLIGO_PROJECT_OLIGO_PREFERENCE_HINT_LABEL),
                IMPORT_OLIGO_PROJECT_OLIGO_COUNT_MAX_TEXT: maxOligoLimitReachedText,
                IMPORT_OLIGO_PROJECT_ERROR_ACCEPT_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_ERROR_ACCEPT_LABEL, this.IMPORT_OLIGO_PROJECT_ERROR_ACCEPT_LABEL),
                IMPORT_OLIGO_PROJECT_TD_OVERWRITE_TEXT: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_TEXT, this.IMPORT_OLIGO_PROJECT_TD_OVERWRITE_TEXT),
                IMPORT_OLIGO_PROJECT_TD_OVERWRITE_OK_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_OK_LABEL, this.IMPORT_OLIGO_PROJECT_TD_OVERWRITE_OK_LABEL),
                IMPORT_OLIGO_PROJECT_TD_OVERWRITE_CANCEL_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_CANCEL_LABEL, this.IMPORT_OLIGO_PROJECT_TD_OVERWRITE_CANCEL_LABEL),
                IMPORT_OLIGO_PROJECT_CONFIRM_OK_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_OK_LABEL, this.IMPORT_OLIGO_PROJECT_CONFIRM_OK_LABEL),
                IMPORT_OLIGO_PROJECT_CONFIRM_CANCEL_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_CANCEL_LABEL, this.IMPORT_OLIGO_PROJECT_CONFIRM_CANCEL_LABEL),
                IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_TEXT: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_TEXT, this.IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_TEXT),
                IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_CONFIG_INCORRECT_ONLY_TEXT: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_CONFIG_INCORRECT_TEXT, this.IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_CONFIG_INCORRECT_ONLY_TEXT),
                IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_MISSING_REQUIRED_ONLY_TEXT: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_MISSING_REQUIRED_ONLY_TEXT, this.IMPORT_OLIGO_PROJECT_CONFIRM_ALERT_MISSING_REQUIRED_ONLY_TEXT),
                IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_TEXT: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_TEXT, this.IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_TEXT),
                IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_CONFIG_INCORRECT_ONLY_TEXT: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_CONFIG_INCORRECT_ONLY_TEXT, this.IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_CONFIG_INCORRECT_ONLY_TEXT),
                IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_MISSING_REQUIRED_ONLY_TEXT: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_MISSING_REQUIRED_ONLY_TEXT, this.IMPORT_OLIGO_PROJECT_CONFIRM_INSTRUCTION_MISSING_REQUIRED_ONLY_TEXT),
                IMPORT_OLIGO_PROJECT_CONFIRM_ERROR_REGION_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ERROR_REGION_LABEL, this.IMPORT_OLIGO_PROJECT_CONFIRM_ERROR_REGION_LABEL),
                IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_OK_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_OK_LABEL, this.IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_OK_LABEL),
                IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_CANCEL_LABEL: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_CANCEL_LABEL, this.IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_CANCEL_LABEL),
                IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_TEXT: this.getVocabularyOrDefault(vocabulary, __WEBPACK_IMPORTED_MODULE_6__models_i18n__["a" /* DictionaryKeys */].PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_TEXT, this.IMPORT_OLIGO_PROJECT_DATA_OVERWRITE_TEXT),
                IMPORT_OLIGO_PROJECT_TD_EXT_UNSUPPORTED_TEXT: unsupportedFileText
            };
        }
    }]);

    return ProjectImportModalController;
}();
var PROJECT_IMPORT_MODAL_NAME = 'projectImportModal';
var ProjectImportModal = function ProjectImportModal($timeout, $document) {
    return {
        template: function () {
            var bsJQ = $.fn;
            if (!bsJQ.modal || !bsJQ.modal.Constructor) {
                return '';
            }
            var version = bsJQ.modal.Constructor.VERSION;
            if (version) {
                if (version.indexOf('4') === 0) {
                    return __webpack_require__("TZRS");
                }
            } else {
                var isBS2 = bsJQ.modal.toString().indexOf('bs.modal') === -1;
                if (isBS2) {
                    return __webpack_require__("BzQJ");
                }
            }
            return '';
        }(),
        controller: ProjectImportModalController,
        controllerAs: 'projectImportModal',
        restrict: 'E',
        scope: {
            onImportStateChange: '&',
            templatePath: '<',
            delegate: '<'
        },
        bindToController: true,
        link: function link($scope, $elem, attrs, ctrl) {
            var controller = ctrl;
            var fileBrowserJQ = void 0;
            var sampleDataPopoverJQ = void 0;
            controller.openFileBrowser = function () {
                if (!fileBrowserJQ) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_4__models_client__["e" /* hasLocalFileSupport */])()) {
                        fileBrowserJQ = $elem.find('#file-open-os');
                    } else {
                        fileBrowserJQ = $document.find('#no-file-support-template-data-file');
                        fileBrowserJQ.on('change', function () {
                            controller.filesChanged(fileBrowserJQ);
                        });
                    }
                }
                fileBrowserJQ.click();
            };
            controller.activateTextArea = function () {
                controller.textAreaActive = true;
                $timeout(function () {
                    $elem.find('.project-import-modal__text-area').eq(0).focus();
                });
            };
            $timeout(function () {
                var sampleDataPopover = $elem.find('.project-import-modal__item-info--popover');
                if (sampleDataPopover.popover) {
                    var popover = {
                        html: true,
                        placement: 'bottom',
                        trigger: 'hover'
                    };
                    sampleDataPopover.popover(popover);
                    sampleDataPopoverJQ = sampleDataPopover;
                }
            });
            var pasteArea = void 0;
            var rowHeader = void 0;
            var pasteAreaScrollWatcher = void 0;
            var cleanupTextAreaScrollWatcher = function cleanupTextAreaScrollWatcher() {
                if (pasteArea && pasteAreaScrollWatcher) {
                    pasteArea.off('scroll', pasteAreaScrollWatcher);
                }
                pasteArea = null;
                rowHeader = null;
                pasteAreaScrollWatcher = null;
            };
            var unwatchTextAreaActive = $scope.$watch(function () {
                return controller.textAreaActive;
            }, function (active) {
                if (active) {
                    $timeout(function () {
                        var foundPasteArea = $elem.find('.project-import-modal__text-area');
                        var foundRowHeader = $elem.find('.project-import-modal__text-area--rowno');
                        var scrollWatcher = function scrollWatcher() {
                            return foundRowHeader.scrollTop(foundPasteArea.scrollTop() || 0);
                        };
                        foundPasteArea.on('scroll', scrollWatcher);
                        pasteArea = foundPasteArea;
                        rowHeader = foundRowHeader;
                        pasteAreaScrollWatcher = scrollWatcher;
                    });
                } else {
                    cleanupTextAreaScrollWatcher();
                }
            });
            var unwatchTemplateText = $scope.$watch(function () {
                return controller.templateTextContent;
            }, function () {
                $timeout(function () {
                    if (pasteAreaScrollWatcher) {
                        pasteAreaScrollWatcher();
                    }
                });
            });
            $scope.$on('$destroy', function () {
                unwatchTextAreaActive();
                unwatchTemplateText();
                cleanupTextAreaScrollWatcher();
                controller.openFileBrowser = function () {
                    return console.info('unbind openFileBrowser');
                };
                controller.activateTextArea = function () {
                    return console.info('unbind activateTextArea');
                };
                if (sampleDataPopoverJQ) {
                    sampleDataPopoverJQ.popover('destroy');
                    sampleDataPopoverJQ = null;
                }
            });
        }
    };
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("0iPh")))

/***/ }),

/***/ "wC1N":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("ydD5");
var TAG = __webpack_require__("kkCw")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "wKCN":
/***/ (function(module, exports) {

module.exports = "../fonts/n-a.ttf";

/***/ }),

/***/ "wPuX":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-55Roman.woff2";

/***/ }),

/***/ "x/He":
/***/ (function(module, exports) {

module.exports = "../fonts/HelveticaNeueLTW01-35Thin.svg";

/***/ }),

/***/ "xAdt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__("oeih");
var defined = __webpack_require__("/whu");

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),

/***/ "xHGE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/app/img/right-caret.png";

/***/ }),

/***/ "xZa+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("bUqO") && !__webpack_require__("zgIt")(function () {
  return Object.defineProperty(__webpack_require__("jhxf")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "xl2K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OligoStates; });
var OligoStates = {
    VALID: 'VALID',
    INVALID: 'INVALID'
};

/***/ }),

/***/ "yYvK":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("lDLk").f;
var has = __webpack_require__("WBcL");
var TAG = __webpack_require__("kkCw")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "ydD5":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "z/Xr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OligoModalTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return OligoModalSupportStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OLIGO_MODAL_SUPPORT_SERVICE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OligoModalSupportService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OligoModalSupportController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OLIGO_MODAL_SUPPORT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OligoModalSupportPanel; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OligoModalTypes = {
    INFO: 'INFO',
    CONFIRM: 'CONFIRM'
};
var OligoModalSupportStatuses = {
    OK: 'OK',
    CANCEL: 'CANCEL',
    CLOSE: 'CLOSE'
};
var MODAL_ID = 'oligo-modal-support';
var OLIGO_MODAL_SUPPORT_SERVICE_NAME = 'oligoModalSupportService';
var OligoModalSupportService = function () {
    function OligoModalSupportService($q) {
        _classCallCheck(this, OligoModalSupportService);

        this.$q = $q;
    }

    _createClass(OligoModalSupportService, [{
        key: 'show',
        value: function show(options) {
            this.data = options;
            this.deferred = this.$q.defer();
            this.getJQ().modal({
                backdrop: 'static',
                show: true,
                keyboard: false
            });
            return this.deferred.promise;
        }
    }, {
        key: 'hide',
        value: function hide(status) {
            if (!this.deferred) {
                return;
            }
            this.deferred.resolve(status);
        }
    }, {
        key: 'getJQ',
        value: function getJQ() {
            if (!this.jq) {
                this.jq = $('#' + MODAL_ID);
            }
            return this.jq;
        }
    }]);

    return OligoModalSupportService;
}();
var OligoModalSupportController = function () {
    function OligoModalSupportController($scope, oligoModalSupport) {
        var _this = this;

        _classCallCheck(this, OligoModalSupportController);

        this.oligoModalSupport = oligoModalSupport;
        this.MODAL_ID = MODAL_ID;
        this.data = {
            title: '',
            content: '',
            type: OligoModalTypes.INFO
        };
        $scope.$watch(function () {
            return oligoModalSupport.data;
        }, function (data) {
            if (!data) {
                return;
            }
            _this.data = Object.assign({}, data);
        });
    }

    _createClass(OligoModalSupportController, [{
        key: 'ok',
        value: function ok() {
            this.getJQ().modal('hide');
            this.oligoModalSupport.hide(OligoModalSupportStatuses.OK);
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.getJQ().modal('hide');
            this.oligoModalSupport.hide(OligoModalSupportStatuses.CANCEL);
        }
    }, {
        key: 'close',
        value: function close() {
            this.getJQ().modal('hide');
            this.oligoModalSupport.hide(OligoModalSupportStatuses.CLOSE);
        }
    }, {
        key: 'getJQ',
        value: function getJQ() {
            if (!this.jq) {
                this.jq = $('#' + MODAL_ID);
            }
            return this.jq;
        }
    }]);

    return OligoModalSupportController;
}();
var OLIGO_MODAL_SUPPORT_NAME = 'oligoModalSupport';
var OligoModalSupportPanel = {
    template: function () {
        var bsJQ = $.fn;
        if (!bsJQ.modal || !bsJQ.modal.Constructor) {
            return '';
        }
        var version = bsJQ.modal.Constructor.VERSION;
        if (version) {
            if (version.indexOf('4') === 0) {
                return __webpack_require__("NGuR");
            }
        } else {
            var isBS2 = bsJQ.modal.toString().indexOf('bs.modal') === -1;
            if (isBS2) {
                return __webpack_require__("Y1wI");
            }
        }
        return '';
    }(),
    controller: OligoModalSupportController,
    controllerAs: 'modalSupport'
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("0iPh")))

/***/ }),

/***/ "zHVU":
/***/ (function(module, exports) {

module.exports = "<div class=\"project-footer\">\n  <form class=\"form-inline\">\n    <div class=\"form-group\">\n      <div class=\"no-of-oligo\"><span>{{projectFooter.NO_OF_OLIGO_LABEL}}</span></div>\n      <input type=\"text\" class=\"form-control\" maxlength=\"2\"\n              ng-model=\"projectFooter.numOligoToAdd\"\n              ng-keypress=\"projectFooter.onQuantityKeyPress($event)\"\n              ng-blur=\"projectFooter.onQuantityBlur()\">\n    </div>\n    <button class=\"btn btn-outline-primary btn-popover\"\n            ng-class=\"{ disabled: projectFooter.cannotAddNewOligo() }\"\n            ng-click=\"projectFooter.doAddOligo()\">\n      {{projectFooter.ADD_OLIGO_LABEL}}\n    </button>\n  </form>\n  <div class=\"loader-container\" ng-if=\"projectFooter.loading\">\n    <div class=\"loader\"></div>\n  </div>\n</div>";

/***/ }),

/***/ "zUDu":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("WgSQ");
module.exports = __webpack_require__("7gX0").Array.keys;


/***/ }),

/***/ "zgIt":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "zmph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ErrorSequenceTextboxObj */
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ErrorSequenceTextboxObj = function ErrorSequenceTextboxObj() {
    _classCallCheck(this, ErrorSequenceTextboxObj);

    this.invalidLength = false;
    this.invalidList = [];
};

/***/ }),

/***/ "zo/l":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("oeih");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ })

},[0]);
});


// WEBPACK FOOTER //
// assets/app/js/app.custom-standard-oligos-ui.b43b1c2c799ff3be8293.js